import { gql, Apollo } from '@thriveglobal/thrive-web-core'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
    [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
    [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
    [SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<
    T extends { [key: string]: unknown },
    K extends keyof T
> = { [_ in K]?: never }
export type Incremental<T> =
    | T
    | {
          [P in keyof T]?: P extends ' $fragmentName' | '__typename'
              ? T[P]
              : never
      }
const defaultOptions = {} as const
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: { input: string; output: string }
    String: { input: string; output: string }
    Boolean: { input: boolean; output: boolean }
    Int: { input: number; output: number }
    Float: { input: number; output: number }
    AllowedLocale: { input: any; output: any }
    BigDecimal: { input: any; output: any }
    Color: { input: any; output: any }
    ISODate: { input: any; output: any }
    Instant: { input: any; output: any }
    JSON: { input: any; output: any }
    Locale: { input: any; output: any }
    Long: { input: any; output: any }
    PartnerUserId: { input: any; output: any }
    TimeZone: { input: any; output: any }
    UUID: { input: any; output: any }
    Url: { input: any; output: any }
}

export type AcceptToSInput = {
    userTime: Scalars['Instant']['input']
    userZoneId?: InputMaybe<Scalars['TimeZone']['input']>
}

export type AccessTypeInput = {
    name: Scalars['String']['input']
}

export type AccessTypePage = {
    __typename?: 'AccessTypePage'
    items: Array<Scalars['String']['output']>
    itemsPerPage: Scalars['Int']['output']
    page: Scalars['Int']['output']
    total: Scalars['Int']['output']
}

export enum AchievementFrequency {
    OnceAMonth = 'ONCE_A_MONTH',
    OneTime = 'ONE_TIME',
    Unlimited = 'UNLIMITED'
}

export type AchievementInfo = {
    __typename?: 'AchievementInfo'
    /** The action type of the achievement */
    actionType?: Maybe<Scalars['String']['output']>
    /** The description of the achievement */
    description?: Maybe<Scalars['String']['output']>
    /** The entity uuid of the related entity */
    entityId?: Maybe<Scalars['UUID']['output']>
    /** The uuid of the achievement */
    id?: Maybe<Scalars['UUID']['output']>
    /** The url of the image */
    image?: Maybe<Scalars['String']['output']>
    /** The quantity of the achievement */
    quantity?: Maybe<Scalars['Int']['output']>
    /** The title of the achievement */
    title?: Maybe<Scalars['String']['output']>
    /** Tell us if the achievement is a one off */
    unique?: Maybe<Scalars['Boolean']['output']>
    /** The achievement upc */
    upc?: Maybe<Scalars['String']['output']>
}

export type AchievementLevel = {
    __typename?: 'AchievementLevel'
    /** the claim date */
    claimedAt?: Maybe<Scalars['Instant']['output']>
    /** the completion date */
    completedAt?: Maybe<Scalars['Instant']['output']>
    /** The level of the achievement */
    level?: Maybe<Scalars['Int']['output']>
    /** The amount needed to get the achievement */
    total?: Maybe<Scalars['Int']['output']>
}

export type AchievementProgress = {
    __typename?: 'AchievementProgress'
    /** The id of the achievement */
    achievementId?: Maybe<Scalars['UUID']['output']>
    /** The levels of the achievement */
    levels: Array<AchievementLevel>
    /** The progress of the achievement */
    progress?: Maybe<Scalars['Int']['output']>
    /** The user id of the achievementProgress */
    userId?: Maybe<Scalars['UUID']['output']>
}

export type AchievementV2 = {
    __typename?: 'AchievementV2'
    /** The achievement action type */
    actionType?: Maybe<Scalars['String']['output']>
    /** The description of the achievement */
    description?: Maybe<Scalars['String']['output']>
    /** The uuid of the achievement */
    id?: Maybe<Scalars['UUID']['output']>
    /** The url of the image */
    image?: Maybe<Scalars['String']['output']>
    /** The maximum level achievable */
    maximumLevel: Scalars['Int']['output']
    /** The reward amount the user will receive when claiming the achievement */
    rewardAmount?: Maybe<Scalars['Int']['output']>
    /** The reward currency code the user will receive when claiming the achievement */
    rewardCurrencyCode?: Maybe<Scalars['String']['output']>
    /** The title of the achievement */
    title?: Maybe<Scalars['String']['output']>
    /** The achievement upc */
    upc?: Maybe<Scalars['String']['output']>
}

export type AchievementV3Info = {
    __typename?: 'AchievementV3Info'
    /** The count of actions needed to complete the achievement */
    actionNumber: Scalars['Int']['output']
    /** The action type of the achievement */
    actionType: Scalars['String']['output']
    /** The description of the achievement */
    description: Scalars['String']['output']
    /** The frequency of how often the achievement can be earned */
    frequency: Scalars['String']['output']
    /** The uuid of the achievement */
    id: Scalars['UUID']['output']
    /** The name of the achievement */
    name: Scalars['String']['output']
    /** The reward amount the user will receive when claiming the achievement */
    rewardAmount: Scalars['Int']['output']
    /** The code of the reward currency the user will receive when claiming the achievement */
    rewardCurrency: Scalars['String']['output']
    /** The achievement upc */
    upc: Scalars['String']['output']
}

export type AchievementV3Progress = {
    __typename?: 'AchievementV3Progress'
    /** The achievement info */
    achievementInfo: AchievementV3Info
    /** The current progress to the completion of the achievement */
    currentProgress: Scalars['Int']['output']
    /** The last time the achievement was completed */
    lastCompletedAt?: Maybe<Scalars['Instant']['output']>
    /** The last time the achievement was updated */
    lastUpdatedAt?: Maybe<Scalars['Instant']['output']>
    /** The amount of times that the achievement has been achieved */
    total: Scalars['Int']['output']
    /** The upc of the achievement */
    upc: Scalars['String']['output']
}

export type AchievementV4 = {
    __typename?: 'AchievementV4'
    /** Conditions that need to be met to complete the achievement */
    conditions: Array<AchievementV4Condition>
    /** The frequency of the achievement, the possible values are: ONCE, TIME_WINDOW_BASED, PER_GAME, SEASONAL, when seasonal is selected starDate and endDate should not be null */
    frequency: Frequency
    /** The date when the achievement starts being available */
    fromDate?: Maybe<Scalars['Instant']['output']>
    /** The uuid of the achievement */
    id: Scalars['UUID']['output']
    /** Maximum number of times this achievement can be completed in the time window */
    maxPerTimeWindow?: Maybe<Scalars['Int']['output']>
    /** The priority of the achievement */
    priority: Scalars['Int']['output']
    /** The rewards for completing the achievement */
    rewards: Array<AchievementV4Reward>
    /** Number of days within which the achievement is valid */
    timeWindowDays?: Maybe<Scalars['Int']['output']>
    /** The date when the achievement ends being available */
    toDate?: Maybe<Scalars['Instant']['output']>
    /** The day of the week the achievement starts */
    weekDayStart?: Maybe<DayOfWeek>
}

export type AchievementV4Condition = {
    __typename?: 'AchievementV4Condition'
    /** The uuid of the achievement this condition belongs */
    achievementId: Scalars['UUID']['output']
    /** List of action types. Any of them is allowed to fulfill this condition */
    actionTypes: Array<ActionType>
    /** The entityId required to fulfill this condition */
    entityId?: Maybe<Scalars['UUID']['output']>
    /** The uuid of the condition */
    id: Scalars['UUID']['output']
    /** If the required count should be non-consecutive days to meet the condition */
    isNonConsecutiveDays: Scalars['Boolean']['output']
    /** Number of times the action must be performed to satisfy the condition */
    requiredCount: Scalars['Int']['output']
    /** Number of consecutive days required to meet the condition */
    streakDays?: Maybe<Scalars['Int']['output']>
}

export type AchievementV4ConditionInput = {
    /** List of action types. Any of them is allowed to fulfill this condition */
    actionTypes: Array<ActionType>
    /** The entityId required to fulfill this condition */
    entityId?: InputMaybe<Scalars['UUID']['input']>
    /** If the required count should be non-consecutive days to meet the condition */
    isNonConsecutiveDays: Scalars['Boolean']['input']
    /** Number of times the action must be performed to satisfy the condition */
    requiredCount: Scalars['Int']['input']
    /** Number of consecutive days required to meet the condition */
    streakDays?: InputMaybe<Scalars['Int']['input']>
}

export type AchievementV4ConditionProgressGql = {
    __typename?: 'AchievementV4ConditionProgressGQL'
    /** The uuid of the condition */
    achievementConditionId: Scalars['UUID']['output']
    /** List of action types. Any of them is allowed to fulfill this condition */
    actionTypes: Array<ActionType>
    /** Number of times the action must be performed to satisfy the condition */
    requiredCount: Scalars['Int']['output']
    /** Number of times completed */
    timesCompletedInCurrentWindow: Scalars['Int']['output']
}

export type AchievementV4Input = {
    /** The frequency of the achievement. If SEASONAL: starDate and endDate should not be null */
    frequency: Frequency
    /** The date when the achievement starts being available */
    fromDate?: InputMaybe<Scalars['Instant']['input']>
    /** Maximum number of times this achievement can be completed in the time window */
    maxPerTimeWindow?: InputMaybe<Scalars['Int']['input']>
    /** The priority of the achievement */
    priority: Scalars['Int']['input']
    /** Number of days within which the achievement is valid */
    timeWindowDays?: InputMaybe<Scalars['Int']['input']>
    /** The date when the achievement ends being available */
    toDate?: InputMaybe<Scalars['Instant']['input']>
    /** The day of the week the achievement starts */
    weekDayStart?: InputMaybe<DayOfWeek>
}

export type AchievementV4ProgressGql = {
    __typename?: 'AchievementV4ProgressGQL'
    /** The uuid of the achievement */
    achievementId: Scalars['UUID']['output']
    /** Conditions progress */
    conditionsProgress: Array<AchievementV4ConditionProgressGql>
    /** The frequency of the achievement */
    frequency: Frequency
    /** Maximum number of times this achievement can be completed in the time window */
    maxPerTimeWindow?: Maybe<Scalars['Int']['output']>
    /** The priority of the achievement */
    priority: Scalars['Int']['output']
    /** The rewards for completing the achievement */
    rewards: Array<AchievementV4Reward>
    /** Number of days within which the achievement is valid */
    timeWindowDays?: Maybe<Scalars['Int']['output']>
    /** Number of times completed in current window */
    timesCompletedInCurrentWindow: Scalars['Int']['output']
}

export type AchievementV4Reward = {
    __typename?: 'AchievementV4Reward'
    /** The uuid of the achievement this reward belongs */
    achievementId: Scalars['UUID']['output']
    /** The uuid of the badge awarded for completing the achievement */
    badgeId?: Maybe<Scalars['UUID']['output']>
    /** The uuid of the reward */
    id: Scalars['UUID']['output']
    /** The number of points awarded for completing the achievement */
    points?: Maybe<Scalars['Int']['output']>
    /** The reward type */
    rewardType: RewardType
}

export type AchievementsMutation = {
    __typename?: 'AchievementsMutation'
    autoClaimAchievementsAdmin: Scalars['Boolean']['output']
    /** Claim achievement */
    claimAchievement: Array<AchievementProgress>
    createAchievement?: Maybe<AchievementInfo>
    createAchievementV3?: Maybe<AchievementV3Info>
    deleteAchievement: Scalars['String']['output']
    deleteAchievementV3: Scalars['String']['output']
    deleteAchievementsForAllUsers: Scalars['String']['output']
    deleteAchievementsForUser: Scalars['String']['output']
    deleteAllAchievementsForUsers: Scalars['String']['output']
    /** Sets a user flag */
    setUserFlag?: Maybe<Scalars['String']['output']>
    updateAchievement?: Maybe<AchievementInfo>
}

export type AchievementsMutationAutoClaimAchievementsAdminArgs = {
    limit: Scalars['Int']['input']
    pageSize: Scalars['Int']['input']
}

export type AchievementsMutationClaimAchievementArgs = {
    achievementId: Scalars['UUID']['input']
    levels: Array<Scalars['Int']['input']>
}

export type AchievementsMutationCreateAchievementArgs = {
    actionType: Scalars['String']['input']
    description: Scalars['String']['input']
    entityId?: InputMaybe<Scalars['UUID']['input']>
    image: Scalars['String']['input']
    title: Scalars['String']['input']
    upc: Scalars['String']['input']
}

export type AchievementsMutationCreateAchievementV3Args = {
    actionNumber: Scalars['Int']['input']
    actionType: ActionType
    description: Scalars['String']['input']
    frequency: AchievementFrequency
    name: Scalars['String']['input']
    rewardAmount: Scalars['Int']['input']
    rewardCurrency: Scalars['String']['input']
    upc: Scalars['String']['input']
}

export type AchievementsMutationDeleteAchievementArgs = {
    achievementId: Scalars['UUID']['input']
}

export type AchievementsMutationDeleteAchievementV3Args = {
    achievementId: Scalars['UUID']['input']
}

export type AchievementsMutationDeleteAchievementsForAllUsersArgs = {
    achievementIds: Array<Scalars['UUID']['input']>
}

export type AchievementsMutationDeleteAchievementsForUserArgs = {
    achievementIds: Array<Scalars['UUID']['input']>
    userId: Scalars['UUID']['input']
}

export type AchievementsMutationDeleteAllAchievementsForUsersArgs = {
    excluding: Scalars['Boolean']['input']
    userIds: Array<Scalars['UUID']['input']>
}

export type AchievementsMutationSetUserFlagArgs = {
    key: Scalars['String']['input']
    value?: InputMaybe<Scalars['String']['input']>
}

export type AchievementsMutationUpdateAchievementArgs = {
    achievementId: Scalars['UUID']['input']
    actionType: Scalars['String']['input']
    description: Scalars['String']['input']
    entityId?: InputMaybe<Scalars['UUID']['input']>
    image: Scalars['String']['input']
    title: Scalars['String']['input']
    upc: Scalars['String']['input']
}

export type AchievementsQuery = {
    __typename?: 'AchievementsQuery'
    /** Get V3 achievements info */
    achievementsV3: Array<AchievementV3Info>
    /** Get achievements V3 progress related to the user */
    achievementsV3UserProgress: Array<AchievementV3Progress>
    /** Get achievement progress related to the user */
    getAchievementsUserProgress: Array<AchievementProgress>
    /** Get v2 achievements related to the user */
    getAchievementsV2: Array<AchievementV2>
    /** Returns the value for a user flag */
    getUserFlag?: Maybe<Scalars['String']['output']>
    /** Returns all flags stored for a user */
    getUserFlags: Array<UserFlag>
}

export type AchievementsQueryGetUserFlagArgs = {
    key: Scalars['String']['input']
}

export enum ActionType {
    AssessmentCompleted = 'ASSESSMENT_COMPLETED',
    CheckIn = 'CHECK_IN',
    ContentFinished = 'CONTENT_FINISHED',
    CourseCompleted = 'COURSE_COMPLETED',
    IntentionSettingCompleted = 'INTENTION_SETTING_COMPLETED',
    JourneyLevelCompleted = 'JOURNEY_LEVEL_COMPLETED',
    PersonalResetCreated = 'PERSONAL_RESET_CREATED',
    ProfileImageAdded = 'PROFILE_IMAGE_ADDED',
    PulseSurveyCompleted = 'PULSE_SURVEY_COMPLETED',
    ReferralCompleted = 'REFERRAL_COMPLETED',
    ResetWatched = 'RESET_WATCHED',
    SocialSharingCompleted = 'SOCIAL_SHARING_COMPLETED',
    WearableConnected = 'WEARABLE_CONNECTED',
    WorkDetailsCompleted = 'WORK_DETAILS_COMPLETED'
}

export type ActiveCoachGqlModel = {
    __typename?: 'ActiveCoachGqlModel'
    firstName: Scalars['String']['output']
    imageUrl: Scalars['String']['output']
    lastName: Scalars['String']['output']
    seatType: SeatType
    thriveUserId: Scalars['UUID']['output']
}

export type ActivityDailyStats = {
    __typename?: 'ActivityDailyStats'
    /** Calendar day */
    day: Scalars['Int']['output']
    /** Calendar month */
    month: Scalars['Int']['output']
    /** Activity steps/points */
    steps: Scalars['Int']['output']
    /** Calendar year */
    year: Scalars['Int']['output']
}

export type ActivityEntry = {
    __typename?: 'ActivityEntry'
    date?: Maybe<Scalars['ISODate']['output']>
    dayOfYear?: Maybe<Scalars['Int']['output']>
    durationMins?: Maybe<Scalars['Int']['output']>
    label?: Maybe<Scalars['String']['output']>
    steps: Scalars['Int']['output']
    year?: Maybe<Scalars['Int']['output']>
}

export type ActivityEntryDto = {
    __typename?: 'ActivityEntryDTO'
    date: Scalars['ISODate']['output']
    durationMins: Scalars['Int']['output']
    id: Scalars['UUID']['output']
    label: Scalars['String']['output']
    steps: Scalars['Int']['output']
}

export type ActivityEntryInput = {
    date?: InputMaybe<Scalars['ISODate']['input']>
    dayOfYear?: InputMaybe<Scalars['Int']['input']>
    durationMins?: InputMaybe<Scalars['Int']['input']>
    label?: InputMaybe<Scalars['String']['input']>
    steps: Scalars['Int']['input']
    year?: InputMaybe<Scalars['Int']['input']>
}

export type ActivityFeatureCountQuery = {
    __typename?: 'ActivityFeatureCountQuery'
    /** Historical Challenges Count for a company */
    historicChallengesCount: HistoricChallengesCountStatsResponse
    /** Historical Microstep Checkin Count for a company */
    historicMicrostepCheckinCount: HistoricMicrostepCheckinCountResponse
}

export type ActivityFeatureCountQueryHistoricChallengesCountArgs = {
    end: MonthYearInput
    start: MonthYearInput
}

export type ActivityFeatureCountQueryHistoricMicrostepCheckinCountArgs = {
    end: MonthYearInput
    start: MonthYearInput
}

export type ActivityMutation = {
    __typename?: 'ActivityMutation'
    /** Delete activity entries by Id for a user */
    deleteManualActivityEntries: Scalars['Boolean']['output']
    /** Save an activity entry for a user */
    saveActivityEntry: ActivityEntry
    /** Save an updated Step Count from Apple Health */
    saveAppleHealthStepsActivity: Array<AppleHealthSteps>
}

export type ActivityMutationDeleteManualActivityEntriesArgs = {
    date: Scalars['ISODate']['input']
    entryIds: Array<Scalars['UUID']['input']>
}

export type ActivityMutationSaveActivityEntryArgs = {
    activityEntry: ActivityEntryInput
}

export type ActivityMutationSaveAppleHealthStepsActivityArgs = {
    stepsRecords: Array<AppleHealthStepsInput>
}

export type ActivityQuery = {
    __typename?: 'ActivityQuery'
    /** Get a list of activity entries for date */
    getActivityEntriesForDate: Array<ActivityEntryDto>
    /** Get a list of activity entries for date for a user */
    getActivityEntriesForDateForUser: Array<ActivityEntryDto>
    /** Get collection of manual activity entry options */
    getManualActivityOptions: Array<BiometricsManualActivityDto>
    /** Get a user's total step count for the given date */
    getStepCount: Scalars['Int']['output']
    /** Get a user's total step count for the given date for a user */
    getStepCountForUser: Scalars['Int']['output']
}

export type ActivityQueryGetActivityEntriesForDateArgs = {
    date: Scalars['ISODate']['input']
}

export type ActivityQueryGetActivityEntriesForDateForUserArgs = {
    date: Scalars['ISODate']['input']
    userId: Scalars['UUID']['input']
}

export type ActivityQueryGetStepCountArgs = {
    date: Scalars['ISODate']['input']
}

export type ActivityQueryGetStepCountForUserArgs = {
    date: Scalars['ISODate']['input']
    userId: Scalars['UUID']['input']
}

export type ActivityStats = {
    __typename?: 'ActivityStats'
    /** Average individual activity steps/points for the whole challenge */
    averageIndividualSteps: Scalars['Int']['output']
    /** Average team activity steps/points for the whole challenge */
    averageTeamSteps?: Maybe<Scalars['Int']['output']>
    dailyIndividualStats: Array<ActivityDailyStats>
    dailyTeamStats: Array<ActivityDailyStats>
}

export type ActivitySummaryStats = {
    averageSteps: Scalars['Float']['output']
}

export type ActivitySummaryStatsResponse = ActivitySummaryStats & {
    __typename?: 'ActivitySummaryStatsResponse'
    averageSteps: Scalars['Float']['output']
}

export type AcuteCareBanner = {
    __typename?: 'AcuteCareBanner'
    description: Scalars['String']['output']
    title: Scalars['String']['output']
}

export type AddAdoptedMicrostepError = {
    __typename?: 'AddAdoptedMicrostepError'
    type: AddAdoptedMicrostepResponseErrorType
}

export type AddAdoptedMicrostepResponse =
    | AddAdoptedMicrostepError
    | AddAdoptedMicrostepResult

export enum AddAdoptedMicrostepResponseErrorType {
    ErrorAddingAdoptedMicrostep = 'ERROR_ADDING_ADOPTED_MICROSTEP',
    MaxAdoptedMicrostepsReached = 'MAX_ADOPTED_MICROSTEPS_REACHED'
}

export type AddAdoptedMicrostepResult = {
    __typename?: 'AddAdoptedMicrostepResult'
    adoptedMicrostepId: Scalars['UUID']['output']
}

export type AdminGoalMutation = {
    __typename?: 'AdminGoalMutation'
    /**
     * Fetches or creates a microstep plan for the user passing the goal id/journey id
     * @deprecated Use fetchPersonalizedPlan query
     */
    fetchOrCreateUserPlan: UserPlanResponse
    /** Resets the intention */
    resetIntention?: Maybe<Intention>
    /** Sets an intention for the user */
    setIntention?: Maybe<Intention>
    /** Sets the subscription tier for intention, 1 is the default tier */
    setSubscriptionTier: Scalars['Int']['output']
}

export type AdminGoalMutationFetchOrCreateUserPlanArgs = {
    companyId: Scalars['UUID']['input']
    getFullHabit?: InputMaybe<Scalars['Boolean']['input']>
    goalId?: InputMaybe<Scalars['UUID']['input']>
    journeyId?: InputMaybe<Scalars['UUID']['input']>
    locale?: InputMaybe<Scalars['Locale']['input']>
    userId: Scalars['UUID']['input']
    zoneId?: InputMaybe<Scalars['String']['input']>
}

export type AdminGoalMutationResetIntentionArgs = {
    userId: Scalars['UUID']['input']
    zoneId?: InputMaybe<Scalars['String']['input']>
}

export type AdminGoalMutationSetIntentionArgs = {
    companyId?: InputMaybe<Scalars['UUID']['input']>
    intention: Scalars['String']['input']
    intentionSettingUx?: InputMaybe<IntentionSettingUxType>
    journeyIds: Array<Scalars['UUID']['input']>
    userId: Scalars['UUID']['input']
    zoneId?: InputMaybe<Scalars['String']['input']>
}

export type AdminGoalMutationSetSubscriptionTierArgs = {
    subscriptionId: Scalars['UUID']['input']
    tier: Scalars['Int']['input']
}

export type AdminGoalQuery = {
    __typename?: 'AdminGoalQuery'
    /** Returns the user's intention */
    fetchIntention?: Maybe<Intention>
    /** Returns an Intention by id */
    fetchIntentionById?: Maybe<Intention>
    /** Fetches the user plan, if the user don't have the intention flow it needs the journey id */
    fetchPersonalizedPlan: UserPlanResponse
    /** Returns recommended content for the user */
    fetchRecommendedContent: Array<RecommendedEntities>
    /** Returns the list of all user steps for the date sent */
    fetchStepsByDate: Array<Step>
    /** Returns the user subscription tier for intention, 1 if not found */
    fetchSubscriptionTier: Scalars['Int']['output']
}

export type AdminGoalQueryFetchIntentionArgs = {
    userId: Scalars['UUID']['input']
}

export type AdminGoalQueryFetchIntentionByIdArgs = {
    id: Scalars['UUID']['input']
}

export type AdminGoalQueryFetchPersonalizedPlanArgs = {
    companyId: Scalars['UUID']['input']
    journeyId?: InputMaybe<Scalars['UUID']['input']>
    locale?: InputMaybe<Scalars['Locale']['input']>
    userId: Scalars['UUID']['input']
    zoneId?: InputMaybe<Scalars['String']['input']>
}

export type AdminGoalQueryFetchRecommendedContentArgs = {
    companyId: Scalars['UUID']['input']
    limit: Scalars['Int']['input']
    locale: Scalars['Locale']['input']
    recommendedTypes: Array<PersonalizedRecommendedContent>
    userId: Scalars['UUID']['input']
    zoneId: Scalars['String']['input']
}

export type AdminGoalQueryFetchStepsByDateArgs = {
    date: Scalars['ISODate']['input']
    locale: Scalars['Locale']['input']
    userId: Scalars['UUID']['input']
}

export type AdminGoalQueryFetchSubscriptionTierArgs = {
    subscriptionId: Scalars['UUID']['input']
}

export type AdminMutation = {
    __typename?: 'AdminMutation'
    /** Pull and save the latest Benchmark Ranges from BigQuery */
    refreshBenchmarkRanges: Array<OptimalRange>
}

export type AdminThriveResetGetByIdsInput = {
    ids: Array<Scalars['UUID']['input']>
    /** UUID of the user these resets are for. This will be used to verify the user has permission to see the resets */
    thriveUserId: Scalars['UUID']['input']
}

export type AgentAnalyticsResponse = {
    __typename?: 'AgentAnalyticsResponse'
    agentId: Scalars['String']['output']
    companyId: Scalars['String']['output']
    data: Array<AgentMetricData>
    endDate: Scalars['Instant']['output']
    startDate: Scalars['Instant']['output']
}

export type AgentEngagement = {
    __typename?: 'AgentEngagement'
    agentId: Scalars['String']['output']
    interactions: Scalars['Int']['output']
    lastResetTimestamp?: Maybe<Scalars['Instant']['output']>
    name: Scalars['String']['output']
    numResetsReceived: Scalars['Int']['output']
    resetCompletionRate: Scalars['Float']['output']
}

export type AgentEngagementReport = {
    __typename?: 'AgentEngagementReport'
    agentCount: Scalars['Int']['output']
    agentEngagementNumbers: Array<AgentEngagement>
}

export type AgentGroup = {
    __typename?: 'AgentGroup'
    id: Scalars['String']['output']
    name?: Maybe<Scalars['String']['output']>
}

export type AgentLastTrigger = {
    __typename?: 'AgentLastTrigger'
    triggerConfiguration?: Maybe<TriggerConfiguration>
    triggerReason?: Maybe<TriggerReason>
}

export type AgentMetricCoordinate = {
    __typename?: 'AgentMetricCoordinate'
    /** Trigger reason: duration in seconds or number of interactions */
    trigger: Scalars['Float']['output']
    /** Time range */
    x: Scalars['String']['output']
    /** Duration in seconds */
    y: Scalars['Float']['output']
}

export type AgentMetricData = {
    __typename?: 'AgentMetricData'
    coordinates: Array<AgentMetricCoordinate>
    metric: AgentMetricType
}

export enum AgentMetricType {
    Break = 'BREAK',
    CallDurationReset = 'CALL_DURATION_RESET',
    ConsecutiveCallReset = 'CONSECUTIVE_CALL_RESET',
    CustomerInteraction = 'CUSTOMER_INTERACTION',
    ManualReset = 'MANUAL_RESET'
}

export type AgentQuery = {
    __typename?: 'AgentQuery'
    /** Terminates an agent's last reset interaction. */
    endReset: Scalars['Boolean']['output']
    /** Get agent details */
    getAgent?: Maybe<PlatformAgent>
    /** Get the trigger configuration for the agent */
    getAgentLastTrigger?: Maybe<AgentLastTrigger>
    /** Get agents that belong to the requested group */
    getGroupAgents: Array<PlatformAgent>
    /** Get agent groups for a company by group type */
    getGroups: PlatformGroup
    /** Checks if the current user is a platform admin. */
    hasAdminAccess: Scalars['Boolean']['output']
    /** Checks if the current user has view permission to Thrive admin page. */
    hasViewAccess: Scalars['Boolean']['output']
    /** Send a Thrive Reset to the requested agent. Returns conversation id of the Reset interaction created. */
    sendReset?: Maybe<Scalars['String']['output']>
    /** Request a reset to be sent to the authenticated user. */
    sendResetToSelf?: Maybe<Scalars['String']['output']>
}

export type AgentQueryEndResetArgs = {
    agentId: Scalars['String']['input']
    companyId: Scalars['UUID']['input']
    platform: PlatformType
}

export type AgentQueryGetAgentArgs = {
    agentId: Scalars['String']['input']
    companyId: Scalars['UUID']['input']
    platform: PlatformType
}

export type AgentQueryGetAgentLastTriggerArgs = {
    agentId: Scalars['String']['input']
    companyId: Scalars['UUID']['input']
    platform: PlatformType
}

export type AgentQueryGetGroupAgentsArgs = {
    companyId: Scalars['UUID']['input']
    groupIdentifier: Scalars['String']['input']
    groupType: GroupType
    platform: PlatformType
}

export type AgentQueryGetGroupsArgs = {
    companyId: Scalars['UUID']['input']
    groupType: GroupType
    platform: PlatformType
}

export type AgentQueryHasAdminAccessArgs = {
    platform: PlatformType
}

export type AgentQueryHasViewAccessArgs = {
    platform: PlatformType
}

export type AgentQuerySendResetArgs = {
    agentId: Scalars['String']['input']
    companyId: Scalars['UUID']['input']
    platform: PlatformType
}

export type AgentQuerySendResetToSelfArgs = {
    platform: PlatformType
}

export type AllAssessmentAttemptsError = {
    __typename?: 'AllAssessmentAttemptsError'
    errorCode: ErrorCode
}

export type AllAssessmentAttemptsResult =
    | AllAssessmentAttemptsError
    | AllAssessmentAttemptsSuccess

export type AllAssessmentAttemptsSuccess = {
    __typename?: 'AllAssessmentAttemptsSuccess'
    userAssessmentAttempts: Array<AssessmentAttemptSuccess>
}

export type AnalyticsResponse = {
    __typename?: 'AnalyticsResponse'
    data: Array<MetricData>
    endDate: Scalars['String']['output']
    granularity: Granularity
    reportName: Scalars['String']['output']
    startDate: Scalars['String']['output']
}

export type AppUsageTrend = {
    __typename?: 'AppUsageTrend'
    endValue: Scalars['Long']['output']
    percentDifference: Scalars['Float']['output']
    startValue: Scalars['Long']['output']
}

export type AppUsageTrends = {
    __typename?: 'AppUsageTrends'
    activeUsers: AppUsageTrend
    challengesStarted: AppUsageTrend
    checkins: AppUsageTrend
    cumlativeActiveUsers: AppUsageTrend
    learnModulesStarted: AppUsageTrend
    microstepsCheckedIn: AppUsageTrend
    resetsPlayed: AppUsageTrend
    uniqueChallengeUsers: AppUsageTrend
    uniqueCheckinUsers: AppUsageTrend
    uniqueLearnUsers: AppUsageTrend
    uniqueMicrostepUsers: AppUsageTrend
    uniqueResetUsers: AppUsageTrend
}

export type AppleHealthSleepBlocksInput = {
    appleHealthId: Scalars['UUID']['input']
    endDate: Scalars['Instant']['input']
    startDate: Scalars['Instant']['input']
    thriveUserId: Scalars['UUID']['input']
    value: Scalars['String']['input']
}

export type AppleHealthSteps = {
    __typename?: 'AppleHealthSteps'
    dayOfYear: Scalars['Int']['output']
    steps: Scalars['Int']['output']
    thriveUserId: Scalars['UUID']['output']
    year: Scalars['Int']['output']
}

export type AppleHealthStepsInput = {
    dayOfYear: Scalars['Int']['input']
    steps: Scalars['Int']['input']
    thriveUserId: Scalars['UUID']['input']
    year: Scalars['Int']['input']
}

export type ArticleAuthor = {
    __typename?: 'ArticleAuthor'
    bio: Scalars['String']['output']
    id: Scalars['ID']['output']
    name: Scalars['String']['output']
    photoUrl: Scalars['String']['output']
    title: Scalars['String']['output']
}

export type ArticleContentStatusInput = {
    /** article id */
    contentId: Scalars['String']['input']
    /** article progress in seconds (for video and audio articles) */
    progressInSeconds?: InputMaybe<Scalars['Int']['input']>
    progressType: LearnContentStatusProgressType
    subtype?: InputMaybe<LearnContentStatusSubtype>
}

export enum ArticleContentType {
    Article = 'Article',
    Audio = 'Audio',
    Text = 'Text',
    Video = 'Video'
}

export type ArticleContributorDto = {
    __typename?: 'ArticleContributorDTO'
    name: Scalars['String']['output']
}

export type ArticleDto = {
    __typename?: 'ArticleDTO'
    authors?: Maybe<Array<ArticleContributorDto>>
    body?: Maybe<Scalars['String']['output']>
    durationInSeconds: Scalars['Int']['output']
    featuredImage?: Maybe<ArticleUploadFileDto>
    isRoleModel: Scalars['Boolean']['output']
    locale?: Maybe<Scalars['String']['output']>
    subtitle?: Maybe<Scalars['String']['output']>
    title: Scalars['String']['output']
    uuid?: Maybe<Scalars['String']['output']>
}

export type ArticleDetail = {
    __typename?: 'ArticleDetail'
    article: ArticleV2
    articleInfo: ArticleV2Detail
    goalType: GoalType
}

export type ArticlePageV2 = {
    __typename?: 'ArticlePageV2'
    hasMore?: Maybe<Scalars['Boolean']['output']>
    items: Array<ArticleV2>
    page: Scalars['Int']['output']
    pageCount?: Maybe<Scalars['Int']['output']>
    pageSize: Scalars['Int']['output']
}

export type ArticleStats = {
    __typename?: 'ArticleStats'
    /** Articles list */
    articles: Array<ArticleStatsDetail>
    /** Number of articles read */
    total: Scalars['Int']['output']
}

export type ArticleStatsDetail = {
    __typename?: 'ArticleStatsDetail'
    articleDetail: ArticleDetail
    completed: Scalars['Boolean']['output']
}

export enum ArticleType {
    Article = 'Article',
    Recipe = 'Recipe',
    RoleModel = 'RoleModel',
    WatchMeThrive = 'WatchMeThrive'
}

export type ArticleUploadFileDto = {
    __typename?: 'ArticleUploadFileDTO'
    caption?: Maybe<Scalars['String']['output']>
    height?: Maybe<Scalars['Int']['output']>
    mime: Scalars['String']['output']
    name: Scalars['String']['output']
    previewUrl?: Maybe<Scalars['String']['output']>
    size: Scalars['Float']['output']
    url: Scalars['String']['output']
    width?: Maybe<Scalars['Int']['output']>
}

export type ArticleV2 = {
    __typename?: 'ArticleV2'
    articleContentType: ArticleContentType
    audioUrl?: Maybe<Scalars['String']['output']>
    authors: Array<ArticleAuthor>
    body?: Maybe<Scalars['String']['output']>
    bookmarked: Scalars['Boolean']['output']
    /** The collection name for this article. Course also has a collection field and they share the same set of collections values to choose from. This is used by Eli Lilly. */
    collection?: Maybe<Scalars['String']['output']>
    /** List of condition tags related to this article. */
    conditions: Array<Tag>
    contentStatus?: Maybe<LearnContentStatus>
    contentType: LearnContentStatusType
    createdAt: Scalars['Instant']['output']
    durationSeconds: Scalars['Int']['output']
    /** List of subscription ids for which this article is considered a featured article. */
    featuredSubscriptionIds: Array<Scalars['UUID']['output']>
    id: Scalars['ID']['output']
    imageAlternativeText?: Maybe<Scalars['String']['output']>
    imageUrl?: Maybe<Scalars['String']['output']>
    /** @deprecated No longer supported, replace with contentType */
    isRoleModelStory: Scalars['Boolean']['output']
    journeyIds: Array<Scalars['ID']['output']>
    journeys: Array<Journey>
    language?: Maybe<Scalars['String']['output']>
    likes: Likes
    relatedArticles: Array<ArticleV2>
    seoDescription?: Maybe<Scalars['String']['output']>
    seoTitle?: Maybe<Scalars['String']['output']>
    source?: Maybe<Scalars['String']['output']>
    /** List of subscription ids for which this article is considered a spotlight article. */
    spotlightSubscriptionIds: Array<Scalars['UUID']['output']>
    summary: Scalars['String']['output']
    /** List of all tags related to this article. */
    tags: Array<Tag>
    title: Scalars['String']['output']
    userJourneys: UserJourneys
}

export type ArticleV2Detail = {
    __typename?: 'ArticleV2Detail'
    articleContentType?: Maybe<Scalars['String']['output']>
    durationSeconds?: Maybe<Scalars['Int']['output']>
    id: Scalars['String']['output']
    imageUrl?: Maybe<Scalars['String']['output']>
    summary?: Maybe<Scalars['String']['output']>
    title?: Maybe<Scalars['String']['output']>
}

export type AspectRatioUrls = {
    __typename?: 'AspectRatioUrls'
    landscape?: Maybe<Scalars['Url']['output']>
    portrait?: Maybe<Scalars['Url']['output']>
}

export type AssessmentAdminMutation = {
    __typename?: 'AssessmentAdminMutation'
    skipAssessment: AssessmentAttemptResult
    submitResponse: AssessmentAttemptResult
}

export type AssessmentAdminMutationSkipAssessmentArgs = {
    input: SkipAssessmentInput
    userId: Scalars['UUID']['input']
}

export type AssessmentAdminMutationSubmitResponseArgs = {
    input: SubmitResponseInput
    userId: Scalars['UUID']['input']
}

export type AssessmentAdminQuery = {
    __typename?: 'AssessmentAdminQuery'
    getInProgressOrCreateNewAttempt: AssessmentAttemptResult
    getRecommendedJourneys: RecommendedJourneysResult
    tryGetLatestAttempt: AssessmentAttemptResult
}

export type AssessmentAdminQueryGetInProgressOrCreateNewAttemptArgs = {
    input: GetAssessmentByNameAndVariantInput
    subscriptionId: Scalars['UUID']['input']
    userId: Scalars['UUID']['input']
}

export type AssessmentAdminQueryGetRecommendedJourneysArgs = {
    input: GetRecommendedJourneysByAssessmentInput
    subscriptionId: Scalars['UUID']['input']
    userId: Scalars['UUID']['input']
}

export type AssessmentAdminQueryTryGetLatestAttemptArgs = {
    input: GetAssessmentByNameAndVariantInput
    subscriptionId: Scalars['UUID']['input']
    userId: Scalars['UUID']['input']
}

export type AssessmentAttemptError = {
    __typename?: 'AssessmentAttemptError'
    errorCode: ErrorCode
}

export type AssessmentAttemptResult =
    | AssessmentAttemptError
    | AssessmentAttemptSuccess

export type AssessmentAttemptSuccess = {
    __typename?: 'AssessmentAttemptSuccess'
    allQuestions: Array<AssessmentItem>
    assessmentAttemptId: Scalars['UUID']['output']
    assessmentId: Scalars['UUID']['output']
    createdAt: Scalars['Instant']['output']
    givenResponses: Array<GivenResponse>
    locale: Scalars['Locale']['output']
    name: Scalars['String']['output']
    status: AssessmentStatus
    superlative?: Maybe<SuperlativeWithScore>
    type: AssessmentType
    updatedAt: Scalars['Instant']['output']
    userId: Scalars['UUID']['output']
    variant: Scalars['String']['output']
}

export type AssessmentError = {
    __typename?: 'AssessmentError'
    errorCode: ErrorCode
}

export type AssessmentItem = {
    __typename?: 'AssessmentItem'
    id: Scalars['UUID']['output']
    journey?: Maybe<AssessmentJourney>
    pillar: AssessmentPillar
    questionText: Scalars['String']['output']
    responses: Array<ResponseOptionCms>
}

export type AssessmentJourney = {
    __typename?: 'AssessmentJourney'
    coreType: JourneyCoreType
    uuid: Scalars['UUID']['output']
}

export type AssessmentMutation = {
    __typename?: 'AssessmentMutation'
    admin: AssessmentAdminMutation
    getOrCreateBaselineAssessmentAttempt: AssessmentAttemptResult
    getOrCreateNewProgressAssessmentAttempt: AssessmentAttemptResult
    skipAssessment: AssessmentAttemptResult
    submitResponse: AssessmentAttemptResult
}

export type AssessmentMutationSkipAssessmentArgs = {
    input: SkipAssessmentInput
}

export type AssessmentMutationSubmitResponseArgs = {
    input: SubmitResponseInput
}

export enum AssessmentPillar {
    Emotional = 'EMOTIONAL',
    MeaningAndPurpose = 'MEANING_AND_PURPOSE',
    Mental = 'MENTAL',
    Physical = 'PHYSICAL',
    Social = 'SOCIAL',
    Unknown = 'UNKNOWN'
}

export type AssessmentQuery = {
    __typename?: 'AssessmentQuery'
    admin: AssessmentAdminQuery
    getAllAssessmentAttempts: AllAssessmentAttemptsResult
    getAssessment: AssessmentResult
    getInProgressOrCreateNewAttempt: AssessmentAttemptResult
    getRecommendedJourneys: RecommendedJourneysResult
    tryGetLatestAttempt: AssessmentAttemptResult
}

export type AssessmentQueryGetAllAssessmentAttemptsArgs = {
    input: GetAssessmentByNameAndVariantInput
}

export type AssessmentQueryGetAssessmentArgs = {
    input: GetAssessmentByNameAndVariantInput
}

export type AssessmentQueryGetInProgressOrCreateNewAttemptArgs = {
    input: GetAssessmentByNameAndVariantInput
}

export type AssessmentQueryGetRecommendedJourneysArgs = {
    input: GetRecommendedJourneysByAssessmentInput
}

export type AssessmentQueryTryGetLatestAttemptArgs = {
    input: GetAssessmentByNameAndVariantInput
}

export type AssessmentResult = AssessmentError | AssessmentSuccess

export type AssessmentStats = {
    average: Scalars['Float']['output']
    survey?: Maybe<Surveys>
    totalNumberOfResponses: Scalars['Int']['output']
    valuePercentage: Scalars['Int']['output']
}

export enum AssessmentStatus {
    Completed = 'completed',
    Expired = 'expired',
    InProgress = 'in_progress',
    Skipped = 'skipped'
}

export type AssessmentSuccess = {
    __typename?: 'AssessmentSuccess'
    allQuestions: Array<AssessmentItem>
    assessmentId: Scalars['UUID']['output']
    locale: Scalars['Locale']['output']
    name: Scalars['String']['output']
    variant: Scalars['String']['output']
}

export enum AssessmentType {
    BaselineAssessment = 'BASELINE_ASSESSMENT',
    ProgressAssessment = 'PROGRESS_ASSESSMENT',
    UncategorizedAssessment = 'UNCATEGORIZED_ASSESSMENT'
}

export type AssetQuery = {
    __typename?: 'AssetQuery'
    /** Get an In App Message for a users subscription */
    getInAppMessage: Array<InAppMessageDto>
    /** Hello World Query */
    helloWorldQuery: Scalars['String']['output']
}

export type Audio = {
    __typename?: 'Audio'
    author: Scalars['String']['output']
    createdAt: Scalars['Instant']['output']
    /** @deprecated this field is deprecated, replace with durationInSeconds */
    duration: Scalars['Int']['output']
    durationInSeconds: Scalars['Int']['output']
    id: Scalars['UUID']['output']
    order?: Maybe<Scalars['Int']['output']>
    provider?: Maybe<AudioProvider>
    thumbnailUrl?: Maybe<Scalars['String']['output']>
    title: Scalars['String']['output']
    updatedAt: Scalars['Instant']['output']
    url: Scalars['String']['output']
}

export type AudioBookChapter = {
    __typename?: 'AudioBookChapter'
    number: Scalars['Int']['output']
    /** Collection of audiobook chapter parts (audio file urls) */
    parts: Array<AudioBookChapterPart>
    /** Audio book chapter progress for user, based on userId from context. Checks progress on audio book chapter parts. */
    progress?: Maybe<LearnContentProgress>
    title?: Maybe<Scalars['String']['output']>
}

export type AudioBookChapterPart = {
    __typename?: 'AudioBookChapterPart'
    /** Url to the audio file */
    audioUrl: Scalars['String']['output']
    /** UUID of parent book */
    bookId?: Maybe<Scalars['UUID']['output']>
    /** Number of parent chapter */
    chapterNumber?: Maybe<Scalars['Int']['output']>
    contentStatus?: Maybe<LearnContentStatus>
    contentType: LearnContentStatusType
    /** Duration in seconds of the audio file */
    durationSeconds: Scalars['Int']['output']
    id: Scalars['UUID']['output']
    /** Audiobook chapter part number */
    number: Scalars['Int']['output']
}

/** Progress input for Podcast Episode */
export type AudioBookChapterPartContentStatusInput = {
    /** audiobook chapter part id */
    contentId: Scalars['String']['input']
    /** progress in seconds */
    progressInSeconds: Scalars['Int']['input']
    progressType: LearnContentStatusProgressType
    /** total duration of in seconds */
    totalInSeconds: Scalars['Int']['input']
}

export type AudioBookMutation = {
    __typename?: 'AudioBookMutation'
    /** Mutation creating or updating audio book chapter part status, based on userId from context */
    updateAudioBookChapterPartStatus: LearnContentStatus
}

export type AudioBookMutationUpdateAudioBookChapterPartStatusArgs = {
    input: AudioBookChapterPartContentStatusInput
}

export type AudioChapterPartParent = {
    __typename?: 'AudioChapterPartParent'
    bookID: Scalars['UUID']['output']
    chapterNumber: Scalars['Int']['output']
    chapterPartNumber: Scalars['Int']['output']
}

export enum AudioProvider {
    Thrive = 'THRIVE',
    Umg = 'UMG'
}

export type AudioQuery = {
    __typename?: 'AudioQuery'
    thrive: ThriveAudioQuery
}

export type AudioResetDetail = {
    __typename?: 'AudioResetDetail'
    description?: Maybe<Scalars['String']['output']>
    id: Scalars['UUID']['output']
    name?: Maybe<Scalars['String']['output']>
    url?: Maybe<Scalars['String']['output']>
}

export type AudioResetGoalDetail = {
    __typename?: 'AudioResetGoalDetail'
    audioReset: ThriveResetAudio
    audioResetInfo: AudioResetDetail
}

export type AudioResetStatsDetail = {
    __typename?: 'AudioResetStatsDetail'
    audioResetDetail: AudioResetGoalDetail
    completed: Scalars['Boolean']['output']
}

export enum AvailabilityInterval {
    Afternoon = 'AFTERNOON',
    EarlyMorning = 'EARLY_MORNING',
    Evening = 'EVENING',
    LateEvening = 'LATE_EVENING',
    Morning = 'MORNING'
}

export type BalanceInfo = {
    __typename?: 'BalanceInfo'
    /** The balance amount */
    amount: Scalars['Int']['output']
    /** The currency code */
    currencyCode: Scalars['String']['output']
}

export type BannerQuery = {
    __typename?: 'BannerQuery'
    thrive: ThriveBannerQuery
}

export type BehavioralProfileError = {
    __typename?: 'BehavioralProfileError'
    errorCode: BehavioralProfileErrorCode
}

export enum BehavioralProfileErrorCode {
    NoAssessmentsCompleted = 'NO_ASSESSMENTS_COMPLETED',
    UnknownError = 'UNKNOWN_ERROR'
}

export type BehavioralProfileQuery = {
    __typename?: 'BehavioralProfileQuery'
    getBehavioralProfile: BehavioralProfileResult
}

export type BehavioralProfileQueryGetBehavioralProfileArgs = {
    input: GetBehavioralProfileInput
}

export type BehavioralProfileResult =
    | BehavioralProfileError
    | BehavioralProfileSuccess

export type BehavioralProfileSuccess = {
    __typename?: 'BehavioralProfileSuccess'
    baselineAssessmentCount: Scalars['Int']['output']
    coreHealthBehaviors: Array<CoreHealthBehaviorScore>
    lastUpdatedAt: Scalars['Instant']['output']
    progressAssessmentCount: Scalars['Int']['output']
}

export type BenefitsConnectDetails = {
    __typename?: 'BenefitsConnectDetails'
    benefitGroupsForLocaleAndSubscription: Array<MiniBenny>
    benefitGroupsForLocaleAndSubscriptionAndCountryCode: Array<MiniBenny>
    benefitsConnectForQuestion?: Maybe<MiniBenny>
    companyUUID: Scalars['UUID']['output']
    countryCodeUsed: Scalars['String']['output']
    dciResponse?: Maybe<SurveyResponse>
    subscriptionUUID: Scalars['UUID']['output']
    triggeredBenefitsConnect?: Maybe<MiniBenny>
    userCountryCode?: Maybe<Scalars['String']['output']>
    userUUID: Scalars['UUID']['output']
}

export type BigRedButtonRespose = {
    __typename?: 'BigRedButtonRespose'
    affectedCompanyIds: Array<Maybe<Scalars['UUID']['output']>>
    wasDestructive: Scalars['Boolean']['output']
}

export type BiometricsManualActivityDto = {
    __typename?: 'BiometricsManualActivityDTO'
    activityDescription: Scalars['String']['output']
    isCoreStep: Scalars['Boolean']['output']
    stepsPerMin: Scalars['Int']['output']
    uuid: Scalars['String']['output']
}

export type BlurbV2 = {
    __typename?: 'BlurbV2'
    description: Scalars['String']['output']
}

export type Book = {
    __typename?: 'Book'
    /** Collection of audiobook chapters */
    audioChapters: Array<AudioBookChapter>
    /** Collection of authors */
    authors: Array<ArticleAuthor>
    id: Scalars['ID']['output']
    imageUrl: Scalars['String']['output']
    /** Url to the pdf resource file of the book */
    resourceUrl?: Maybe<Scalars['String']['output']>
    subtitle: Scalars['String']['output']
    title: Scalars['String']['output']
    uuid: Scalars['UUID']['output']
}

export type BookMutation = {
    __typename?: 'BookMutation'
    audio: AudioBookMutation
}

export type BookPage = {
    __typename?: 'BookPage'
    hasMore?: Maybe<Scalars['Boolean']['output']>
    items: Array<Book>
    page: Scalars['Int']['output']
    pageCount?: Maybe<Scalars['Int']['output']>
    pageSize: Scalars['Int']['output']
}

export type BookQuery = {
    __typename?: 'BookQuery'
    /** Get book */
    getBook?: Maybe<Book>
    /** Get books */
    getBooks: BookPage
}

export type BookQueryGetBookArgs = {
    bookId: Scalars['UUID']['input']
}

export type BookQueryGetBooksArgs = {
    page?: InputMaybe<Scalars['Int']['input']>
    pageSize?: InputMaybe<Scalars['Int']['input']>
}

export type BookmarkMutation = {
    __typename?: 'BookmarkMutation'
    create: Scalars['Boolean']['output']
    delete: Scalars['Boolean']['output']
}

export type BookmarkMutationCreateArgs = {
    id: Scalars['UUID']['input']
}

export type BookmarkMutationDeleteArgs = {
    id: Scalars['UUID']['input']
}

export type BookmarkQuery = {
    __typename?: 'BookmarkQuery'
    bookmarked: BookmarkedContentPage
    isBookmarked: Scalars['Boolean']['output']
}

export type BookmarkQueryBookmarkedArgs = {
    page?: InputMaybe<Scalars['Int']['input']>
    pageSize?: InputMaybe<Scalars['Int']['input']>
}

export type BookmarkQueryIsBookmarkedArgs = {
    id: Scalars['UUID']['input']
}

export type BookmarkedContent = ThriveReset | ThriveResetAudio

export type BookmarkedContentPage = {
    __typename?: 'BookmarkedContentPage'
    items: Array<BookmarkedContent>
    page: Scalars['Int']['output']
    pageSize: Scalars['Int']['output']
    total: Scalars['Int']['output']
}

export type BotUserId = {
    __typename?: 'BotUserId'
    slackUserId: Scalars['String']['output']
}

export type Brand = {
    __typename?: 'Brand'
    companyId: Scalars['UUID']['output']
    createdAt: Scalars['Instant']['output']
    imageUrl?: Maybe<Scalars['String']['output']>
    isPublic: Scalars['Boolean']['output']
    name: Scalars['String']['output']
    updatedAt: Scalars['Instant']['output']
}

export type BrandInput = {
    imageUrl?: InputMaybe<Scalars['String']['input']>
    isPublic?: InputMaybe<Scalars['Boolean']['input']>
    name: Scalars['String']['input']
}

export type BrandInputGraphQlInput = {
    companyId: Scalars['UUID']['input']
    imageUrl?: InputMaybe<Scalars['String']['input']>
    isPublic: Scalars['Boolean']['input']
    name: Scalars['String']['input']
}

export type BrandPage = {
    __typename?: 'BrandPage'
    items: Array<Brand>
    itemsPerPage: Scalars['Int']['output']
    page: Scalars['Int']['output']
    total: Scalars['Int']['output']
}

export type BulkDailyCheckInRequestInput = {
    /** The Daily Check-In request date */
    requestDate: Scalars['ISODate']['input']
    /** The channel requesting the Daily Check-In */
    requestingChannel: Channel
    /** The user options for the requested Daily Check-Ins */
    userConfigs: Array<UserConfigInput>
}

export type CallToAction = {
    __typename?: 'CallToAction'
    args: Array<Scalars['String']['output']>
    title: Scalars['String']['output']
    type: CallToActionType
}

export enum CallToActionType {
    CreatePersonalizedReset = 'CreatePersonalizedReset',
    PlayThriveReset = 'PlayThriveReset',
    Redirect = 'Redirect',
    ScheduleResetPlayback = 'ScheduleResetPlayback'
}

export type CallsCommand = {
    companyId: Scalars['UUID']['output']
    date: Scalars['Instant']['output']
    platformType: PlatformType
    type: CallsCommandType
    userId: Scalars['String']['output']
}

export enum CallsCommandType {
    TriggerReset = 'TRIGGER_RESET'
}

export type CallsMutation = {
    __typename?: 'CallsMutation'
    company: CompanyMutation
    /** Mutations for creating structure needed to install new companies */
    install: InstallationMutation
    trigger: TriggerMutation
}

export type CallsQuery = {
    __typename?: 'CallsQuery'
    agent: AgentQuery
    company: CompanyQuery
    connect: ConnectQuery
    inject: InjectQuery
    reporting: ReportingQuery
    trigger: TriggerQuery
}

export type CentralizedNotificationsMutation = {
    __typename?: 'CentralizedNotificationsMutation'
    /** Mutation root for nudge mutations */
    nudge: CnsNudgeMutation
    /** Mutation to update the nudge status for the user and type; SOFT-DEPRECATED: use nudge->selfNudgeStatus */
    nudgeStatus: UserNudgeStatusUpsertResponse
    /** Mutation root for nudge triggers for the current user */
    selfTrigger: CnsSelfTriggerMutation
    /** Mutation root for nudge triggers */
    trigger: CnsTriggerMutation
}

export type CentralizedNotificationsMutationNudgeStatusArgs = {
    input: NudgeStatusUpdateInput
}

export type CentralizedNotificationsQuery = {
    __typename?: 'CentralizedNotificationsQuery'
    /** Query root for nudge queries */
    nudge: CnsNudgeQuery
    /** Get the status (enabled/disabled) of all nudges for the current user.  SOFT-DEPRECATED: use nudge->selfNudgeStatus instead. */
    nudgeStatus: UserNudgeStatusFetchResponse
    /** Get any pending nudges for the current user.  SOFT-DEPRECATED: use nudge->selfNudgeStatus instead. */
    pendingNudges: UserPendingNudgesFetchResponse
}

export type CentralizedNotificationsQueryPendingNudgesArgs = {
    input?: InputMaybe<PendingNudgesInput>
}

export type ChallengeCustomization = {
    __typename?: 'ChallengeCustomization'
    challengeId: Scalars['UUID']['output']
    stepsAmount?: Maybe<Scalars['Int']['output']>
    userId: Scalars['UUID']['output']
    waterAmount?: Maybe<Scalars['Int']['output']>
}

export type ChallengeCustomizationOperationResult =
    | ChallengeCustomizationResult
    | ErrorMessageCustomization

export type ChallengeCustomizationResult = {
    __typename?: 'ChallengeCustomizationResult'
    challengeCustomization: ChallengeCustomization
}

export type ChallengeGoal = {
    __typename?: 'ChallengeGoal'
    /** The id of the entity related with the alternative goal */
    altGoalEntityId?: Maybe<Scalars['UUID']['output']>
    /** The title of the alternative goal entity */
    altGoalEntityTitle?: Maybe<Scalars['String']['output']>
    /** Alternative goal type */
    altGoalType?: Maybe<Scalars['String']['output']>
    /** The id of the challenge */
    challengeId: Scalars['UUID']['output']
    createdAt?: Maybe<Scalars['Instant']['output']>
    /** The day of the goal */
    day: Scalars['Int']['output']
    /** The id of the challenge goal entity */
    goalEntityId?: Maybe<Scalars['UUID']['output']>
    /** The title of the goal entity */
    goalEntityTitle?: Maybe<Scalars['String']['output']>
    /** Number of steps for GoalType.STEPS */
    goalSteps?: Maybe<Scalars['Int']['output']>
    /** The goal type */
    goalType?: Maybe<Scalars['String']['output']>
    /** Number of water intake for GoalType.WATER */
    goalWater?: Maybe<Scalars['Int']['output']>
    /** The id of this challenge goal */
    id: Scalars['UUID']['output']
    /** Ordering of the goal */
    position?: Maybe<Scalars['Int']['output']>
    updatedAt?: Maybe<Scalars['Instant']['output']>
    /** The url in case of EXTERNAL_LINK goal type */
    url?: Maybe<Scalars['String']['output']>
}

export type ChallengeGoalCreateInput = {
    /** The id of the entity related with the alternative goal */
    altGoalEntityId?: InputMaybe<Scalars['UUID']['input']>
    /** Alternative goal type */
    altGoalType?: InputMaybe<Scalars['String']['input']>
    /** The id of the challenge */
    challengeId: Scalars['UUID']['input']
    /** Day this goal belongs during the challenge */
    day: Scalars['Int']['input']
    /** The id of the entity related with the goal */
    goalEntityId?: InputMaybe<Scalars['UUID']['input']>
    /** Number of steps for GoalType.STEPS */
    goalSteps?: InputMaybe<Scalars['Int']['input']>
    /** Goal type */
    goalType: Scalars['String']['input']
    /** Number of water intake for GoalType.WATER */
    goalWater?: InputMaybe<Scalars['Int']['input']>
    /** Ordering during the day */
    position?: InputMaybe<Scalars['Int']['input']>
    /** The url in case of EXTERNAL_LINK goal type */
    url?: InputMaybe<Scalars['String']['input']>
}

export type ChallengeStats = {
    __typename?: 'ChallengeStats'
    activityStats: ActivityStats
    articleStats: ArticleStats
    feelingQuestionStats: FeelingQuestionStats
    microstepStats: MicrostepStats
    resetStats: ResetStats
    waterStats: WaterStats
}

export type ChallengeSubscriptionsInfo = {
    __typename?: 'ChallengeSubscriptionsInfo'
    challengeId: Scalars['UUID']['output']
    companyId: Scalars['UUID']['output']
    companyName: Scalars['String']['output']
    enabled: Scalars['Boolean']['output']
    id: Scalars['UUID']['output']
    subscriptionId?: Maybe<Scalars['UUID']['output']>
}

export type ChallengeTeamDailyGoal = {
    __typename?: 'ChallengeTeamDailyGoal'
    /** The external entity detail */
    userDailyGoals: Array<ChallengeUserDailyGoal>
    /** The user's display name */
    userDisplayName: Scalars['String']['output']
}

export type ChallengeTemplate = {
    __typename?: 'ChallengeTemplate'
    /** Indicates if this template allows customers to override step goals */
    allowCustomSteps: Scalars['Boolean']['output']
    /** The background image */
    backgroundImage?: Maybe<Scalars['String']['output']>
    /** The biotype of the challenge */
    biotype?: Maybe<TemplateBiotype>
    /** Category */
    category?: Maybe<UnifiedJourney>
    /** Description of the template */
    description?: Maybe<Scalars['String']['output']>
    /** Identifies if challenge supports wearables functionality  */
    deviceEnabled: Scalars['Boolean']['output']
    /** Duration of the challenge */
    duration: Scalars['Int']['output']
    /** Goal of the challenge */
    goal?: Maybe<Scalars['String']['output']>
    /** Header image */
    header?: Maybe<Scalars['String']['output']>
    /** The id of this template */
    id: Scalars['UUID']['output']
    /** Indicates is this a featured template */
    isFeatured: Scalars['Boolean']['output']
    /** List of Journeys associated to this template */
    journeys?: Maybe<Array<TemplateJourney>>
    /** Name of the template */
    name: Scalars['String']['output']
    /** Custom  order position set for the challenge */
    position: Scalars['Int']['output']
    /** The description for promo 1 field */
    promoDescription1?: Maybe<Scalars['String']['output']>
    /** The description for promo 2 field */
    promoDescription2?: Maybe<Scalars['String']['output']>
    /** The description for promo 3 field */
    promoDescription3?: Maybe<Scalars['String']['output']>
    /** The header for promo 1 field */
    promoHeader1?: Maybe<Scalars['String']['output']>
    /** The header for promo 2 field */
    promoHeader2?: Maybe<Scalars['String']['output']>
    /** The header for promo 3 field */
    promoHeader3?: Maybe<Scalars['String']['output']>
    /** The image for promo 1 field */
    promoImage1?: Maybe<Scalars['String']['output']>
    /** The image for promo 2 field */
    promoImage2?: Maybe<Scalars['String']['output']>
    /** The image for promo 3 field */
    promoImage3?: Maybe<Scalars['String']['output']>
    /** List of Quotes associated to this template */
    quotes?: Maybe<Array<TemplateQuote>>
    /** Indicates the scope of this template: COMPANY, GROUP... */
    templateScope: Scalars['String']['output']
    /** The company challenge theme */
    theme?: Maybe<Scalars['String']['output']>
    /** Thumbnail */
    thumbnail?: Maybe<Scalars['String']['output']>
    /** The image for the community challenge trophy plant */
    trophyPlantImage?: Maybe<Scalars['String']['output']>
}

export type ChallengeTemplateCreateInput = {
    /** The id of the challenge template */
    challengeTemplateId?: InputMaybe<Scalars['UUID']['input']>
    /** The company id to which the challenge is assigned */
    companyId?: InputMaybe<Scalars['UUID']['input']>
    /** Enabled flag for the challenge */
    enabled?: InputMaybe<Scalars['Boolean']['input']>
    /** Indicates if the challenge is featured */
    isFeatured?: InputMaybe<Scalars['Boolean']['input']>
    /** Indicates if team members are unlimited */
    isUnlimited?: InputMaybe<Scalars['Boolean']['input']>
    /** Indicates the maximum number of members allowed in teams */
    maxTeamSize?: InputMaybe<Scalars['Int']['input']>
    /** Optional prefix to be displayed before the challenge's name */
    namePrefix?: InputMaybe<Scalars['String']['input']>
    /** The signup date of the challenge */
    signupDate?: InputMaybe<Scalars['ISODate']['input']>
    /** The start date of the challenge */
    startDate?: InputMaybe<Scalars['ISODate']['input']>
    /** The subscription id to which the challenge is assigned */
    subscriptionId?: InputMaybe<Scalars['UUID']['input']>
    /** Trophy plant image url */
    trophyPlantImgUrl?: InputMaybe<Scalars['String']['input']>
}

export type ChallengeTemplateGoal = {
    __typename?: 'ChallengeTemplateGoal'
    /** The id of the entity related with the alternative goal */
    altGoalEntityId?: Maybe<Scalars['UUID']['output']>
    /** The title of the alternative goal entity */
    altGoalEntityTitle?: Maybe<Scalars['String']['output']>
    /** Alternative goal type */
    altGoalType?: Maybe<Scalars['String']['output']>
    /** The id of the challenge template */
    challengeTemplateId: Scalars['UUID']['output']
    /** The day of the goal */
    day: Scalars['Int']['output']
    /** The id of the challenge goal entity */
    goalEntityId?: Maybe<Scalars['UUID']['output']>
    /** The title of the challenge goal entity */
    goalEntityTitle?: Maybe<Scalars['String']['output']>
    /** Number of steps for GoalType.STEPS */
    goalSteps?: Maybe<Scalars['Int']['output']>
    /** The goal type */
    goalType?: Maybe<Scalars['String']['output']>
    /** Number of water intake for GoalType.WATER */
    goalWater?: Maybe<Scalars['Int']['output']>
    /** Ordering of the goal */
    position?: Maybe<Scalars['Int']['output']>
    /** The url in case of EXTERNAL_LINK goal type */
    url?: Maybe<Scalars['String']['output']>
}

export type ChallengeTemplateInstance = {
    __typename?: 'ChallengeTemplateInstance'
    /** The challenge company relation */
    challengeCompanyRelation: UnifiedChallengeCompany
    /** The challenge goals */
    challengeGoals: Array<ChallengeGoal>
    /** The challenge */
    challengeInstance: UnifiedChallenge
    /** The challenge template */
    challengeTemplate?: Maybe<ChallengeTemplate>
}

export enum ChallengeTimePoint {
    End = 'END',
    Start = 'START'
}

export type ChallengeUserDailyGoal = {
    __typename?: 'ChallengeUserDailyGoal'
    /** The challenge goal info */
    challengeGoal: ChallengeGoal
    /** True if the user has completed this daily goal */
    completed: Scalars['Boolean']['output']
    /** The external entity detail */
    goalEntityDetail: GoalEntityDetail
}

export enum Channel {
    MobileAndroid = 'MOBILE_ANDROID',
    MobileIos = 'MOBILE_IOS',
    MobileNotification = 'MOBILE_NOTIFICATION',
    MsTeams = 'MS_TEAMS',
    Slack = 'SLACK',
    Web = 'WEB',
    Webex = 'WEBEX'
}

export type CheckInResponseDetailsDto = {
    __typename?: 'CheckInResponseDetailsDTO'
    pulseUserId: Scalars['UUID']['output']
    /** @deprecated Use selectedOption and responseChannel in root of object */
    response: DailyCheckInResponseDto
    responseChannel: Scalars['String']['output']
    responseDate: Scalars['ISODate']['output']
    selectedOption: OptionsDto
    survey: PulseSurveyQuestionDto
    thriveId?: Maybe<Scalars['UUID']['output']>
}

export type CheckInResponseDetailsPage = {
    __typename?: 'CheckInResponseDetailsPage'
    content: Array<CheckInResponseDetailsDto>
    page: Scalars['Long']['output']
    totalElements: Scalars['Long']['output']
    totalPages: Scalars['Long']['output']
}

export type CheckinCount = {
    __typename?: 'CheckinCount'
    count: Scalars['Int']['output']
    date: Scalars['Instant']['output']
}

export type ClaimGardenItemError = {
    __typename?: 'ClaimGardenItemError'
    error: ClaimGardenItemErrorType
    message: Scalars['String']['output']
}

export enum ClaimGardenItemErrorType {
    CannotStoreItem = 'CANNOT_STORE_ITEM',
    InvalidProduct = 'INVALID_PRODUCT',
    InvalidRewardType = 'INVALID_REWARD_TYPE',
    LevelRewardNotFound = 'LEVEL_REWARD_NOT_FOUND',
    ProductNotFound = 'PRODUCT_NOT_FOUND',
    ProductNotInGardenItemSet = 'PRODUCT_NOT_IN_GARDEN_ITEM_SET',
    RewardAlreadyClaimed = 'REWARD_ALREADY_CLAIMED'
}

export type ClaimGardenItemResult = {
    __typename?: 'ClaimGardenItemResult'
    userLevelReward: UserLevelReward
}

export type ClaimGardenItemRewardResponse =
    | ClaimGardenItemError
    | ClaimGardenItemResult

export enum CmsContentType {
    CmsArticle = 'CMS_ARTICLE',
    CmsBook = 'CMS_BOOK',
    CmsChallenge = 'CMS_CHALLENGE',
    CmsCompanySubscription = 'CMS_COMPANY_SUBSCRIPTION',
    CmsCourse = 'CMS_COURSE',
    CmsCourseLesson = 'CMS_COURSE_LESSON',
    CmsCourseModule = 'CMS_COURSE_MODULE',
    CmsJourney = 'CMS_JOURNEY',
    CmsMicrostep = 'CMS_MICROSTEP',
    CmsPodcast = 'CMS_PODCAST',
    CmsPodcastEpisode = 'CMS_PODCAST_EPISODE',
    CmsPodcastSeason = 'CMS_PODCAST_SEASON',
    CmsReset = 'CMS_RESET',
    CmsResetAudio = 'CMS_RESET_AUDIO',
    CmsResetStockAudio = 'CMS_RESET_STOCK_AUDIO'
}

export type CnsAsyncTriggerEventLaunchFailed = {
    __typename?: 'CnsAsyncTriggerEventLaunchFailed'
    error: Scalars['String']['output']
}

export type CnsAsyncTriggerEventLaunched = {
    __typename?: 'CnsAsyncTriggerEventLaunched'
    launched: Scalars['Boolean']['output']
}

export type CnsAsyncTriggerEventLaunchedResponse =
    | CnsAsyncTriggerEventLaunchFailed
    | CnsAsyncTriggerEventLaunched

export type CnsBatchTriggerEventFailure = {
    __typename?: 'CnsBatchTriggerEventFailure'
    error: Scalars['String']['output']
}

export type CnsBatchTriggerEventResponse =
    | CnsBatchTriggerEventFailure
    | CnsBatchTriggerEventSuccess

export type CnsBatchTriggerEventSuccess = {
    __typename?: 'CnsBatchTriggerEventSuccess'
    successes: Array<UserNudgesSentResult>
}

export type CnsLargeBatchTriggerEventAttempted = {
    __typename?: 'CnsLargeBatchTriggerEventAttempted'
    failuresCount: Scalars['Int']['output']
    successfulUserIdsCount: Scalars['Int']['output']
}

export type CnsLargeBatchTriggerEventResponse =
    | CnsLargeBatchTriggerEventAttempted
    | CnsLargeBatchTriggerEventTotalFailure

export type CnsLargeBatchTriggerEventTotalFailure = {
    __typename?: 'CnsLargeBatchTriggerEventTotalFailure'
    error: Scalars['String']['output']
}

export type CnsNudgeMutation = {
    __typename?: 'CnsNudgeMutation'
    /** Mutation to update the nudge sentAt timestamp for matching nudges (identified by the user IDs, nudge type, send date, and send time).  If nudges do not exist for any users, they won't be returned in the response. */
    nudgeSentAtForUsers: UpdateNudgeSentAtResponse
    /** Mutation to update the nudge status for the user and type */
    nudgeStatusForUser: UserNudgeStatusUpsertResponse
    /** Mutation to update the nudge sentAt timestamp for the user's nudge (identified by the nudge type, send date, and send time).  If no nudge matches, a successful response with no nudges will be returned. */
    selfNudgeSentAt: UpdateNudgeSentAtResponse
    /** Mutation to update the nudge status for the user and type */
    selfNudgeStatus: UserNudgeStatusUpsertResponse
}

export type CnsNudgeMutationNudgeSentAtForUsersArgs = {
    input: NudgeSentAtUpdateInput
    userIds: Array<Scalars['UUID']['input']>
}

export type CnsNudgeMutationNudgeStatusForUserArgs = {
    input: NudgeStatusUpdateInput
    userId: Scalars['UUID']['input']
}

export type CnsNudgeMutationSelfNudgeSentAtArgs = {
    input: NudgeSentAtUpdateInput
}

export type CnsNudgeMutationSelfNudgeStatusArgs = {
    input: NudgeStatusUpdateInput
}

export type CnsNudgeQuery = {
    __typename?: 'CnsNudgeQuery'
    /** Get the status (enabled/disabled) of all nudges for the given user. */
    nudgeStatusForUser: UserNudgeStatusFetchResponse
    /** Get any pending nudges for the given user. */
    pendingNudgesForUser: UserPendingNudgesFetchResponse
    /** Get the status (enabled/disabled) of all nudges for the current user. */
    selfNudgeStatus: UserNudgeStatusFetchResponse
    /** Get any pending nudges for the current user. */
    selfPendingNudges: UserPendingNudgesFetchResponse
}

export type CnsNudgeQueryNudgeStatusForUserArgs = {
    userId: Scalars['UUID']['input']
}

export type CnsNudgeQueryPendingNudgesForUserArgs = {
    input?: InputMaybe<PendingNudgesInput>
    userId: Scalars['UUID']['input']
}

export type CnsNudgeQuerySelfPendingNudgesArgs = {
    input?: InputMaybe<PendingNudgesInput>
}

export type CnsSelfTriggerMutation = {
    __typename?: 'CnsSelfTriggerMutation'
    /** Triggers an immediate test nudge event for the user from the auth token (does not validate Thrive User ID) */
    selfTestEvent: CnsTriggerEventResponse
}

export type CnsSelfTriggerMutationSelfTestEventArgs = {
    input?: InputMaybe<TriggerSelfTestEventInput>
}

export type CnsTriggerEventFailure = {
    __typename?: 'CnsTriggerEventFailure'
    error: Scalars['String']['output']
}

export type CnsTriggerEventResponse =
    | CnsTriggerEventFailure
    | CnsTriggerEventSuccess

export type CnsTriggerEventSuccess = {
    __typename?: 'CnsTriggerEventSuccess'
    result: UserNudgesSentResult
}

export type CnsTriggerMutation = {
    __typename?: 'CnsTriggerMutation'
    /** Triggers an immediate in-challenge goal reminder nudge event for the given users (does not validate Thrive User IDs).  Note that the event is dispatched immediately, but it is marked with the sendTime/sendDate provided, and the expiration is based on sendDate (and the timezone).  In the future, the dispatch will be based on the input sendTime/sendDate.  If a nudge has already been sent for a user at the given sendTime/sendDate, this will not dispatch a new nudge.  Only newly dispatched nudges will be returned by this mutation. */
    inChallengeGoalReminders: CnsBatchTriggerEventResponse
    /** Triggers an immediate test nudge event for the given user (does not validate Thrive User ID) */
    testEvent: CnsTriggerEventResponse
    /** Triggers an immediate test nudge event for the given users (does not validate Thrive User IDs) */
    testEvents: CnsBatchTriggerEventResponse
    /** Triggers an immediate web nudge announcement for all users at the given company.  Note that the event is dispatched immediately, and is marked with a sendTime/sendDate based on the current time at UTC.  This should be fine as this is a one-time nudge, web-only, and has a 90-day expiration.  Due to the number of users at companies, this only returns counts of successes/failures. */
    webNudgeAnnouncementsForCompany: CnsLargeBatchTriggerEventResponse
    /** Triggers an immediate web nudge announcement for all users at the given company.  Note that the event is dispatched immediately, and is marked with a sendTime/sendDate based on the current time at UTC.  This should be fine as this is a one-time nudge, web-only, and has a 90-day expiration.  This kicks off the launch asynchronously and only returns whether the kickoff worked (not the results, which may take a while). */
    webNudgeAnnouncementsForCompanyAsync: CnsAsyncTriggerEventLaunchedResponse
}

export type CnsTriggerMutationInChallengeGoalRemindersArgs = {
    input: TriggerInChallengeGoalRemindersInput
}

export type CnsTriggerMutationTestEventArgs = {
    input: TriggerTestEventInput
}

export type CnsTriggerMutationTestEventsArgs = {
    input: TriggerTestEventsInput
}

export type CnsTriggerMutationWebNudgeAnnouncementsForCompanyArgs = {
    input: TriggerWebNudgeAnnouncementsForCompanyInput
}

export type CnsTriggerMutationWebNudgeAnnouncementsForCompanyAsyncArgs = {
    input: TriggerWebNudgeAnnouncementsForCompanyInput
}

export type CoachCapacityGqlModel = {
    __typename?: 'CoachCapacityGqlModel'
    maxCoachees: Scalars['Int']['output']
    thriveUserId: Scalars['UUID']['output']
}

export enum CoachCategory {
    Career = 'CAREER',
    CommunicationConnection = 'COMMUNICATION_CONNECTION',
    HealthWellbeing = 'HEALTH_WELLBEING',
    Identity = 'IDENTITY'
}

export type CoachGqlModel = {
    __typename?: 'CoachGqlModel'
    bio: Scalars['String']['output']
    coachingLanguages: Array<Scalars['String']['output']>
    coachingTimezones: Array<Scalars['String']['output']>
    favouriteMicrostepDescription?: Maybe<Scalars['String']['output']>
    firstName: Scalars['String']['output']
    imageUrl: Scalars['String']['output']
    lastName: Scalars['String']['output']
    specialities: Array<Scalars['String']['output']>
    thriveUserId: Scalars['UUID']['output']
    whatHelpsMeThrive?: Maybe<Scalars['String']['output']>
}

export type CoachSummaryGqlModel = {
    __typename?: 'CoachSummaryGqlModel'
    bio: Scalars['String']['output']
    firstName: Scalars['String']['output']
    imageUrl: Scalars['String']['output']
    lastName: Scalars['String']['output']
    thriveUserId: Scalars['UUID']['output']
}

export enum CoachVisibility {
    All = 'ALL',
    Coach = 'COACH',
    Coachee = 'COACHEE'
}

export type CoacheeAvailabilityIntervalGqlModel = {
    __typename?: 'CoacheeAvailabilityIntervalGqlModel'
    availabilityInterval: AvailabilityInterval
    endTime?: Maybe<Scalars['String']['output']>
    isSelected: Scalars['Boolean']['output']
    startTime?: Maybe<Scalars['String']['output']>
}

export type CoacheeAvailabilityIntervalsFailure = {
    __typename?: 'CoacheeAvailabilityIntervalsFailure'
    errorCode: CoachingErrorCode
}

export type CoacheeAvailabilityIntervalsGqlResponse =
    | CoacheeAvailabilityIntervalsFailure
    | CoacheeAvailabilityIntervalsSuccess

export type CoacheeAvailabilityIntervalsSuccess = {
    __typename?: 'CoacheeAvailabilityIntervalsSuccess'
    result: Array<CoacheeAvailabilityIntervalGqlModel>
}

export type CoacheeBookSessionFailure = {
    __typename?: 'CoacheeBookSessionFailure'
    errorCode: CoachingErrorCode
}

export type CoacheeBookSessionGqlResponse =
    | CoacheeBookSessionFailure
    | CoacheeBookSessionSuccess

export type CoacheeBookSessionSuccess = {
    __typename?: 'CoacheeBookSessionSuccess'
    result: CoachingSessionGqlModel
}

export type CoacheeCancelSessionFailure = {
    __typename?: 'CoacheeCancelSessionFailure'
    errorCode: CoachingErrorCode
}

export type CoacheeCancelSessionGqlResponse =
    | CoacheeCancelSessionFailure
    | CoacheeCancelSessionSuccess

export type CoacheeCancelSessionSuccess = {
    __typename?: 'CoacheeCancelSessionSuccess'
    result: CoachingSessionGqlModel
}

export enum CoacheeCohortStatus {
    Active = 'ACTIVE',
    ActiveNoBooking = 'ACTIVE_NO_BOOKING',
    Completed = 'COMPLETED',
    Removed = 'REMOVED'
}

export type CoacheeMutation = {
    __typename?: 'CoacheeMutation'
    /** Remove specified user's identity and specialty preferences */
    removeCoacheePreferences: RemoveCoacheePreferencesGqlResponse
    /** Saves a coachee's availability intervals */
    saveCoacheeAvailabilityIntervals: CoacheeAvailabilityIntervalsGqlResponse
    /** Save a user's identity and specialty preferences */
    saveCoacheePreferences: SetCoacheePreferencesGqlResponse
    /** Saves a coachee's preferred locales */
    saveCoacheePreferredLocales: CoacheePreferredLocalesGqlResponse
}

export type CoacheeMutationRemoveCoacheePreferencesArgs = {
    specialties: Array<Scalars['UUID']['input']>
}

export type CoacheeMutationSaveCoacheeAvailabilityIntervalsArgs = {
    availabilityIntervals: Array<AvailabilityInterval>
}

export type CoacheeMutationSaveCoacheePreferencesArgs = {
    specialties: Array<Scalars['UUID']['input']>
}

export type CoacheeMutationSaveCoacheePreferredLocalesArgs = {
    locales: Array<Scalars['Locale']['input']>
}

export type CoacheeOnboardingState = {
    __typename?: 'CoacheeOnboardingState'
    coacheeUserId: Scalars['UUID']['output']
    createdAt: Scalars['Instant']['output']
    state: OnboardingState
    updatedAt: Scalars['Instant']['output']
}

export type CoacheePreferredLocalesFailure = {
    __typename?: 'CoacheePreferredLocalesFailure'
    errorCode: CoachingErrorCode
}

export type CoacheePreferredLocalesGqlResponse =
    | CoacheePreferredLocalesFailure
    | CoacheePreferredLocalesSuccess

export type CoacheePreferredLocalesSuccess = {
    __typename?: 'CoacheePreferredLocalesSuccess'
    result: Array<Scalars['Locale']['output']>
}

export type CoacheeQuery = {
    __typename?: 'CoacheeQuery'
    /** Returns active coaches for the requesting coachee */
    getActiveCoaches: GetActiveCoachesForCoacheeGqlResponse
    /** Returns availability interval selections for the requesting coachee */
    getAvailabilityIntervals: CoacheeAvailabilityIntervalsGqlResponse
    /** Returns the list of coaching specialties, indicating which are selected for the requesting coachee */
    getCoacheeSpecialties: GetCoacheeSpecialtiesResponse
    /** Returns the list of coaching session start times for the requesting coachee */
    getCoachingSessionStartTimes: GetCoacheeSessionStartTimesGqlResponse
    /** Returns coaching session stats and cohort status for the requesting coachee */
    getCoachingSessionStatsAndCohortStatus: GetCoacheeSessionStatsAndCohortStatusGqlResponse
    /** Returns the list of coaching sessions for the requesting coachee */
    getCoachingSessions: GetCoacheeSessionsGqlResponse
    /** Returns the coachee's onboarding state */
    getOnboardingState: GetCoacheeOnboardingStateResponse
    /** Returns preferred locale selections for the requesting coachee */
    getPreferredLocales: CoacheePreferredLocalesGqlResponse
    /** Returns whether the requesting coachee has completed onboarding */
    isOnboardingComplete: IsCoacheeOnboardingCompleteResponse
}

export type CoacheeQueryGetActiveCoachesArgs = {
    seatType?: InputMaybe<SeatType>
}

export type CoacheeQueryGetCoacheeSpecialtiesArgs = {
    categories?: InputMaybe<Array<CoachCategory>>
}

export type CoacheeQueryGetCoachingSessionStartTimesArgs = {
    sessionStatuses?: InputMaybe<Array<SessionStatus>>
}

export type CoacheeQueryGetCoachingSessionsArgs = {
    sessionDate?: InputMaybe<Scalars['ISODate']['input']>
}

export type CoacheeSessionUsageAndCohortDataGqlModel = {
    __typename?: 'CoacheeSessionUsageAndCohortDataGqlModel'
    cohortEndDate: Scalars['ISODate']['output']
    cohortStatus: CoacheeCohortStatus
    completedSessionCount: Scalars['Int']['output']
    hasCompletedAllSessions: Scalars['Boolean']['output']
    sessionsRemaining: Scalars['Int']['output']
    totalSessionCount: Scalars['Int']['output']
    usedSessionCount: Scalars['Int']['output']
}

export type CoacheeSpecialtyGqlModel = {
    __typename?: 'CoacheeSpecialtyGqlModel'
    id: Scalars['UUID']['output']
    isSelected: Scalars['Boolean']['output']
    name: Scalars['String']['output']
}

export type CoachesMutation = {
    __typename?: 'CoachesMutation'
    /** Save a coach's capacity preferences */
    upsertCapacity: UpsertCoachCapacityGqlResponse
}

export type CoachesMutationUpsertCapacityArgs = {
    coachUserId: Scalars['UUID']['input']
    maxCoachees: Scalars['Int']['input']
}

export type CoachesQuery = {
    __typename?: 'CoachesQuery'
    /** Get all coaches */
    getAll: GetCoachesGqlResponse
    /**
     * Get a coach's available time slots from cal.com.
     * The startDate and endDate params are both inclusive.
     * If startDate = 12/01/2021 and endDate = 12/01/2021, then the time slots for 12/01/2021 will be returned.
     * If startDate = 12/01/2021 and endDate = 12/04/2021, then the time slots for 12/01/2021, 12/02/2021, 12/03/2021, and 12/04/2021 will be returned.
     */
    getAvailableTimeSlotsForCoach: GetCoachAvailableTimeSlotsGqlResponse
    /** Get one coach by id */
    getById: GetCoachGqlResponse
    /** Get recommended coaches for a user */
    getRecommendedForUser: GetRecommendedCoachesGqlResponse
}

export type CoachesQueryGetAllArgs = {
    input?: InputMaybe<GetAllCoachesInput>
}

export type CoachesQueryGetAvailableTimeSlotsForCoachArgs = {
    coachUserId: Scalars['UUID']['input']
    endDate: Scalars['ISODate']['input']
    startDate: Scalars['ISODate']['input']
}

export type CoachesQueryGetByIdArgs = {
    thriveUserId: Scalars['UUID']['input']
}

export enum CoachingErrorCode {
    ApiClientError = 'API_CLIENT_ERROR',
    CoacheeHasNoActiveCohorts = 'COACHEE_HAS_NO_ACTIVE_COHORTS',
    CoacheeMissingEmail = 'COACHEE_MISSING_EMAIL',
    CoacheeNotFound = 'COACHEE_NOT_FOUND',
    CoacheeSessionUsageNotFound = 'COACHEE_SESSION_USAGE_NOT_FOUND',
    CoachingSessionNotFound = 'COACHING_SESSION_NOT_FOUND',
    CoachEventTypeNotFound = 'COACH_EVENT_TYPE_NOT_FOUND',
    CoachNotFound = 'COACH_NOT_FOUND',
    EndDateBeforeStartDate = 'END_DATE_BEFORE_START_DATE',
    GqlApiError = 'GQL_API_ERROR',
    GqlInvalidInput = 'GQL_INVALID_INPUT',
    GqlMappingError = 'GQL_MAPPING_ERROR',
    InvalidBookingCancellation = 'INVALID_BOOKING_CANCELLATION',
    InvalidBookingCreation = 'INVALID_BOOKING_CREATION',
    StartDateInPast = 'START_DATE_IN_PAST',
    UnexpectedError = 'UNEXPECTED_ERROR'
}

export type CoachingMutation = {
    __typename?: 'CoachingMutation'
    /** CRUD operations associated with a Coachee */
    coachee: CoacheeMutation
    /** Book a coaching session with a coach for the specified coachee */
    coacheeBookSession: CoacheeBookSessionGqlResponse
    /** Cancel a coaching session with a coach for the specified coachee */
    coacheeCancelSession: CoacheeCancelSessionGqlResponse
    /** CRUD operations associated with a Coach */
    coaches: CoachesMutation
}

export type CoachingMutationCoacheeBookSessionArgs = {
    assignCoach?: InputMaybe<Scalars['Boolean']['input']>
    bookTime: Scalars['Instant']['input']
    coachUserId: Scalars['UUID']['input']
}

export type CoachingMutationCoacheeCancelSessionArgs = {
    sessionId: Scalars['UUID']['input']
}

export type CoachingQuery = {
    __typename?: 'CoachingQuery'
    /** Coachee related queries */
    coachee: CoacheeQuery
    /** Coach related queries */
    coaches: CoachesQuery
    /** Returns a list of coaching specialties and their associated categories */
    getSpecialties: GetCoachingSpecialtiesResponse
}

export type CoachingQueryGetSpecialtiesArgs = {
    input?: InputMaybe<GetCoachingSpecialtiesInput>
}

export type CoachingSessionCoacheeGqlModel = {
    __typename?: 'CoachingSessionCoacheeGqlModel'
    coacheeUserId: Scalars['UUID']['output']
    countsTowardsLimit: Scalars['Boolean']['output']
    sessionNumber: Scalars['Int']['output']
}

export type CoachingSessionGqlModel = {
    __typename?: 'CoachingSessionGqlModel'
    calBookingUid: Scalars['String']['output']
    coachUserId: Scalars['UUID']['output']
    coachees: Array<CoachingSessionCoacheeGqlModel>
    endTime: Scalars['Instant']['output']
    seatType: SeatType
    sessionId: Scalars['UUID']['output']
    sessionTotal: Scalars['Int']['output']
    startTime: Scalars['Instant']['output']
    status: SessionStatus
    videoUrl: Scalars['String']['output']
}

export type CommunityChallengeCompletedDay = {
    __typename?: 'CommunityChallengeCompletedDay'
    /** The challenge id */
    challengeId: Scalars['UUID']['output']
    createdAt?: Maybe<Scalars['Instant']['output']>
    /** The completed day */
    day: Scalars['Int']['output']
    updatedAt?: Maybe<Scalars['Instant']['output']>
    /** The user's id */
    userId: Scalars['UUID']['output']
}

export type CommunityChallengeThreshold = {
    __typename?: 'CommunityChallengeThreshold'
    achieved: Scalars['Int']['output']
    threshold: Scalars['Int']['output']
    total: Scalars['Int']['output']
}

export type CommunityGardenInfo = {
    __typename?: 'CommunityGardenInfo'
    /** Challenge day date */
    date: Scalars['Instant']['output']
    /** Total number of plants for that day */
    plantsNumber: Scalars['Int']['output']
    /** The 30*15 plants template to represent the garden */
    plantsTemplate: Array<PlantInfo>
}

export type CompaniesQuery = {
    __typename?: 'CompaniesQuery'
    /** Get company details from Pulse */
    info?: Maybe<CompanyInfoDto>
}

export type Company = {
    __typename?: 'Company'
    brands: Array<Brand>
    configuration: Scalars['String']['output']
    createdAt: Scalars['Instant']['output']
    id: Scalars['UUID']['output']
    imageUrl?: Maybe<Scalars['String']['output']>
    isPublic: Scalars['Boolean']['output']
    name: Scalars['String']['output']
    seatsAllowed: Scalars['Int']['output']
    /** Social Groups for this company */
    socialGroups: Array<SocialGroup>
    status: CompanyStatus
    updatedAt: Scalars['Instant']['output']
}

export type CompanyConfiguration = {
    __typename?: 'CompanyConfiguration'
    agentTriggerLimit?: Maybe<Scalars['Int']['output']>
    companyId?: Maybe<Scalars['UUID']['output']>
    companyName?: Maybe<Scalars['String']['output']>
    createdAt: Scalars['Instant']['output']
    digitalResetRoutingId?: Maybe<Scalars['String']['output']>
    isActive: Scalars['Boolean']['output']
    isListening: Scalars['Boolean']['output']
    isSmart: Scalars['Boolean']['output']
    oauthClientId: Scalars['String']['output']
    /** @deprecated This field has been renamed to platformOrgId, replace with platformOrgId */
    organizationId?: Maybe<Scalars['String']['output']>
    platform: PlatformType
    platformOrgId?: Maybe<Scalars['String']['output']>
    queryAllQueues: Scalars['Boolean']['output']
    region?: Maybe<Scalars['String']['output']>
    resetBufferMinutes?: Maybe<Scalars['Int']['output']>
    resetPriority?: Maybe<Scalars['Int']['output']>
    resetRoutingId?: Maybe<Scalars['String']['output']>
    resetScriptId?: Maybe<Scalars['String']['output']>
    shiftBlockPeriodMinutes?: Maybe<Scalars['Int']['output']>
    /** @deprecated This field has been renamed to companyId, replace with companyId */
    thriveCompanyId?: Maybe<Scalars['UUID']['output']>
    triggerConfiguration: Array<TriggerConfiguration>
    updatedAt: Scalars['Instant']['output']
    usesPilotPage: Scalars['Boolean']['output']
    usesSSO: Scalars['Boolean']['output']
    webResourceName?: Maybe<Scalars['String']['output']>
    wrapUpCodeId?: Maybe<Scalars['String']['output']>
}

export type CompanyConfigurationCreateInput = {
    acChromeSigningKey?: InputMaybe<Scalars['String']['input']>
    agentTriggerLimit?: InputMaybe<Scalars['Int']['input']>
    companyId: Scalars['UUID']['input']
    digitalResetRoutingId?: InputMaybe<Scalars['String']['input']>
    oauthClientId: Scalars['String']['input']
    oauthClientSecret: Scalars['String']['input']
    platform: PlatformType
    platformOrgId?: InputMaybe<Scalars['String']['input']>
    region?: InputMaybe<Scalars['String']['input']>
    resetBufferMinutes?: InputMaybe<Scalars['Int']['input']>
    resetPriority?: InputMaybe<Scalars['Int']['input']>
    resetRoutingId?: InputMaybe<Scalars['String']['input']>
    resetScriptId?: InputMaybe<Scalars['String']['input']>
    shiftBlockPeriodMinutes?: InputMaybe<Scalars['Int']['input']>
    usesPilotPage?: InputMaybe<Scalars['Boolean']['input']>
    usesSSO?: InputMaybe<Scalars['Boolean']['input']>
    webResourceName?: InputMaybe<Scalars['String']['input']>
    webhookSecret?: InputMaybe<Scalars['String']['input']>
    wrapUpCodeId?: InputMaybe<Scalars['String']['input']>
}

export type CompanyId = {
    __typename?: 'CompanyId'
    id: Scalars['UUID']['output']
}

export type CompanyInfoDto = {
    __typename?: 'CompanyInfoDTO'
    age?: Maybe<Scalars['Int']['output']>
    createdAt?: Maybe<Scalars['Instant']['output']>
    id: Scalars['UUID']['output']
    matured?: Maybe<Scalars['Boolean']['output']>
    totalEmployees: Scalars['Int']['output']
}

export type CompanyInputGraphQlInput = {
    brands?: InputMaybe<Array<BrandInput>>
    configuration?: InputMaybe<Scalars['String']['input']>
    imageUrl?: InputMaybe<Scalars['String']['input']>
    isPublic?: InputMaybe<Scalars['Boolean']['input']>
    name: Scalars['String']['input']
    seatsAllowed?: InputMaybe<Scalars['Int']['input']>
    status?: InputMaybe<CompanyStatus>
}

export type CompanyMutation = {
    __typename?: 'CompanyMutation'
    /** Disables all relevant companies and attempts to stop further resets from occurring */
    bigRedButton: BigRedButtonRespose
    /** Adds company configuration details for an organization */
    create: CompanyConfiguration
    /** Deletes the configuration for a company */
    delete: Scalars['String']['output']
    /** Disables a company and prevents further resets from occurring */
    uninstall?: Maybe<Scalars['UUID']['output']>
    /** Modifies the configuration for an existing company */
    update: CompanyConfiguration
}

export type CompanyMutationBigRedButtonArgs = {
    companyIds?: InputMaybe<Array<Scalars['UUID']['input']>>
    destructive: Scalars['Boolean']['input']
    onlyActive?: InputMaybe<Scalars['Boolean']['input']>
    platform: PlatformType
}

export type CompanyMutationCreateArgs = {
    companyConfiguration: CompanyConfigurationCreateInput
}

export type CompanyMutationDeleteArgs = {
    companyId: Scalars['UUID']['input']
    platform: PlatformType
}

export type CompanyMutationUninstallArgs = {
    companyId: Scalars['UUID']['input']
    platform: PlatformType
}

export type CompanyMutationUpdateArgs = {
    agentTriggerLimit?: InputMaybe<Scalars['Int']['input']>
    companyId: Scalars['UUID']['input']
    digitalResetRoutingId?: InputMaybe<Scalars['String']['input']>
    isActive?: InputMaybe<Scalars['Boolean']['input']>
    platform: PlatformType
    platformOrgId?: InputMaybe<Scalars['String']['input']>
    region?: InputMaybe<Scalars['String']['input']>
    resetBufferMinutes?: InputMaybe<Scalars['Int']['input']>
    resetPriority?: InputMaybe<Scalars['Int']['input']>
    resetRoutingId?: InputMaybe<Scalars['String']['input']>
    resetScriptId?: InputMaybe<Scalars['String']['input']>
    usesPilotPage?: InputMaybe<Scalars['Boolean']['input']>
    usesSSO?: InputMaybe<Scalars['Boolean']['input']>
    webResourceName?: InputMaybe<Scalars['String']['input']>
    webhookSecret?: InputMaybe<Scalars['String']['input']>
    wrapUpCodeId?: InputMaybe<Scalars['String']['input']>
}

export type CompanyPage = {
    __typename?: 'CompanyPage'
    items: Array<Company>
    itemsPerPage: Scalars['Int']['output']
    page: Scalars['Int']['output']
    total: Scalars['Int']['output']
}

export type CompanyQuery = {
    __typename?: 'CompanyQuery'
    /** Retrieves calls company configuration with filters. */
    getAllCompanyConfiguration: Array<CompanyConfiguration>
    /** Retrieves calls company configuration by Thrive company id. */
    getCompanyConfigurationByThriveCompanyId?: Maybe<CompanyConfiguration>
    /** Returns company information for an agent */
    getCompanyConfigurationForAgent?: Maybe<CompanyConfiguration>
    /** Retrieves the company configuration for the current user. */
    getCompanyConfigurationForUser: Array<CompanyConfiguration>
}

export type CompanyQueryGetAllCompanyConfigurationArgs = {
    companyId?: InputMaybe<Scalars['UUID']['input']>
    isActive?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    page?: InputMaybe<Scalars['Int']['input']>
    platformType?: InputMaybe<PlatformType>
}

export type CompanyQueryGetCompanyConfigurationByThriveCompanyIdArgs = {
    companyId: Scalars['UUID']['input']
    platform: PlatformType
}

export type CompanyQueryGetCompanyConfigurationForAgentArgs = {
    agentId: Scalars['String']['input']
    routingId: Scalars['String']['input']
    scriptId: Scalars['String']['input']
}

export type CompanyQueryGetCompanyConfigurationForUserArgs = {
    isActive?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    page?: InputMaybe<Scalars['Int']['input']>
    platformType?: InputMaybe<PlatformType>
}

export type CompanyResourceGroup = {
    __typename?: 'CompanyResourceGroup'
    alreadySeenToday: Scalars['Boolean']['output']
    companyResources: Array<CompanyResourceV3>
    contentStatus?: Maybe<LearnContentStatus>
    createdAt: Scalars['Instant']['output']
    groupType: Array<CompanyResourceGroupType>
    id: Scalars['ID']['output']
    locale: Scalars['Locale']['output']
    pulseDimensionTypes: Array<Scalars['String']['output']>
    pulseSurveyIds: Array<Scalars['String']['output']>
    subtitle: Scalars['String']['output']
    title: Scalars['String']['output']
    updatedAt: Scalars['Instant']['output']
    /** Ignore this field, it's only been added so that it can be used for the resolver */
    userCountryCode: Scalars['String']['output']
    uuid: Scalars['String']['output']
}

export type CompanyResourceGroupPage = {
    __typename?: 'CompanyResourceGroupPage'
    items: Array<CompanyResourceGroup>
    page: Scalars['Int']['output']
    pageSize: Scalars['Int']['output']
}

export enum CompanyResourceGroupType {
    BenefitsConnect = 'BENEFITS_CONNECT',
    Section = 'SECTION'
}

export type CompanyResourceImage = {
    __typename?: 'CompanyResourceImage'
    alternativeText?: Maybe<Scalars['String']['output']>
    caption?: Maybe<Scalars['String']['output']>
    height?: Maybe<Scalars['Int']['output']>
    name?: Maybe<Scalars['String']['output']>
    url: Scalars['String']['output']
    width?: Maybe<Scalars['Int']['output']>
}

export type CompanyResourceRevealedInfo = {
    __typename?: 'CompanyResourceRevealedInfo'
    content?: Maybe<Scalars['String']['output']>
    type?: Maybe<CompanyResourceRevealedInfoType>
}

export enum CompanyResourceRevealedInfoType {
    Call = 'CALL',
    Email = 'EMAIL'
}

export enum CompanyResourceType {
    Call = 'Call',
    Email = 'Email',
    Link = 'Link',
    Pdf = 'Pdf'
}

export type CompanyResourceV3 = {
    __typename?: 'CompanyResourceV3'
    alertLevelResource: Scalars['Boolean']['output']
    appearOnSectionsOnly?: Maybe<Scalars['Boolean']['output']>
    companyResourceTypeName: Scalars['String']['output']
    id: Scalars['ID']['output']
    image?: Maybe<CompanyResourceImage>
    link?: Maybe<Scalars['String']['output']>
    publishedAt?: Maybe<Scalars['Instant']['output']>
    revealedInfo?: Maybe<Array<CompanyResourceRevealedInfo>>
    subtitle: Scalars['String']['output']
    title: Scalars['String']['output']
    type: CompanyResourceType
}

export enum CompanyStatus {
    Active = 'active',
    Demo = 'demo',
    Inactive = 'inactive',
    Prospect = 'prospect',
    Test = 'test'
}

export type ConnectQuery = {
    __typename?: 'ConnectQuery'
    /** Mutation to post events from the Desktop app */
    desktop: Scalars['Boolean']['output']
    poll: PollResponse
    /** Poll for events for a given user and company. It does not check jwt token. This is a temporary solution until Identity implements Webex integration. */
    pollWithUserIdAndCompanyId: PollResponse
    /**
     * Generates a dummy TriggerReset command to allow testing from the FE
     * @deprecated This is a temporary solution until we have MVP working end to end
     */
    sendTriggerResetCommand: Scalars['Boolean']['output']
}

export type ConnectQueryDesktopArgs = {
    event: DesktopWebhookEventInput
}

export type ConnectQueryPollArgs = {
    platformType: PlatformType
    sessionId?: InputMaybe<Scalars['String']['input']>
}

export type ConnectQueryPollWithUserIdAndCompanyIdArgs = {
    companyId: Scalars['UUID']['input']
    platformType: PlatformType
    sessionId?: InputMaybe<Scalars['String']['input']>
    userId: Scalars['String']['input']
}

export type ConnectQuerySendTriggerResetCommandArgs = {
    companyId: Scalars['UUID']['input']
    date?: InputMaybe<Scalars['Instant']['input']>
    platformType: PlatformType
    userId: Scalars['String']['input']
}

export enum ContentDifficulty {
    Difficult = 'DIFFICULT',
    Easy = 'EASY',
    Moderate = 'MODERATE'
}

export type ContentExperienceQuery = {
    __typename?: 'ContentExperienceQuery'
    /** Get acute care banner for the user's locale */
    getAcuteCareBanner?: Maybe<AcuteCareBanner>
    /** Benefits Connect (Acute Care) Resource */
    getAdminBenefitsConnectGroup?: Maybe<CompanyResourceGroup>
    /** Benefits Connect (Acute Care) Resource */
    getBenefitsConnectGroup?: Maybe<CompanyResourceGroup>
    /** Get journey progress for the user selected journey */
    getJourneyProgress?: Maybe<JourneyProgress>
}

export type ContentExperienceQueryGetAdminBenefitsConnectGroupArgs = {
    locale: Scalars['String']['input']
    pulseDimensionType: Scalars['String']['input']
    pulseSurveyId: Scalars['String']['input']
    subscriptionId: Scalars['UUID']['input']
    userId: Scalars['UUID']['input']
}

export type ContentExperienceQueryGetBenefitsConnectGroupArgs = {
    pulseDimensionType: Scalars['String']['input']
    pulseSurveyId: Scalars['String']['input']
}

export type ContentExperienceQueryGetJourneyProgressArgs = {
    journeyUUID: Scalars['UUID']['input']
}

export enum ContentFeedback {
    Negative = 'Negative',
    Positive = 'Positive'
}

export type ContentFilterInput = {
    /** Skip any validation checks and always return benefits connect content, when available. By default, false */
    alwaysReturnBenefitsConnect?: InputMaybe<Scalars['Boolean']['input']>
    /** Only include content associated with these dimensions (values match pulse dimension type field in the CMS). By default, all are included. If this list is empty (not null), then only content with no pulse dimension will be included. If the pulse dimension relationship does not apply to a given content type, then this filter will be ignored. */
    dimensions?: InputMaybe<Array<Scalars['String']['input']>>
    /** List of UUIDs for content to exclude. By default, none are excluded. Both includedContent and excludedContent cannot be used together. */
    excludedContent?: InputMaybe<Array<Scalars['String']['input']>>
    /** List of UUIDs for content to include. By default, all are included. Both includedContent and excludedContent cannot be used together. */
    includedContent?: InputMaybe<Array<Scalars['String']['input']>>
    /** Only include content associated with these journeys. By default, all are included. If this list is empty (not null), then only content with no journey will be included. If the journeys relationship does not apply to a given content type, then this filter will be ignored. */
    journeys?: InputMaybe<Array<Scalars['String']['input']>>
    /** Only include articles associated with the journey from a user's most recent DCI or, if journey from user's most recent DCI is not available, use the user's currently selected journey. By default, this is true. When this is set to false, articles will not be limited to current journey. Keep in mind, other filters may influence included articles as well. */
    limitArticlesToCurrentJourney?: InputMaybe<Scalars['Boolean']['input']>
    /** Only include course modules associated with the journey from a user's most recent DCI or, if journey from user's most recent DCI is not available, use the user's currently selected journey. By default, this is false. When this is set to false, course modules will not be limited to current journey. Keep in mind, other filters may influence included course modules as well. */
    limitCourseModulesToCurrentJourney?: InputMaybe<Scalars['Boolean']['input']>
    /** Only include journey daily steps associated with the journey from a user's most recent DCI or, if journey from user's most recent DCI is not available, use the user's currently selected journey. By default, this is true. When this is set to false, journey daily steps will not be limited to current journey. Keep in mind, other filters may influence included daily journey steps as well. */
    limitJourneyDailyStepToCurrentJourney?: InputMaybe<
        Scalars['Boolean']['input']
    >
    /** Only include microsteps associated with the journey from a user's most recent DCI or, if journey from user's most recent DCI is not available, use the user's currently selected journey. By default, this is true. When this is set to false, microsteps will not be limited to current journey. Keep in mind, other filters may influence included microsteps as well. */
    limitMicrostepsToCurrentJourney?: InputMaybe<Scalars['Boolean']['input']>
    /** Only include podcast episodes associated with the journey from a user's most recent DCI or, if journey from user's most recent DCI is not available, use the user's currently selected journey. By default, this is true. When this is set to false, podcast episodes will not be limited to current journey. Keep in mind, other filters may influence included podcast episodes as well. */
    limitPodcastEpisodesToCurrentJourney?: InputMaybe<
        Scalars['Boolean']['input']
    >
    /** Only include content associated with these personas. By default, all are included. If this list is empty (not null), then only content with no persona will be included. If the personas relationship does not apply to a given content type, then this filter will be ignored. */
    personas?: InputMaybe<Array<Scalars['String']['input']>>
    /** Optional text that will be used to improve microstep, article, and reset recommendations. By default, null (searchString will not be used). */
    searchString?: InputMaybe<Scalars['String']['input']>
    /** Only include content associated with these tags. By default, all are included. If this list is empty (not null), then only content with no tag will be included. If the tags relationship does not apply to a given content type, then this filter will be ignored. */
    tags?: InputMaybe<Array<Scalars['String']['input']>>
    /** Skip any journey information related to the latest DCI and use the user's currently Intention, if available. By default, false. */
    useOnlyIntentionRelatedContent?: InputMaybe<Scalars['Boolean']['input']>
}

export enum ContentImpact {
    High = 'HIGH',
    Low = 'LOW',
    Moderate = 'MODERATE'
}

export type ContentMutation = {
    __typename?: 'ContentMutation'
    book: BookMutation
    journal: JournalMutation
    successStory: SuccessStoryMutation
}

export type ContentQuery = {
    __typename?: 'ContentQuery'
    journal: JournalQuery
    successStory: SuccessStoryQuery
    thrive: ThriveContentQuery
}

export enum ContentType {
    Audio = 'AUDIO',
    Text = 'TEXT',
    Video = 'VIDEO'
}

export type Contributor = {
    __typename?: 'Contributor'
    bio: Scalars['String']['output']
    id: Scalars['ID']['output']
    name: Scalars['String']['output']
    photoUrl: Scalars['String']['output']
    title: Scalars['String']['output']
}

export type CoreHealthBehaviorScore = {
    __typename?: 'CoreHealthBehaviorScore'
    averageScore?: Maybe<Scalars['Float']['output']>
    journeyCoreType: JourneyCoreType
}

export type CountryGroup = {
    __typename?: 'CountryGroup'
    /** List of allowed countries for the country group */
    countryAllowList?: Maybe<Array<Scalars['String']['output']>>
    /** Description of the country group */
    description: Scalars['String']['output']
    /** Cms id of the country group */
    id?: Maybe<Scalars['Int']['output']>
    /** Name of the country group */
    name: Scalars['String']['output']
    /** Unique identifier of the country group */
    uuid: Scalars['UUID']['output']
}

export type CourseModuleParent = {
    __typename?: 'CourseModuleParent'
    courseID: Scalars['ID']['output']
    lessonID: Scalars['ID']['output']
}

export type CourseMutation = {
    /** Mutation creating or updating course resource status (for course or lesson), based on userId from context */
    markCourseResourceAsCompleted: LearnContentStatus
}

export type CourseMutationMarkCourseResourceAsCompletedArgs = {
    contentId: Scalars['String']['input']
}

export type CoursePage = {
    __typename?: 'CoursePage'
    hasMore?: Maybe<Scalars['Boolean']['output']>
    items: Array<CourseV2>
    page: Scalars['Int']['output']
    pageCount?: Maybe<Scalars['Int']['output']>
    pageSize: Scalars['Int']['output']
}

export type CourseQuery = {
    /** Get course by id */
    getCourse?: Maybe<CourseV2>
    /** Get courses by companyId and subscriptionId from context */
    getCourses: CoursePage
}

export type CourseQueryGetCourseArgs = {
    courseId: Scalars['String']['input']
}

export type CourseQueryGetCoursesArgs = {
    page?: InputMaybe<Scalars['Int']['input']>
    pageSize?: InputMaybe<Scalars['Int']['input']>
    sort?: InputMaybe<Array<Scalars['String']['input']>>
}

/** Supplementary Course Resource */
export type CourseResource = {
    __typename?: 'CourseResource'
    /** Course resource progress for user, based on userId from context. */
    contentStatus?: Maybe<LearnContentStatus>
    createdAt: Scalars['Instant']['output']
    hasCompleted: Scalars['Boolean']['output']
    /** CourseResource identifier, value of uuid from CMS */
    id: Scalars['ID']['output']
    /** course resource type */
    resourceType: CourseResourceType
    /** link to the resource, if link contains '$companyId' tag it is replaced with user company id from context */
    source: Scalars['String']['output']
    summary?: Maybe<Scalars['String']['output']>
    title: Scalars['String']['output']
    updatedAt: Scalars['Instant']['output']
}

/** Supplementary Course Resource Type */
export enum CourseResourceType {
    Link = 'Link',
    Pdf = 'PDF',
    Survey = 'Survey'
}

export type CourseV2 = {
    __typename?: 'CourseV2'
    about: Scalars['String']['output']
    blurbs: Array<BlurbV2>
    bookmarked: Scalars['Boolean']['output']
    /** The collection name for this course. Article also has a collection field and they share the same set of collections values to choose from. This is used by Eli Lilly. */
    collection: Scalars['String']['output']
    /** List of condition tags related to this course. */
    conditions: Array<Tag>
    contentType: LearnContentStatusType
    experts: Array<Contributor>
    /** List of subscription ids for which this course is considered a featured course. */
    featuredSubscriptionIds: Array<Scalars['UUID']['output']>
    id: Scalars['ID']['output']
    isCompleted: Scalars['Boolean']['output']
    lessons: Array<LessonV2>
    /** Course progress for user, based on userId from context. Checks progress on lessons. */
    progress?: Maybe<LearnContentProgress>
    resources: Array<CourseResource>
    seoDescription: Scalars['String']['output']
    seoTitle: Scalars['String']['output']
    subTitle: Scalars['String']['output']
    /** List of all tags related to this course. */
    tags: Array<Tag>
    thumbnail?: Maybe<Scalars['String']['output']>
    title: Scalars['String']['output']
    uuid?: Maybe<Scalars['UUID']['output']>
}

export type CurrencyInfo = {
    __typename?: 'CurrencyInfo'
    /** The three letter code that represents this currency */
    code: Scalars['String']['output']
    /** The key that points to the translated property in the i18n file */
    name: Scalars['String']['output']
}

export type DailyActivitySummaryStatsResponse = ActivitySummaryStats & {
    __typename?: 'DailyActivitySummaryStatsResponse'
    averageSteps: Scalars['Float']['output']
    day: Scalars['Int']['output']
    month: Scalars['Int']['output']
    year: Scalars['Int']['output']
}

export type DailyAssessmentStatsResponse = AssessmentStats & {
    __typename?: 'DailyAssessmentStatsResponse'
    average: Scalars['Float']['output']
    day: Scalars['Int']['output']
    month: Scalars['Int']['output']
    survey?: Maybe<Surveys>
    totalNumberOfResponses: Scalars['Int']['output']
    valuePercentage: Scalars['Int']['output']
    year: Scalars['Int']['output']
}

export type DailyCheckInDto = {
    __typename?: 'DailyCheckInDTO'
    dispatchDate: Scalars['ISODate']['output']
    id: Scalars['UUID']['output']
    pulseUserId: Scalars['UUID']['output']
    /** @deprecated Use response.recommendedContentDimension */
    recommendedContentDimension?: Maybe<Surveys>
    response?: Maybe<DailyCheckInResponseDto>
    status: Scalars['String']['output']
    survey: PulseSurveyQuestionDto
    thriveId: Scalars['UUID']['output']
}

export type DailyCheckInResponseDto = {
    __typename?: 'DailyCheckInResponseDTO'
    recommendAcuteCare: Scalars['Boolean']['output']
    recommendedContentDimension: Surveys
    responseChannel: Scalars['String']['output']
    selectedOption?: Maybe<OptionsDto>
}

export type DailyCheckInResponseInput = {
    /** The unique id of the Daily Check-In */
    id?: InputMaybe<Scalars['UUID']['input']>
    /** When true (default), the markJourneyDailyStepAsCompleted mutation will be invoked in DCI flow */
    markJourneyDailyStepAsCompleted?: InputMaybe<Scalars['Boolean']['input']>
    /** The channel in which the Daily Check-In response is coming from */
    respondingChannel: Channel
    /** The date of the survey that the Daily Check-In response is for */
    responseDate: Scalars['ISODate']['input']
    /** The Daily Check-In response value */
    responseValue: Scalars['Int']['input']
    /** The list of desired recommended content types to be returned on success. Defaults to all */
    supportedContentTypes?: InputMaybe<Array<SupportedRecommendedContentType>>
    /** The local date of the user at the time of the response */
    userCurrentDate: Scalars['ISODate']['input']
}

export type DailyCheckInScoresQuery = {
    __typename?: 'DailyCheckInScoresQuery'
    /** Historic Daily Check In Scores for a company */
    historicDailyCheckInScores: HistoricDailyCheckInScoresResponse
    /** Recent Daily Check In Scores for a company */
    recentDailyCheckInScores?: Maybe<RecentDailyCheckInScoresResponse>
}

export type DailyCheckInScoresQueryHistoricDailyCheckInScoresArgs = {
    companyId: Scalars['UUID']['input']
    dimension: Scalars['String']['input']
    end: MonthYearInput
    start: MonthYearInput
}

export type DailyCheckInScoresQueryRecentDailyCheckInScoresArgs = {
    companyId: Scalars['UUID']['input']
}

export type DailyCheckinDetail = {
    __typename?: 'DailyCheckinDetail'
    name?: Maybe<Scalars['String']['output']>
}

export type DailyExperienceMutation = {
    __typename?: 'DailyExperienceMutation'
    goals: GoalMutation
}

export type DailyExperienceQuery = {
    __typename?: 'DailyExperienceQuery'
    /** Goals Query */
    goals: GoalQuery
}

export type DailySleepSummaryStatsResponse = SleepSummaryStats & {
    __typename?: 'DailySleepSummaryStatsResponse'
    averageBedTimeStart?: Maybe<Scalars['Long']['output']>
    averageMinutesAsleep: Scalars['Float']['output']
    day: Scalars['Int']['output']
    month: Scalars['Int']['output']
    year: Scalars['Int']['output']
}

export enum DashboardViewType {
    Admin = 'ADMIN',
    Personal = 'PERSONAL'
}

export enum DayOfWeek {
    Friday = 'FRIDAY',
    Monday = 'MONDAY',
    Saturday = 'SATURDAY',
    Sunday = 'SUNDAY',
    Thursday = 'THURSDAY',
    Tuesday = 'TUESDAY',
    Wednesday = 'WEDNESDAY'
}

export type DeleteGameAchievementConditionResponse =
    | DeleteGameAchievementConditionResponseError
    | DeleteGameAchievementConditionResponseResult

export type DeleteGameAchievementConditionResponseError = {
    __typename?: 'DeleteGameAchievementConditionResponseError'
    error: DeleteGameAchievementConditionResponseErrorType
    message: Scalars['String']['output']
}

export enum DeleteGameAchievementConditionResponseErrorType {
    ConditionNotFound = 'CONDITION_NOT_FOUND',
    GameAlreadyStarted = 'GAME_ALREADY_STARTED',
    GameNotFound = 'GAME_NOT_FOUND'
}

export type DeleteGameAchievementConditionResponseResult = {
    __typename?: 'DeleteGameAchievementConditionResponseResult'
    deletedConditionId: Scalars['UUID']['output']
}

export type DeleteGameAchievementResponse =
    | DeleteGameAchievementResponseError
    | DeleteGameAchievementResponseResult

export type DeleteGameAchievementResponseError = {
    __typename?: 'DeleteGameAchievementResponseError'
    error: DeleteGameAchievementResponseErrorType
    message: Scalars['String']['output']
}

export enum DeleteGameAchievementResponseErrorType {
    AchievementNotFound = 'ACHIEVEMENT_NOT_FOUND',
    GameAlreadyStarted = 'GAME_ALREADY_STARTED',
    GameNotFound = 'GAME_NOT_FOUND'
}

export type DeleteGameAchievementResponseResult = {
    __typename?: 'DeleteGameAchievementResponseResult'
    deletedAchievementId: Scalars['UUID']['output']
}

export type DeleteGameAchievementRewardResponse =
    | DeleteGameAchievementRewardResponseError
    | DeleteGameAchievementRewardResponseResult

export type DeleteGameAchievementRewardResponseError = {
    __typename?: 'DeleteGameAchievementRewardResponseError'
    error: DeleteGameAchievementRewardResponseErrorType
    message: Scalars['String']['output']
}

export enum DeleteGameAchievementRewardResponseErrorType {
    GameAlreadyStarted = 'GAME_ALREADY_STARTED',
    GameNotFound = 'GAME_NOT_FOUND',
    RewardNotFound = 'REWARD_NOT_FOUND'
}

export type DeleteGameAchievementRewardResponseResult = {
    __typename?: 'DeleteGameAchievementRewardResponseResult'
    deletedRewardId: Scalars['UUID']['output']
}

export type DeleteGameResponse =
    | DeleteGameResponseError
    | DeleteGameResponseResult

export type DeleteGameResponseError = {
    __typename?: 'DeleteGameResponseError'
    error: DeleteGameResponseErrorType
    message: Scalars['String']['output']
}

export enum DeleteGameResponseErrorType {
    GameAlreadyStarted = 'GAME_ALREADY_STARTED',
    GameNotFound = 'GAME_NOT_FOUND'
}

export type DeleteGameResponseResult = {
    __typename?: 'DeleteGameResponseResult'
    deletedGameId: Scalars['UUID']['output']
}

export type DeleteLevelResponse =
    | DeleteLevelResponseError
    | DeleteLevelResponseResult

export type DeleteLevelResponseError = {
    __typename?: 'DeleteLevelResponseError'
    error: DeleteLevelResponseErrorType
    message: Scalars['String']['output']
}

export enum DeleteLevelResponseErrorType {
    GameAlreadyStarted = 'GAME_ALREADY_STARTED',
    GameNotFound = 'GAME_NOT_FOUND',
    LevelNotFound = 'LEVEL_NOT_FOUND'
}

export type DeleteLevelResponseResult = {
    __typename?: 'DeleteLevelResponseResult'
    deletedLevelId: Scalars['UUID']['output']
}

export type DeleteLevelRewardFilterResponse =
    | DeleteLevelRewardFilterResponseError
    | DeleteLevelRewardFilterResponseResult

export type DeleteLevelRewardFilterResponseError = {
    __typename?: 'DeleteLevelRewardFilterResponseError'
    error: DeleteLevelRewardFilterResponseErrorType
    message: Scalars['String']['output']
}

export enum DeleteLevelRewardFilterResponseErrorType {
    GameAlreadyStarted = 'GAME_ALREADY_STARTED',
    GameNotFound = 'GAME_NOT_FOUND',
    InvalidFilterValue = 'INVALID_FILTER_VALUE',
    LevelNotFound = 'LEVEL_NOT_FOUND',
    LevelRewardFilterNotFound = 'LEVEL_REWARD_FILTER_NOT_FOUND',
    LevelRewardNotFound = 'LEVEL_REWARD_NOT_FOUND'
}

export type DeleteLevelRewardFilterResponseResult = {
    __typename?: 'DeleteLevelRewardFilterResponseResult'
    deletedFilterId: Scalars['UUID']['output']
}

export type DeleteLevelRewardResponse =
    | DeleteLevelRewardResponseError
    | DeleteLevelRewardResponseResult

export type DeleteLevelRewardResponseError = {
    __typename?: 'DeleteLevelRewardResponseError'
    error: DeleteLevelRewardResponseErrorType
    message: Scalars['String']['output']
}

export enum DeleteLevelRewardResponseErrorType {
    GameAlreadyStarted = 'GAME_ALREADY_STARTED',
    GameNotFound = 'GAME_NOT_FOUND',
    LevelNotFound = 'LEVEL_NOT_FOUND',
    LevelRewardNotFound = 'LEVEL_REWARD_NOT_FOUND'
}

export type DeleteLevelRewardResponseResult = {
    __typename?: 'DeleteLevelRewardResponseResult'
    deletedLevelRewardId: Scalars['UUID']['output']
}

/** Rachel made these names */
export type DeprovisionResponse = {
    __typename?: 'DeprovisionResponse'
    successfulUserIds?: Maybe<Array<Scalars['String']['output']>>
    unsuccessfulUserIds?: Maybe<Array<Scalars['String']['output']>>
}

export type DesktopWebhookEventInput = {
    agentId: Scalars['String']['input']
    companyId: Scalars['UUID']['input']
    contactId: Scalars['String']['input']
    date: Scalars['Instant']['input']
    state: ResetState
}

export type DimensionTrendsDto = {
    __typename?: 'DimensionTrendsDTO'
    currentPeriodScore: Scalars['Int']['output']
    difference: Scalars['Int']['output']
    isZeroTrend: Scalars['Boolean']['output']
    lastPeriodScore: Scalars['Int']['output']
    optimalRange: OptimalRange
    type: Surveys
}

export enum Direction {
    Inbound = 'INBOUND',
    Na = 'NA',
    Outbound = 'OUTBOUND'
}

export type DislikeStepError = {
    __typename?: 'DislikeStepError'
    error: DislikeStepResponseError
}

export type DislikeStepResponse = DislikeStepError | DislikeStepResult

export enum DislikeStepResponseError {
    ErrorCreatingStep = 'ERROR_CREATING_STEP',
    ErrorQueryingMicrostep = 'ERROR_QUERYING_MICROSTEP',
    NonExistentStep = 'NON_EXISTENT_STEP',
    NonExistentToken = 'NON_EXISTENT_TOKEN',
    NoNewRecommendationFound = 'NO_NEW_RECOMMENDATION_FOUND'
}

export type DislikeStepResult = {
    __typename?: 'DislikeStepResult'
    newStep: Step
}

export type DisplayName = {
    __typename?: 'DisplayName'
    displayName?: Maybe<Scalars['String']['output']>
    isPublic: Scalars['Boolean']['output']
    userId?: Maybe<Scalars['UUID']['output']>
}

export enum DisplayTarget {
    Chat = 'CHAT',
    Mobile = 'MOBILE',
    Web = 'WEB',
    /** In addition to showing up on the web, also send a web notification */
    WebNotify = 'WEB_NOTIFY'
}

export type EmailChangeInput = {
    newEmail: Scalars['String']['input']
    oldEmail: Scalars['String']['input']
}

export type EmailChangeOutput = {
    __typename?: 'EmailChangeOutput'
    newEmail: Scalars['String']['output']
    oldEmail: Scalars['String']['output']
}

export type EnablingChallengeStatus = {
    __typename?: 'EnablingChallengeStatus'
    challengesInCompany: Array<UnifiedChallengeCompany>
}

export type EngagementLevelsQuery = {
    __typename?: 'EngagementLevelsQuery'
    /** Historical Engagement Levels for a company */
    historicEngagementLevels: HistoricEngagementLevelResponse
    /** Recent Engagement Levels for a company */
    recentEngagementLevels: RecentEngagementLevelResponse
}

export type EngagementLevelsQueryHistoricEngagementLevelsArgs = {
    companyId: Scalars['UUID']['input']
    end: MonthYearInput
    start: MonthYearInput
}

export type EngagementLevelsQueryRecentEngagementLevelsArgs = {
    companyId: Scalars['UUID']['input']
}

export type EngagementReportResponse = {
    __typename?: 'EngagementReportResponse'
    challengesStarted: Scalars['Long']['output']
    checkins: Scalars['Long']['output']
    companyId: Scalars['UUID']['output']
    lastUpdated: Scalars['ISODate']['output']
    learnModulesStarted: Scalars['Long']['output']
    microstepsCheckedin: Scalars['Long']['output']
    period: ReportPeriod
    resetsPlayed: Scalars['Long']['output']
    uniqueChallengeUsers: Scalars['Long']['output']
    uniqueCheckinUsers: Scalars['Long']['output']
    uniqueLearnUsers: Scalars['Long']['output']
    uniqueMicrostepUsers: Scalars['Long']['output']
    uniqueResetUsers: Scalars['Long']['output']
}

export enum EntityType {
    Microstep = 'MICROSTEP',
    Reset = 'RESET'
}

export enum ErrorCode {
    AssessmentAttemptCompletedAlready = 'ASSESSMENT_ATTEMPT_COMPLETED_ALREADY',
    AssessmentAttemptNotCompleted = 'ASSESSMENT_ATTEMPT_NOT_COMPLETED',
    AssessmentAttemptNotFound = 'ASSESSMENT_ATTEMPT_NOT_FOUND',
    AssessmentBaselineCmsAssessmentNotFound = 'ASSESSMENT_BASELINE_CMS_ASSESSMENT_NOT_FOUND',
    AssessmentBaselineIneligible = 'ASSESSMENT_BASELINE_INELIGIBLE',
    AssessmentCmsAssessmentNotFound = 'ASSESSMENT_CMS_ASSESSMENT_NOT_FOUND',
    AssessmentIneligible = 'ASSESSMENT_INELIGIBLE',
    AssessmentNotAllowed = 'ASSESSMENT_NOT_ALLOWED',
    AssessmentNoJourney = 'ASSESSMENT_NO_JOURNEY',
    AssessmentUnexpectedError = 'ASSESSMENT_UNEXPECTED_ERROR'
}

export type ErrorMessage = {
    __typename?: 'ErrorMessage'
    message: Scalars['String']['output']
}

export type ErrorMessageCustomization = {
    __typename?: 'ErrorMessageCustomization'
    message: Scalars['String']['output']
}

export type ErrorMessageFeelingQuestion = {
    __typename?: 'ErrorMessageFeelingQuestion'
    message: Scalars['String']['output']
}

export type ErrorMessageSleepHabits = {
    __typename?: 'ErrorMessageSleepHabits'
    message: Scalars['String']['output']
}

export type ErrorMessageTemplate = {
    __typename?: 'ErrorMessageTemplate'
    message: Scalars['String']['output']
}

export type ErrorMessageWater = {
    __typename?: 'ErrorMessageWater'
    message: Scalars['String']['output']
}

export type Event = {
    __typename?: 'Event'
    rawJson: Scalars['JSON']['output']
}

export type ExampleGraphapiQuery = {
    __typename?: 'ExampleGraphapiQuery'
    /** Very simple example query */
    helloWorld: Scalars['String']['output']
    /** Return list of microsteps for given list of UUIDs. For example only. */
    readMicrosteps: Array<GraphQlMicrostep>
}

export type ExampleGraphapiQueryReadMicrostepsArgs = {
    uuids: Array<Scalars['String']['input']>
}

export type ExampleQuery = {
    __typename?: 'ExampleQuery'
    /** Very simple example query */
    exampleQuery: Scalars['String']['output']
    /** Return list of microsteps for given list of UUIDs. For example only. */
    microsteps: Array<GraphQlMicrostep>
}

export type ExampleQueryMicrostepsArgs = {
    uuids: Array<Scalars['String']['input']>
}

export type ExternalLinkDetail = {
    __typename?: 'ExternalLinkDetail'
    name?: Maybe<Scalars['String']['output']>
}

export type ExternalPulseMutation = {
    __typename?: 'ExternalPulseMutation'
    /** Create a pulse survey response */
    saveSurveyAnswer: SaveSurveyAnswerResponse
}

export type ExternalPulseMutationSaveSurveyAnswerArgs = {
    requestDate: Scalars['ISODate']['input']
    responseValue: Scalars['Int']['input']
    supportedContentTypes?: InputMaybe<Array<SupportedRecommendedContentType>>
    thriveUserId?: InputMaybe<Scalars['UUID']['input']>
}

export type ExternalPulseQuery = {
    __typename?: 'ExternalPulseQuery'
    /** Company Information */
    company?: Maybe<PulseCompanyDto>
    /** Retrieve actionable Pulse recommendations for a company based on employee responses for a specified set of dimensions */
    getRecommendedContentForCompany: Array<RecommendedContent>
    /** Retrieves a survey for a Thrive user */
    getSurveyForUser: PulseOnDemand
    /** Get All Survey Questions */
    getSurveys: Array<PulseSurveyQuestionDto>
}

export type ExternalPulseQueryCompanyArgs = {
    companyId: Scalars['UUID']['input']
}

export type ExternalPulseQueryGetRecommendedContentForCompanyArgs = {
    companyId: Scalars['UUID']['input']
    dimensions: Array<Surveys>
    from: Scalars['String']['input']
    to: Scalars['String']['input']
}

export type ExternalPulseQueryGetSurveyForUserArgs = {
    channel: Channel
    companyId?: InputMaybe<Scalars['UUID']['input']>
    requestDate: Scalars['ISODate']['input']
    thriveUserId?: InputMaybe<Scalars['UUID']['input']>
}

export type ExternalPulseQueryGetSurveysArgs = {
    activeOnly?: InputMaybe<Scalars['Boolean']['input']>
}

export enum Feedback {
    Dislike = 'Dislike',
    Like = 'Like'
}

export type FeedbackQuestionResponse = FeedbackQuestionYesNoResponse

export enum FeedbackQuestionType {
    YesNo = 'YesNo'
}

export type FeedbackQuestionYesNoResponse = {
    __typename?: 'FeedbackQuestionYesNoResponse'
    response: Scalars['Boolean']['output']
}

export type FeedbackWeightsInput = {
    negative: Scalars['Int']['input']
    neutral: Scalars['Int']['input']
    positive: Scalars['Int']['input']
}

export type FeelingAnswer = {
    __typename?: 'FeelingAnswer'
    /** Answer value */
    answer: Scalars['Int']['output']
    /** Answer day */
    answerDate: Scalars['ISODate']['output']
    /** Challenge day */
    challengeDay: Scalars['Int']['output']
    /** Challenge id */
    challengeId: Scalars['UUID']['output']
}

export type FeelingQuestionDailyStats = {
    __typename?: 'FeelingQuestionDailyStats'
    /** User answer */
    answer: Scalars['Int']['output']
    /** Answer's challenge day */
    challengeDay: Scalars['Int']['output']
    /** Answer's calendar day */
    day: Scalars['Int']['output']
    /** Answer's calendar month */
    month: Scalars['Int']['output']
    /** Answer's calendar year */
    year: Scalars['Int']['output']
}

export type FeelingQuestionDetail = {
    __typename?: 'FeelingQuestionDetail'
    name?: Maybe<Scalars['String']['output']>
}

export type FeelingQuestionOperationResult =
    | ErrorMessageFeelingQuestion
    | FeelingQuestionResult

export type FeelingQuestionResult = {
    __typename?: 'FeelingQuestionResult'
    feelingAnswer: FeelingAnswer
}

export type FeelingQuestionStats = {
    __typename?: 'FeelingQuestionStats'
    /** Average answer through the whole challenge */
    averageAnswer: Scalars['Int']['output']
    dailyStats: Array<FeelingQuestionDailyStats>
}

export enum FilterAttributeType {
    CountryGroup = 'COUNTRY_GROUP'
}

export enum FilterComparator {
    In = 'IN',
    NotIn = 'NOT_IN'
}

export type Frame = {
    _: Scalars['Boolean']['output']
}

export type FrameInputIdInput = {
    frameType: FrameInputType
    id: Scalars['UUID']['input']
    videoEndTimeSeconds?: InputMaybe<Scalars['Int']['input']>
    videoStartTimeSeconds?: InputMaybe<Scalars['Int']['input']>
}

export enum FrameInputType {
    Image = 'image',
    PersonalizedQuote = 'personalizedQuote',
    PersonalizedVideo = 'personalizedVideo',
    Quote = 'quote'
}

export enum Frequency {
    Once = 'ONCE',
    PerGame = 'PER_GAME',
    Seasonal = 'SEASONAL',
    TimeWindowBased = 'TIME_WINDOW_BASED'
}

export type Game = {
    __typename?: 'Game'
    /** The achievements of the game */
    achievements: Array<AchievementV4>
    /** The companyId this game is linked to */
    companyId: Scalars['UUID']['output']
    /** The created date of the game */
    createdAt: Scalars['Instant']['output']
    /** The end date of the game */
    endDate: Scalars['Instant']['output']
    /** The uuid of the game */
    id: Scalars['UUID']['output']
    /** The levels of the game */
    levels: Array<Level>
    /** The name of the game */
    name?: Maybe<Scalars['String']['output']>
    /** The start date of the game */
    startDate: Scalars['Instant']['output']
    /** The subscriptionIds this game is linked to */
    subscriptionIds: Array<Scalars['UUID']['output']>
    /** The updated date of the game */
    updatedAt: Scalars['Instant']['output']
}

export type GameAchievementConditionError = {
    __typename?: 'GameAchievementConditionError'
    error: GameAchievementConditionErrorType
    message: Scalars['String']['output']
}

export enum GameAchievementConditionErrorType {
    AchievementNotFound = 'ACHIEVEMENT_NOT_FOUND',
    ConditionNotFound = 'CONDITION_NOT_FOUND',
    GameAlreadyStarted = 'GAME_ALREADY_STARTED',
    GameNotFound = 'GAME_NOT_FOUND',
    InvalidCondition = 'INVALID_CONDITION'
}

export type GameAchievementConditionResponse =
    | GameAchievementConditionError
    | GameAchievementConditionResult

export type GameAchievementConditionResult = {
    __typename?: 'GameAchievementConditionResult'
    condition: AchievementV4Condition
}

export type GameAchievementError = {
    __typename?: 'GameAchievementError'
    error: GameAchievementErrorType
    message: Scalars['String']['output']
}

export enum GameAchievementErrorType {
    AchievementNotFound = 'ACHIEVEMENT_NOT_FOUND',
    GameAlreadyStarted = 'GAME_ALREADY_STARTED',
    GameNotFound = 'GAME_NOT_FOUND'
}

export type GameAchievementResponse =
    | GameAchievementError
    | GameAchievementResult

export type GameAchievementResult = {
    __typename?: 'GameAchievementResult'
    achievement: AchievementV4
}

export type GameAchievementRewardError = {
    __typename?: 'GameAchievementRewardError'
    error: GameAchievementRewardErrorType
    message: Scalars['String']['output']
}

export enum GameAchievementRewardErrorType {
    AchievementNotFound = 'ACHIEVEMENT_NOT_FOUND',
    GameAlreadyStarted = 'GAME_ALREADY_STARTED',
    GameNotFound = 'GAME_NOT_FOUND',
    InvalidReward = 'INVALID_REWARD',
    RewardNotFound = 'REWARD_NOT_FOUND'
}

export type GameAchievementRewardResponse =
    | GameAchievementRewardError
    | GameAchievementRewardResult

export type GameAchievementRewardResult = {
    __typename?: 'GameAchievementRewardResult'
    reward: AchievementV4Reward
}

export type GameMutation = {
    __typename?: 'GameMutation'
    /** Claims a user reward of type GARDEN_ITEM */
    claimGardenItemReward: ClaimGardenItemRewardResponse
    /** Admin - Creates a new achievement condition */
    createAchievementConditionInGame: GameAchievementConditionResponse
    /** Admin - Creates a new achievement for a game */
    createAchievementInGame: GameAchievementResponse
    /** Admin - Creates a new achievement reward */
    createAchievementRewardInGame: GameAchievementRewardResponse
    /** Admin - Creates a game using default values for levels and achievements */
    createDefaultGame: GameResponse
    /** Admin - Creates a new level for a game */
    createLevel: LevelResponse
    /** Admin - Creates a new reward for a level */
    createLevelReward: LevelRewardResponse
    /** Admin - Creates a new filter for a reward */
    createLevelRewardFilter: LevelRewardFilterResponse
    /** Admin - Deletes an existing achievement condition */
    deleteAchievementConditionInGame: DeleteGameAchievementConditionResponse
    /** Admin - Deletes an existing achievement */
    deleteAchievementInGame: DeleteGameAchievementResponse
    /** Admin - Deletes an existing achievement reward */
    deleteAchievementRewardInGame: DeleteGameAchievementRewardResponse
    /** Admin - Deletes an existing game */
    deleteGame: DeleteGameResponse
    /** Admin - Deletes an existing level */
    deleteLevel: DeleteLevelResponse
    /** Admin - Deletes an existing level reward */
    deleteLevelReward: DeleteLevelRewardResponse
    /** Admin - Deletes an existing level reward filter */
    deleteLevelRewardFilter: DeleteLevelRewardFilterResponse
    /** Admin - Edits an existing achievement condition */
    editAchievementConditionInGame: GameAchievementConditionResponse
    /** Admin - Edits an existing achievement */
    editAchievementInGame: GameAchievementResponse
    /** Admin - Edits an existing achievement reward */
    editAchievementRewardInGame: GameAchievementRewardResponse
    /** Admin - Edits an existing game */
    editGame: GameResponse
    /** Admin - Edits an existing level */
    editLevel: LevelResponse
    /** Admin - Edits an existing level reward */
    editLevelReward: LevelRewardResponse
    /** Admin - Edits an existing filter for a reward */
    editLevelRewardFilter: LevelRewardFilterResponse
}

export type GameMutationClaimGardenItemRewardArgs = {
    productUpc: Scalars['String']['input']
    userLevelRewardId: Scalars['UUID']['input']
}

export type GameMutationCreateAchievementConditionInGameArgs = {
    achievementId: Scalars['UUID']['input']
    conditionInput: AchievementV4ConditionInput
    gameId: Scalars['UUID']['input']
}

export type GameMutationCreateAchievementInGameArgs = {
    achievementInput: AchievementV4Input
    gameId: Scalars['UUID']['input']
}

export type GameMutationCreateAchievementRewardInGameArgs = {
    achievementId: Scalars['UUID']['input']
    badgeId?: InputMaybe<Scalars['UUID']['input']>
    gameId: Scalars['UUID']['input']
    points?: InputMaybe<Scalars['Int']['input']>
    rewardType: RewardType
}

export type GameMutationCreateDefaultGameArgs = {
    companyId: Scalars['UUID']['input']
    endDate: Scalars['Instant']['input']
    name?: InputMaybe<Scalars['String']['input']>
    startDate: Scalars['Instant']['input']
    subscriptionIds: Array<Scalars['UUID']['input']>
}

export type GameMutationCreateLevelArgs = {
    gameId: Scalars['UUID']['input']
    levelNumber: Scalars['Int']['input']
    requiredPoints: Scalars['Int']['input']
}

export type GameMutationCreateLevelRewardArgs = {
    gardenItemSet?: InputMaybe<Scalars['UUID']['input']>
    levelId: Scalars['UUID']['input']
    rewardType: LevelRewardType
}

export type GameMutationCreateLevelRewardFilterArgs = {
    comparator: FilterComparator
    customKey?: InputMaybe<Scalars['String']['input']>
    filterAttributeType: FilterAttributeType
    levelRewardId: Scalars['UUID']['input']
    value: Array<Scalars['String']['input']>
}

export type GameMutationDeleteAchievementConditionInGameArgs = {
    conditionId: Scalars['UUID']['input']
    gameId: Scalars['UUID']['input']
}

export type GameMutationDeleteAchievementInGameArgs = {
    achievementId: Scalars['UUID']['input']
    gameId: Scalars['UUID']['input']
}

export type GameMutationDeleteAchievementRewardInGameArgs = {
    gameId: Scalars['UUID']['input']
    rewardId: Scalars['UUID']['input']
}

export type GameMutationDeleteGameArgs = {
    gameId: Scalars['UUID']['input']
}

export type GameMutationDeleteLevelArgs = {
    levelId: Scalars['UUID']['input']
}

export type GameMutationDeleteLevelRewardArgs = {
    levelRewardId: Scalars['UUID']['input']
}

export type GameMutationDeleteLevelRewardFilterArgs = {
    filterId: Scalars['UUID']['input']
}

export type GameMutationEditAchievementConditionInGameArgs = {
    conditionId: Scalars['UUID']['input']
    conditionInput: AchievementV4ConditionInput
    gameId: Scalars['UUID']['input']
}

export type GameMutationEditAchievementInGameArgs = {
    achievementId: Scalars['UUID']['input']
    achievementInput: AchievementV4Input
    gameId: Scalars['UUID']['input']
}

export type GameMutationEditAchievementRewardInGameArgs = {
    badgeId?: InputMaybe<Scalars['UUID']['input']>
    gameId: Scalars['UUID']['input']
    points?: InputMaybe<Scalars['Int']['input']>
    rewardId: Scalars['UUID']['input']
    rewardType: RewardType
}

export type GameMutationEditGameArgs = {
    companyId: Scalars['UUID']['input']
    endDate: Scalars['Instant']['input']
    gameId: Scalars['UUID']['input']
    name?: InputMaybe<Scalars['String']['input']>
    startDate: Scalars['Instant']['input']
    subscriptionIds: Array<Scalars['UUID']['input']>
}

export type GameMutationEditLevelArgs = {
    levelId: Scalars['UUID']['input']
    levelNumber: Scalars['Int']['input']
    requiredPoints: Scalars['Int']['input']
}

export type GameMutationEditLevelRewardArgs = {
    gardenItemSet?: InputMaybe<Scalars['UUID']['input']>
    levelRewardId: Scalars['UUID']['input']
    rewardType: LevelRewardType
}

export type GameMutationEditLevelRewardFilterArgs = {
    comparator: FilterComparator
    customKey?: InputMaybe<Scalars['String']['input']>
    filterAttributeType: FilterAttributeType
    filterId: Scalars['UUID']['input']
    value: Array<Scalars['String']['input']>
}

export type GameProgress = {
    __typename?: 'GameProgress'
    /** User's current level */
    currentLevelNumber: Scalars['Int']['output']
    /** Total points required for current level */
    currentLevelPointsRequired: Scalars['Int']['output']
    /** Game id */
    gameId?: Maybe<Scalars['UUID']['output']>
    /** Indicates if the user has had any game in the past */
    hasPastOrActualGames: Scalars['Boolean']['output']
    /** List of completed levels */
    levelsProgress: Array<LevelProgress>
    /** Total points required for next level. Null if max level reached */
    nextLevelPointsRequired?: Maybe<Scalars['Int']['output']>
    /** User's points */
    pointsProgress: Scalars['Int']['output']
}

export type GameQuery = {
    __typename?: 'GameQuery'
    /** Gets the current game for the user */
    getCurrentGame?: Maybe<Game>
    /** Gets the current game achievements progress for the user */
    getCurrentGameAchievementsProgress: Array<AchievementV4ProgressGql>
    /** Gets the current game progress for the user */
    getCurrentGameProgress: GameProgress
    /** Admin - Gets a game by id */
    getGame?: Maybe<Game>
    /** Admin - Gets a list of games belonging to a company */
    getGames: Array<Game>
    /** Get all garden item sets */
    getGardenItemSets: Array<GardenItemSet>
    /** Get user rewards */
    getUserRewards: Array<UserLevelReward>
}

export type GameQueryGetCurrentGameAchievementsProgressArgs = {
    actionTypes?: InputMaybe<Array<ActionType>>
    frequencies?: InputMaybe<Array<Frequency>>
}

export type GameQueryGetGameArgs = {
    gameId: Scalars['UUID']['input']
}

export type GameQueryGetGamesArgs = {
    companyId: Scalars['UUID']['input']
}

export type GameQueryGetUserRewardsArgs = {
    includeClaimed?: InputMaybe<Scalars['Boolean']['input']>
}

export type GameResponse = GameResponseError | GameResponseResult

export type GameResponseError = {
    __typename?: 'GameResponseError'
    error: GameResponseErrorType
    message: Scalars['String']['output']
}

export enum GameResponseErrorType {
    GameAlreadyStarted = 'GAME_ALREADY_STARTED',
    GameNotFound = 'GAME_NOT_FOUND',
    InvalidDates = 'INVALID_DATES',
    InvalidName = 'INVALID_NAME',
    NoSubscriptions = 'NO_SUBSCRIPTIONS',
    OverlappingGameDates = 'OVERLAPPING_GAME_DATES'
}

export type GameResponseResult = {
    __typename?: 'GameResponseResult'
    game: Game
}

/** Specific reward information for GARDEN_ITEM types */
export type GardenItemContent = {
    __typename?: 'GardenItemContent'
    /** List of items available as reward */
    availableItems: Array<GardenItemInfo>
    /** If claimed, this indicates the item the user selected */
    claimedItem?: Maybe<GardenItemInfo>
    /** The uuid of the set */
    id: Scalars['UUID']['output']
}

/** Contains information related to a garden item */
export type GardenItemInfo = {
    __typename?: 'GardenItemInfo'
    /** The name of the item */
    name?: Maybe<Scalars['String']['output']>
    /** The item upc */
    upc: Scalars['String']['output']
}

export type GardenItemSet = {
    __typename?: 'GardenItemSet'
    /** The uuid of the set */
    id: Scalars['UUID']['output']
    /** The name of the set */
    name: Scalars['String']['output']
}

export type GenesysIntegrationMutation = {
    __typename?: 'GenesysIntegrationMutation'
    /** Disables Genesys integration for given company. If company doesn't exist it is a NOOP. Returns true if operation actually changed anything */
    disable: Scalars['Boolean']['output']
    /** Add a new Genesys integration to given company. If company doesn't exist, will return an error. If config already exists, it will be enabled without changing anything else. Returns true if operation actually changed anything */
    enable: Scalars['Boolean']['output']
}

export type GenesysIntegrationMutationDisableArgs = {
    companyId: Scalars['UUID']['input']
}

export type GenesysIntegrationMutationEnableArgs = {
    companyId: Scalars['UUID']['input']
    genesysOrgId: Scalars['String']['input']
    iss: Scalars['String']['input']
}

export enum GenesysRegion {
    ApNortheast_1 = 'AP_NORTHEAST_1',
    ApNortheast_2 = 'AP_NORTHEAST_2',
    ApSoutheast_2 = 'AP_SOUTHEAST_2',
    ApSouth_1 = 'AP_SOUTH_1',
    CaCentral_1 = 'CA_CENTRAL_1',
    EuCentral_1 = 'EU_CENTRAL_1',
    EuWest_1 = 'EU_WEST_1',
    EuWest_2 = 'EU_WEST_2',
    UsEast_1 = 'US_EAST_1',
    UsEast_2 = 'US_EAST_2',
    UsWest_2 = 'US_WEST_2',
    Wiremock = 'WIREMOCK'
}

export type GenesysUsEast1IntegrationMutation = {
    __typename?: 'GenesysUsEast1IntegrationMutation'
    /** Disables Genesys US East 1 integration for given company. If company doesn't exist it is a NOOP. Returns true if operation actually changed anything */
    disable: Scalars['Boolean']['output']
    /** Add a new Genesys US East 1 integration to given company. If company doesn't exist, will return an error. If config already exists, it will be enabled without changing anything else. Returns true if operation actually changed anything */
    enable: Scalars['Boolean']['output']
}

export type GenesysUsEast1IntegrationMutationDisableArgs = {
    companyId: Scalars['UUID']['input']
}

export type GenesysUsEast1IntegrationMutationEnableArgs = {
    companyId: Scalars['UUID']['input']
    orgId: Scalars['String']['input']
}

export type GenesysUsWest2IntegrationMutation = {
    __typename?: 'GenesysUsWest2IntegrationMutation'
    /** Disables Genesys US West 2 integration for given company. If company doesn't exist it is a NOOP. Returns true if operation actually changed anything */
    disable: Scalars['Boolean']['output']
    /** Add a new Genesys US West 2 integration to given company. If company doesn't exist, will return an error. If config already exists, it will be enabled without changing anything else. Returns true if operation actually changed anything */
    enable: Scalars['Boolean']['output']
}

export type GenesysUsWest2IntegrationMutationDisableArgs = {
    companyId: Scalars['UUID']['input']
}

export type GenesysUsWest2IntegrationMutationEnableArgs = {
    companyId: Scalars['UUID']['input']
    orgId: Scalars['String']['input']
}

export type GetActiveCoachesForCoacheeFailure = {
    __typename?: 'GetActiveCoachesForCoacheeFailure'
    errorCode: CoachingErrorCode
}

export type GetActiveCoachesForCoacheeGqlResponse =
    | GetActiveCoachesForCoacheeFailure
    | GetActiveCoachesForCoacheeSuccess

export type GetActiveCoachesForCoacheeSuccess = {
    __typename?: 'GetActiveCoachesForCoacheeSuccess'
    result: Array<ActiveCoachGqlModel>
}

export type GetAllCoachesInput = {
    localeFilter?: InputMaybe<Array<Scalars['Locale']['input']>>
    page?: InputMaybe<Scalars['Long']['input']>
    pageSize?: InputMaybe<Scalars['Long']['input']>
    specialtyFilter?: InputMaybe<Array<Scalars['UUID']['input']>>
}

export type GetAssessmentByNameAndVariantInput = {
    name: Scalars['String']['input']
    variant?: InputMaybe<Scalars['String']['input']>
}

export type GetBehavioralProfileInput = {
    from: Scalars['String']['input']
    to: Scalars['String']['input']
}

export type GetCoachAvailableTimeSlotsFailure = {
    __typename?: 'GetCoachAvailableTimeSlotsFailure'
    errorCode: CoachingErrorCode
}

export type GetCoachAvailableTimeSlotsGqlResponse =
    | GetCoachAvailableTimeSlotsFailure
    | GetCoachAvailableTimeSlotsSuccess

export type GetCoachAvailableTimeSlotsSuccess = {
    __typename?: 'GetCoachAvailableTimeSlotsSuccess'
    result: Array<SlotGroup>
}

export type GetCoachFailure = {
    __typename?: 'GetCoachFailure'
    errorCode: CoachingErrorCode
}

export type GetCoachGqlResponse = GetCoachFailure | GetCoachSuccess

export type GetCoachSuccess = {
    __typename?: 'GetCoachSuccess'
    result?: Maybe<CoachGqlModel>
}

export type GetCoacheeOnboardingStateFailure = {
    __typename?: 'GetCoacheeOnboardingStateFailure'
    error: Scalars['String']['output']
}

export type GetCoacheeOnboardingStateResponse =
    | GetCoacheeOnboardingStateFailure
    | GetCoacheeOnboardingStateSuccess

export type GetCoacheeOnboardingStateSuccess = {
    __typename?: 'GetCoacheeOnboardingStateSuccess'
    result?: Maybe<CoacheeOnboardingState>
}

export type GetCoacheeSessionStartTimesFailure = {
    __typename?: 'GetCoacheeSessionStartTimesFailure'
    errorCode: CoachingErrorCode
}

export type GetCoacheeSessionStartTimesGqlResponse =
    | GetCoacheeSessionStartTimesFailure
    | GetCoacheeSessionStartTimesSuccess

export type GetCoacheeSessionStartTimesSuccess = {
    __typename?: 'GetCoacheeSessionStartTimesSuccess'
    result: Array<Scalars['Instant']['output']>
}

export type GetCoacheeSessionStatsAndCohortStatusFailure = {
    __typename?: 'GetCoacheeSessionStatsAndCohortStatusFailure'
    errorCode: CoachingErrorCode
}

export type GetCoacheeSessionStatsAndCohortStatusGqlResponse =
    | GetCoacheeSessionStatsAndCohortStatusFailure
    | GetCoacheeSessionStatsAndCohortStatusSuccess

export type GetCoacheeSessionStatsAndCohortStatusSuccess = {
    __typename?: 'GetCoacheeSessionStatsAndCohortStatusSuccess'
    result: CoacheeSessionUsageAndCohortDataGqlModel
}

export type GetCoacheeSessionsFailure = {
    __typename?: 'GetCoacheeSessionsFailure'
    errorCode: CoachingErrorCode
}

export type GetCoacheeSessionsGqlResponse =
    | GetCoacheeSessionsFailure
    | GetCoacheeSessionsSuccess

export type GetCoacheeSessionsSuccess = {
    __typename?: 'GetCoacheeSessionsSuccess'
    result: Array<CoachingSessionGqlModel>
}

export type GetCoacheeSpecialtiesFailure = {
    __typename?: 'GetCoacheeSpecialtiesFailure'
    errorCode: CoachingErrorCode
}

export type GetCoacheeSpecialtiesResponse =
    | GetCoacheeSpecialtiesFailure
    | GetCoacheeSpecialtiesSuccess

export type GetCoacheeSpecialtiesSuccess = {
    __typename?: 'GetCoacheeSpecialtiesSuccess'
    result: Array<GroupedCoacheeSpecialtyGqlModel>
}

export type GetCoachesFailure = {
    __typename?: 'GetCoachesFailure'
    errorCode: CoachingErrorCode
}

export type GetCoachesGqlResponse = GetCoachesFailure | GetCoachesSuccess

export type GetCoachesSuccess = {
    __typename?: 'GetCoachesSuccess'
    hasMore: Scalars['Boolean']['output']
    page: Scalars['Int']['output']
    pageCount: Scalars['Int']['output']
    pageSize: Scalars['Int']['output']
    result: Array<CoachSummaryGqlModel>
}

export type GetCoachingSpecialtiesInput = {
    categories?: InputMaybe<Array<CoachCategory>>
    visibility?: InputMaybe<CoachVisibility>
}

export type GetCoachingSpecialtiesResponse =
    | GetCoachingSpecialtyFailure
    | GetCoachingSpecialtySuccess

export type GetCoachingSpecialtyFailure = {
    __typename?: 'GetCoachingSpecialtyFailure'
    errorCode: CoachingErrorCode
}

export type GetCoachingSpecialtySuccess = {
    __typename?: 'GetCoachingSpecialtySuccess'
    result: Array<SpecialtyGqlModel>
}

export type GetNotificationSettings = {
    __typename?: 'GetNotificationSettings'
    /** Returns the notification settings for MS Teams user */
    getNotificationSettings: NotificationSettingsOperationResult
}

export type GetNotificationSettingsGetNotificationSettingsArgs = {
    input: NotificationSettingsInput
}

export type GetRecommendedCoachesFailure = {
    __typename?: 'GetRecommendedCoachesFailure'
    errorCode: CoachingErrorCode
}

export type GetRecommendedCoachesGqlResponse =
    | GetRecommendedCoachesFailure
    | GetRecommendedCoachesSuccess

export type GetRecommendedCoachesSuccess = {
    __typename?: 'GetRecommendedCoachesSuccess'
    result: Array<CoachSummaryGqlModel>
}

export type GetRecommendedJourneysByAssessmentInput = {
    assessmentAttemptId: Scalars['UUID']['input']
}

export type GetTimezoneForUserInput = {
    users: Array<Scalars['UUID']['input']>
}

export type GetTimezoneForUserResult = {
    __typename?: 'GetTimezoneForUserResult'
    usersByZone: Array<UsersByTimezone>
}

export type GetTimezoneForUsersQuery = {
    __typename?: 'GetTimezoneForUsersQuery'
    /** Retrieve the timezone and locale information for users */
    getTimezoneForUsers: GetTimezoneForUserResult
}

export type GetTimezoneForUsersQueryGetTimezoneForUsersArgs = {
    input: GetTimezoneForUserInput
}

export type GivenResponse = {
    __typename?: 'GivenResponse'
    assessmentItemId: Scalars['UUID']['output']
    createdAt: Scalars['Instant']['output']
    response?: Maybe<Response>
    updatedAt: Scalars['Instant']['output']
    userTime?: Maybe<Scalars['String']['output']>
}

export type GoalDto = {
    __typename?: 'GoalDTO'
    goal?: Maybe<Scalars['String']['output']>
    id: Scalars['UUID']['output']
    journeyIds: Array<Scalars['UUID']['output']>
}

export type GoalEntityDetail =
    | ArticleDetail
    | AudioResetGoalDetail
    | DailyCheckinDetail
    | ExternalLinkDetail
    | FeelingQuestionDetail
    | MicrostepGoalDetail
    | ResetGoalDetail
    | StepsGoalDetail
    | WaterGoalDetail

export type GoalMutation = {
    __typename?: 'GoalMutation'
    /** Acknowledge the user's answer to change the intention */
    acknowledgeUserIntentionResponse: Scalars['Boolean']['output']
    /** Add adopted microstep to the user's plan */
    addAdoptedMicrostep: AddAdoptedMicrostepResponse
    admin: AdminGoalMutation
    /** Dislike a step and return a new one */
    dislikeStep: DislikeStepResponse
    /**
     * Fetches or creates a microstep plan for the user passing the goal id/journey id
     * @deprecated Use fetchPersonalizedPlan query
     */
    fetchOrCreateUserPlan: UserPlanResponse
    /** Remove adopted microstep to the user's plan */
    removeAdoptedMicrostep: RemoveAdoptedMicrostepResponse
    /** Remove disliked content from the user's list. If contentIds is empty, all disliked content will be removed. */
    resetDislikedContent: Scalars['Int']['output']
    /** Save the user's feedback loop answers */
    saveFeedbackLoopAnswers: SaveFeedbackResponse
    /**
     * Sets an intention for the user
     * @deprecated Use setIntentionV2
     */
    setIntention?: Maybe<Intention>
    /** Sets an intention for the user */
    setIntentionV2: SetIntentionResponse
}

export type GoalMutationAcknowledgeUserIntentionResponseArgs = {
    habitId: Scalars['UUID']['input']
    intentionId: Scalars['UUID']['input']
}

export type GoalMutationAddAdoptedMicrostepArgs = {
    microstepId: Scalars['UUID']['input']
}

export type GoalMutationDislikeStepArgs = {
    stepId: Scalars['UUID']['input']
}

export type GoalMutationFetchOrCreateUserPlanArgs = {
    getFullHabit?: InputMaybe<Scalars['Boolean']['input']>
    goalId?: InputMaybe<Scalars['UUID']['input']>
    journeyId?: InputMaybe<Scalars['UUID']['input']>
}

export type GoalMutationRemoveAdoptedMicrostepArgs = {
    microstepId: Scalars['UUID']['input']
}

export type GoalMutationResetDislikedContentArgs = {
    contentIds: Array<Scalars['UUID']['input']>
}

export type GoalMutationSaveFeedbackLoopAnswersArgs = {
    feedbackQuestion: Scalars['String']['input']
    feedbackScore: Scalars['Int']['input']
}

export type GoalMutationSetIntentionArgs = {
    intention: Scalars['String']['input']
    intentionSettingUx?: InputMaybe<IntentionSettingUxType>
    journeyIds: Array<Scalars['UUID']['input']>
}

export type GoalMutationSetIntentionV2Args = {
    intention: Scalars['String']['input']
    intentionSettingUx?: InputMaybe<IntentionSettingUxType>
    journeyIds: Array<Scalars['UUID']['input']>
}

export type GoalPage = {
    __typename?: 'GoalPage'
    hasMore?: Maybe<Scalars['Boolean']['output']>
    items: Array<GoalDto>
    page: Scalars['Int']['output']
    pageCount?: Maybe<Scalars['Int']['output']>
    pageSize: Scalars['Int']['output']
}

export type GoalQuery = {
    __typename?: 'GoalQuery'
    admin: AdminGoalQuery
    /** Returns true if user needs to be asked for feedback */
    displayFeedback: Scalars['Boolean']['output']
    /** Returns paginated goals from the CMS */
    fetchCMSGoalsPaginated: GoalPage
    /** Returns the user's intention */
    fetchIntention?: Maybe<Intention>
    /** Fetches the user plan */
    fetchPersonalizedPlan: UserPlanResponse
    /** Returns recommended content for the user related to the intention */
    fetchRecommendedContent: Array<RecommendedEntities>
    /** Returns recommended microsteps for the user related to the intention */
    fetchRecommendedMicrosteps: Array<RecommendedMicrostep>
    /** Returns the list of all user steps for the date sect. Defaults to today */
    fetchStepsByDate: Array<Step>
    /** Returns the user subscription tier for intention, 1 is the default tier */
    fetchSubscriptionTier: Scalars['Int']['output']
    /** Return a list of the user habits */
    fetchUserHabitHistory: Array<UserHabitHistory>
    /**
     * Given an intention, goes to ML to retrieve the list of related journeys
     * @deprecated Use mapIntentionToJourneysV2
     */
    mapIntentionToJourneys?: Maybe<IntentionToJourneysResponse>
    /** Given an intention, goes to ML to retrieve the list of related journeys */
    mapIntentionToJourneysV2: IntentionToJourneysResponseV2
}

export type GoalQueryFetchCmsGoalsPaginatedArgs = {
    journeyIds?: InputMaybe<Array<Scalars['UUID']['input']>>
    page?: InputMaybe<Scalars['Int']['input']>
    pageSize?: InputMaybe<Scalars['Int']['input']>
}

export type GoalQueryFetchPersonalizedPlanArgs = {
    journeyId?: InputMaybe<Scalars['UUID']['input']>
}

export type GoalQueryFetchRecommendedContentArgs = {
    limit: Scalars['Int']['input']
    recommendedTypes: Array<PersonalizedRecommendedContent>
}

export type GoalQueryFetchRecommendedMicrostepsArgs = {
    limit: Scalars['Int']['input']
}

export type GoalQueryFetchStepsByDateArgs = {
    date?: InputMaybe<Scalars['ISODate']['input']>
}

export type GoalQueryMapIntentionToJourneysArgs = {
    intention: Scalars['String']['input']
}

export type GoalQueryMapIntentionToJourneysV2Args = {
    intention: Scalars['String']['input']
}

export enum GoalType {
    ArticleRead = 'ARTICLE_READ',
    ArticleWatched = 'ARTICLE_WATCHED',
    CheckIn = 'CHECK_IN',
    ExternalLink = 'EXTERNAL_LINK',
    FeelingQuestion = 'FEELING_QUESTION',
    PulseCheckIn = 'PULSE_CHECK_IN',
    RecipeRead = 'RECIPE_READ',
    RecipeWatched = 'RECIPE_WATCHED',
    ResetListened = 'RESET_LISTENED',
    ResetWatched = 'RESET_WATCHED',
    RoleModelRead = 'ROLE_MODEL_READ',
    RoleModelWatched = 'ROLE_MODEL_WATCHED',
    Steps = 'STEPS',
    Water = 'WATER'
}

export enum Granularity {
    Day = 'DAY',
    Hour = 'HOUR',
    Week = 'WEEK'
}

export type GraphQlMicrostep = {
    __typename?: 'GraphQlMicrostep'
    action: Scalars['String']['output']
    body: Scalars['String']['output']
    cadence: Scalars['String']['output']
    checked?: Maybe<Scalars['Boolean']['output']>
    committed?: Maybe<Scalars['Boolean']['output']>
    company_id?: Maybe<Scalars['ID']['output']>
    created_at: Scalars['String']['output']
    duration: Scalars['Int']['output']
    frequency: Scalars['String']['output']
    gender: Scalars['String']['output']
    id: Scalars['ID']['output']
    journeyIds?: Maybe<Array<Scalars['ID']['output']>>
    journeys: Array<Maybe<Journey>>
    liked?: Maybe<Scalars['Boolean']['output']>
    reminder_enabled: Scalars['Boolean']['output']
    tags: Array<Tag>
    time_of_day: Scalars['String']['output']
    time_unit: Scalars['String']['output']
    title: Scalars['String']['output']
    totalCheckins: Scalars['Int']['output']
    updated_at: Scalars['String']['output']
    useInOnboarding?: Maybe<Scalars['Boolean']['output']>
    worker_type: Scalars['String']['output']
}

export type GraphQlMicrostepMomentum = {
    __typename?: 'GraphQlMicrostepMomentum'
    checkins: Array<CheckinCount>
    total: Scalars['Int']['output']
}

export type GraphQlSearchResult = {
    __typename?: 'GraphQlSearchResult'
    contentType: ContentType
    snippet: Scalars['String']['output']
    title: Scalars['String']['output']
    type: Type
    uuid: Scalars['UUID']['output']
}

export type GroupChallengeTemplateCreateInput = {
    /** The id of the challenge template */
    challengeTemplateId: Scalars['UUID']['input']
    /** To indicate if the private challenge is GROUP or PERSONAL */
    groupChallengeType?: InputMaybe<GroupChallengeType>
    /** Indicates if team members are unlimited */
    isUnlimited?: InputMaybe<Scalars['Boolean']['input']>
    /** Indicates the maximum number of members allowed in teams */
    maxTeamSize?: InputMaybe<Scalars['Int']['input']>
    /** Optional prefix to be displayed before the challenge's name */
    namePrefix?: InputMaybe<Scalars['String']['input']>
    /** The start date of the challenge */
    startDate?: InputMaybe<Scalars['ISODate']['input']>
}

export enum GroupChallengeType {
    Group = 'GROUP',
    Personal = 'PERSONAL'
}

export enum GroupType {
    Group = 'GROUP',
    Queue = 'QUEUE',
    Skill = 'SKILL',
    Team = 'TEAM'
}

export type GroupedCoacheeSpecialtyGqlModel = {
    __typename?: 'GroupedCoacheeSpecialtyGqlModel'
    category: CoachCategory
    specialties: Array<CoacheeSpecialtyGqlModel>
}

export type HapiActivitySummaryModel = {
    __typename?: 'HAPIActivitySummaryModel'
    calories: Scalars['Int']['output']
    createdAt: Scalars['String']['output']
    date: Scalars['String']['output']
    distance: Scalars['Int']['output']
    duration: Scalars['Int']['output']
    humanId: Scalars['String']['output']
    id: Scalars['String']['output']
    light: Scalars['Int']['output']
    moderate: Scalars['Int']['output']
    sedentary: Scalars['Int']['output']
    source: Scalars['String']['output']
    steps: Scalars['Int']['output']
    updatedAt: Scalars['String']['output']
    vigorous: Scalars['Int']['output']
}

export type Habit = {
    __typename?: 'Habit'
    createdAt: Scalars['Instant']['output']
    durationInDays: Scalars['Int']['output']
    id: Scalars['UUID']['output']
    lastUpdatedBy: Scalars['UUID']['output']
    replacedByHabit?: Maybe<Scalars['UUID']['output']>
    steps: Array<Step>
    updatedAt: Scalars['Instant']['output']
}

export type HapiAccessToken = {
    __typename?: 'HapiAccessToken'
    accessToken: Scalars['String']['output']
    expiresIn: Scalars['Int']['output']
    refreshToken: Scalars['String']['output']
}

export type HapiIdToken = {
    __typename?: 'HapiIdToken'
    idRefreshToken: Scalars['String']['output']
    idToken: Scalars['String']['output']
    idTokenExpiresIn: Scalars['Int']['output']
    tokenType: Scalars['String']['output']
}

export type HapiSessionToken = {
    __typename?: 'HapiSessionToken'
    expiresIn: Scalars['Int']['output']
    humanId: Scalars['String']['output']
    sessionToken: Scalars['String']['output']
}

export type HistoricAppUsageResponse = {
    __typename?: 'HistoricAppUsageResponse'
    data: Array<HistoricAppUsageStats>
    trends: AppUsageTrends
}

export type HistoricAppUsageStats = {
    __typename?: 'HistoricAppUsageStats'
    activeUsagePercentage: Scalars['Float']['output']
    activeUsers: Scalars['Long']['output']
    challengesStarted: Scalars['Long']['output']
    checkins: Scalars['Long']['output']
    cumlativeActiveUsers: Scalars['Long']['output']
    learnModulesStarted: Scalars['Long']['output']
    microstepsCheckedIn: Scalars['Long']['output']
    period: MonthYear
    resetsPlayed: Scalars['Long']['output']
    uniqueChallengeUsers: Scalars['Long']['output']
    uniqueCheckinUsers: Scalars['Long']['output']
    uniqueLearnUsers: Scalars['Long']['output']
    uniqueMicrostepUsers: Scalars['Long']['output']
    uniqueResetUsers: Scalars['Long']['output']
}

export type HistoricChallengesCountStats = {
    __typename?: 'HistoricChallengesCountStats'
    challengesJoinedCount: Scalars['Int']['output']
    period: MonthYear
}

export type HistoricChallengesCountStatsResponse = {
    __typename?: 'HistoricChallengesCountStatsResponse'
    data: Array<HistoricChallengesCountStats>
}

export type HistoricDailyCheckInScoresResponse = {
    __typename?: 'HistoricDailyCheckInScoresResponse'
    data: Array<HistoricDailyCheckInScoresStats>
}

export type HistoricDailyCheckInScoresStats = {
    __typename?: 'HistoricDailyCheckInScoresStats'
    averageScore: Scalars['Float']['output']
    averageScoreBenchmarkScorePercentageDifference: Scalars['Float']['output']
    averageScorePercentage: Scalars['Float']['output']
    benchmarkScore: Scalars['Float']['output']
    benchmarkScorePercentage: Scalars['Float']['output']
    employeeCount: Scalars['Int']['output']
    period: MonthYear
    responseCount: Scalars['Int']['output']
}

export type HistoricEngagementLevelMonthlyStats = {
    __typename?: 'HistoricEngagementLevelMonthlyStats'
    benchmarkCount: Scalars['Int']['output']
    benchmarkPercentage: Scalars['Float']['output']
    employeeCount: Scalars['Int']['output']
    percentage: Scalars['Float']['output']
}

export type HistoricEngagementLevelResponse = {
    __typename?: 'HistoricEngagementLevelResponse'
    data: Array<HistoricEngagementLevelStats>
}

export type HistoricEngagementLevelStats = {
    __typename?: 'HistoricEngagementLevelStats'
    atRisk: HistoricEngagementLevelMonthlyStats
    highlyEngaged: HistoricEngagementLevelMonthlyStats
    moderatelyEngaged: HistoricEngagementLevelMonthlyStats
    period: MonthYear
}

export type HistoricMicrostepCheckinCountResponse = {
    __typename?: 'HistoricMicrostepCheckinCountResponse'
    data: Array<HistoricMicrostepCheckinCountStats>
}

export type HistoricMicrostepCheckinCountStats = {
    __typename?: 'HistoricMicrostepCheckinCountStats'
    microstepCheckinUsers: Scalars['Int']['output']
    microstepCheckins: Scalars['Int']['output']
    microstepId: Scalars['UUID']['output']
    microstepName: Scalars['String']['output']
    period: MonthYear
}

export type HumanApiMutation = {
    __typename?: 'HumanApiMutation'
    /** Manually sync all HAPI sources for a user */
    syncSources: Scalars['Boolean']['output']
}

export type HumanApiQuery = {
    __typename?: 'HumanApiQuery'
    /** Get a list of HumanApi source information */
    sourceReference: Array<HumanApiSourceReferenceDto>
}

export type HumanApiSourceReferenceDto = {
    __typename?: 'HumanApiSourceReferenceDTO'
    humanApiSourceId: Scalars['String']['output']
    sourceId: Scalars['UUID']['output']
    sourceName: Scalars['String']['output']
}

export type IdentityAccessTypeMutation = {
    __typename?: 'IdentityAccessTypeMutation'
    /** Create a new access type from the given input */
    create?: Maybe<Scalars['String']['output']>
    /** Tries to delete existing access type by name */
    tryDelete: Scalars['Boolean']['output']
}

export type IdentityAccessTypeMutationCreateArgs = {
    input: AccessTypeInput
}

export type IdentityAccessTypeMutationTryDeleteArgs = {
    name: Scalars['String']['input']
}

export type IdentityAccessTypeQuery = {
    __typename?: 'IdentityAccessTypeQuery'
    /** Returns all access types with optional pagination */
    getAll: AccessTypePage
}

export type IdentityAccessTypeQueryGetAllArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    page?: InputMaybe<Scalars['Int']['input']>
}

export type IdentityBrandMutation = {
    __typename?: 'IdentityBrandMutation'
    /** Create a new brand from the given input */
    create: Brand
    /** Tries to delete existing brand by name */
    tryDelete: Scalars['Boolean']['output']
    /** Tries to update existing brand by the provided input */
    tryUpdate?: Maybe<Brand>
}

export type IdentityBrandMutationCreateArgs = {
    input: BrandInputGraphQlInput
}

export type IdentityBrandMutationTryDeleteArgs = {
    name: Scalars['String']['input']
}

export type IdentityBrandMutationTryUpdateArgs = {
    input: BrandInputGraphQlInput
    name: Scalars['String']['input']
}

export type IdentityBrandQuery = {
    __typename?: 'IdentityBrandQuery'
    /** Returns all brands with optional pagination */
    getAll: BrandPage
    /** Tries to fetch existing brand by name */
    tryGet?: Maybe<Brand>
}

export type IdentityBrandQueryGetAllArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    page?: InputMaybe<Scalars['Int']['input']>
    publicOnly?: InputMaybe<Scalars['Boolean']['input']>
}

export type IdentityBrandQueryTryGetArgs = {
    name: Scalars['String']['input']
}

export type IdentityCompanyMutation = {
    __typename?: 'IdentityCompanyMutation'
    /** Add new brands to the company, returning the company */
    addBrands?: Maybe<Company>
    /** Adds an email domain to owned email domains */
    addOwnedEmailDomain: OwnedEmailDomain
    /** Create a new company from the given input */
    create: Company
    /** Change company status. Enables IDP configs if new status is ACTIVE.  Disables IDP configs if new status is INACTIVE. Returns true if company was found and updated */
    tryChangeStatus: Scalars['Boolean']['output']
    /** Tries to delete existing company by id */
    tryDelete: Scalars['Boolean']['output']
    /** Deletes an email domain from owned email domains */
    tryDeleteOwnedEmailDomain: Scalars['Boolean']['output']
    /** Tries to update existing company by id and provided input */
    tryUpdate?: Maybe<Company>
}

export type IdentityCompanyMutationAddBrandsArgs = {
    brands: Array<BrandInput>
    id: Scalars['UUID']['input']
}

export type IdentityCompanyMutationAddOwnedEmailDomainArgs = {
    input: OwnedEmailDomainInput
}

export type IdentityCompanyMutationCreateArgs = {
    input: CompanyInputGraphQlInput
}

export type IdentityCompanyMutationTryChangeStatusArgs = {
    id: Scalars['UUID']['input']
    status: CompanyStatus
}

export type IdentityCompanyMutationTryDeleteArgs = {
    id: Scalars['UUID']['input']
}

export type IdentityCompanyMutationTryDeleteOwnedEmailDomainArgs = {
    emailDomain: Scalars['String']['input']
}

export type IdentityCompanyMutationTryUpdateArgs = {
    id: Scalars['UUID']['input']
    input: CompanyInputGraphQlInput
}

export type IdentityCompanyQuery = {
    __typename?: 'IdentityCompanyQuery'
    /** Returns all company with optional pagination */
    getAll: CompanyPage
    /** Returns all owned email domains for a company */
    getOwnedEmailDomains: Array<OwnedEmailDomain>
    /** Tries to fetch existing company by id */
    tryGet?: Maybe<Company>
}

export type IdentityCompanyQueryGetAllArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    page?: InputMaybe<Scalars['Int']['input']>
    publicOnly?: InputMaybe<Scalars['Boolean']['input']>
}

export type IdentityCompanyQueryGetOwnedEmailDomainsArgs = {
    companyId: Scalars['UUID']['input']
}

export type IdentityCompanyQueryTryGetArgs = {
    id: Scalars['UUID']['input']
}

export type IdentityIdpConfigMutation = {
    __typename?: 'IdentityIdpConfigMutation'
    /** Allow email domain for given IDP config */
    allowEmailDomain?: Maybe<IdpConfig>
    /** Change the idpCompanyId for a given company. Returns true if config exists and idpCompanyId updated */
    changeIdpCompanyId: Scalars['Boolean']['output']
    /** Change whether idpType is used for friends and family signups only. Returns true if config does exist and was updated */
    changeIdpConfigFriendsAndFamilyOnlyStatus: Scalars['Boolean']['output']
    /** Change priority for IDP config for given company. Returns true if config does exist and was updated */
    changePriority: Scalars['Boolean']['output']
    /** Create a new IDP Config from the given input */
    create: IdpConfig
    /** Disable IDP config for given company. Returns true if config does exist and was disabled */
    disable: Scalars['Boolean']['output']
    /** Disallow email domain for given IDP config */
    disallowEmailDomain?: Maybe<IdpConfig>
    /** Enables IDP config for given company. Returns true if config does exist and was enabled */
    enable: Scalars['Boolean']['output']
    /** Set (replace) email domain allowlist for given IDP config */
    setEmailAllowlist?: Maybe<IdpConfig>
    /** Tries to delete existing IDP Config by id */
    tryDelete: Scalars['Boolean']['output']
    /** Tries to update existing IDP Config by id and provided input */
    tryUpdate?: Maybe<IdpConfig>
}

export type IdentityIdpConfigMutationAllowEmailDomainArgs = {
    emailDomain: Scalars['String']['input']
    idpConfigId: Scalars['UUID']['input']
}

export type IdentityIdpConfigMutationChangeIdpCompanyIdArgs = {
    companyId: Scalars['UUID']['input']
    idpCompanyId: Scalars['String']['input']
    idpType: IdpType
}

export type IdentityIdpConfigMutationChangeIdpConfigFriendsAndFamilyOnlyStatusArgs =
    {
        companyId: Scalars['UUID']['input']
        friendsAndFamilyOnly: Scalars['Boolean']['input']
        idpType: IdpType
    }

export type IdentityIdpConfigMutationChangePriorityArgs = {
    companyId: Scalars['UUID']['input']
    idpType: IdpType
    priority?: InputMaybe<Scalars['Int']['input']>
}

export type IdentityIdpConfigMutationCreateArgs = {
    input: IdpConfigInputGraphQlInput
}

export type IdentityIdpConfigMutationDisableArgs = {
    companyId: Scalars['UUID']['input']
    idpType: IdpType
}

export type IdentityIdpConfigMutationDisallowEmailDomainArgs = {
    emailDomain: Scalars['String']['input']
    idpConfigId: Scalars['UUID']['input']
}

export type IdentityIdpConfigMutationEnableArgs = {
    companyId: Scalars['UUID']['input']
    idpType: IdpType
}

export type IdentityIdpConfigMutationSetEmailAllowlistArgs = {
    idpConfigId: Scalars['UUID']['input']
    input: IdpConfigSetEmailAllowlistInput
}

export type IdentityIdpConfigMutationTryDeleteArgs = {
    id: Scalars['UUID']['input']
}

export type IdentityIdpConfigMutationTryUpdateArgs = {
    id: Scalars['UUID']['input']
    input: IdpConfigInputGraphQlInput
}

export type IdentityIdpConfigQuery = {
    __typename?: 'IdentityIdpConfigQuery'
    /** Returns all IDP Configs with optional pagination */
    getAll: IdpConfigPage
    /** Tries to fetch existing IDP Config by id */
    tryGet?: Maybe<IdpConfig>
    /** Tries to find an existing IDP Config by IDP Type + IDP Company ID (external company ID, or signupCode for ZP/cognito) */
    tryGetByIdpCompanyId?: Maybe<IdpConfig>
}

export type IdentityIdpConfigQueryGetAllArgs = {
    filters?: InputMaybe<IdpConfigFiltersInput>
    limit?: InputMaybe<Scalars['Int']['input']>
    page?: InputMaybe<Scalars['Int']['input']>
}

export type IdentityIdpConfigQueryTryGetArgs = {
    id: Scalars['UUID']['input']
}

export type IdentityIdpConfigQueryTryGetByIdpCompanyIdArgs = {
    idpCompanyId: Scalars['String']['input']
    idpType: IdpType
}

export type IdentityJwkCacheMutation = {
    __typename?: 'IdentityJwkCacheMutation'
    /** Purge all JWK cache entries */
    purge: Scalars['Boolean']['output']
}

export type IdentityJwkCacheQuery = {
    __typename?: 'IdentityJwkCacheQuery'
    /** Get all current cache entries from JWK cache */
    entries: Array<JwkCacheEntry>
}

export type IdentityMutation = {
    __typename?: 'IdentityMutation'
    accessType: IdentityAccessTypeMutation
    brand: IdentityBrandMutation
    company: IdentityCompanyMutation
    idpConfig: IdentityIdpConfigMutation
    idpProfile: IdpProfileMutation
    integration: IntegrationMutation
    jwkCache: IdentityJwkCacheMutation
    resourceType: IdentityResourceTypeMutation
    scope: IdentityScopeMutation
    signupCode: IdentitySignupCodeMutation
    subscription: IdentitySubscriptionMutation
    user: IdentityUserMutation
    /** Used to update attributes attached to this user (e.g. timezone, locale,...). Not to be confused with with attributes coming from IDP information. */
    userAttributes: UserAttributeMutation
}

export type IdentityQuery = {
    __typename?: 'IdentityQuery'
    accessType: IdentityAccessTypeQuery
    brand: IdentityBrandQuery
    company: IdentityCompanyQuery
    idpConfig: IdentityIdpConfigQuery
    jwkCache: IdentityJwkCacheQuery
    /** Returns authenticated user */
    me: User
    partner: PartnerQuery
    /** Used to query for referral information */
    referrals: IdentityReferralsQuery
    resourceType: IdentityResourceTypeQuery
    scope: IdentityScopeQuery
    signupCode: IdentitySignupCodeQuery
    subscription: IdentitySubscriptionQuery
    user: IdentityUserQuery
    /** Used to query attributes attached to this user (e.g. timezone, locale,...). Not to be confused with with attributes coming from IDP information (see 'me' query). */
    userAttributes: UserAttributeQuery
    userGroups: IdentityUserGroupQuery
}

export type IdentityReferralsQuery = {
    __typename?: 'IdentityReferralsQuery'
    /** Retrieve subscriptions and signup codes for a users company */
    subscriptionGroupCodes: SubscriptionGroupCodesResponse
}

export type IdentityResourceTypeMutation = {
    __typename?: 'IdentityResourceTypeMutation'
    /** Create a new resource type from the given input */
    create?: Maybe<Scalars['String']['output']>
    /** Tries to delete existing resource type by name */
    tryDelete: Scalars['Boolean']['output']
}

export type IdentityResourceTypeMutationCreateArgs = {
    input: ResourceTypeInput
}

export type IdentityResourceTypeMutationTryDeleteArgs = {
    name: Scalars['String']['input']
}

export type IdentityResourceTypeQuery = {
    __typename?: 'IdentityResourceTypeQuery'
    /** Returns all resource types with optional pagination */
    getAll: ResourceTypePage
}

export type IdentityResourceTypeQueryGetAllArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    page?: InputMaybe<Scalars['Int']['input']>
}

export type IdentityScopeMutation = {
    __typename?: 'IdentityScopeMutation'
    /** Create a new scope from the given input */
    create: Scope
    /** Tries to delete existing scope by id */
    tryDelete: Scalars['Boolean']['output']
    /** Tries to update existing scope by id and provided input */
    tryUpdate?: Maybe<Scope>
}

export type IdentityScopeMutationCreateArgs = {
    input: ScopeInputGraphQlInput
}

export type IdentityScopeMutationTryDeleteArgs = {
    id: Scalars['UUID']['input']
}

export type IdentityScopeMutationTryUpdateArgs = {
    id: Scalars['UUID']['input']
    input: ScopeInputGraphQlInput
}

export type IdentityScopeQuery = {
    __typename?: 'IdentityScopeQuery'
    /** Returns all scopes with optional pagination and filters */
    getAll: ScopePage
    /** Tries to fetch existing scope by id */
    tryGet?: Maybe<Scope>
}

export type IdentityScopeQueryGetAllArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    page?: InputMaybe<Scalars['Int']['input']>
    subscriptionId?: InputMaybe<Scalars['UUID']['input']>
}

export type IdentityScopeQueryTryGetArgs = {
    id: Scalars['UUID']['input']
}

export type IdentitySignupCodeMutation = {
    __typename?: 'IdentitySignupCodeMutation'
    /** Create a new signup code from the given input */
    create: SignupCode
    /** Tries to delete existing signup code by name */
    tryDelete: Scalars['Boolean']['output']
    /** Tries to update existing signup code by name and provided input */
    tryUpdate?: Maybe<SignupCode>
}

export type IdentitySignupCodeMutationCreateArgs = {
    input: SignupCodeInput
}

export type IdentitySignupCodeMutationTryDeleteArgs = {
    signupCode: Scalars['String']['input']
}

export type IdentitySignupCodeMutationTryUpdateArgs = {
    input: SignupCodeInput
    signupCode: Scalars['String']['input']
}

export type IdentitySignupCodeQuery = {
    __typename?: 'IdentitySignupCodeQuery'
    /** Returns all signup codes with optional pagination */
    getAll: SignupCodePage
    /** Tries to fetch existing signup code by name */
    tryGet?: Maybe<SignupCode>
}

export type IdentitySignupCodeQueryGetAllArgs = {
    filters?: InputMaybe<SignupCodeFiltersInput>
    limit?: InputMaybe<Scalars['Int']['input']>
    page?: InputMaybe<Scalars['Int']['input']>
}

export type IdentitySignupCodeQueryTryGetArgs = {
    signupCode: Scalars['String']['input']
}

export type IdentitySubscriptionMutation = {
    __typename?: 'IdentitySubscriptionMutation'
    /** Create a new subscription from the given input */
    create: UserSubscription
    /** Sets the provided subscription as the default (will disable isDefault on all other subscriptions) */
    makeDefault: Scalars['UUID']['output']
    /** Sets the isDefault flag if possible, returning the value of the flag (unchanged if it cannot be changed) */
    setDefault: Scalars['Boolean']['output']
    /** Tries to delete existing subscription by id */
    tryDelete: Scalars['Boolean']['output']
    /** Tries to update existing subscription by id and provided input */
    tryUpdate?: Maybe<UserSubscription>
}

export type IdentitySubscriptionMutationCreateArgs = {
    input: SubscriptionInputGraphQlInput
}

export type IdentitySubscriptionMutationMakeDefaultArgs = {
    id: Scalars['UUID']['input']
}

export type IdentitySubscriptionMutationSetDefaultArgs = {
    id: Scalars['UUID']['input']
    isDefault: Scalars['Boolean']['input']
}

export type IdentitySubscriptionMutationTryDeleteArgs = {
    id: Scalars['UUID']['input']
}

export type IdentitySubscriptionMutationTryUpdateArgs = {
    id: Scalars['UUID']['input']
    input: SubscriptionInputGraphQlInput
}

export type IdentitySubscriptionQuery = {
    __typename?: 'IdentitySubscriptionQuery'
    /** Returns all subscriptions with optional pagination */
    getAll: SubscriptionPage
    /** Tries to fetch existing subscription by id */
    tryGet?: Maybe<UserSubscription>
}

export type IdentitySubscriptionQueryGetAllArgs = {
    filters?: InputMaybe<SubscriptionFiltersInput>
    limit?: InputMaybe<Scalars['Int']['input']>
    page?: InputMaybe<Scalars['Int']['input']>
}

export type IdentitySubscriptionQueryTryGetArgs = {
    id: Scalars['UUID']['input']
}

export type IdentityUserAttribute = {
    __typename?: 'IdentityUserAttribute'
    name: Scalars['String']['output']
    userId: Scalars['UUID']['output']
    value: Scalars['String']['output']
}

export type IdentityUserGroupQuery = {
    __typename?: 'IdentityUserGroupQuery'
    /** Returns the list of user groups with associated auth roles which can be assigned to a user. */
    getUserGroups: Array<UserGroup>
}

export type IdentityUserMutation = {
    __typename?: 'IdentityUserMutation'
    /** Accept the Terms of Service for the authenticated user. Returns the date and time the user accepted the ToS. If the user has already accepted the ToS, returns the date and time the user accepted the ToS previously. */
    acceptToS: WhenToSAccepted
    /** Adds user to a Thrive group */
    addUserToGroup: Scalars['Boolean']['output']
    /** Change an attribute of an existing user */
    changeAttributeOfAnExistingUser: Scalars['Boolean']['output']
    /** Change the email address of an existing user */
    changeEmailAddressOfAnExistingUser: Scalars['Boolean']['output']
    /** Change the email address of an existing user when a conflicting user exists */
    changeEmailAddressOfAnExistingUserWithConflict: Scalars['Boolean']['output']
    /** Change the email address of many existing users and handle conflicts appropriately */
    changeEmailAddressOfExistingUsersWithConflict: Array<EmailChangeOutput>
    /** Change a subscription of an existing user */
    changeSubscriptionOfAnExistingUser: Scalars['Boolean']['output']
    /** Create a new partner user for the given input */
    createPartnerUser: IdpProfile
    /** Delete a group of users. */
    deleteUsers: Scalars['Boolean']['output']
    /** Deprovision a group of users */
    deprovisionUsers: DeprovisionResponse
    /** Get a magic link for a user */
    getMagicLink: PrivateMagicLinkResponse
    impersonate: TokenResponse
    /** Given IDP information and Thrive User ID of an existing user returns that user's token from Keycloak if the user is allowed to login */
    impersonateExistingUserByIdp: TokenResponse
    /** Initiate the deletion process for the authenticated user's account, using the supplied email as a point of contact.  Email must match hash, or for users with no email hash, email must not match any other users.  Throws an error if email doesn't match or user cannot be found.  Returns 'true' if the delete initiation was successful, or 'false' if the initiation failed given a valid user. */
    initiateDeletion: Scalars['Boolean']['output']
    /** Request one-time upload URL for Cloudflare Images */
    initiateDirectUpload?: Maybe<Scalars['String']['output']>
    refreshToken: TokenResponse
    /** Remove user from a Thrive group */
    removeUserFromGroup: Scalars['Boolean']['output']
    /** Send referral emails to a list of email addresses */
    sendReferralEmails: ReferralEmailResponse
    /** Tries to delete existing user by id */
    tryDelete: Scalars['Boolean']['output']
    /** Update the verification status of an existing user */
    updateVerificationStatus?: Maybe<User>
    /** Get existing or create new user object within Identity Database based purely on email hash. Will throw an error if subscription associated with given ID couldn't be found. Will TRY to update subscription (depends on is-default flag) if subscription Id is present on fetching */
    upsert: User
    /** Write an event acknowledging that a user referred another user */
    writeReferral: Scalars['Boolean']['output']
}

export type IdentityUserMutationAcceptToSArgs = {
    input?: InputMaybe<AcceptToSInput>
}

export type IdentityUserMutationAddUserToGroupArgs = {
    group: Scalars['UUID']['input']
    userId: Scalars['UUID']['input']
}

export type IdentityUserMutationChangeAttributeOfAnExistingUserArgs = {
    attribute: VisibleProfileAttribute
    userId: Scalars['UUID']['input']
    value: Scalars['String']['input']
}

export type IdentityUserMutationChangeEmailAddressOfAnExistingUserArgs = {
    newEmail: Scalars['String']['input']
    oldEmail: Scalars['String']['input']
}

export type IdentityUserMutationChangeEmailAddressOfAnExistingUserWithConflictArgs =
    {
        newEmail: Scalars['String']['input']
        oldEmail: Scalars['String']['input']
    }

export type IdentityUserMutationChangeEmailAddressOfExistingUsersWithConflictArgs =
    {
        emailChanges: Array<EmailChangeInput>
    }

export type IdentityUserMutationChangeSubscriptionOfAnExistingUserArgs = {
    subscriptionId: Scalars['UUID']['input']
    userId: Scalars['UUID']['input']
}

export type IdentityUserMutationCreatePartnerUserArgs = {
    input: PartnerUserInputGraphQlInput
}

export type IdentityUserMutationDeleteUsersArgs = {
    reason: Scalars['String']['input']
    userList?: InputMaybe<Array<Scalars['String']['input']>>
}

export type IdentityUserMutationDeprovisionUsersArgs = {
    attributeName?: InputMaybe<Scalars['String']['input']>
    attributeValue?: InputMaybe<Scalars['String']['input']>
    deprovisionReason: Scalars['String']['input']
    userList?: InputMaybe<Array<Scalars['String']['input']>>
}

export type IdentityUserMutationGetMagicLinkArgs = {
    input: PrivateMagicLinkRequestInput
}

export type IdentityUserMutationImpersonateArgs = {
    attributes?: InputMaybe<Array<UserAttributeInput>>
    companyName: Scalars['String']['input']
    email?: InputMaybe<Scalars['String']['input']>
    firstName?: InputMaybe<Scalars['String']['input']>
    idpId: Scalars['String']['input']
    idpType: IdpType
    ignoreKcUpdate?: InputMaybe<Scalars['Boolean']['input']>
    issuer?: InputMaybe<Scalars['String']['input']>
    lastName?: InputMaybe<Scalars['String']['input']>
    realm?: InputMaybe<Realm>
    userId?: InputMaybe<Scalars['UUID']['input']>
}

export type IdentityUserMutationImpersonateExistingUserByIdpArgs = {
    companyIdpId: Scalars['String']['input']
    idpId: Scalars['String']['input']
    idpType: IdpType
    userId: Scalars['UUID']['input']
}

export type IdentityUserMutationInitiateDeletionArgs = {
    email: Scalars['String']['input']
}

export type IdentityUserMutationRemoveUserFromGroupArgs = {
    group: Scalars['UUID']['input']
    userId: Scalars['UUID']['input']
}

export type IdentityUserMutationSendReferralEmailsArgs = {
    input: ReferralEmailRequestInput
}

export type IdentityUserMutationTryDeleteArgs = {
    id: Scalars['UUID']['input']
}

export type IdentityUserMutationUpdateVerificationStatusArgs = {
    userId: Scalars['UUID']['input']
    verificationStatus: VerificationStatus
}

export type IdentityUserMutationUpsertArgs = {
    input: UpsertUserInput
}

export type IdentityUserMutationWriteReferralArgs = {
    referringUserId: Scalars['UUID']['input']
}

export type IdentityUserQuery = {
    __typename?: 'IdentityUserQuery'
    /** Returns the country code sent by cloudflare */
    getCountryCodeHeader?: Maybe<Scalars['String']['output']>
    /** Tries to fetch existing user by id */
    tryGet?: Maybe<User>
    /** Tries to fetch existing user by email */
    tryGetByEmail?: Maybe<User>
    /** Tries to fetch existing user by idp id, idp type and company name in idp config */
    tryGetByIdpId?: Maybe<User>
    /** Tries to fetch existing user using IDP id and IDP type */
    tryGetByIdpIdAndIdpType?: Maybe<User>
    /** Fetches a user with their idp profiles by user id */
    tryGetUserWithIdpProfiles?: Maybe<User>
    /** Tries to fetch existing user with their idp profiles by email */
    tryGetUserWithIdpProfilesByEmail?: Maybe<User>
    usersForCompany: UserByCompanyPage
    /** Tries to get when Terms of Service was accepted for the current user. If the user has not accepted the Terms of Service, returns null. */
    whenToSAccepted?: Maybe<WhenToSAccepted>
    /** Returns the view we would have of an authenticated user */
    you: User
}

export type IdentityUserQueryTryGetArgs = {
    id: Scalars['UUID']['input']
}

export type IdentityUserQueryTryGetByEmailArgs = {
    email: Scalars['String']['input']
    realm?: InputMaybe<Realm>
}

export type IdentityUserQueryTryGetByIdpIdArgs = {
    idpCompanyName: Scalars['String']['input']
    idpId: Scalars['String']['input']
    idpType: IdpType
}

export type IdentityUserQueryTryGetByIdpIdAndIdpTypeArgs = {
    idpId: Scalars['String']['input']
    idpType: IdpType
    lookupKeycloak: Scalars['Boolean']['input']
}

export type IdentityUserQueryTryGetUserWithIdpProfilesArgs = {
    id: Scalars['UUID']['input']
}

export type IdentityUserQueryTryGetUserWithIdpProfilesByEmailArgs = {
    email: Scalars['String']['input']
    realm?: InputMaybe<Realm>
}

export type IdentityUserQueryUsersForCompanyArgs = {
    companyId: Scalars['UUID']['input']
    limit?: InputMaybe<Scalars['Int']['input']>
    page?: InputMaybe<Scalars['Int']['input']>
}

export type IdentityUserQueryYouArgs = {
    idpId?: InputMaybe<Scalars['String']['input']>
    idpType?: InputMaybe<IdpType>
    userId: Scalars['UUID']['input']
}

export type IdpConfig = {
    __typename?: 'IdpConfig'
    companyId: Scalars['UUID']['output']
    configuration: Scalars['String']['output']
    emailAllowList: Array<Scalars['String']['output']>
    enabled: Scalars['Boolean']['output']
    id: Scalars['UUID']['output']
    idpCompanyId?: Maybe<Scalars['String']['output']>
    idpType: Scalars['String']['output']
    loginMethod: Scalars['String']['output']
}

export type IdpConfigFiltersInput = {
    companyId?: InputMaybe<Scalars['UUID']['input']>
    idpTypes?: InputMaybe<Array<IdpType>>
}

export type IdpConfigInputGraphQlInput = {
    companyId: Scalars['UUID']['input']
    configuration: Scalars['String']['input']
    emailAllowList?: InputMaybe<Array<Scalars['String']['input']>>
    enabled?: InputMaybe<Scalars['Boolean']['input']>
    idpCompanyId?: InputMaybe<Scalars['String']['input']>
    idpType: IdpType
    loginMethod: LoginMethod
}

export type IdpConfigPage = {
    __typename?: 'IdpConfigPage'
    items: Array<IdpConfig>
    itemsPerPage: Scalars['Int']['output']
    page: Scalars['Int']['output']
    total: Scalars['Int']['output']
}

export type IdpConfigSetEmailAllowlistInput = {
    emailAllowlist: Array<Scalars['String']['input']>
}

export type IdpIdEntry = {
    __typename?: 'IdpIdEntry'
    idpId?: Maybe<Scalars['String']['output']>
    idpType: IdpType
    source?: Maybe<Scalars['String']['output']>
}

export type IdpProfile = {
    __typename?: 'IdpProfile'
    idpId: Scalars['String']['output']
    idpType: Scalars['String']['output']
    userId: Scalars['UUID']['output']
}

export type IdpProfileMutation = {
    __typename?: 'IdpProfileMutation'
    /** Links authenticated user with defined provider using token in body */
    link: IdpProfile
}

export type IdpProfileMutationLinkArgs = {
    token: Scalars['String']['input']
    type: IdpType
}

export enum IdpType {
    Awscognito = 'awscognito',
    Azuread = 'azuread',
    Genesys = 'genesys',
    GenesysUsEast_1 = 'genesys_us_east_1',
    GenesysUsWest_2 = 'genesys_us_west_2',
    HumanApi = 'human_api',
    KeycloakDirectPassword = 'keycloak_direct_password',
    KeycloakDirectWebauthn = 'keycloak_direct_webauthn',
    KeycloakOktaSso = 'keycloak_okta_sso',
    KeycloakSso = 'keycloak_sso',
    KeycloakTokenExchange = 'keycloak_token_exchange',
    Magiclink = 'magiclink',
    Nice = 'nice',
    Okta = 'okta',
    OktaZp = 'okta_zp',
    Partner = 'partner',
    Slack = 'slack',
    Webex = 'webex',
    WebexTst = 'webex_tst',
    Zoom = 'zoom'
}

export type Image = Frame & {
    __typename?: 'Image'
    _: Scalars['Boolean']['output']
    accentColor?: Maybe<Scalars['Color']['output']>
    createdAt: Scalars['Instant']['output']
    description?: Maybe<Scalars['String']['output']>
    dominantColors: Array<Scalars['Color']['output']>
    id: Scalars['UUID']['output']
    order?: Maybe<Scalars['Int']['output']>
    resets: Array<PersonalizedReset>
    tag?: Maybe<ImageTag>
    /** @deprecated this field is deprecated, replace with urls.xs */
    thumbnailUrl?: Maybe<Scalars['Url']['output']>
    updatedAt: Scalars['Instant']['output']
    /** @deprecated this field is deprecated, replace with urls.xl */
    url: Scalars['Url']['output']
    urls: ImageUrls
    user?: Maybe<ResetApiUser>
}

export type ImageQuery = {
    __typename?: 'ImageQuery'
    personalized: PersonalizedImageQuery
    thrive: ThriveImageQuery
}

export enum ImageTag {
    Animal = 'Animal',
    Family = 'Family',
    Nature = 'Nature'
}

export type ImageUrls = {
    __typename?: 'ImageUrls'
    lg: Scalars['Url']['output']
    md: Scalars['Url']['output']
    sm: Scalars['Url']['output']
    xl: Scalars['Url']['output']
    xs: Scalars['Url']['output']
}

export type ImagesMutation = {
    __typename?: 'ImagesMutation'
    personalized: PersonalizedImagesMutation
}

export type InAppMessageDto = {
    __typename?: 'InAppMessageDTO'
    body: Scalars['String']['output']
    callToActionText?: Maybe<Scalars['String']['output']>
    callToActionUrl?: Maybe<Scalars['String']['output']>
    endDate?: Maybe<Scalars['ISODate']['output']>
    excludedSubscriptions: Array<Scalars['UUID']['output']>
    eyebrowText?: Maybe<Scalars['String']['output']>
    header: Scalars['String']['output']
    image?: Maybe<UploadFileDto>
    imageUrl?: Maybe<Scalars['String']['output']>
    includedSubscriptions: Array<Scalars['UUID']['output']>
    isUnrestricted?: Maybe<Scalars['Boolean']['output']>
    locale?: Maybe<Scalars['String']['output']>
    page: InAppMessagePageDto
    startDate?: Maybe<Scalars['ISODate']['output']>
    type: InAppMessageTypeDto
    uuid: Scalars['String']['output']
}

export enum InAppMessagePageDto {
    Challenges = 'CHALLENGES',
    Guide = 'GUIDE',
    Insights = 'INSIGHTS',
    Journeys = 'JOURNEYS',
    Learn = 'LEARN',
    Pulse = 'PULSE',
    Reset = 'RESET'
}

export enum InAppMessageTypeDto {
    Banner = 'BANNER',
    ImageBanner = 'IMAGE_BANNER',
    PersonalizedReset = 'PERSONALIZED_RESET',
    UnknownValue = 'UNKNOWN_VALUE'
}

export type InChallengeData = {
    __typename?: 'InChallengeData'
    challengeDay: Scalars['Int']['output']
    challengeId: Scalars['UUID']['output']
    challengeType: InChallengeType
}

export type InChallengeDataInput = {
    challengeDay: Scalars['Int']['input']
    challengeId: Scalars['UUID']['input']
    challengeType: InChallengeType
}

export type InChallengeGoalReminder = {
    __typename?: 'InChallengeGoalReminder'
    challenges: Array<InChallengeData>
}

export enum InChallengeType {
    Biotype = 'BIOTYPE',
    Company = 'COMPANY',
    Group = 'GROUP',
    Journey = 'JOURNEY',
    Personal = 'PERSONAL',
    Prize = 'PRIZE'
}

export type InjectQuery = {
    __typename?: 'InjectQuery'
    /** Mutation to generate a TMobile shaped contact event on Firebase DB (on default Thrive company with id: da4d10d3-6b4b-4ee6-8a9f-521805ad89f4). It does it async and completes in 10 seconds. */
    injectTMobileInboundContact: Scalars['Boolean']['output']
    /** Mutation to generate a TMobile shaped READY_FOR_RESET event on Firebase DB (on default Thrive company with id: da4d10d3-6b4b-4ee6-8a9f-521805ad89f4). */
    injectTMobileWaitingForReset: Scalars['Boolean']['output']
}

export type InjectQueryInjectTMobileInboundContactArgs = {
    agentId: Scalars['String']['input']
    companyId?: InputMaybe<Scalars['UUID']['input']>
}

export type InjectQueryInjectTMobileWaitingForResetArgs = {
    agentId: Scalars['String']['input']
}

export type InputFeedbackInput = {
    answer: ContentFeedback
    question: Scalars['String']['input']
}

export type InsightsMutation = {
    __typename?: 'InsightsMutation'
    /** Update the last time a user played the tutorial to now */
    setTutorialLastPlayedToNow?: Maybe<TutorialConfig>
}

export type InsightsQuery = {
    __typename?: 'InsightsQuery'
    /** Get the given user's changes in a dimension over a given date range */
    adminDimensionTrends?: Maybe<Array<DimensionTrendsDto>>
    /** Get assessment statistics for the given time range and interval */
    assessmentStats?: Maybe<Array<AssessmentStats>>
    /** Get total completed assessments over the given range for survey dimensions */
    completedAssessments: Scalars['Int']['output']
    /** Get changes in a dimension over a given date range */
    dimensionTrends?: Maybe<Array<DimensionTrendsDto>>
    /** Get risk cohort statistics over the specified range */
    riskCohortStatistics: Array<RiskCohortStats>
    /** Get a users trend highlights */
    trendHighlights: TrendHighlights
    /** Get user checkin maturity status, determines whether the user can see their individual dashboard and - if they can't - how many responses are left until their account is considered mature */
    userCheckinMaturity?: Maybe<UserCheckinMaturity>
    /** Get a users tutorial config */
    userTutorialConfig?: Maybe<TutorialConfig>
}

export type InsightsQueryAdminDimensionTrendsArgs = {
    companyId: Scalars['UUID']['input']
    dimensions: Array<Surveys>
    userId: Scalars['UUID']['input']
}

export type InsightsQueryAssessmentStatsArgs = {
    dashboardViewType?: InputMaybe<DashboardViewType>
    dimensions: Array<Surveys>
    intervalType: ReportInterval
}

export type InsightsQueryCompletedAssessmentsArgs = {
    dashboardViewType?: InputMaybe<DashboardViewType>
    dimensions?: InputMaybe<Array<Surveys>>
}

export type InsightsQueryDimensionTrendsArgs = {
    dimensions: Array<Surveys>
}

export type InsightsQueryRiskCohortStatisticsArgs = {
    dimension: Surveys
}

export type InsightsQueryTrendHighlightsArgs = {
    dimensions: Array<Surveys>
}

export type InstallationMutation = {
    __typename?: 'InstallationMutation'
    /** Used to create required identify resources during Genesys self install */
    createIdentityCompanyForGenesys: Scalars['String']['output']
}

export type InstallationMutationCreateIdentityCompanyForGenesysArgs = {
    genesysRegion: GenesysRegion
    token: Scalars['String']['input']
}

export type IntakeResult = {
    __typename?: 'IntakeResult'
    waterIntake: WaterIntake
}

export type IntegrationMutation = {
    __typename?: 'IntegrationMutation'
    genesys: GenesysIntegrationMutation
    genesysUsEast1: GenesysUsEast1IntegrationMutation
    genesysUsWest2: GenesysUsWest2IntegrationMutation
    keycloakDirectPassword: KeycloakDirectPasswordIntegrationMutation
    keycloakOktaSso: KeycloakOktaSsoIntegrationMutation
    keycloakSso: KeycloakSsoIntegrationMutation
    magicLink: MagicLinkIntegrationMutation
    msTeams: MsTeamsIntegrationMutation
    nice: NiceIntegrationMutation
    oktaSso: OktaIntegrationMutation
    partner: PartnerIntegrationMutation
    slack: SlackIntegrationMutation
    webex: WebexIntegrationMutation
    webexTst: WebexTstIntegrationMutation
}

export type Intention = {
    __typename?: 'Intention'
    createdAt: Scalars['Instant']['output']
    /** The id of this intention */
    id: Scalars['UUID']['output']
    /** The intention string */
    intention?: Maybe<Scalars['String']['output']>
    /** If the user selected 'not now' when setting the intention */
    intentionSettingUx?: Maybe<IntentionSettingUxType>
    /** The journey id the intention is associated with */
    journeyIds?: Maybe<Array<Scalars['UUID']['output']>>
    journeys: Array<Maybe<Journey>>
    updatedAt: Scalars['Instant']['output']
    /** The id of the user */
    userId: Scalars['UUID']['output']
}

export type IntentionSettingMutation = {
    __typename?: 'IntentionSettingMutation'
    /** Send a confirmation to a user's chat confirming intention selection */
    sendIntentionSelectedConfirmation: TeamsSendIntentionSelectedConfirmationResult
}

export enum IntentionSettingUxType {
    FreeText = 'FREE_TEXT',
    PredefinedSelected = 'PREDEFINED_SELECTED',
    TopicsSelected = 'TOPICS_SELECTED',
    UserDefersToThrive = 'USER_DEFERS_TO_THRIVE',
    UserPostponed = 'USER_POSTPONED'
}

export type IntentionToJourneysResponse = {
    __typename?: 'IntentionToJourneysResponse'
    journeyIds?: Maybe<Array<Scalars['UUID']['output']>>
    journeys: Array<Maybe<Journey>>
}

export type IntentionToJourneysResponseV2 =
    | IntentionToJourneysV2Error
    | IntentionToJourneysV2Result

export type IntentionToJourneysV2Error = {
    __typename?: 'IntentionToJourneysV2Error'
    inappropriateContent?: Maybe<IntentionValidation>
    type: IntentionToJourneysV2ErrorType
}

export enum IntentionToJourneysV2ErrorType {
    InappropriateContentError = 'INAPPROPRIATE_CONTENT_ERROR',
    IntentionLengthError = 'INTENTION_LENGTH_ERROR'
}

export type IntentionToJourneysV2Result = {
    __typename?: 'IntentionToJourneysV2Result'
    journeyIds?: Maybe<Array<Scalars['UUID']['output']>>
    journeys: Array<Maybe<Journey>>
}

export type IntentionValidation = {
    __typename?: 'IntentionValidation'
    items: Array<IntentionValidationItem>
}

export enum IntentionValidationCategory {
    Hate = 'HATE',
    SelfHarm = 'SELF_HARM',
    Sexual = 'SEXUAL',
    Violence = 'VIOLENCE'
}

export type IntentionValidationItem = {
    __typename?: 'IntentionValidationItem'
    /** Category for which the validation has found a match */
    category: IntentionValidationCategory
    /** Severity of the match. Higher is more severe */
    severity: Scalars['Int']['output']
}

export type InvalidAction = {
    __typename?: 'InvalidAction'
    message: Scalars['String']['output']
}

export type InvalidField = {
    __typename?: 'InvalidField'
    field: InvalidFieldIdentifier
    message: Scalars['String']['output']
}

export enum InvalidFieldIdentifier {
    Id = 'ID',
    Name = 'NAME'
}

export type InvalidInput = {
    __typename?: 'InvalidInput'
    invalidFields: Array<InvalidField>
}

export type IsCoacheeOnboardingCompleteResponse =
    | IsOnboardingCompleteFailure
    | IsOnboardingCompleteSuccess

export type IsOnboardingCompleteFailure = {
    __typename?: 'IsOnboardingCompleteFailure'
    error: Scalars['String']['output']
}

export type IsOnboardingCompleteSuccess = {
    __typename?: 'IsOnboardingCompleteSuccess'
    result: Scalars['Boolean']['output']
}

export type JoinChallengeSucceeded = {
    __typename?: 'JoinChallengeSucceeded'
    challengeActivity: UnifiedUserChallengeActivity
}

export type JournalMutation = {
    __typename?: 'JournalMutation'
    saveMySurveyJournal?: Maybe<MySurveyJournal>
}

export type JournalMutationSaveMySurveyJournalArgs = {
    input: MySurveyJournalInput
}

export type JournalQuery = {
    __typename?: 'JournalQuery'
    getMySurveyJournal?: Maybe<MySurveyJournal>
    getMySurveyJournals: MySurveyJournalPage
}

export type JournalQueryGetMySurveyJournalArgs = {
    id: Scalars['UUID']['input']
}

export type JournalQueryGetMySurveyJournalsArgs = {
    page?: InputMaybe<Scalars['Int']['input']>
    pageSize?: InputMaybe<Scalars['Int']['input']>
}

export type Journey = {
    __typename?: 'Journey'
    colorPalette: JourneyColorPalette
    coreType?: Maybe<JourneyCoreType>
    createdAt: Scalars['Instant']['output']
    description?: Maybe<Scalars['String']['output']>
    emoji?: Maybe<Scalars['String']['output']>
    enabled: Scalars['Boolean']['output']
    hasMicrosteps: Scalars['Boolean']['output']
    id: Scalars['ID']['output']
    /** @deprecated Use imageUrl */
    image?: Maybe<Scalars['String']['output']>
    imageUrl: Scalars['String']['output']
    /** @deprecated Use getLatestUserProgress */
    isSelected: Scalars['Boolean']['output']
    /** Total number of levels in the journey */
    journeyLevels?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use getLatestUserProgress */
    journeyProgress?: Maybe<JourneyProgress>
    journeyProgressForGivenUser?: Maybe<JourneyProgress>
    name: Scalars['String']['output']
    preferredOrder?: Maybe<Scalars['Int']['output']>
    shortName?: Maybe<Scalars['String']['output']>
    thumbnailUrl: Scalars['String']['output']
    topic?: Maybe<Scalars['String']['output']>
    updatedAt: Scalars['Instant']['output']
}

export type JourneyJourneyProgressForGivenUserArgs = {
    userId: Scalars['UUID']['input']
}

export type JourneyColorPalette = {
    __typename?: 'JourneyColorPalette'
    contrastText: Scalars['Color']['output']
    dark: Scalars['Color']['output']
    light: Scalars['Color']['output']
    main: Scalars['Color']['output']
}

export enum JourneyCoreType {
    Connect = 'Connect',
    Focus = 'Focus',
    Food = 'Food',
    Money = 'Money',
    Move = 'Move',
    Recharge = 'Recharge',
    StressManagement = 'Stress_Management'
}

export type JourneyDailyStep = {
    __typename?: 'JourneyDailyStep'
    contentStatus?: Maybe<LearnContentStatus>
    contentType: LearnContentStatusType
    day: Scalars['Int']['output']
    description: Scalars['String']['output']
    durationInSeconds: Scalars['Int']['output']
    id: Scalars['ID']['output']
    iframeUrl: Scalars['String']['output']
    imageUrl: Scalars['String']['output']
    isCompleted: Scalars['Boolean']['output']
    journey?: Maybe<Journey>
    level: Scalars['Int']['output']
    microsteps: Array<GraphQlMicrostep>
    /** MicrostepsV2 filter by subscriptionId */
    microstepsV2: Array<MicrostepV2>
    /** calculated based on the 'order'; example 'Day 3' */
    name: Scalars['String']['output']
    title: Scalars['String']['output']
    videoUrl: Scalars['String']['output']
}

export type JourneyDailyStepIframeUrlArgs = {
    userId: Scalars['UUID']['input']
    utmSource: Scalars['String']['input']
}

export type JourneyDailyStepContentStatusInput = {
    /** JourneyDailyStep id */
    contentId: Scalars['String']['input']
    /** JourneyDailyStep progress in seconds */
    progressInSeconds?: InputMaybe<Scalars['Int']['input']>
    progressType: LearnContentStatusProgressType
    totalInSeconds?: InputMaybe<Scalars['Int']['input']>
}

export type JourneyDailyStepV2 = {
    __typename?: 'JourneyDailyStepV2'
    contentType: LearnContentStatusType
    day: Scalars['Int']['output']
    description: Scalars['String']['output']
    durationInSeconds: Scalars['Int']['output']
    id: Scalars['UUID']['output']
    iframeUrl: Scalars['String']['output']
    imageUrl: Scalars['String']['output']
    level: Scalars['Int']['output']
    microsteps: Array<GraphQlMicrostep>
    /** calculated based on the 'order'; example 'Day 3' */
    name: Scalars['String']['output']
    title: Scalars['String']['output']
    videoUrl: Scalars['String']['output']
}

export type JourneyDailyStepV2IframeUrlArgs = {
    userId: Scalars['UUID']['input']
    utmSource: Scalars['String']['input']
}

export type JourneyDailyStepVideoMetadata = {
    __typename?: 'JourneyDailyStepVideoMetadata'
    alternativeText?: Maybe<Scalars['String']['output']>
    caption?: Maybe<Scalars['String']['output']>
    day?: Maybe<Scalars['Int']['output']>
    description?: Maybe<Scalars['String']['output']>
    id?: Maybe<Scalars['Int']['output']>
    journeyId?: Maybe<Scalars['Int']['output']>
    journeyName?: Maybe<Scalars['String']['output']>
    journeyUuid?: Maybe<Scalars['UUID']['output']>
    level?: Maybe<Scalars['Int']['output']>
    name: Scalars['String']['output']
    thumbnailUrl?: Maybe<Scalars['String']['output']>
    title: Scalars['String']['output']
    url: Scalars['String']['output']
    uuid?: Maybe<Scalars['UUID']['output']>
}

export type JourneyLevel = {
    __typename?: 'JourneyLevel'
    /** collection of daily steps, usually 7 */
    dailySteps: Array<JourneyDailyStep>
    /** Returns JourneyLevelCompletionFeedback from CMS when level is completed, otherwise returns null.Feedback question response is populated if user submitted their response */
    feedback?: Maybe<JourneyLevelCompletionFeedback>
    journey?: Maybe<Journey>
    journeyLevelProgress: JourneyLevelProgress
    level: Scalars['Int']['output']
    /** calculated based on the 'order'; example 'Level 2' */
    name: Scalars['String']['output']
}

export type JourneyLevelCompletionFeedback = {
    __typename?: 'JourneyLevelCompletionFeedback'
    isSkipped?: Maybe<Scalars['Boolean']['output']>
    isSubmitted?: Maybe<Scalars['Boolean']['output']>
    questions: Array<JourneyLevelCompletionFeedbackQuestion>
    uuid: Scalars['UUID']['output']
}

export type JourneyLevelCompletionFeedbackQuestion = {
    __typename?: 'JourneyLevelCompletionFeedbackQuestion'
    question: Scalars['String']['output']
    /** @deprecated No longer supported */
    response?: Maybe<FeedbackQuestionResponse>
    type: FeedbackQuestionType
}

export type JourneyLevelProgress = {
    __typename?: 'JourneyLevelProgress'
    isCompleted: Scalars['Boolean']['output']
    numberOfCompletedSteps: Scalars['Int']['output']
    /** @deprecated Use numberOfCompletedSteps and totalNumberOfSteps instead */
    progressInPercent: Scalars['Int']['output']
    totalNumberOfSteps: Scalars['Int']['output']
}

export type JourneyLevelV2 = {
    __typename?: 'JourneyLevelV2'
    completedDailySteps: Array<JourneyDailyStepV2>
    /** collection of daily steps, usually 7 */
    dailySteps: Array<JourneyDailyStepV2>
    /** Returns JourneyLevelCompletionFeedback from CMS when level is completed, otherwise returns null.Feedback question response is populated if user submitted their response */
    feedback?: Maybe<JourneyLevelCompletionFeedback>
    journeyId: Scalars['UUID']['output']
    journeyLevelProgress: JourneyLevelProgress
    level: Scalars['Int']['output']
    /** calculated based on the 'order'; example 'Level 2' */
    name: Scalars['String']['output']
}

export type JourneyMutation = {
    __typename?: 'JourneyMutation'
    /** Completes journey for the user */
    completeJourneyForUser?: Maybe<Array<LearnContentStatus>>
    /**
     * Restart Journey
     * @deprecated Use restartJourneyV2Admin instead
     */
    restartJourney: Scalars['String']['output']
    /** Restart journey for the user */
    restartJourneyV2: JourneyRestartResponse
    /** Admin endpoint for restarting the journey for a user */
    restartJourneyV2Admin: JourneyRestartResponse
    /** Save JourneyLevelCompletionFeedback for a journey and level */
    saveJourneyLevelCompletionFeedback: Scalars['String']['output']
    /** User mutation to select one of the Core Journeys, userId is taken from the jwt token */
    selectCoreJourney: Scalars['String']['output']
    /** User mutation to select one of the Core Journeys, userId is passed as a parameter (for Chat) */
    selectCoreJourneyForGivenUser: Scalars['String']['output']
    /** Skips JourneyLevelCompletionFeedback (saves user skip action) for a journey and level */
    skipJourneyLevelCompletionFeedback: Scalars['String']['output']
    /** User mutation to unselect user's Core journey */
    unselectCoreJourneyForGivenUser: Scalars['String']['output']
}

export type JourneyMutationCompleteJourneyForUserArgs = {
    companyId: Scalars['UUID']['input']
    journeyId: Scalars['UUID']['input']
    locale: Scalars['String']['input']
    subscriptionId: Scalars['UUID']['input']
    userId: Scalars['UUID']['input']
    zoneId: Scalars['String']['input']
}

export type JourneyMutationRestartJourneyArgs = {
    journeyId: Scalars['UUID']['input']
    userId: Scalars['UUID']['input']
}

export type JourneyMutationRestartJourneyV2Args = {
    journeyId: Scalars['UUID']['input']
}

export type JourneyMutationRestartJourneyV2AdminArgs = {
    journeyId: Scalars['UUID']['input']
    userId: Scalars['UUID']['input']
}

export type JourneyMutationSaveJourneyLevelCompletionFeedbackArgs = {
    feedback?: InputMaybe<Array<InputFeedbackInput>>
    journeyId: Scalars['UUID']['input']
    level: Scalars['Int']['input']
}

export type JourneyMutationSelectCoreJourneyArgs = {
    journeyId: Scalars['UUID']['input']
}

export type JourneyMutationSelectCoreJourneyForGivenUserArgs = {
    journeyId: Scalars['UUID']['input']
    userId: Scalars['UUID']['input']
}

export type JourneyMutationSkipJourneyLevelCompletionFeedbackArgs = {
    journeyId: Scalars['UUID']['input']
    level: Scalars['Int']['input']
}

export type JourneyMutationUnselectCoreJourneyForGivenUserArgs = {
    userId: Scalars['UUID']['input']
}

export type JourneyProgress = {
    __typename?: 'JourneyProgress'
    currentLevel?: Maybe<JourneyLevel>
    currentStep?: Maybe<JourneyDailyStep>
    dailySteps: Array<JourneyDailyStep>
    isCompleted: Scalars['Boolean']['output']
    isTodaysProgress: Scalars['Boolean']['output']
    journey?: Maybe<Journey>
    journeyLevel?: Maybe<JourneyLevel>
    stepCompletedToday?: Maybe<JourneyDailyStep>
}

export type JourneyProgressJourneyLevelArgs = {
    level: Scalars['Int']['input']
}

export type JourneyProgressV2 = {
    __typename?: 'JourneyProgressV2'
    completedProgress: Array<UserJourneyProgress>
    currentLevel?: Maybe<JourneyLevelV2>
    currentStep?: Maybe<JourneyDailyStepV2>
    dailySteps?: Maybe<Array<JourneyDailyStepV2>>
    isCompleted: Scalars['Boolean']['output']
    isTodaysProgress: Scalars['Boolean']['output']
    journey?: Maybe<Journey>
    stepCompletedToday?: Maybe<UserJourneyProgress>
}

export type JourneyQuery = {
    __typename?: 'JourneyQuery'
    /** Get all Journey Daily Step */
    getAllJourneyDailySteps: Array<JourneyDailyStep>
    /** Core Journeys available to a company */
    getCoreJourneys: Array<Journey>
    /** Journey Daily Step by uuid */
    getJourneyDailyStep?: Maybe<JourneyDailyStep>
    /** Journey Daily Step videos */
    getJourneyDailyStepVideos: Array<JourneyDailyStepVideoMetadata>
    /** User completed journey progress V2 */
    getLatestUserProgressV2?: Maybe<UserJourneyProgressV2>
    /** Returns the list of uncompleted journeys */
    getUncompletedJourneys: Array<Scalars['UUID']['output']>
    /** Returns the list of uncompleted journeys */
    getUncompletedJourneysAdmin: Array<Scalars['UUID']['output']>
    /** Returns the list of uncompleted journeys with journey progress details */
    getUncompletedJourneysProgress: Array<UncompletedJourneyProgress>
    /** Individual Journey information */
    journey?: Maybe<Journey>
    /** Individual Journey information */
    journeys: Array<Journey>
    /** A users preferred journeys and the journeys available to them. */
    myJourneyPreferences: UserJourneys
    /** A users preferred journeys and the journeys available to them for a given user id. */
    myJourneyPreferencesForGivenUserId: UserJourneys
}

export type JourneyQueryGetCoreJourneysArgs = {
    adaptToIntentions?: InputMaybe<Scalars['Boolean']['input']>
}

export type JourneyQueryGetJourneyDailyStepArgs = {
    contentId: Scalars['UUID']['input']
}

export type JourneyQueryGetLatestUserProgressV2Args = {
    userId?: InputMaybe<Scalars['UUID']['input']>
}

export type JourneyQueryGetUncompletedJourneysAdminArgs = {
    userId: Scalars['UUID']['input']
}

export type JourneyQueryJourneyArgs = {
    id: Scalars['ID']['input']
}

export type JourneyQueryJourneysArgs = {
    ids: Array<Scalars['ID']['input']>
}

export type JourneyQueryMyJourneyPreferencesForGivenUserIdArgs = {
    userID: Scalars['UUID']['input']
}

export type JourneyRestart = {
    __typename?: 'JourneyRestart'
    createdAt: Scalars['Instant']['output']
    journeyId: Scalars['UUID']['output']
    restartCount: Scalars['Int']['output']
    updatedAt: Scalars['Instant']['output']
    userId: Scalars['UUID']['output']
}

export type JourneyRestartError = {
    __typename?: 'JourneyRestartError'
    error: RestartError
}

export type JourneyRestartResponse = JourneyRestartError | JourneyRestartResult

export type JourneyRestartResult = {
    __typename?: 'JourneyRestartResult'
    journeyRestart: JourneyRestart
}

export type JwkCacheEntry = {
    __typename?: 'JwkCacheEntry'
    algoName?: Maybe<Scalars['String']['output']>
    e?: Maybe<Scalars['String']['output']>
    issuer: Scalars['String']['output']
    jwkUrl: Scalars['Url']['output']
    kid?: Maybe<Scalars['String']['output']>
    n?: Maybe<Scalars['String']['output']>
}

export type KeycloakDirectPasswordIntegrationMutation = {
    __typename?: 'KeycloakDirectPasswordIntegrationMutation'
    /** Disables Keycloak Direct Password integration for given company. If company doesn't exist it is a NOOP. Returns true if operation actually changed anything */
    disable: Scalars['Boolean']['output']
    /** Add a new Keycloak Direct Password integration to given company. If company doesn't exist, will return an error. If config already exists, it will be enabled without changing anything else. Returns true if operation actually changed anything. */
    enable: Scalars['Boolean']['output']
}

export type KeycloakDirectPasswordIntegrationMutationDisableArgs = {
    companyId: Scalars['UUID']['input']
}

export type KeycloakDirectPasswordIntegrationMutationEnableArgs = {
    companyId: Scalars['UUID']['input']
    emailAllowList?: InputMaybe<Array<Scalars['String']['input']>>
}

export type KeycloakOktaSsoIntegrationMutation = {
    __typename?: 'KeycloakOktaSsoIntegrationMutation'
    /** Disables Keycloak Okta SSO integration for given company. If company doesn't exist it is a NOOP. Returns true if operation actually changed anything */
    disable: Scalars['Boolean']['output']
    /** Add a new Keycloak Okta SSO integration to given company. If company doesn't exist, will return an error. If config already exists, it will be enabled without changing anything else. Returns true if operation actually changed anything. IdpHint is a unique identifier of SSO connection in the Keycloak */
    enable: Scalars['Boolean']['output']
}

export type KeycloakOktaSsoIntegrationMutationDisableArgs = {
    companyId: Scalars['UUID']['input']
}

export type KeycloakOktaSsoIntegrationMutationEnableArgs = {
    companyId: Scalars['UUID']['input']
    emailAllowList?: InputMaybe<Array<Scalars['String']['input']>>
    idpHint: Scalars['String']['input']
}

export type KeycloakSsoIntegrationMutation = {
    __typename?: 'KeycloakSsoIntegrationMutation'
    /** Disables Keycloak SSO integration for given company. If company doesn't exist it is a NOOP. Returns true if operation actually changed anything */
    disable: Scalars['Boolean']['output']
    /** Add a new Keycloak SSO integration to given company. If company doesn't exist, will return an error. If config already exists, it will be enabled without changing anything else. Returns true if operation actually changed anything. IdpHint is a unique identifier of SSO connection in the Keycloak */
    enable: Scalars['Boolean']['output']
}

export type KeycloakSsoIntegrationMutationDisableArgs = {
    companyId: Scalars['UUID']['input']
}

export type KeycloakSsoIntegrationMutationEnableArgs = {
    companyId: Scalars['UUID']['input']
    emailAllowList?: InputMaybe<Array<Scalars['String']['input']>>
    idpHint: Scalars['String']['input']
}

export type Leaderboard = {
    __typename?: 'Leaderboard'
    rankedList: Array<ScoreRanked>
    /** The requester entity ranked position */
    requesterRank: Scalars['Int']['output']
    totalEntries: Scalars['Int']['output']
}

export type LearnContentBookmark = {
    __typename?: 'LearnContentBookmark'
    bookmarked: Scalars['Boolean']['output']
    contentId: Scalars['String']['output']
    contentSubtype?: Maybe<LearnContentStatusSubtype>
    contentType: LearnContentStatusType
    createdAt: Scalars['Instant']['output']
    updatedAt: Scalars['Instant']['output']
    userId: Scalars['UUID']['output']
}

export type LearnContentByTopicOutput = {
    __typename?: 'LearnContentByTopicOutput'
    itemPage: LearnContentItemPage
    topic: Topic
}

export type LearnContentFeedback = {
    __typename?: 'LearnContentFeedback'
    contentId: Scalars['String']['output']
    contentSubtype?: Maybe<LearnContentStatusSubtype>
    contentType: LearnContentStatusType
    feedbackAnswer: ContentFeedback
    feedbackQuestion: Scalars['String']['output']
    openAnswer?: Maybe<Scalars['String']['output']>
    openQuestion?: Maybe<Scalars['String']['output']>
    subscriptionId: Scalars['UUID']['output']
    userId: Scalars['UUID']['output']
}

export type LearnContentItem = {
    __typename?: 'LearnContentItem'
    contentStatus?: Maybe<LearnContentStatus>
    contentSubtype: LearnContentStatusSubtype
    contentType: LearnContentStatusType
    durationInSeconds?: Maybe<Scalars['Int']['output']>
    iconName?: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    imageUrl: Scalars['String']['output']
    parent?: Maybe<LearnContentParent>
    title: Scalars['String']['output']
}

export type LearnContentItemPage = {
    __typename?: 'LearnContentItemPage'
    hasMore?: Maybe<Scalars['Boolean']['output']>
    items: Array<LearnContentItem>
    page: Scalars['Int']['output']
    pageCount?: Maybe<Scalars['Int']['output']>
    pageSize: Scalars['Int']['output']
}

export type LearnContentLikes = {
    __typename?: 'LearnContentLikes'
    contentId: Scalars['String']['output']
    contentSubtype?: Maybe<LearnContentStatusSubtype>
    contentType: LearnContentStatusType
    createdAt: Scalars['Instant']['output']
    likes: Scalars['Int']['output']
    updatedAt: Scalars['Instant']['output']
    userId: Scalars['UUID']['output']
}

export type LearnContentParent =
    | AudioChapterPartParent
    | CourseModuleParent
    | PodcastEpisodeParent

/** Represents progress of a content */
export type LearnContentProgress = {
    __typename?: 'LearnContentProgress'
    /** Calculated, returns true if content is completed or if both numberOfCompletedItems and totalNumberOfItems is 0 */
    isCompleted: Scalars['Boolean']['output']
    numberOfCompletedItems: Scalars['Int']['output']
    /** Calculated, returns percentage of completion */
    progressInPercent: Scalars['Int']['output']
    totalNumberOfItems: Scalars['Int']['output']
}

export type LearnContentStatus = {
    __typename?: 'LearnContentStatus'
    contentId: Scalars['String']['output']
    createdAt: Scalars['Instant']['output']
    hasCompleted: Scalars['Boolean']['output']
    inProgress: Scalars['Boolean']['output']
    key: LearnContentStatusKey
    progressInPercent: Scalars['Int']['output']
    progressInSeconds?: Maybe<Scalars['Int']['output']>
    progressInSecondsOrDefault: Scalars['Int']['output']
    progressType: LearnContentStatusProgressType
    subscriptionId?: Maybe<Scalars['UUID']['output']>
    subtype?: Maybe<LearnContentStatusSubtype>
    totalInSeconds?: Maybe<Scalars['Int']['output']>
    totalInSecondsOrDefault: Scalars['Int']['output']
    type: LearnContentStatusType
    updatedAt: Scalars['Instant']['output']
    userId: Scalars['UUID']['output']
}

export type LearnContentStatusKey = {
    __typename?: 'LearnContentStatusKey'
    contentId: Scalars['String']['output']
    type: LearnContentStatusType
    userId: Scalars['UUID']['output']
}

export enum LearnContentStatusProgressType {
    Finished = 'Finished',
    InProgress = 'InProgress',
    Opened = 'Opened'
}

export enum LearnContentStatusSubtype {
    Audio = 'Audio',
    Text = 'Text',
    Video = 'Video'
}

export enum LearnContentStatusType {
    AcuteCareResource = 'AcuteCareResource',
    Article = 'Article',
    AudioBookChapterPart = 'AudioBookChapterPart',
    Course = 'Course',
    CourseResource = 'CourseResource',
    JourneyDailyStep = 'JourneyDailyStep',
    Lesson = 'Lesson',
    Microstep = 'Microstep',
    Module = 'Module',
    Podcast = 'Podcast',
    PodcastEpisode = 'PodcastEpisode',
    Recipe = 'Recipe',
    Reset = 'Reset',
    RoleModel = 'RoleModel',
    WatchMeThrive = 'WatchMeThrive',
    Webinar = 'Webinar'
}

export type LearnFeaturedContent = {
    __typename?: 'LearnFeaturedContent'
    featuredArticle?: Maybe<ArticleV2>
    featuredCourse?: Maybe<CourseV2>
    featuredPodcastEpisode?: Maybe<PodcastEpisode>
    id: Scalars['ID']['output']
    isUnrestricted: Scalars['Boolean']['output']
    trendingArticle?: Maybe<ArticleV2>
    trendingCourse?: Maybe<CourseV2>
    trendingPodcastEpisode?: Maybe<PodcastEpisode>
}

export type LearnMutationV2 = CourseMutation &
    ModuleMutation & {
        __typename?: 'LearnMutationV2'
        /** Mutation to create a bookmark, based on userId from context */
        createBookmark: LearnContentBookmark
        /** Mutation to delete a bookmark, based on userId from context */
        deleteBookmark?: Maybe<LearnContentBookmark>
        /** Mutation creating or updating journey daily step status, for a given user. Emits event 'JourneyLevelCompleted'. */
        markAcuteCareResourceAsSeen: LearnContentStatus
        /** Mutation creating or updating course resource status (for course or lesson), based on userId from context */
        markCourseResourceAsCompleted: LearnContentStatus
        /** Mutation creating or updating journey daily step status, based on userId from context. Emits event 'JourneyLevelCompleted'. */
        markJourneyDailyStepAsCompleted: LearnContentStatus
        /** Mutation creating or updating journey daily step status, for a given user. Emits event 'JourneyLevelCompleted'. */
        markJourneyDailyStepAsCompletedForGivenUser: LearnContentStatus
        /** Mutation to register a user to a webinar using webinarId and userId from context */
        registerForWebinar: WebinarRegistrationResponse
        /** Save feedback of any type of content from questions at the end, one positive/negative feedback plus a free text field question */
        saveLearnContentFeedback: LearnContentFeedback
        /** Mutation setting the current journey daily step for a given user. Emits event 'JourneyLevelCompleted' for all steps completed. */
        setCurrentJourneyDailyStepForGivenUser?: Maybe<LearnContentStatus>
        /** Mutation for setting a user's onboarding status. */
        setUserOnboarding?: Maybe<UserOnboarding>
        /** Mutation for setting a user's onboarding assessment. */
        setUserOnboardingAssessment?: Maybe<UserOnboardingAssessment>
        /** Mutation to unmark a daily step for a given user. */
        unmarkJourneyDailyStepAsCompletedForGivenUser?: Maybe<LearnContentStatus>
        /** Mutation creating or updating article status, based on userId from context */
        updateArticleStatus: LearnContentStatus
        /** Mutation creating or updating content feedback, based on userId from context */
        updateContentLikes: LearnContentLikes
        /** Mutation creating or updating JourneyDailyStep status, based on userId from context */
        updateJourneyDailyStepStatus: LearnContentStatus
        /** Mutation creating or updating module status, based on userId from context */
        updateModuleStatus: LearnContentStatus
        /** Mutation creating or updating podcast status, based on userId from context */
        updatePodcastStatus: LearnContentStatus
        /** Mutation to set the attendance of a user to a webinar session id, based on userId from context */
        updateWebinarSessionStatus: Scalars['Boolean']['output']
        /** Mutation creating or updating video status, based on userId from context */
        updateWebinarVideoStatus: LearnContentStatus
    }

export type LearnMutationV2CreateBookmarkArgs = {
    contentId: Scalars['String']['input']
    contentSubtype?: InputMaybe<LearnContentStatusSubtype>
    contentType: LearnContentStatusType
}

export type LearnMutationV2DeleteBookmarkArgs = {
    contentId: Scalars['String']['input']
    contentSubtype?: InputMaybe<LearnContentStatusSubtype>
    contentType: LearnContentStatusType
}

export type LearnMutationV2MarkAcuteCareResourceAsSeenArgs = {
    contentId: Scalars['String']['input']
}

export type LearnMutationV2MarkCourseResourceAsCompletedArgs = {
    contentId: Scalars['String']['input']
}

export type LearnMutationV2MarkJourneyDailyStepAsCompletedArgs = {
    contentId: Scalars['String']['input']
}

export type LearnMutationV2MarkJourneyDailyStepAsCompletedForGivenUserArgs = {
    contentId: Scalars['String']['input']
    userId: Scalars['UUID']['input']
}

export type LearnMutationV2RegisterForWebinarArgs = {
    webinarId: Scalars['String']['input']
}

export type LearnMutationV2SaveLearnContentFeedbackArgs = {
    contentId: Scalars['String']['input']
    contentSubtype?: InputMaybe<LearnContentStatusSubtype>
    contentType: LearnContentStatusType
    feedbackAnswer: ContentFeedback
    feedbackQuestion: Scalars['String']['input']
    openAnswer?: InputMaybe<Scalars['String']['input']>
    openQuestion?: InputMaybe<Scalars['String']['input']>
}

export type LearnMutationV2SetCurrentJourneyDailyStepForGivenUserArgs = {
    dailyStepId: Scalars['UUID']['input']
    journeyId: Scalars['UUID']['input']
    userId: Scalars['UUID']['input']
}

export type LearnMutationV2SetUserOnboardingArgs = {
    status: OnboardingAssessmentStatus
    version?: InputMaybe<Scalars['Float']['input']>
}

export type LearnMutationV2SetUserOnboardingAssessmentArgs = {
    assessmentChoices: Scalars['String']['input']
    onboardingId: Scalars['UUID']['input']
}

export type LearnMutationV2UnmarkJourneyDailyStepAsCompletedForGivenUserArgs = {
    contentId: Scalars['String']['input']
    userId: Scalars['UUID']['input']
}

export type LearnMutationV2UpdateArticleStatusArgs = {
    input: ArticleContentStatusInput
}

export type LearnMutationV2UpdateContentLikesArgs = {
    input: LikesInput
}

export type LearnMutationV2UpdateJourneyDailyStepStatusArgs = {
    input: JourneyDailyStepContentStatusInput
}

export type LearnMutationV2UpdateModuleStatusArgs = {
    input: ModuleContentStatusInput
}

export type LearnMutationV2UpdatePodcastStatusArgs = {
    input: PodcastContentStatusInput
}

export type LearnMutationV2UpdateWebinarSessionStatusArgs = {
    sessionId: Scalars['String']['input']
}

export type LearnMutationV2UpdateWebinarVideoStatusArgs = {
    input: WebinarVideoContentStatusInput
}

export type LearnQueryV2 = CourseQuery & {
    __typename?: 'LearnQueryV2'
    /** Get articleV2 by id from CMS cache */
    getArticleV2?: Maybe<ArticleV2>
    /** Get articleV2 by id and subscriptionId from CMS cache for default locale (used by Admin Tool) */
    getArticleV2BySubscription?: Maybe<ArticleV2>
    /** Get articles, returns articles, recipes or role models for a given subscription from CMS */
    getArticlesV2: ArticlePageV2
    /**
     * Get bookmarked items for a user
     * @deprecated No longer supported, replace with /content/thrive/getBookmarkedContent
     */
    getBookmarkedItems: LearnContentItemPage
    /** Get company resource sections by subscription Id */
    getCompanyResourceSectionsV2: CompanyResourceGroupPage
    /** Get Country Groups from the cms */
    getCountryGroups: Array<CountryGroup>
    /** Get course by id */
    getCourse?: Maybe<CourseV2>
    /** Get courses by companyId and subscriptionId from context */
    getCourses: CoursePage
    /** Get featured content from CMS based on subscriptionId */
    getFeaturedContent?: Maybe<LearnFeaturedContent>
    /** Get Latest User Onboarding */
    getLatestUserOnboarding?: Maybe<UserOnboarding>
    /**
     * Get Learn Content by Topic. A topic can have Journey UUID or a Pulse Dimension Type.
     * @deprecated No longer supported, replace with /content/thrive/getContentByTopic
     */
    getLearnContentByTopic: LearnContentByTopicOutput
    /** Get podcasts for Overview page */
    getOverviewPodcasts: PodcastPage
    /** Get podcast by id */
    getPodcast?: Maybe<Podcast>
    /** Get podcasts */
    getPodcasts: PodcastPage
    /** Get Pulse Dimensions */
    getPulseDimensions: Array<PulseDimension>
    /** Get recently played Podcast episodes, returns episodes or empty if there are no played episodes */
    getRecentlyPlayedPodcastEpisodes: PodcastEpisodePage
    /** Get Latest User Onboarding assessment */
    getUserOnboardingAssessment?: Maybe<UserOnboardingAssessment>
    /** Get User Onboarding History */
    getUserOnboardingHistory: Array<UserOnboarding>
    /** Get webinar by id */
    getWebinar?: Maybe<Webinar>
    /** Get webinars registered to a user id */
    getWebinars: WebinarPage
}

export type LearnQueryV2GetArticleV2Args = {
    id: Scalars['String']['input']
    localeStr?: InputMaybe<Scalars['String']['input']>
}

export type LearnQueryV2GetArticleV2BySubscriptionArgs = {
    id: Scalars['String']['input']
    subscriptionId: Scalars['UUID']['input']
}

export type LearnQueryV2GetArticlesV2Args = {
    articleTypes?: InputMaybe<Array<ArticleType>>
    contentTypes?: InputMaybe<Array<ArticleContentType>>
    page?: InputMaybe<Scalars['Int']['input']>
    pageSize?: InputMaybe<Scalars['Int']['input']>
}

export type LearnQueryV2GetBookmarkedItemsArgs = {
    page?: InputMaybe<Scalars['Int']['input']>
    pageSize?: InputMaybe<Scalars['Int']['input']>
}

export type LearnQueryV2GetCompanyResourceSectionsV2Args = {
    includeEnglish?: InputMaybe<Scalars['Boolean']['input']>
    page?: InputMaybe<Scalars['Int']['input']>
    pageSize?: InputMaybe<Scalars['Int']['input']>
}

export type LearnQueryV2GetCourseArgs = {
    courseId: Scalars['String']['input']
}

export type LearnQueryV2GetCoursesArgs = {
    page?: InputMaybe<Scalars['Int']['input']>
    pageSize?: InputMaybe<Scalars['Int']['input']>
    sort?: InputMaybe<Array<Scalars['String']['input']>>
}

export type LearnQueryV2GetLatestUserOnboardingArgs = {
    version?: InputMaybe<Scalars['Float']['input']>
}

export type LearnQueryV2GetLearnContentByTopicArgs = {
    page?: InputMaybe<Scalars['Int']['input']>
    pageSize?: InputMaybe<Scalars['Int']['input']>
    topic: TopicInput
}

export type LearnQueryV2GetOverviewPodcastsArgs = {
    numberOfPodcasts?: InputMaybe<Scalars['Int']['input']>
}

export type LearnQueryV2GetPodcastArgs = {
    podcastId: Scalars['String']['input']
}

export type LearnQueryV2GetPodcastsArgs = {
    page?: InputMaybe<Scalars['Int']['input']>
    pageSize?: InputMaybe<Scalars['Int']['input']>
}

export type LearnQueryV2GetRecentlyPlayedPodcastEpisodesArgs = {
    page?: InputMaybe<Scalars['Int']['input']>
    pageSize?: InputMaybe<Scalars['Int']['input']>
}

export type LearnQueryV2GetUserOnboardingHistoryArgs = {
    version?: InputMaybe<Scalars['Float']['input']>
}

export type LearnQueryV2GetWebinarArgs = {
    webinarId: Scalars['String']['input']
}

export type LearnQueryV2GetWebinarsArgs = {
    page?: InputMaybe<Scalars['Int']['input']>
    pageSize?: InputMaybe<Scalars['Int']['input']>
}

export type LessonFeedback = {
    __typename?: 'LessonFeedback'
    feedbackQuestion: Scalars['String']['output']
    openQuestion: Scalars['String']['output']
}

export type LessonV2 = {
    __typename?: 'LessonV2'
    courseID?: Maybe<Scalars['String']['output']>
    feedback?: Maybe<LessonFeedback>
    id: Scalars['ID']['output']
    moduleIds: Array<Scalars['ID']['output']>
    modules: Array<ModuleV2>
    order: Scalars['Int']['output']
    /** Course Lesson progress for user, based on userId from context. Checks progress on modules and lesson resources. */
    progress?: Maybe<LearnContentProgress>
    resources: Array<CourseResource>
    title: Scalars['String']['output']
}

export type Level = {
    __typename?: 'Level'
    /** The uuid of the level */
    id: Scalars['UUID']['output']
    /** The rewards assigned to this level */
    levelRewards: Array<LevelReward>
    /** The level number */
    number: Scalars['Int']['output']
    /** The required points to reach the level */
    requiredPoints: Scalars['Int']['output']
}

export type LevelProgress = {
    __typename?: 'LevelProgress'
    /** Completion timestamp */
    completedAt: Scalars['Instant']['output']
    /** Level id */
    levelId: Scalars['UUID']['output']
}

export type LevelResponse = LevelResponseError | LevelResponseResult

export type LevelResponseError = {
    __typename?: 'LevelResponseError'
    error: LevelResponseErrorType
    message: Scalars['String']['output']
}

export enum LevelResponseErrorType {
    GameAlreadyStarted = 'GAME_ALREADY_STARTED',
    GameNotFound = 'GAME_NOT_FOUND',
    InvalidLevelNumber = 'INVALID_LEVEL_NUMBER',
    InvalidLevelPoints = 'INVALID_LEVEL_POINTS',
    LevelAlreadyExists = 'LEVEL_ALREADY_EXISTS',
    LevelNotFound = 'LEVEL_NOT_FOUND'
}

export type LevelResponseResult = {
    __typename?: 'LevelResponseResult'
    level: Level
}

export type LevelReward = {
    __typename?: 'LevelReward'
    /** The filters assigned to this reward */
    filters: Array<LevelRewardFilter>
    /** For GARDEN_ITEM types. */
    gardenItemSet?: Maybe<GardenItemSet>
    /** The uuid of the reward */
    id: Scalars['UUID']['output']
    /** The reward type */
    rewardType: LevelRewardType
}

export type LevelRewardFilter = {
    __typename?: 'LevelRewardFilter'
    /** Comparator to be used to match the filter */
    comparator: FilterComparator
    /** Custom key to use in case attribute type is 'CUSTOM' */
    customKey?: Maybe<Scalars['String']['output']>
    /** The attribute type */
    filterAttributeType: FilterAttributeType
    /** The uuid of the filter */
    id: Scalars['UUID']['output']
    /** List of values used for filter matching */
    value: Array<Scalars['String']['output']>
}

export type LevelRewardFilterResponse =
    | LevelRewardFilterResponseError
    | LevelRewardFilterResponseResult

export type LevelRewardFilterResponseError = {
    __typename?: 'LevelRewardFilterResponseError'
    error: LevelRewardFilterResponseErrorType
    message: Scalars['String']['output']
}

export enum LevelRewardFilterResponseErrorType {
    GameAlreadyStarted = 'GAME_ALREADY_STARTED',
    GameNotFound = 'GAME_NOT_FOUND',
    InvalidFilterValue = 'INVALID_FILTER_VALUE',
    LevelNotFound = 'LEVEL_NOT_FOUND',
    LevelRewardFilterNotFound = 'LEVEL_REWARD_FILTER_NOT_FOUND',
    LevelRewardNotFound = 'LEVEL_REWARD_NOT_FOUND'
}

export type LevelRewardFilterResponseResult = {
    __typename?: 'LevelRewardFilterResponseResult'
    filter: LevelRewardFilter
}

export type LevelRewardResponse =
    | LevelRewardResponseError
    | LevelRewardResponseResult

export type LevelRewardResponseError = {
    __typename?: 'LevelRewardResponseError'
    error: LevelRewardResponseErrorType
    message: Scalars['String']['output']
}

export enum LevelRewardResponseErrorType {
    GameAlreadyStarted = 'GAME_ALREADY_STARTED',
    GameNotFound = 'GAME_NOT_FOUND',
    InvalidReward = 'INVALID_REWARD',
    LevelNotFound = 'LEVEL_NOT_FOUND',
    LevelRewardNotFound = 'LEVEL_REWARD_NOT_FOUND'
}

export type LevelRewardResponseResult = {
    __typename?: 'LevelRewardResponseResult'
    levelReward: LevelReward
}

export enum LevelRewardType {
    Badge = 'BADGE',
    GardenItem = 'GARDEN_ITEM'
}

export enum LicenseType {
    /** @deprecated Old name */
    Lite = 'lite',
    Standard = 'standard',
    /** @deprecated Another old name */
    ThriveResetForTeams = 'thriveResetForTeams',
    ThriveResetOnly = 'thriveResetOnly'
}

export type LikeMutation = {
    __typename?: 'LikeMutation'
    create: Scalars['Boolean']['output']
    delete: Scalars['Boolean']['output']
}

export type LikeMutationCreateArgs = {
    id: Scalars['UUID']['input']
}

export type LikeMutationDeleteArgs = {
    id: Scalars['UUID']['input']
}

export type LikeQuery = {
    __typename?: 'LikeQuery'
    isLiked: Scalars['Boolean']['output']
}

export type LikeQueryIsLikedArgs = {
    id: Scalars['UUID']['input']
}

export type Likes = {
    __typename?: 'Likes'
    isLiked: Scalars['Boolean']['output']
    numberOfLikes: Scalars['Int']['output']
    totalNumberOfLikes: Scalars['Int']['output']
}

export type LikesInput = {
    contentId: Scalars['String']['input']
    contentSubtype?: InputMaybe<LearnContentStatusSubtype>
    contentType: LearnContentStatusType
    likes: Scalars['Int']['input']
}

export type LinkedAccountDto = {
    __typename?: 'LinkedAccountDTO'
    /** The type of linked account */
    channel: Channel
    /** When this account was created in Pulse */
    createdAt: Scalars['Instant']['output']
    /** If that user has an admin account on the tenant workspace */
    isAdmin: Scalars['Boolean']['output']
    /** If that user is marked as deleted on the account */
    isDeleted: Scalars['Boolean']['output']
    /** If that user is subscribed to Pulse on the account */
    subscribed: Scalars['Boolean']['output']
    /** The tenant/team id for the account */
    tenantId: Scalars['String']['output']
    /** The user's timezone for the account */
    timezone: Scalars['String']['output']
    /** When this account was last updated in Pulse */
    updatedAt: Scalars['Instant']['output']
    /** The user id for the account */
    userId: Scalars['String']['output']
}

export type LocalizedThriveResetTag = {
    __typename?: 'LocalizedThriveResetTag'
    localized: Scalars['String']['output']
    value: ThriveResetTag
}

export enum LoginMethod {
    Credentials = 'credentials',
    Sso = 'sso'
}

export type MsTeamsSubscribeUserMutation = {
    __typename?: 'MSTeamsSubscribeUserMutation'
    /** Subscribe user who onboarded through Home Tab */
    subscribeUser: TeamsSubscribeUserResult
}

export type MagicLinkIntegrationMutation = {
    __typename?: 'MagicLinkIntegrationMutation'
    /** Disables MagicLink integration for given company. If company doesn't exist it is a NOOP. Returns true if operation actually changed anything */
    disable: Scalars['Boolean']['output']
    /** Add a new MagicLink integration to given company. If config already exists, it will be enabled without changing anything else. */
    enable: Scalars['Boolean']['output']
}

export type MagicLinkIntegrationMutationDisableArgs = {
    companyId: Scalars['UUID']['input']
}

export type MagicLinkIntegrationMutationEnableArgs = {
    companyId: Scalars['UUID']['input']
}

export enum MeasureUnit {
    Ml = 'ML',
    Oz = 'OZ'
}

export enum MediaType {
    Chat = 'CHAT',
    Email = 'EMAIL',
    Message = 'MESSAGE',
    None = 'NONE',
    Voice = 'VOICE',
    WorkItem = 'WORK_ITEM'
}

export type MessageParameters = {
    __typename?: 'MessageParameters'
    body: Scalars['String']['output']
    ctaLabel?: Maybe<Scalars['String']['output']>
    ctaUrl?: Maybe<Scalars['String']['output']>
    header?: Maybe<Scalars['String']['output']>
    imageUrl?: Maybe<Scalars['String']['output']>
}

export type MessageParametersInput = {
    body: Scalars['String']['input']
    ctaLabel?: InputMaybe<Scalars['String']['input']>
    ctaUrl?: InputMaybe<Scalars['String']['input']>
    header?: InputMaybe<Scalars['String']['input']>
    imageUrl?: InputMaybe<Scalars['String']['input']>
}

export type MetricData = {
    __typename?: 'MetricData'
    coordinates: Array<ReportingCoordinates>
    description?: Maybe<Scalars['String']['output']>
    metric: Scalars['String']['output']
}

export type MicrostepAndRemovalReasonInput = {
    microstepId: Scalars['ID']['input']
    removalReason?: InputMaybe<MicrostepRemovalReason>
}

export type MicrostepCheckin = {
    __typename?: 'MicrostepCheckin'
    checkInDate: Scalars['ISODate']['output']
    dateTime: Scalars['String']['output']
    microstepId: Scalars['ID']['output']
    status: Scalars['String']['output']
    userId: Scalars['ID']['output']
}

/** Stores information for querying the number of checkins for a user from a `fromDate`, `today` is used to return whether the user has checked in that day */
export type MicrostepCheckinDateInput = {
    /** the specific date that we want to know if the use has checked the microstep */
    dateToCheck?: InputMaybe<Scalars['ISODate']['input']>
    /** the date from where we want to count the checkins */
    fromDate: Scalars['ISODate']['input']
    /** id of the microstep we want the information about */
    microstepId: Scalars['UUID']['input']
}

export type MicrostepCheckinDateList = {
    __typename?: 'MicrostepCheckinDateList'
    checkinDates: Array<Scalars['ISODate']['output']>
    microstepId: Scalars['ID']['output']
}

export type MicrostepCheckinProgressDate = {
    __typename?: 'MicrostepCheckinProgressDate'
    date: Scalars['String']['output']
    microstepsCheckedIn: Array<Scalars['ID']['output']>
    microstepsCheckedInCount: Scalars['Int']['output']
    microstepsCheckedInInfo: Array<GraphQlMicrostep>
    microstepsCommittedCount: Scalars['Int']['output']
    microstepsCommittedIds: Array<Scalars['ID']['output']>
    microstepsCommittedInfo: Array<GraphQlMicrostep>
}

/** Stores information about the number of checkins from a date and whether the user has checked that microstep today */
export type MicrostepCheckinsFromDateOutput = {
    __typename?: 'MicrostepCheckinsFromDateOutput'
    /** the number of checkins from the `fromDate` */
    checkedInCount: Scalars['Int']['output']
    /** the specific date that we wanted to know if the use has checked the microstep passed in `MicrostepCheckinDateInput.dateToCheck` */
    checkedOnSpecificDate?: Maybe<Scalars['Boolean']['output']>
    /** the date from when we wanted to count the checkins */
    fromDate: Scalars['ISODate']['output']
    /** id of the microstep we wanted the information about */
    microstepId: Scalars['UUID']['output']
}

export type MicrostepDetail = {
    __typename?: 'MicrostepDetail'
    id: Scalars['UUID']['output']
    title?: Maybe<Scalars['String']['output']>
}

export type MicrostepGoalDetail = {
    __typename?: 'MicrostepGoalDetail'
    microstep: GraphQlMicrostep
    microstepInfo: MicrostepDetail
}

export enum MicrostepMomentumError {
    DateRangeNotValid = 'DATE_RANGE_NOT_VALID'
}

export type MicrostepMomentumErrorResponse = {
    __typename?: 'MicrostepMomentumErrorResponse'
    error: MicrostepMomentumError
}

export type MicrostepMomentumResult =
    | GraphQlMicrostepMomentum
    | MicrostepMomentumErrorResponse

export type MicrostepPage = {
    __typename?: 'MicrostepPage'
    hasMore?: Maybe<Scalars['Boolean']['output']>
    items: Array<GraphQlMicrostep>
    page: Scalars['Int']['output']
    pageCount?: Maybe<Scalars['Int']['output']>
    pageSize: Scalars['Int']['output']
    totalItems: Scalars['Int']['output']
}

export enum MicrostepRemovalReason {
    Accomplished = 'ACCOMPLISHED',
    NotInterested = 'NOT_INTERESTED'
}

export type MicrostepStats = {
    __typename?: 'MicrostepStats'
    /** Microsteps list */
    microsteps: Array<MicrostepStatsDetail>
    /** Number of microsteps checked */
    total: Scalars['Int']['output']
}

export type MicrostepStatsDetail = {
    __typename?: 'MicrostepStatsDetail'
    completed: Scalars['Boolean']['output']
    microstepDetail: MicrostepGoalDetail
}

export type MicrostepSubscription = {
    __typename?: 'MicrostepSubscription'
    microstepId: Scalars['ID']['output']
    status: Scalars['String']['output']
    userId: Scalars['ID']['output']
}

export type MicrostepUserProgress = {
    __typename?: 'MicrostepUserProgress'
    checkedInCount: Scalars['Int']['output']
    microstepId: Scalars['ID']['output']
}

export type MicrostepUserStatus = {
    __typename?: 'MicrostepUserStatus'
    checkedIn: Scalars['Boolean']['output']
    committed: Scalars['Boolean']['output']
    microstep: GraphQlMicrostep
}

export type MicrostepUserTotal = {
    __typename?: 'MicrostepUserTotal'
    checkedInCount: Scalars['Int']['output']
    userId: Scalars['ID']['output']
}

export type MicrostepV2 = {
    __typename?: 'MicrostepV2'
    action: Scalars['String']['output']
    body: Scalars['String']['output']
    createdAt?: Maybe<Scalars['Instant']['output']>
    deprecateAt?: Maybe<Scalars['ISODate']['output']>
    duration: Scalars['Int']['output']
    id: Scalars['UUID']['output']
    journeyIds: Array<Scalars['UUID']['output']>
    journeys: Array<Maybe<Journey>>
    timeUnit: Scalars['String']['output']
    title: Scalars['String']['output']
    updatedAt?: Maybe<Scalars['Instant']['output']>
}

export type MiniBenny = {
    __typename?: 'MiniBenny'
    companyResourceCount: Scalars['Int']['output']
    companyResourceGroupUUID: Scalars['UUID']['output']
    name?: Maybe<Scalars['String']['output']>
    title?: Maybe<Scalars['String']['output']>
}

export type ModuleContentStatusInput = {
    /** module id */
    contentId: Scalars['String']['input']
    /** module progress in seconds */
    progressInSeconds: Scalars['Int']['input']
    progressType: LearnContentStatusProgressType
    /** total duration of module in seconds */
    totalInSeconds: Scalars['Int']['input']
}

export type ModuleMutation = {
    /** Mutation creating or updating module status, based on userId from context */
    updateModuleStatus: LearnContentStatus
}

export type ModuleMutationUpdateModuleStatusArgs = {
    input: ModuleContentStatusInput
}

export type ModuleV2 = {
    __typename?: 'ModuleV2'
    bookmarked: Scalars['Boolean']['output']
    byline: Scalars['String']['output']
    contentStatus?: Maybe<LearnContentStatus>
    courseID?: Maybe<Scalars['String']['output']>
    /** Display name, directly from CMS */
    displayName: Scalars['String']['output']
    hlsVideoLink?: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    /** Label calculated from CMS 'displayName' minus ': title' */
    label: Scalars['String']['output']
    lessonID?: Maybe<Scalars['String']['output']>
    likes: Likes
    /** Order, order of the component in CMS */
    order: Scalars['Int']['output']
    thumbnail: Scalars['String']['output']
    title: Scalars['String']['output']
    type: Scalars['String']['output']
    videoLink: Scalars['String']['output']
}

export type MonthYear = {
    __typename?: 'MonthYear'
    month: Scalars['Int']['output']
    year: Scalars['Int']['output']
}

export type MonthYearInput = {
    month: Scalars['Int']['input']
    year: Scalars['Int']['input']
}

export type MonthlyActivitySummaryStatsResponse = ActivitySummaryStats & {
    __typename?: 'MonthlyActivitySummaryStatsResponse'
    averageSteps: Scalars['Float']['output']
    month: Scalars['Int']['output']
    year: Scalars['Int']['output']
}

export type MonthlyAssessmentStatsResponse = AssessmentStats & {
    __typename?: 'MonthlyAssessmentStatsResponse'
    average: Scalars['Float']['output']
    month: Scalars['Int']['output']
    survey?: Maybe<Surveys>
    totalNumberOfResponses: Scalars['Int']['output']
    valuePercentage: Scalars['Int']['output']
    year: Scalars['Int']['output']
}

export type MonthlySleepSummaryStatsResponse = SleepSummaryStats & {
    __typename?: 'MonthlySleepSummaryStatsResponse'
    averageBedTimeStart?: Maybe<Scalars['Long']['output']>
    averageMinutesAsleep: Scalars['Float']['output']
    month: Scalars['Int']['output']
    year: Scalars['Int']['output']
}

export type MsTeamsIntegrationMutation = {
    __typename?: 'MsTeamsIntegrationMutation'
    /** Disables Microsoft Teams integration for given company. If company doesn't exist it is a NOOP. Returns true if operation actually changed anything */
    disable: Scalars['Boolean']['output']
    /** Add a new Microsoft Teams integration to given company. If company doesn't exist, will return an error. If config already exists, it will be enabled without changing anything else. Returns true if operation actually changed anything */
    enable: Scalars['Boolean']['output']
}

export type MsTeamsIntegrationMutationDisableArgs = {
    companyId: Scalars['UUID']['input']
}

export type MsTeamsIntegrationMutationEnableArgs = {
    companyId: Scalars['UUID']['input']
    emailAllowList?: InputMaybe<Array<Scalars['String']['input']>>
    tenantId: Scalars['UUID']['input']
}

export type Mutation = {
    __typename?: 'Mutation'
    /** Achievements Mutation */
    achievements: AchievementsMutation
    assessment: AssessmentMutation
    /** Thrive for Support Teams Mutations */
    calls: CallsMutation
    /** Centralized Notifications Root Mutation */
    centralizedNotifications: CentralizedNotificationsMutation
    /** Root function for Coaching mutations */
    coaching: CoachingMutation
    /** Content Root Mutation */
    content: ContentMutation
    /** Daily Experience Root Mutation */
    dailyExperience: DailyExperienceMutation
    /** Example Graphapi Mutation */
    exampleGraphapiMutation: Scalars['String']['output']
    /** Game Mutation */
    game: GameMutation
    /** @deprecated Just placeholder for testing, replace with pulse */
    hello: Scalars['String']['output']
    /** Hello World Mutation */
    helloWorldMutation: Scalars['String']['output']
    /** Hello World Mutation */
    helloWorlddMutation: Scalars['String']['output']
    identity: IdentityMutation
    /** Journeys Root Mutation */
    journeys: JourneyMutation
    /** Learn V2 Root Mutation */
    learnV2: LearnMutationV2
    notification: NotificationMutation
    /** Onboarding Root Mutation */
    onboarding: OnboardingMutation
    /** Update Thrive Pulse data */
    pulse: ThrivePulseMutation
    /** Pulse Reporting Root Mutation */
    pulseReporting: PulseReportingMutation
    /**
     * External Pulse Root Mutation
     * @deprecated Still work but latest APIs are now in pulse, replace with pulse
     */
    pulseV2: ExternalPulseMutation
    recommendation: RecommendationMutation
    /** Capture a NPSResults for a User */
    recordNPSResult: UserNpsResult
    reset: ResetMutation
    /** Reset Root Mutation */
    resetV2: ResetMutationV2
    /** Retail Mutation */
    retail: RetailMutation
    search: SearchMutation
    /** Slack Root Mutation */
    slack: SlackMutation
    /** Social Groups Root Mutation */
    socialGroups: SocialGroupMutation
    /** Teams Root Mutation */
    teams: TeamsMutation
    /** Test Mutation */
    testMutation: Scalars['String']['output']
    today: TodayMutation
    /** Unified Challenges Root Mutation */
    unifiedChallenges: UnifiedChallengesMutation
    userHistory: UserHistoryMutation
    /** Wearables Platform Root Mutation */
    wearables: WearablesPlatformMutation
}

export type MutationRecordNpsResultArgs = {
    comment?: InputMaybe<Scalars['String']['input']>
    completionDate: Scalars['Instant']['input']
    locationPath: Scalars['String']['input']
    npsScore?: InputMaybe<Scalars['Float']['input']>
    platform: Scalars['String']['input']
    sessionId?: InputMaybe<Scalars['UUID']['input']>
    userId: Scalars['UUID']['input']
    userLanguage: Scalars['String']['input']
}

export type MySuccessStory = {
    __typename?: 'MySuccessStory'
    /** Unique id of the content related to the story */
    contentId?: Maybe<Scalars['String']['output']>
    /** Content type of the content related to the story */
    contentType?: Maybe<LearnContentStatusType>
    createdAt: Scalars['Instant']['output']
    iconName: Scalars['String']['output']
    id: Scalars['UUID']['output']
    /** Url of an image for my success story */
    imageUrl?: Maybe<Scalars['String']['output']>
    /** Defaults to private story, not shared with Thrive nor employer */
    isPrivate: Scalars['Boolean']['output']
    /** Text of my success story */
    story: Scalars['String']['output']
    /** Title of My Success Story */
    title: Scalars['String']['output']
    type: SuccessStoryFeedbackType
    updatedAt: Scalars['Instant']['output']
    userId: Scalars['UUID']['output']
}

export type MySuccessStoryInput = {
    /** Unique id of the content related to the story */
    contentId?: InputMaybe<Scalars['String']['input']>
    /** Content type of the content related to the story */
    contentType?: InputMaybe<LearnContentStatusType>
    /** Url of an image for my success story */
    imageUrl?: InputMaybe<Scalars['String']['input']>
    /** Defaults to private story, not shared with Thrive nor employer */
    isPrivate: Scalars['Boolean']['input']
    /** Text of my success story */
    story: Scalars['String']['input']
    /** Title of My Success Story */
    title: Scalars['String']['input']
    /** Type of Success Story feedback */
    type: SuccessStoryFeedbackType
}

export type MySuccessStoryPage = {
    __typename?: 'MySuccessStoryPage'
    hasMore?: Maybe<Scalars['Boolean']['output']>
    items: Array<MySuccessStory>
    page: Scalars['Int']['output']
    pageCount?: Maybe<Scalars['Int']['output']>
    pageSize: Scalars['Int']['output']
}

/** User journal related to Pulse survey question (Pulse Check In) */
export type MySurveyJournal = {
    __typename?: 'MySurveyJournal'
    /** Content of my journal */
    content: Scalars['String']['output']
    createdAt: Scalars['Instant']['output']
    id: Scalars['UUID']['output']
    surveyId: Scalars['UUID']['output']
}

export type MySurveyJournalInput = {
    /** Content of my journal */
    content: Scalars['String']['input']
    surveyId: Scalars['UUID']['input']
}

export type MySurveyJournalPage = {
    __typename?: 'MySurveyJournalPage'
    hasMore?: Maybe<Scalars['Boolean']['output']>
    items: Array<MySurveyJournal>
    page: Scalars['Int']['output']
    pageCount?: Maybe<Scalars['Int']['output']>
    pageSize: Scalars['Int']['output']
}

export type NiceIntegrationMutation = {
    __typename?: 'NiceIntegrationMutation'
    /** Disables NICE integration for given company. If company doesn't exist it is a NOOP. Returns true if operation actually changed anything */
    disable: Scalars['Boolean']['output']
    /** Add a new Nice integration to given company. If company doesn't exist, will return an error. If config already exists, it will be enabled without changing anything else. Returns true if operation actually changed anything */
    enable: Scalars['Boolean']['output']
}

export type NiceIntegrationMutationDisableArgs = {
    companyId: Scalars['UUID']['input']
}

export type NiceIntegrationMutationEnableArgs = {
    companyId: Scalars['UUID']['input']
    tenantId: Scalars['String']['input']
}

export type NoMetadata = {
    __typename?: 'NoMetadata'
    thisFieldIsNotUsedItIsJustHereToMakeGqlHappy: Scalars['Boolean']['output']
}

export type NotificationMutation = {
    __typename?: 'NotificationMutation'
    /** Adds a deviceId (OneSignal id) to a user */
    addDevice: Scalars['Boolean']['output']
    /** Sends a notification with a custom title and message to a list of user_ids with company_ids. Notifications won't be send to user_ids not registered in the third party message providerMax 2000 users per call */
    sendCustomNotificationV2: Scalars['Boolean']['output']
    /** Sets the notificationType activated/deactivated for the logged in user */
    setNotificationStatus: Scalars['Boolean']['output']
}

export type NotificationMutationAddDeviceArgs = {
    deviceId: Scalars['String']['input']
}

export type NotificationMutationSendCustomNotificationV2Args = {
    message: Scalars['String']['input']
    notificationType: NotificationType
    title: Scalars['String']['input']
    users: Array<UserInfoInput>
}

export type NotificationMutationSetNotificationStatusArgs = {
    active: Scalars['Boolean']['input']
    notificationType: NotificationType
}

export type NotificationQuery = {
    __typename?: 'NotificationQuery'
    /** Gets the playerId (OneSignal id) for the logged in user */
    getDevices: Array<Scalars['String']['output']>
    /** Gets true if the notification type is active for the logged in user */
    getNotificationStatus: Scalars['Boolean']['output']
}

export type NotificationQueryGetNotificationStatusArgs = {
    notificationType: NotificationType
}

export type NotificationSettingsInput = {
    teamsUserId: Scalars['UUID']['input']
}

export type NotificationSettingsOperationResult = NotificationSettingsResult

export type NotificationSettingsResult = {
    __typename?: 'NotificationSettingsResult'
    error?: Maybe<Scalars['String']['output']>
    pulseSettings?: Maybe<PulseSettings>
}

export enum NotificationType {
    CompanyChallengeReminder = 'COMPANY_CHALLENGE_REMINDER',
    PulseReminder = 'PULSE_REMINDER'
}

export type NotifyChallengeUserResult = {
    __typename?: 'NotifyChallengeUserResult'
    error?: Maybe<Scalars['String']['output']>
    numberOfUsersNotified: Scalars['Int']['output']
}

export type NotifyMutation = {
    __typename?: 'NotifyMutation'
    /** Send a reminder to all users in a challenge to complete the daily goals for the challenge */
    notifyDailyGoalsChallengeUsers: NotifyChallengeUserResult
}

export type NotifyMutationNotifyDailyGoalsChallengeUsersArgs = {
    input: ThriveChallengeDailyGoalNotificationInput
}

export type NudgeMetadata =
    | InChallengeGoalReminder
    | NoMetadata
    | SmartNudgeReset
    | TestNudge

export type NudgeRecommendedReset = {
    __typename?: 'NudgeRecommendedReset'
    context: TimedRecommendedResetContext
    thriveReset: ThriveReset
}

export type NudgeSentAtUpdateInput = {
    nudgeType: NudgeType
    sendDate: Scalars['ISODate']['input']
    /** ISO-8601 time string */
    sendTime: Scalars['String']['input']
    sentAt: Scalars['Instant']['input']
}

export type NudgeStatusUpdateInput = {
    enabled: Scalars['Boolean']['input']
    type: NudgeType
}

export enum NudgeType {
    InChallengeGoalReminder = 'IN_CHALLENGE_GOAL_REMINDER',
    SmartNudgeMsTeamsMvp = 'SMART_NUDGE_MS_TEAMS_MVP',
    TestNudge = 'TEST_NUDGE',
    WebNudgesLaunchAnnouncement = 'WEB_NUDGES_LAUNCH_ANNOUNCEMENT'
}

export type OktaIntegrationMutation = {
    __typename?: 'OktaIntegrationMutation'
    /** Disables Okta SSO integration for given company. If company doesn't exist it is a NOOP. Returns true if operation actually changed anything */
    disable: Scalars['Boolean']['output']
    /** Add a new Okta SSO integration to given company. If company doesn't exist, will return an error. If config already exists, it will be enabled without changing anything else. Returns true if operation actually changed anything */
    enable: Scalars['Boolean']['output']
}

export type OktaIntegrationMutationDisableArgs = {
    companyId: Scalars['UUID']['input']
}

export type OktaIntegrationMutationEnableArgs = {
    companyId: Scalars['UUID']['input']
    emailAllowList?: InputMaybe<Array<Scalars['String']['input']>>
    idpId: Scalars['String']['input']
}

export enum OnboardingAssessmentStatus {
    Completed = 'COMPLETED',
    InProgress = 'IN_PROGRESS'
}

/** The onboarding information for the user */
export type OnboardingInfo = {
    __typename?: 'OnboardingInfo'
    cmsId?: Maybe<Scalars['UUID']['output']>
    /** The pages for onboarding  */
    pages: Array<OnboardingPage>
    /** The users onboarding progress */
    progress: OnboardingProgress
    /** The type of onboarding */
    type: OnboardingType
}

export type OnboardingMutation = {
    __typename?: 'OnboardingMutation'
    /** Resets the onboarding progress for the specified user */
    resetOnboardingProgress: Scalars['Boolean']['output']
    /** Sets the onboarding progress for the user */
    setOnboardingProgress: OnboardingProgress
}

export type OnboardingMutationResetOnboardingProgressArgs = {
    userId: Scalars['UUID']['input']
}

export type OnboardingMutationSetOnboardingProgressArgs = {
    cmsId?: InputMaybe<Scalars['UUID']['input']>
    status: UserOnboardingStatus
}

export type OnboardingPage = {
    __typename?: 'OnboardingPage'
    body: Scalars['String']['output']
    header: Scalars['String']['output']
    image?: Maybe<OnboardingPageImage>
}

export type OnboardingPageImage = {
    __typename?: 'OnboardingPageImage'
    alternativeText?: Maybe<Scalars['String']['output']>
    caption?: Maybe<Scalars['String']['output']>
    height?: Maybe<Scalars['Int']['output']>
    url: Scalars['String']['output']
    width?: Maybe<Scalars['Int']['output']>
}

export type OnboardingProgress = {
    __typename?: 'OnboardingProgress'
    /** The CMS ID for the onboarding template */
    cmsId?: Maybe<Scalars['UUID']['output']>
    createdAt?: Maybe<Scalars['Instant']['output']>
    /** The status of the onboarding process */
    status: UserOnboardingStatus
    updatedAt?: Maybe<Scalars['Instant']['output']>
    userId?: Maybe<Scalars['UUID']['output']>
}

export type OnboardingQuery = {
    __typename?: 'OnboardingQuery'
    /** Gets onboarding information for the user */
    getOnboardingInfo: OnboardingInfo
    /** Gets onboarding progress for the user */
    getOnboardingProgress: OnboardingProgress
}

export enum OnboardingState {
    Completed = 'COMPLETED',
    Started = 'STARTED'
}

export enum OnboardingType {
    Coaching = 'COACHING',
    General = 'GENERAL',
    UnknownValue = 'UNKNOWN_VALUE'
}

export type OptimalRange = {
    __typename?: 'OptimalRange'
    dimension: Surveys
    high: Scalars['Int']['output']
    low: Scalars['Int']['output']
}

export type OptionsDto = {
    __typename?: 'OptionsDTO'
    text: Scalars['String']['output']
    value: Scalars['Int']['output']
}

export enum OtmTemplateName {
    Basic = 'BASIC'
}

export type OuraMutation = {
    __typename?: 'OuraMutation'
    /** Disconnect Oura account from Thrive */
    disconnect: Scalars['Boolean']['output']
}

export type OuraQuery = {
    __typename?: 'OuraQuery'
    /** Get an authorisation url to begin the Oura OAuth flow */
    oauthAuthorisationUrl?: Maybe<Scalars['String']['output']>
}

export type OuraQueryOauthAuthorisationUrlArgs = {
    redirectPath?: InputMaybe<Scalars['String']['input']>
}

export type OwnedEmailDomain = {
    __typename?: 'OwnedEmailDomain'
    company: Company
    createdAt: Scalars['Instant']['output']
    emailDomain: Scalars['String']['output']
    updatedAt: Scalars['Instant']['output']
}

export type OwnedEmailDomainInput = {
    companyId: Scalars['UUID']['input']
    emailDomain: Scalars['String']['input']
}

export type PageInfo = {
    __typename?: 'PageInfo'
    endCursor?: Maybe<Scalars['String']['output']>
    hasNextPage: Scalars['Boolean']['output']
    hasPreviousPage: Scalars['Boolean']['output']
    startCursor?: Maybe<Scalars['String']['output']>
}

export enum PageSortOrder {
    Asc = 'ASC',
    Desc = 'DESC'
}

export type PaginationInput = {
    page?: InputMaybe<Scalars['Long']['input']>
    pageSize?: InputMaybe<Scalars['Int']['input']>
    sortOrder?: InputMaybe<PageSortOrder>
}

export enum Partner {
    Azure = 'azure',
    Coda = 'coda',
    Cognito = 'cognito',
    Hermes = 'hermes',
    Okta = 'okta',
    Thriveglobal = 'thriveglobal',
    Thriveglobalidentity = 'thriveglobalidentity',
    /** @deprecated Use thriveglobalidentity, replace with thriveglobalidentity */
    Thriveglobalkeycloak = 'thriveglobalkeycloak',
    Thriveglobalweb = 'thriveglobalweb',
    Webex = 'webex',
    Westvirginiaunivercity = 'westvirginiaunivercity',
    Zoom = 'zoom'
}

export type PartnerEnableResponse = {
    __typename?: 'PartnerEnableResponse'
    enabled: Scalars['Boolean']['output']
    token?: Maybe<Scalars['String']['output']>
}

export type PartnerIntegrationMutation = {
    __typename?: 'PartnerIntegrationMutation'
    /** Disables Partner integration for given company. If company doesn't exist it is a NOOP. Returns true if operation actually changed anything */
    disable: Scalars['Boolean']['output']
    /** Add a new partner integration to given company. If company doesn't exist, will return an error. If config already exists, it will be enabled without changing anything else. If enabled or created, a response will contain a token for the partner. */
    enable: PartnerEnableResponse
}

export type PartnerIntegrationMutationDisableArgs = {
    companyId: Scalars['UUID']['input']
}

export type PartnerIntegrationMutationEnableArgs = {
    companyId: Scalars['UUID']['input']
}

export type PartnerQuery = {
    __typename?: 'PartnerQuery'
    sign: TokenResponse
}

export type PartnerQuerySignArgs = {
    companyName: Scalars['String']['input']
}

export type PartnerUserInputGraphQlInput = {
    companyId?: InputMaybe<Scalars['UUID']['input']>
    scope: Scalars['String']['input']
    userId: Scalars['String']['input']
}

/** Input for pendingNudges query */
export type PendingNudgesInput = {
    /** Whether to filter by expired notifications. Defaults to null, in which case both expired and unexpired notifications will be returned if they fall within the other filters. */
    isExpired?: InputMaybe<Scalars['Boolean']['input']>
    /**
     * Whether to filter by sentAt timestamp.
     * When true, only sent notifications will be returned.
     * When false, only unsent notifications will be returned.
     * Defaults to null, in which case both sent and unsent notifications will be returned.
     */
    isSent?: InputMaybe<Scalars['Boolean']['input']>
    /** The platform categories to filter by. By default, all platforms will be returned. */
    platformCategories?: InputMaybe<Array<PlatformCategory>>
    /** The ISO-8601 duration to filter by. Defaults to 90 days */
    within?: InputMaybe<Scalars['String']['input']>
}

export type PersonalPlantEntityInfo = {
    __typename?: 'PersonalPlantEntityInfo'
    createdAt: Scalars['Instant']['output']
    /** The entity id */
    entityId: Scalars['UUID']['output']
    /** The entity type */
    entityType: EntityType
    /** The date the entity was added */
    eventDate: Scalars['ISODate']['output']
    /** The plant id */
    plantId: Scalars['UUID']['output']
    updatedAt: Scalars['Instant']['output']
}

export type PersonalizedImageConnection = {
    __typename?: 'PersonalizedImageConnection'
    edges: Array<PersonalizedImageEdge>
    /** @deprecated this field is deprecated, replace with nodes */
    items: Array<Image>
    /** @deprecated this field is deprecated, replace with pageInfo */
    itemsPerPage: Scalars['Int']['output']
    nodes: Array<Image>
    /** @deprecated this field is deprecated, replace with pageInfo */
    page: Scalars['Int']['output']
    pageInfo: PageInfo
    /** @deprecated this field is deprecated, replace with pageInfo */
    total: Scalars['Int']['output']
}

export type PersonalizedImageEdge = {
    __typename?: 'PersonalizedImageEdge'
    cursor: Scalars['String']['output']
    node: Image
}

export type PersonalizedImageQuery = {
    __typename?: 'PersonalizedImageQuery'
    get: PersonalizedImageConnection
}

export type PersonalizedImageQueryGetArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    page?: InputMaybe<Scalars['Int']['input']>
}

export type PersonalizedImagesMutation = {
    __typename?: 'PersonalizedImagesMutation'
    delete: Scalars['Boolean']['output']
}

export type PersonalizedImagesMutationDeleteArgs = {
    imageId: Scalars['UUID']['input']
}

export type PersonalizedQuote = Frame & {
    __typename?: 'PersonalizedQuote'
    _: Scalars['Boolean']['output']
    author: Scalars['String']['output']
    createdAt: Scalars['Instant']['output']
    id: Scalars['UUID']['output']
    text: Scalars['String']['output']
    updatedAt: Scalars['Instant']['output']
    user: ResetApiUser
}

export type PersonalizedQuoteConnection = {
    __typename?: 'PersonalizedQuoteConnection'
    edges: Array<PersonalizedQuoteEdge>
    nodes: Array<PersonalizedQuote>
    pageInfo: PageInfo
}

export type PersonalizedQuoteEdge = {
    __typename?: 'PersonalizedQuoteEdge'
    cursor: Scalars['String']['output']
    node: PersonalizedQuote
}

export type PersonalizedQuoteInput = {
    author: Scalars['String']['input']
    backgroundColor?: InputMaybe<Scalars['Color']['input']>
    text: Scalars['String']['input']
    textColor?: InputMaybe<Scalars['Color']['input']>
}

export type PersonalizedQuoteQuery = {
    __typename?: 'PersonalizedQuoteQuery'
    get: PersonalizedQuoteConnection
}

export type PersonalizedQuoteQueryGetArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    page?: InputMaybe<Scalars['Int']['input']>
}

export type PersonalizedQuotesMutation = {
    __typename?: 'PersonalizedQuotesMutation'
    create: PersonalizedQuote
    delete: Scalars['Boolean']['output']
    update?: Maybe<PersonalizedQuote>
}

export type PersonalizedQuotesMutationCreateArgs = {
    quote: PersonalizedQuoteInput
}

export type PersonalizedQuotesMutationDeleteArgs = {
    quoteId: Scalars['UUID']['input']
}

export type PersonalizedQuotesMutationUpdateArgs = {
    quote: PersonalizedQuoteInput
    quoteId: Scalars['UUID']['input']
}

export enum PersonalizedRecommendedContent {
    Article = 'ARTICLE',
    JourneyDailyStep = 'JOURNEY_DAILY_STEP',
    Microstep = 'MICROSTEP'
}

export type PersonalizedReset = Reset & {
    __typename?: 'PersonalizedReset'
    _: Scalars['Boolean']['output']
    audio: Audio
    audioEndTime?: Maybe<Scalars['Int']['output']>
    audioProvider?: Maybe<AudioProvider>
    audioStartTime?: Maybe<Scalars['Int']['output']>
    createdAt: Scalars['Instant']['output']
    durationInSeconds: Scalars['Int']['output']
    frames: Array<Frame>
    id: Scalars['UUID']['output']
    name: Scalars['String']['output']
    shared: Array<SharedPersonalizedReset>
    updatedAt: Scalars['Instant']['output']
    user: ResetApiUser
}

export type PersonalizedResetActionsMutation = {
    __typename?: 'PersonalizedResetActionsMutation'
    watched: Scalars['Boolean']['output']
}

export type PersonalizedResetActionsMutationWatchedArgs = {
    resetId: Scalars['UUID']['input']
}

export type PersonalizedResetAdminQuery = {
    __typename?: 'PersonalizedResetAdminQuery'
    /** Get a personalized reset for a user. Selection logic: 1) select random between unwatched 2) if all watched select the one not watched for more time.This requires a service token with 'admin:reset' scope. */
    getOne?: Maybe<PersonalizedReset>
}

export type PersonalizedResetAdminQueryGetOneArgs = {
    input: PersonalizedResetForUserInput
}

export type PersonalizedResetForUserInput = {
    /** UUID of the user these reset is for */
    thriveUserId: Scalars['UUID']['input']
}

export type PersonalizedResetInput = {
    audioEndTime?: InputMaybe<Scalars['Int']['input']>
    audioId: Scalars['UUID']['input']
    audioProvider?: InputMaybe<AudioProvider>
    audioStartTime?: InputMaybe<Scalars['Int']['input']>
    frames: Array<FrameInputIdInput>
    name: Scalars['String']['input']
}

export type PersonalizedResetPage = {
    __typename?: 'PersonalizedResetPage'
    items: Array<PersonalizedReset>
    itemsPerPage: Scalars['Int']['output']
    page: Scalars['Int']['output']
    total: Scalars['Int']['output']
}

export type PersonalizedResetQuery = {
    __typename?: 'PersonalizedResetQuery'
    get: PersonalizedResetPage
    getByIds: Array<PersonalizedReset>
    watched: PersonalizedResetWatchQuery
}

export type PersonalizedResetQueryGetArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    page?: InputMaybe<Scalars['Int']['input']>
}

export type PersonalizedResetQueryGetByIdsArgs = {
    ids: Array<Scalars['UUID']['input']>
}

export type PersonalizedResetWatchQuery = {
    __typename?: 'PersonalizedResetWatchQuery'
    historyByDay: Array<ResetDailyWatched>
}

export type PersonalizedResetWatchQueryHistoryByDayArgs = {
    from: Scalars['ISODate']['input']
    to: Scalars['ISODate']['input']
}

export type PersonalizedResetsMutation = {
    __typename?: 'PersonalizedResetsMutation'
    create: PersonalizedReset
    delete: Scalars['Boolean']['output']
    event: PersonalizedResetActionsMutation
    share?: Maybe<SharedPersonalizedReset>
    unshare: Scalars['Boolean']['output']
    update?: Maybe<PersonalizedReset>
}

export type PersonalizedResetsMutationCreateArgs = {
    reset: PersonalizedResetInput
}

export type PersonalizedResetsMutationDeleteArgs = {
    resetId: Scalars['UUID']['input']
}

export type PersonalizedResetsMutationShareArgs = {
    resetId: Scalars['UUID']['input']
}

export type PersonalizedResetsMutationUnshareArgs = {
    sharedId: Scalars['UUID']['input']
}

export type PersonalizedResetsMutationUpdateArgs = {
    reset: PersonalizedResetInput
    resetId: Scalars['UUID']['input']
}

export type PersonalizedVideo = {
    __typename?: 'PersonalizedVideo'
    createdAt: Scalars['Instant']['output']
    id: Scalars['UUID']['output']
    urls: VideoUrls
    user?: Maybe<ResetApiUser>
}

export type PersonalizedVideoFrame = Frame & {
    __typename?: 'PersonalizedVideoFrame'
    _: Scalars['Boolean']['output']
    createdAt: Scalars['Instant']['output']
    endTimeSeconds: Scalars['Int']['output']
    id: Scalars['UUID']['output']
    startTimeSeconds: Scalars['Int']['output']
    urls: VideoUrls
    user?: Maybe<ResetApiUser>
}

export type PersonalizedVideoInputGraphQlInput = {
    playbackUrl: Scalars['String']['input']
    thumbnailUrl: Scalars['String']['input']
}

export type PersonalizedVideoMutation = {
    __typename?: 'PersonalizedVideoMutation'
    create: PersonalizedVideo
    delete: Scalars['Boolean']['output']
}

export type PersonalizedVideoMutationCreateArgs = {
    input: PersonalizedVideoInputGraphQlInput
}

export type PersonalizedVideoMutationDeleteArgs = {
    videoId: Scalars['UUID']['input']
}

export type PersonalizedVideoPage = {
    __typename?: 'PersonalizedVideoPage'
    items: Array<PersonalizedVideo>
    itemsPerPage: Scalars['Int']['output']
    page: Scalars['Int']['output']
    total: Scalars['Int']['output']
}

export type PersonalizedVideoQuery = {
    __typename?: 'PersonalizedVideoQuery'
    get: PersonalizedVideoPage
}

export type PersonalizedVideoQueryGetArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    page?: InputMaybe<Scalars['Int']['input']>
}

export type PlanEntity = {
    __typename?: 'PlanEntity'
    createdAt: Scalars['Instant']['output']
    currentHabit: Habit
    id: Scalars['UUID']['output']
    intention: Intention
    startDate: Scalars['ISODate']['output']
    updatedAt: Scalars['Instant']['output']
}

export enum PlanResponseType {
    CurrentPlan = 'CURRENT_PLAN',
    NewHabit = 'NEW_HABIT',
    NewPlan = 'NEW_PLAN'
}

export enum PlantActionError {
    ErrorProcessingPlantAction = 'ERROR_PROCESSING_PLANT_ACTION',
    PlantAlreadyPlanted = 'PLANT_ALREADY_PLANTED',
    PlantGrowthNotComplete = 'PLANT_GROWTH_NOT_COMPLETE',
    PlantNotFoundForUser = 'PLANT_NOT_FOUND_FOR_USER'
}

export type PlantActionErrorResult = {
    __typename?: 'PlantActionErrorResult'
    error: PlantActionError
}

export type PlantActionResponse = PlantActionErrorResult | PlantActionResult

export type PlantActionResult = {
    __typename?: 'PlantActionResult'
    userGardenId?: Maybe<Scalars['UUID']['output']>
    userPlants?: Maybe<Array<UserPlantInfo>>
}

export type PlantInfo = {
    __typename?: 'PlantInfo'
    /** Plant color for layer 1 */
    colorLayer1?: Maybe<Scalars['String']['output']>
    /** Plant color for layer 2 */
    colorLayer2?: Maybe<Scalars['String']['output']>
    /** Plant color for layer 3 */
    colorLayer3?: Maybe<Scalars['String']['output']>
    /** Plant color for layer 4 */
    colorLayer4?: Maybe<Scalars['String']['output']>
    /** The product upc associated to the plant */
    productUpc: Scalars['String']['output']
}

export type PlantsLeaderboard = {
    __typename?: 'PlantsLeaderboard'
    rankedList: Array<PlantsRanked>
    /** The requester entity ranked position */
    requesterRank: Scalars['Int']['output']
    totalEntries: Scalars['Int']['output']
}

export type PlantsRanked = {
    __typename?: 'PlantsRanked'
    /** The entity display name */
    displayName: Scalars['String']['output']
    /** The entity id */
    entityId: Scalars['UUID']['output']
    /** The rank position on the leaderboard */
    rank: Scalars['Int']['output']
    /** Total plants number */
    totalPlants: Scalars['Int']['output']
}

export type PlatformAgent = {
    __typename?: 'PlatformAgent'
    email?: Maybe<Scalars['String']['output']>
    firstName?: Maybe<Scalars['String']['output']>
    id: Scalars['String']['output']
    isActive: Scalars['Boolean']['output']
    lastName?: Maybe<Scalars['String']['output']>
    lastResetTimestamp?: Maybe<Scalars['Instant']['output']>
    name?: Maybe<Scalars['String']['output']>
}

export enum PlatformCategory {
    Chat = 'CHAT',
    Mobile = 'MOBILE',
    Web = 'WEB'
}

export type PlatformGroup = {
    __typename?: 'PlatformGroup'
    groupType: GroupType
    groups: Array<AgentGroup>
}

export enum PlatformType {
    AmazonConnect = 'AMAZON_CONNECT',
    Desktop = 'DESKTOP',
    Genesys = 'GENESYS',
    Nice = 'NICE',
    Salesforce = 'SALESFORCE',
    Webex = 'WEBEX'
}

export type Podcast = {
    __typename?: 'Podcast'
    id: Scalars['ID']['output']
    imageUrl?: Maybe<Scalars['String']['output']>
    numberOfEpisodes: Scalars['Int']['output']
    numberOfSeasons: Scalars['Int']['output']
    /** @deprecated Not supported, replace with LearnContentProgress */
    podcastProgress: PodcastProgress
    /** Podcast progress for user, based on userId from context. Checks progress on seasons. */
    progress?: Maybe<LearnContentProgress>
    seasons: Array<PodcastSeason>
    summary: Scalars['String']['output']
    tags: Array<Tag>
    title: Scalars['String']['output']
}

/** Progress input for Podcast Episode */
export type PodcastContentStatusInput = {
    /** podcast episode id */
    contentId: Scalars['String']['input']
    /** podcast episode progress in seconds */
    progressInSeconds: Scalars['Int']['input']
    progressType: LearnContentStatusProgressType
    /** total duration of podcast episode in seconds */
    totalInSeconds: Scalars['Int']['input']
}

export type PodcastEpisode = {
    __typename?: 'PodcastEpisode'
    audioUrl?: Maybe<Scalars['String']['output']>
    bookmarked: Scalars['Boolean']['output']
    contentStatus?: Maybe<LearnContentStatus>
    contentType: LearnContentStatusType
    guests: Array<Contributor>
    id: Scalars['ID']['output']
    imageUrl?: Maybe<Scalars['String']['output']>
    likes: Likes
    number: Scalars['Int']['output']
    podcast?: Maybe<Podcast>
    podcastEpisodeProgress?: Maybe<PodcastEpisodeProgress>
    podcastId?: Maybe<Scalars['ID']['output']>
    season?: Maybe<PodcastSeason>
    seasonId?: Maybe<Scalars['ID']['output']>
    summary: Scalars['String']['output']
    tags: Array<Tag>
    title: Scalars['String']['output']
    transcriptUrl?: Maybe<Scalars['String']['output']>
}

export type PodcastEpisodePage = {
    __typename?: 'PodcastEpisodePage'
    hasMore?: Maybe<Scalars['Boolean']['output']>
    items: Array<PodcastEpisode>
    page: Scalars['Int']['output']
    pageCount?: Maybe<Scalars['Int']['output']>
    pageSize: Scalars['Int']['output']
}

export type PodcastEpisodeParent = {
    __typename?: 'PodcastEpisodeParent'
    podcastID: Scalars['ID']['output']
    seasonID: Scalars['ID']['output']
}

export type PodcastEpisodeProgress = {
    __typename?: 'PodcastEpisodeProgress'
    durationInSeconds: Scalars['Int']['output']
    hasCompleted: Scalars['Boolean']['output']
    inProgress: Scalars['Boolean']['output']
    progressInPercent: Scalars['Int']['output']
    progressInSeconds: Scalars['Int']['output']
    updatedAt: Scalars['Instant']['output']
}

export type PodcastPage = {
    __typename?: 'PodcastPage'
    hasMore?: Maybe<Scalars['Boolean']['output']>
    items: Array<Podcast>
    page: Scalars['Int']['output']
    pageCount?: Maybe<Scalars['Int']['output']>
    pageSize: Scalars['Int']['output']
}

export type PodcastProgress = {
    __typename?: 'PodcastProgress'
    durationInSeconds: Scalars['Int']['output']
    inProgress: Scalars['Boolean']['output']
    isPreviouslyCompleted: Scalars['Boolean']['output']
    isPristine: Scalars['Boolean']['output']
    numberOfEpisodesInProgress: Scalars['Int']['output']
    numberOfEpisodesPreviouslyCompleted: Scalars['Int']['output']
    numberOfPristineEpisodes: Scalars['Int']['output']
    numberOfPristineSeasons: Scalars['Int']['output']
    numberOfSeasonsInProgress: Scalars['Int']['output']
    numberOfSeasonsPreviouslyCompleted: Scalars['Int']['output']
    progressInPercent: Scalars['Int']['output']
    progressInSeconds: Scalars['Int']['output']
    updatedAt: Scalars['Instant']['output']
}

export type PodcastSeason = {
    __typename?: 'PodcastSeason'
    episodes: Array<PodcastEpisode>
    id: Scalars['ID']['output']
    number: Scalars['Int']['output']
    numberOfEpisodes: Scalars['Int']['output']
    podcast?: Maybe<Podcast>
    /** @deprecated Not supported, replace with LearnContentProgress */
    podcastSeasonProgress?: Maybe<PodcastSeasonProgress>
    /** Podcast season progress for user, based on userId from context. Checks progress on podcast episodes. */
    progress?: Maybe<LearnContentProgress>
    summary: Scalars['String']['output']
    title: Scalars['String']['output']
}

export type PodcastSeasonProgress = {
    __typename?: 'PodcastSeasonProgress'
    durationInSeconds: Scalars['Int']['output']
    inProgress: Scalars['Boolean']['output']
    isPristine: Scalars['Boolean']['output']
    numberOfEpisodesInProgress: Scalars['Int']['output']
    numberOfEpisodesPreviouslyCompleted: Scalars['Int']['output']
    numberOfPristineEpisodes: Scalars['Int']['output']
    progressInPercent: Scalars['Int']['output']
    progressInSeconds: Scalars['Int']['output']
    statusList: Array<Maybe<LearnContentStatus>>
    updatedAt: Scalars['Instant']['output']
}

export type PollResponse = {
    __typename?: 'PollResponse'
    items: Array<CallsCommand>
    sessionId: Scalars['String']['output']
}

export type Post = {
    __typename?: 'Post'
    /** The id of this challenge */
    challengeId?: Maybe<Scalars['UUID']['output']>
    createdAt?: Maybe<Scalars['Instant']['output']>
    createdBy?: Maybe<Scalars['UUID']['output']>
    createdBySocialGroup?: Maybe<Scalars['String']['output']>
    /** The id of the entity that originated the post */
    entityId?: Maybe<Scalars['String']['output']>
    /** The name of the entity that originated the post */
    entityName?: Maybe<Scalars['String']['output']>
    /** The thumbnail of the entity that originated the post */
    entityThumbnail?: Maybe<Scalars['String']['output']>
    /** The post of the entity that originated the post */
    entityType?: Maybe<Scalars['String']['output']>
    /** The id of this post */
    id: Scalars['UUID']['output']
    lastUpdatedBy?: Maybe<Scalars['UUID']['output']>
    postType: PostType
    profilePhotoUrl?: Maybe<Scalars['String']['output']>
    reactions?: Maybe<PostReactions>
    /** The id of this social group */
    socialGroupId: Scalars['UUID']['output']
    updatedAt?: Maybe<Scalars['Instant']['output']>
    userDisplayName?: Maybe<Scalars['String']['output']>
    userId?: Maybe<Scalars['UUID']['output']>
}

export type PostOperationSucceeded = {
    __typename?: 'PostOperationSucceeded'
    /** The ID of the post for which the operation succeeded */
    postId: Scalars['UUID']['output']
}

export type PostReaction = {
    __typename?: 'PostReaction'
    /** The id of this reaction */
    id: Scalars['UUID']['output']
    /** The id of this post */
    postId: Scalars['UUID']['output']
    /** The type of this reaction */
    postReactionTypeId: Scalars['String']['output']
    /** The profile pic for the user who created the reaction */
    profilePhotoUrl?: Maybe<Scalars['String']['output']>
    /** The user display name who created the reaction */
    userDisplayName?: Maybe<Scalars['String']['output']>
    /** The id of the user who created the reaction */
    userId: Scalars['UUID']['output']
}

export type PostReactionCreationSucceeded = {
    __typename?: 'PostReactionCreationSucceeded'
    /** The post Item ID for  which the operation succeeded */
    postReactionId: Scalars['UUID']['output']
}

export type PostReactionInput = {
    /** The id of this post */
    postId: Scalars['UUID']['input']
    /** The type of this reaction */
    postTypeId: Scalars['String']['input']
}

export type PostReactions = {
    __typename?: 'PostReactions'
    celebrates?: Maybe<Array<PostReaction>>
    likes?: Maybe<Array<PostReaction>>
    loves?: Maybe<Array<PostReaction>>
}

export type PostType = {
    __typename?: 'PostType'
    language: Scalars['String']['output']
    message: Scalars['String']['output']
    postTypeId: Scalars['String']['output']
    region: Scalars['String']['output']
}

export type PrivateMagicLinkRequestInput = {
    clientId: Scalars['String']['input']
    expiresInSeconds?: InputMaybe<Scalars['Int']['input']>
    force?: InputMaybe<Scalars['Boolean']['input']>
    relay?: InputMaybe<Scalars['String']['input']>
    userId: Scalars['String']['input']
}

export type PrivateMagicLinkResponse = {
    __typename?: 'PrivateMagicLinkResponse'
    cacheId?: Maybe<Scalars['UUID']['output']>
    link?: Maybe<Scalars['String']['output']>
    userId?: Maybe<Scalars['UUID']['output']>
}

export type ProductInfo = {
    __typename?: 'ProductInfo'
    /** The product cost */
    cost?: Maybe<Scalars['Int']['output']>
    createdAt?: Maybe<Scalars['Instant']['output']>
    /** The currency code */
    currencyCode?: Maybe<Scalars['String']['output']>
    /** The description of the product */
    description?: Maybe<Scalars['String']['output']>
    /** For plants, number of steps to fully grow */
    plantWateringSteps?: Maybe<Scalars['Int']['output']>
    /** Deprecated - Use productTypeEnum */
    productType?: Maybe<Scalars['String']['output']>
    /** The product type as an Enum */
    productTypeEnum?: Maybe<ProductType>
    /** The title of the product */
    title?: Maybe<Scalars['String']['output']>
    /** The product id */
    upc: Scalars['String']['output']
    updatedAt?: Maybe<Scalars['Instant']['output']>
}

export enum ProductType {
    CommunityPlant = 'COMMUNITY_PLANT',
    Object = 'OBJECT',
    Plant = 'PLANT',
    TrophyPlant = 'TROPHY_PLANT'
}

export type PulseCompanyDto = {
    __typename?: 'PulseCompanyDTO'
    age?: Maybe<Scalars['Int']['output']>
    /** @deprecated No longer supported. Will be removed in a future release */
    cadenceOption: Scalars['String']['output']
    createdAt?: Maybe<Scalars['Instant']['output']>
    id: Scalars['UUID']['output']
    matured?: Maybe<Scalars['Boolean']['output']>
    totalEmployees: Scalars['Int']['output']
}

export type PulseDimension = {
    __typename?: 'PulseDimension'
    name: Scalars['String']['output']
    type: Scalars['String']['output']
}

export type PulseDispatchEventResponse = {
    __typename?: 'PulseDispatchEventResponse'
    channel: Channel
    cleared: Scalars['Boolean']['output']
    eligibility: SurveyEligibility
    expiresAt: Scalars['Instant']['output']
    id: Scalars['UUID']['output']
    pulseUserId: Scalars['UUID']['output']
    responded: Scalars['Boolean']['output']
    responseValue?: Maybe<Scalars['Int']['output']>
    survey?: Maybe<PulseSurveyQuestionDto>
    surveyIssueDate: Scalars['ISODate']['output']
}

export type PulseOnDemand =
    | PulseDispatchEventResponse
    | PulseOnDemandErrorResponse

export type PulseOnDemandErrorResponse = {
    __typename?: 'PulseOnDemandErrorResponse'
    message: Scalars['String']['output']
}

export type PulseReportingAdminMutation = {
    __typename?: 'PulseReportingAdminMutation'
    /** Manually Trigger Refresh of Engagement Reports */
    refreshEngagementMetrics: RefreshEngagementReportResponse
    /** Manually Trigger Refresh of Historic App Usage */
    refreshHistoricAppUsage: RefreshEngagementReportResponse
    /** Manually Trigger Refresh of Challenges Count */
    refreshHistoricChallengesCounts: RefreshEngagementReportResponse
    /** Manually Trigger Refresh of Historic Daily Check In Benchmarks */
    refreshHistoricDailyCheckInBenchmarks: RefreshEngagementReportResponse
    /** Manually Trigger Refresh of Historic Daily Check In Scores */
    refreshHistoricDailyCheckInScores: RefreshEngagementReportResponse
    /** Manually Trigger Refresh of Historic Engagement Levels */
    refreshHistoricEngagementLevels: RefreshEngagementReportResponse
    /** Manually Trigger Refresh of Microstep Checkin Count */
    refreshHistoricMicrostepCheckinCounts: RefreshEngagementReportResponse
    /** Manually Trigger Refresh of Recent Daily Check In Benchmarks */
    refreshRecentDailyCheckInBenchmarks: RefreshEngagementReportResponse
    /** Manually Trigger Refresh of Recent Daily Check In Scores */
    refreshRecentDailyCheckInScores: RefreshEngagementReportResponse
    /** Manually Trigger Refresh of Recent Engagement Levels */
    refreshRecentEngagementLevels: RefreshEngagementReportResponse
}

export type PulseReportingEngagementReportQuery = {
    __typename?: 'PulseReportingEngagementReportQuery'
    /** Engagement Reports */
    engagementReport?: Maybe<EngagementReportResponse>
}

export type PulseReportingEngagementReportQueryEngagementReportArgs = {
    companyId: Scalars['UUID']['input']
    period: ReportPeriod
}

export type PulseReportingMutation = {
    __typename?: 'PulseReportingMutation'
    /** Manually Trigger Reports */
    admin: PulseReportingAdminMutation
}

export type PulseReportingQuery = {
    __typename?: 'PulseReportingQuery'
    activityFeatureCount: ActivityFeatureCountQuery
    dailyCheckInScores: DailyCheckInScoresQuery
    /** Engagement metrics for a company */
    engagement: PulseReportingEngagementReportQuery
    engagementLevels: EngagementLevelsQuery
    usage: UsageQuery
}

export type PulseSettings = {
    __typename?: 'PulseSettings'
    /** Pulse schedule */
    pulseSchedule: Array<Scalars['String']['output']>
    /** Pulse time */
    pulseTime: Scalars['String']['output']
}

export type PulseSettingsInput = {
    pulseSchedule: Array<Scalars['String']['input']>
    pulseTime: Scalars['String']['input']
    teamsUserId: Scalars['UUID']['input']
}

export type PulseSettingsMutation = {
    __typename?: 'PulseSettingsMutation'
    /** Save Pulse settings for a user */
    savePulseSettings: PulseSettingsResult
}

export type PulseSettingsMutationSavePulseSettingsArgs = {
    input: PulseSettingsInput
}

export type PulseSettingsResult = {
    __typename?: 'PulseSettingsResult'
    error?: Maybe<Scalars['String']['output']>
    updated: Scalars['Boolean']['output']
}

export type PulseStreakDto = {
    __typename?: 'PulseStreakDTO'
    current: Scalars['Int']['output']
    max: Scalars['Int']['output']
}

export type PulseSurveyQuestionDto = {
    __typename?: 'PulseSurveyQuestionDTO'
    displayName: Scalars['String']['output']
    id: Scalars['UUID']['output']
    journeyId?: Maybe<Scalars['UUID']['output']>
    label: Scalars['String']['output']
    locale: Scalars['String']['output']
    name: Scalars['String']['output']
    question: QuestionDto
}

export enum PurchaseError {
    CantPurchaseCommunityPlants = 'CANT_PURCHASE_COMMUNITY_PLANTS',
    CantPurchaseNewPlants = 'CANT_PURCHASE_NEW_PLANTS',
    CantPurchaseProduct = 'CANT_PURCHASE_PRODUCT',
    DailyLimitReached = 'DAILY_LIMIT_REACHED',
    ErrorProcessingPurchase = 'ERROR_PROCESSING_PURCHASE',
    InsufficientFoundsForThatCurrency = 'INSUFFICIENT_FOUNDS_FOR_THAT_CURRENCY',
    ProductDoesntExist = 'PRODUCT_DOESNT_EXIST'
}

export type PurchaseErrorResult = {
    __typename?: 'PurchaseErrorResult'
    error: PurchaseError
}

export type PurchaseResponse = PurchaseErrorResult | PurchaseResult

export type PurchaseResult = {
    __typename?: 'PurchaseResult'
    userBalance?: Maybe<Array<BalanceInfo>>
    userInventory: Array<UserInventoryInfo>
}

export type Query = {
    __typename?: 'Query'
    /** Achievements Query */
    achievements: AchievementsQuery
    assessment: AssessmentQuery
    behavioralProfile: BehavioralProfileQuery
    /** Thrive for Support Teams Queries */
    calls: CallsQuery
    /** Centralized Notifications Root Query */
    centralizedNotifications: CentralizedNotificationsQuery
    /** Root function for Coaching queries */
    coaching: CoachingQuery
    content: ContentQuery
    contentExperience: ContentExperienceQuery
    /** Daily Experience Root Query */
    dailyExperience: DailyExperienceQuery
    example: ExampleQuery
    exampleGraphapiQuery: ExampleGraphapiQuery
    /** Game Query */
    game: GameQuery
    /** Returns all public companies with optional pagination */
    getCompanies: CompanyPage
    /** Get a list of NPSResults for a User */
    getNPSResult: Array<UserNpsResult>
    /** @deprecated Just placeholder for testing, replace with pulse */
    hello: Scalars['String']['output']
    /** Hello World Query */
    helloWorldQuery: Scalars['String']['output']
    identity: IdentityQuery
    inAppMessage: AssetQuery
    /** Journeys Root Query */
    journeys: JourneyQuery
    /** Learn Root Query - Version 2 */
    learnV2: LearnQueryV2
    notification: NotificationQuery
    /** Onboarding Root Query */
    onboarding: OnboardingQuery
    /** Access to Thrive Pulse data */
    pulse: ThrivePulseQuery
    /** Pulse Reporting Root Query */
    pulseReporting: PulseReportingQuery
    /**
     * External Pulse Root Query
     * @deprecated Still work but latest APIs are now in pulse, replace with pulse
     */
    pulseV2: ExternalPulseQuery
    recommendation: RecommendationQuery
    reset: ResetQuery
    /**
     * Reset Root Query
     * @deprecated Use reset under content.thrive
     */
    resetV2: ResetQueryV2
    /** Retail Query */
    retail: RetailQuery
    search: SearchQuery
    /** Slack Root Query */
    slack: SlackQuery
    /** Social Groups Root Query */
    socialGroups: SocialGroupQuery
    /** Teams Root Query */
    teams: TeamsQuery
    /** Test Query */
    testQuery: Scalars['String']['output']
    /** Thrive score */
    thriveScore: ThriveScoreQuery
    today: TodayQuery
    /** Unified Challenges Root Query */
    unifiedChallenges: UnifiedChallengesQuery
    userHistory: UserHistoryQuery
    /** Wearables Platform Root Query */
    wearables: WearablesPlatformQuery
}

export type QueryGetCompaniesArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryGetNpsResultArgs = {
    userId: Scalars['UUID']['input']
}

export type QueryPulseV2Args = {
    companyId?: InputMaybe<Scalars['UUID']['input']>
}

export type QuestionDto = {
    __typename?: 'QuestionDTO'
    options: Array<OptionsDto>
    text: Scalars['String']['output']
}

export type QuoteQuery = {
    __typename?: 'QuoteQuery'
    personalized: PersonalizedQuoteQuery
    thrive: ThriveQuoteQuery
}

export type QuotesMutation = {
    __typename?: 'QuotesMutation'
    personalized: PersonalizedQuotesMutation
}

export enum Realm {
    ThriveGlobal = 'ThriveGlobal',
    Master = 'master'
}

export type RecentDailyCheckInScores = {
    __typename?: 'RecentDailyCheckInScores'
    aboveBenchmark: Scalars['Boolean']['output']
    averageScore: Scalars['Float']['output']
    averageScorePercentage: Scalars['Float']['output']
    benchmarkScore: Scalars['Float']['output']
    benchmarkScorePercentage: Scalars['Float']['output']
}

export type RecentDailyCheckInScoresResponse = {
    __typename?: 'RecentDailyCheckInScoresResponse'
    belonging?: Maybe<RecentDailyCheckInScores>
    effectiveness?: Maybe<RecentDailyCheckInScores>
    employeeCount: Scalars['Int']['output']
    energy?: Maybe<RecentDailyCheckInScores>
    enthusiasm?: Maybe<RecentDailyCheckInScores>
    productivity?: Maybe<RecentDailyCheckInScores>
    responseCount: Scalars['Int']['output']
    retention?: Maybe<RecentDailyCheckInScores>
}

export type RecentEngagementLevelResponse = {
    __typename?: 'RecentEngagementLevelResponse'
    atRisk: RecentEngagementLevelStats
    employeeCount: Scalars['Int']['output']
    highlyEngaged: RecentEngagementLevelStats
    moderatelyEngaged: RecentEngagementLevelStats
}

export type RecentEngagementLevelStats = {
    __typename?: 'RecentEngagementLevelStats'
    changeInPercentage: Scalars['Float']['output']
    employeeCount: Scalars['Int']['output']
    percentage: Scalars['Float']['output']
}

export type RecommendationFilterInput = {
    /** Content filters to apply to the recommendations. */
    contentFilter?: InputMaybe<ContentFilterInput>
    /** Include these types in the recommendations. By default, all supported types are included. */
    recommendationTypes?: InputMaybe<Array<RecommendationType>>
    /** The requested number of recommendations to return for each content type. Not guaranteed to return this amount. Must be greater than 0 if set. Defaults to null, meaning that recommendations are not guaranteed to be returned for each type. */
    requestedRecommendationsPerType?: InputMaybe<Scalars['Int']['input']>
    /** The max number of recommendations to return in total. Not guaranteed to return this amount. Must be greater than 0 if set. Defaults to null */
    requestedRecommendationsTotal?: InputMaybe<Scalars['Int']['input']>
}

export type RecommendationMutation = {
    __typename?: 'RecommendationMutation'
    /** Record a user's interaction with a piece of content. Past user interactions will affect future recommendations. */
    recordUserInteraction: Scalars['Boolean']['output']
}

export type RecommendationMutationRecordUserInteractionArgs = {
    contentId: Scalars['UUID']['input']
    contentType: UserRecommendationsContentType
    interactionType: UserRecommendationsInteractionType
    userId: Scalars['UUID']['input']
}

export type RecommendationQuery = {
    __typename?: 'RecommendationQuery'
    /**
     * Hello World query for testing
     * @deprecated No longer supported.
     */
    helloRecommendationTestQuery: Scalars['String']['output']
    /** Get recommendations for a user. This requires a service token with 'admin:recommendations' scope. */
    recommendationsForUser: Array<Maybe<RecommendedResourceV3>>
    /**
     * Get troubleshooting data for benefits connect
     * @deprecated Come talk to Content Platform team in #ask-content-platform
     */
    troubleshootBenefitsConnectData: BenefitsConnectDetails
    /** Get recommendations for a user. This requires a user token. */
    userRecommendations: Array<Maybe<RecommendedResourceV3>>
}

export type RecommendationQueryRecommendationsForUserArgs = {
    filter?: InputMaybe<RecommendationFilterInput>
    input?: InputMaybe<UserRecommendationInput>
    numberOfRecommendations?: InputMaybe<Scalars['Int']['input']>
    userId: Scalars['UUID']['input']
}

export type RecommendationQueryTroubleshootBenefitsConnectDataArgs = {
    locale: Scalars['String']['input']
    userId: Scalars['UUID']['input']
}

export type RecommendationQueryUserRecommendationsArgs = {
    filter?: InputMaybe<RecommendationFilterInput>
    input?: InputMaybe<UserRecommendationInput>
    numberOfRecommendations?: InputMaybe<Scalars['Int']['input']>
}

export enum RecommendationType {
    Article = 'ARTICLE',
    BenefitsConnect = 'BENEFITS_CONNECT',
    CompanyResource = 'COMPANY_RESOURCE',
    CourseModule = 'COURSE_MODULE',
    JourneyDailyStep = 'JOURNEY_DAILY_STEP',
    Microstep = 'MICROSTEP',
    PodcastEpisode = 'PODCAST_EPISODE',
    Recipe = 'RECIPE',
    Reset = 'RESET',
    RoleModel = 'ROLE_MODEL'
}

export type RecommendationsQuery = {
    __typename?: 'RecommendationsQuery'
    /** Retrieve actionable Pulse recommendations for a company based on employee responses for a specified set of dimensions */
    byRangeAndDimensions: Array<RecommendedContent>
}

export type RecommendationsQueryByRangeAndDimensionsArgs = {
    dimensions: Array<Surveys>
    from: Scalars['String']['input']
    to: Scalars['String']['input']
}

export type RecommendedContent = {
    __typename?: 'RecommendedContent'
    URL: Scalars['String']['output']
    contentType: SupportedRecommendedContentType
    description: Scalars['String']['output']
    difficulty: ContentDifficulty
    dimension: Surveys
    impact: ContentImpact
    reason: Scalars['String']['output']
    riskProfile: RiskProfile
}

export type RecommendedContentDto = {
    __typename?: 'RecommendedContentDTO'
    article?: Maybe<ArticleDto>
    contentType?: Maybe<SupportedRecommendedContentType>
    reset?: Maybe<ResetDto>
}

export type RecommendedEntities =
    | ArticleV2
    | GraphQlMicrostep
    | JourneyDailyStep

export type RecommendedJourneysError = {
    __typename?: 'RecommendedJourneysError'
    errorCode: ErrorCode
}

export type RecommendedJourneysInconclusive = {
    __typename?: 'RecommendedJourneysInconclusive'
    inconclusive: Scalars['Boolean']['output']
}

export type RecommendedJourneysResult =
    | RecommendedJourneysError
    | RecommendedJourneysInconclusive
    | RecommendedJourneysSuccess

export type RecommendedJourneysSuccess = {
    __typename?: 'RecommendedJourneysSuccess'
    inconclusive: Scalars['Boolean']['output']
    recommendedJourneys: Array<JourneyCoreType>
}

export type RecommendedMicrostep = GraphQlMicrostep

export enum RecommendedPlantsError {
    DailyLimitReached = 'DAILY_LIMIT_REACHED'
}

export type RecommendedPlantsErrorResult = {
    __typename?: 'RecommendedPlantsErrorResult'
    error: RecommendedPlantsError
}

export type RecommendedPlantsResponse =
    | RecommendedPlantsErrorResult
    | RecommendedPlantsResult

export type RecommendedPlantsResult = {
    __typename?: 'RecommendedPlantsResult'
    recommendedPlants: Array<ProductInfo>
}

export type RecommendedResetsGraphQlInput = {
    count: Scalars['Int']['input']
    filterByTimeOfDay: Scalars['Boolean']['input']
    filterByUserIntention: Scalars['Boolean']['input']
}

export type RecommendedResourceV3 =
    | ArticleV2
    | CompanyResourceGroup
    | GraphQlMicrostep
    | JourneyDailyStep
    | ModuleV2
    | PodcastEpisode
    | ThriveReset

export type ReferralEmailRequestInput = {
    allowExistingUsers?: InputMaybe<Scalars['Boolean']['input']>
    clientId?: InputMaybe<Scalars['String']['input']>
    companyId: Scalars['UUID']['input']
    coworkerReferralLink: Scalars['String']['input']
    emailAddresses: Array<Scalars['String']['input']>
    friendsAndFamilyReferralLink?: InputMaybe<Scalars['String']['input']>
    referralType?: InputMaybe<Scalars['String']['input']>
}

export type ReferralEmailResponse = {
    __typename?: 'ReferralEmailResponse'
    alreadyUsers: Array<Scalars['String']['output']>
    failedToSendEmailTo: Array<Scalars['String']['output']>
}

export type RefreshEngagementReportResponse = {
    __typename?: 'RefreshEngagementReportResponse'
    recordsUpdated: Scalars['Int']['output']
}

export type RemoveAdoptedMicrostepError = {
    __typename?: 'RemoveAdoptedMicrostepError'
    type: RemoveAdoptedMicrostepResponseErrorType
}

export type RemoveAdoptedMicrostepResponse =
    | RemoveAdoptedMicrostepError
    | RemoveAdoptedMicrostepResult

export enum RemoveAdoptedMicrostepResponseErrorType {
    ErrorRemovingAdoptedMicrostep = 'ERROR_REMOVING_ADOPTED_MICROSTEP'
}

export type RemoveAdoptedMicrostepResult = {
    __typename?: 'RemoveAdoptedMicrostepResult'
    removedMicrostepId: Scalars['UUID']['output']
}

export type RemoveChallengeResult = RemoveErrorMessage | RemoveSuccess

export type RemoveCoacheePreferencesFailure = {
    __typename?: 'RemoveCoacheePreferencesFailure'
    errorCode: CoachingErrorCode
}

export type RemoveCoacheePreferencesGqlResponse =
    | RemoveCoacheePreferencesFailure
    | RemoveCoacheePreferencesSuccess

export type RemoveCoacheePreferencesSuccess = {
    __typename?: 'RemoveCoacheePreferencesSuccess'
    result: Array<Scalars['UUID']['output']>
}

export type RemoveErrorMessage = {
    __typename?: 'RemoveErrorMessage'
    message: Scalars['String']['output']
}

export type RemoveSuccess = {
    __typename?: 'RemoveSuccess'
    message: Scalars['String']['output']
}

export enum ReportInterval {
    Daily = 'DAILY',
    Monthly = 'MONTHLY',
    Ungrouped = 'UNGROUPED',
    Weekly = 'WEEKLY'
}

export enum ReportPeriod {
    OneHundredEighty = 'ONE_HUNDRED_EIGHTY',
    Sixty = 'SIXTY',
    Thirty = 'THIRTY'
}

export type ReportingCoordinates = {
    __typename?: 'ReportingCoordinates'
    x: Scalars['String']['output']
    y: Scalars['Float']['output']
}

export type ReportingQuery = {
    __typename?: 'ReportingQuery'
    /** Returns agent analytics */
    getAgentAnalytics: AgentAnalyticsResponse
    /** Returns a high-level overview of each agent's engagement with Thrive Resets */
    getAgentEngagement?: Maybe<AgentEngagementReport>
    /** Returns the percentage of agents that have received a Thrive Reset */
    getAgentReach?: Maybe<SingleMetricResult>
    /** Returns agent reset completion rate */
    getAgentResetCompletionRate: SingleMetricResult
    /** Returns resets accepted */
    getAgentResetsAccepted: SingleMetricResult
    /** Returns resets received */
    getAgentResetsReceived: SingleMetricResult
    /** Returns agent stat for total interactions */
    getAgentTotalInteractions: SingleMetricResult
    /** Get average reset call duration for the selected client and timeframe */
    getAverageResetCallDuration: AnalyticsResponse
    /** Get answer rate for reset calls for the selected client and timeframe */
    getResetCallAnswerRate: AnalyticsResponse
    /** Get average reset call completion rate for the selected client and timeframe */
    getResetCallCompletionRate: AnalyticsResponse
    /** Get reset call count averages per agent for the selected client and timeframe */
    getResetCallCountAveragesPerAgent: AnalyticsResponse
    /** Get reset call counts for the selected client and timeframe */
    getResetCallCounts: AnalyticsResponse
    /** Get the percentage of Thrive Resets that were viewed for longer than 50 seconds */
    getResetCompletionRate?: Maybe<SingleMetricResult>
    /** Returns the number of interactions handled by Thrive agents */
    getTotalInteractions?: Maybe<SingleMetricResult>
}

export type ReportingQueryGetAgentAnalyticsArgs = {
    agentId: Scalars['String']['input']
    companyId: Scalars['UUID']['input']
    endDate: Scalars['Instant']['input']
    platform: PlatformType
    startDate: Scalars['Instant']['input']
}

export type ReportingQueryGetAgentEngagementArgs = {
    agentGroupId?: InputMaybe<Scalars['String']['input']>
    companyId: Scalars['UUID']['input']
    endDate: Scalars['Instant']['input']
    groupType?: InputMaybe<GroupType>
    platform: PlatformType
    startDate: Scalars['Instant']['input']
}

export type ReportingQueryGetAgentReachArgs = {
    agentGroupId?: InputMaybe<Scalars['String']['input']>
    companyId: Scalars['UUID']['input']
    endDate: Scalars['Instant']['input']
    groupType?: InputMaybe<GroupType>
    platform: PlatformType
    startDate: Scalars['Instant']['input']
}

export type ReportingQueryGetAgentResetCompletionRateArgs = {
    agentId: Scalars['String']['input']
    companyId: Scalars['UUID']['input']
    endDate: Scalars['Instant']['input']
    platform: PlatformType
    startDate: Scalars['Instant']['input']
}

export type ReportingQueryGetAgentResetsAcceptedArgs = {
    agentId: Scalars['String']['input']
    companyId: Scalars['UUID']['input']
    endDate: Scalars['Instant']['input']
    platform: PlatformType
    startDate: Scalars['Instant']['input']
}

export type ReportingQueryGetAgentResetsReceivedArgs = {
    agentId: Scalars['String']['input']
    companyId: Scalars['UUID']['input']
    endDate: Scalars['Instant']['input']
    platform: PlatformType
    startDate: Scalars['Instant']['input']
}

export type ReportingQueryGetAgentTotalInteractionsArgs = {
    agentId: Scalars['String']['input']
    companyId: Scalars['UUID']['input']
    endDate: Scalars['Instant']['input']
    platform: PlatformType
    startDate: Scalars['Instant']['input']
}

export type ReportingQueryGetAverageResetCallDurationArgs = {
    agentGroupId?: InputMaybe<Scalars['String']['input']>
    companyId: Scalars['UUID']['input']
    endDate: Scalars['Instant']['input']
    granularity: Granularity
    groupType?: InputMaybe<GroupType>
    platform: PlatformType
    startDate: Scalars['Instant']['input']
}

export type ReportingQueryGetResetCallAnswerRateArgs = {
    agentGroupId?: InputMaybe<Scalars['String']['input']>
    companyId: Scalars['UUID']['input']
    endDate: Scalars['Instant']['input']
    granularity: Granularity
    groupType?: InputMaybe<GroupType>
    platform: PlatformType
    startDate: Scalars['Instant']['input']
}

export type ReportingQueryGetResetCallCompletionRateArgs = {
    agentGroupId?: InputMaybe<Scalars['String']['input']>
    companyId: Scalars['UUID']['input']
    endDate: Scalars['Instant']['input']
    granularity: Granularity
    groupType?: InputMaybe<GroupType>
    platform: PlatformType
    startDate: Scalars['Instant']['input']
}

export type ReportingQueryGetResetCallCountAveragesPerAgentArgs = {
    agentGroupId?: InputMaybe<Scalars['String']['input']>
    companyId: Scalars['UUID']['input']
    endDate: Scalars['Instant']['input']
    granularity: Granularity
    groupType?: InputMaybe<GroupType>
    platform: PlatformType
    startDate: Scalars['Instant']['input']
}

export type ReportingQueryGetResetCallCountsArgs = {
    agentGroupId?: InputMaybe<Scalars['String']['input']>
    companyId: Scalars['UUID']['input']
    endDate: Scalars['Instant']['input']
    granularity: Granularity
    groupType?: InputMaybe<GroupType>
    platform: PlatformType
    startDate: Scalars['Instant']['input']
}

export type ReportingQueryGetResetCompletionRateArgs = {
    agentGroupId?: InputMaybe<Scalars['String']['input']>
    companyId: Scalars['UUID']['input']
    endDate: Scalars['Instant']['input']
    groupType?: InputMaybe<GroupType>
    platform: PlatformType
    startDate: Scalars['Instant']['input']
}

export type ReportingQueryGetTotalInteractionsArgs = {
    agentGroupId?: InputMaybe<Scalars['String']['input']>
    companyId: Scalars['UUID']['input']
    endDate: Scalars['Instant']['input']
    groupType?: InputMaybe<GroupType>
    platform: PlatformType
    startDate: Scalars['Instant']['input']
}

export type Reset = {
    _: Scalars['Boolean']['output']
}

export type ResetAdminQuery = {
    __typename?: 'ResetAdminQuery'
    /** Get a reset to be used as a nudge for a user. A thriveReset is always returned, a personalizedReset is returned on a configured frequency.This does not send the nudge to the user, that is responsibility of the client. This requires a service token with 'admin:reset' scope. */
    nudge: ResetNudgeResponse
    personalized: PersonalizedResetAdminQuery
    thrive: ThriveResetAdminQuery
}

export type ResetAdminQueryNudgeArgs = {
    input: ResetNudgeInput
}

export type ResetApiUser = {
    __typename?: 'ResetApiUser'
    companyId?: Maybe<CompanyId>
    createdAt: Scalars['Instant']['output']
    id: Scalars['UUID']['output']
    partner: Partner
    partnerUserId: Scalars['PartnerUserId']['output']
    subscriptionId?: Maybe<SubscriptionId>
    updatedAt: Scalars['Instant']['output']
}

export type ResetAudioMutationV2 = WithBookmarkMutation &
    WithLikeMutation & {
        __typename?: 'ResetAudioMutationV2'
        bookmark: BookmarkMutation
        like: LikeMutation
    }

export type ResetAudioQueryV2 = WithBookmarkQuery &
    WithLikeQuery & {
        __typename?: 'ResetAudioQueryV2'
        bookmark: BookmarkQuery
        /** Get reset audio */
        getAudios: ThriveResetAudioPageV2
        like: LikeQuery
    }

export type ResetAudioQueryV2GetAudiosArgs = {
    page?: InputMaybe<Scalars['Int']['input']>
    pageSize?: InputMaybe<Scalars['Int']['input']>
}

export type ResetDto = {
    __typename?: 'ResetDTO'
    closedCaption?: Maybe<Scalars['String']['output']>
    description: Scalars['String']['output']
    durationInSeconds: Scalars['Int']['output']
    iframeUrlLandscape?: Maybe<Scalars['String']['output']>
    iframeUrlPortrait?: Maybe<Scalars['String']['output']>
    manifestUrlLandscape?: Maybe<Scalars['String']['output']>
    manifestUrlPortrait?: Maybe<Scalars['String']['output']>
    name: Scalars['String']['output']
    thumbnailUrlLandscape?: Maybe<Scalars['String']['output']>
    thumbnailUrlPortrait?: Maybe<Scalars['String']['output']>
    uuid: Scalars['String']['output']
}

export type ResetDailyWatched = {
    __typename?: 'ResetDailyWatched'
    count: Scalars['Int']['output']
    date: Scalars['ISODate']['output']
    resetIds: Array<Scalars['UUID']['output']>
}

export type ResetDetail = {
    __typename?: 'ResetDetail'
    description?: Maybe<Scalars['String']['output']>
    id: Scalars['UUID']['output']
    landscape?: Maybe<ResetLandscape>
    name?: Maybe<Scalars['String']['output']>
}

export type ResetGoalDetail = {
    __typename?: 'ResetGoalDetail'
    reset: ThriveReset
    resetInfo: ResetDetail
}

export type ResetLandscape = {
    __typename?: 'ResetLandscape'
    iframe?: Maybe<Scalars['String']['output']>
    thumbnail?: Maybe<Scalars['String']['output']>
}

export type ResetMutation = {
    __typename?: 'ResetMutation'
    image: ImagesMutation
    personalized: PersonalizedResetsMutation
    quote: QuotesMutation
    thrive: ThriveResetsMutation
    thriveAudio: ThriveResetAudioMutation
    video: VideoMutation
}

export type ResetMutationV2 = {
    __typename?: 'ResetMutationV2'
    audio: ResetAudioMutationV2
    video: ResetVideoMutationV2
}

export type ResetNudgeInput = {
    /** ISO-8601 time string.  Should be the time the nudge should send, in the users' timezone. */
    sendTime: Scalars['String']['input']
    /** UUID of the user these nudge is for */
    thriveUserId: Scalars['UUID']['input']
}

export type ResetNudgeResponse = {
    __typename?: 'ResetNudgeResponse'
    personalizedReset?: Maybe<PersonalizedReset>
    recommendedReset: NudgeRecommendedReset
}

export type ResetQuery = {
    __typename?: 'ResetQuery'
    admin: ResetAdminQuery
    audio: AudioQuery
    banner: BannerQuery
    image: ImageQuery
    personalized: PersonalizedResetQuery
    quote: QuoteQuery
    thrive: ThriveResetQuery
    thriveAudio: ThriveResetAudioQuery
    video: VideoQuery
}

export type ResetQueryV2 = {
    __typename?: 'ResetQueryV2'
    audio: ResetAudioQueryV2
    video: ResetVideoQueryV2
}

export enum ResetRecommendationTimeOfDay {
    Afternoon = 'Afternoon',
    Evening = 'Evening',
    Morning = 'Morning'
}

export enum ResetState {
    Complete = 'COMPLETE',
    OfferAccepted = 'OFFER_ACCEPTED',
    OfferDeclined = 'OFFER_DECLINED',
    ResetOffered = 'RESET_OFFERED',
    Timeout = 'TIMEOUT'
}

export type ResetStats = {
    __typename?: 'ResetStats'
    /** Audio Resets list */
    audioResets: Array<AudioResetStatsDetail>
    /** Number of minutes watched */
    minutes: Scalars['Int']['output']
    /** Resets list */
    resets: Array<ResetStatsDetail>
    /** Number of resets watched */
    total: Scalars['Int']['output']
}

export type ResetStatsDetail = {
    __typename?: 'ResetStatsDetail'
    completed: Scalars['Boolean']['output']
    resetDetail: ResetGoalDetail
}

export type ResetVideoMutationV2 = WithBookmarkMutation &
    WithLikeMutation & {
        __typename?: 'ResetVideoMutationV2'
        bookmark: BookmarkMutation
        like: LikeMutation
    }

export type ResetVideoQueryV2 = WithBookmarkQuery &
    WithLikeQuery & {
        __typename?: 'ResetVideoQueryV2'
        bookmark: BookmarkQuery
        /** Get reset videos */
        getVideos: ThriveResetPageV2
        /** Get reset videos (admin-scoped) */
        getVideosAdmin: ThriveResetPageV2
        like: LikeQuery
    }

export type ResetVideoQueryV2GetVideosArgs = {
    page?: InputMaybe<Scalars['Int']['input']>
    pageSize?: InputMaybe<Scalars['Int']['input']>
}

export type ResetVideoQueryV2GetVideosAdminArgs = {
    locale: Scalars['String']['input']
    page?: InputMaybe<Scalars['Int']['input']>
    pageSize?: InputMaybe<Scalars['Int']['input']>
    subscriptionId?: InputMaybe<Scalars['UUID']['input']>
}

export type ResourceTypeInput = {
    name: Scalars['String']['input']
}

export type ResourceTypePage = {
    __typename?: 'ResourceTypePage'
    items: Array<Scalars['String']['output']>
    itemsPerPage: Scalars['Int']['output']
    page: Scalars['Int']['output']
    total: Scalars['Int']['output']
}

export type Response = {
    __typename?: 'Response'
    normalizedValue: Scalars['BigDecimal']['output']
    text: Scalars['String']['output']
    value: Scalars['Int']['output']
}

export type ResponseInput = {
    normalizedValue: Scalars['BigDecimal']['input']
    text: Scalars['String']['input']
    value: Scalars['Int']['input']
}

export type ResponseOptionCms = {
    __typename?: 'ResponseOptionCms'
    displayOrder?: Maybe<Scalars['Int']['output']>
    normalizedValue: Scalars['BigDecimal']['output']
    text: Scalars['String']['output']
    value: Scalars['Int']['output']
}

export enum RestartError {
    ErrorRestartingJourney = 'ERROR_RESTARTING_JOURNEY',
    JourneyDoesntExist = 'JOURNEY_DOESNT_EXIST'
}

export type RetailMutation = {
    __typename?: 'RetailMutation'
    /** Create new currency */
    createCurrency?: Maybe<CurrencyInfo>
    /** Create new product */
    createProduct?: Maybe<ProductInfo>
    /** Delete a currency */
    deleteCurrency: Scalars['String']['output']
    /** Delete product */
    deleteProduct: Scalars['String']['output']
    grantCommunityPlant?: Maybe<UserPlant>
    /** Grants the onboarding plant to the user */
    grantOnboardingPlant?: Maybe<UserPlantInfo>
    /**
     * Grants a personal plant for a user. Available UPC:
     *         plant.beginner
     *         plant.intermediate
     *         plant.advanced
     *         plant.beginner.rare
     *         plant.intermediate.rare
     *         plant.advanced.rare
     *         plant.resiliflora.rare
     *         plant.nutrivora
     */
    grantPersonalPlant?: Maybe<UserPlant>
    grantTokens: Scalars['String']['output']
    /** plant in personal garden */
    plantPlant: PlantActionResponse
    /** purchase product */
    purchaseProduct: PurchaseResponse
    refillWaterCan: Array<UserPlantInfo>
    /** add water to plant */
    waterPlant: WaterPlantResponse
}

export type RetailMutationCreateCurrencyArgs = {
    code: Scalars['String']['input']
    name: Scalars['String']['input']
}

export type RetailMutationCreateProductArgs = {
    cost: Scalars['Int']['input']
    currencyCode: Scalars['String']['input']
    description: Scalars['String']['input']
    plantWateringSteps?: InputMaybe<Scalars['Int']['input']>
    productType: Scalars['String']['input']
    title: Scalars['String']['input']
    upc: Scalars['String']['input']
}

export type RetailMutationDeleteCurrencyArgs = {
    code: Scalars['String']['input']
}

export type RetailMutationDeleteProductArgs = {
    upc: Scalars['String']['input']
}

export type RetailMutationGrantCommunityPlantArgs = {
    challengeId: Scalars['UUID']['input']
    socialGroupId?: InputMaybe<Scalars['UUID']['input']>
    userId: Scalars['UUID']['input']
}

export type RetailMutationGrantPersonalPlantArgs = {
    plantUpc: Scalars['String']['input']
    userId: Scalars['UUID']['input']
}

export type RetailMutationGrantTokensArgs = {
    amount: Scalars['Int']['input']
    userId: Scalars['UUID']['input']
}

export type RetailMutationPlantPlantArgs = {
    plantId: Scalars['UUID']['input']
}

export type RetailMutationPurchaseProductArgs = {
    upc: Scalars['String']['input']
}

export type RetailMutationRefillWaterCanArgs = {
    userId: Scalars['UUID']['input']
}

export type RetailMutationWaterPlantArgs = {
    plantId: Scalars['UUID']['input']
}

export type RetailQuery = {
    __typename?: 'RetailQuery'
    /** Get user's balance */
    getBalance: Array<BalanceInfo>
    /** Get currencies defined in the system */
    getCurrencies: Array<CurrencyInfo>
    /** Get grouped community challenge plants for whole challenge */
    getGroupedCommunityChallengePlants: Array<CommunityGardenInfo>
    /** Get user's inventory */
    getInventory: Array<UserInventoryInfo>
    /** Get user's objects */
    getObjects: Array<UserObjectInfo>
    /** Get entities (microsteps/resets) used to grow a plant */
    getPersonalPlantEntities: Array<PersonalPlantEntityInfo>
    /** Get user's plants */
    getPlants: Array<UserPlantInfo>
    /** Get products defined in the system */
    getProducts: Array<ProductInfo>
    /** Get next plants recommended for the user */
    getRecommendedPlants: RecommendedPlantsResponse
    /** Returns the user's plants rank if participating solo on a given challenge */
    getSoloPlantsRank: PlantsRanked
    /** Get team's community challenge plants */
    getTeamCommunityChallengePlants: Array<UserPlantInfo>
    /** Returns the social group plants rank on a given challenge using totals */
    getTeamPlantsRank: PlantsRanked
    /** Returns the social group plants rank on a given challenge using averages */
    getTeamPlantsRankByAverage: PlantsRanked
    /** Returns the team players plants leaderboard for a challenge using totals */
    getTeamsPlantsLeaderboard: PlantsLeaderboard
    /** Returns the team players plants leaderboard for a challenge using averages */
    getTeamsPlantsLeaderboardByAverage: PlantsLeaderboard
    /** Get user's transaction history */
    getTransactionHistory: Array<TransactionHistoryInfo>
    /** Get user's community challenge plants */
    getUserCommunityChallengePlants: Array<UserPlantInfo>
    /** Get user percentile based on total plants earned during the challenge */
    getUserPlantsPercentile: Scalars['Float']['output']
    /** Returns the solo players plants leaderboard for a challenge */
    getUsersPlantsLeaderboard: PlantsLeaderboard
}

export type RetailQueryGetGroupedCommunityChallengePlantsArgs = {
    challengeId: Scalars['UUID']['input']
    socialGroupId?: InputMaybe<Scalars['UUID']['input']>
}

export type RetailQueryGetPersonalPlantEntitiesArgs = {
    plantId: Scalars['UUID']['input']
}

export type RetailQueryGetSoloPlantsRankArgs = {
    challengeId: Scalars['UUID']['input']
}

export type RetailQueryGetTeamCommunityChallengePlantsArgs = {
    challengeId: Scalars['UUID']['input']
    socialGroupId: Scalars['UUID']['input']
}

export type RetailQueryGetTeamPlantsRankArgs = {
    challengeId: Scalars['UUID']['input']
    socialGroupId: Scalars['UUID']['input']
}

export type RetailQueryGetTeamPlantsRankByAverageArgs = {
    challengeId: Scalars['UUID']['input']
    socialGroupId: Scalars['UUID']['input']
}

export type RetailQueryGetTeamsPlantsLeaderboardArgs = {
    challengeId: Scalars['UUID']['input']
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    socialGroupId?: InputMaybe<Scalars['UUID']['input']>
}

export type RetailQueryGetTeamsPlantsLeaderboardByAverageArgs = {
    challengeId: Scalars['UUID']['input']
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    socialGroupId?: InputMaybe<Scalars['UUID']['input']>
}

export type RetailQueryGetUserCommunityChallengePlantsArgs = {
    challengeId: Scalars['UUID']['input']
}

export type RetailQueryGetUserPlantsPercentileArgs = {
    challengeId: Scalars['UUID']['input']
}

export type RetailQueryGetUsersPlantsLeaderboardArgs = {
    challengeId: Scalars['UUID']['input']
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
}

export enum RewardType {
    Badge = 'BADGE',
    Points = 'POINTS'
}

export enum RiskCohort {
    HighRisk = 'HighRisk',
    MediumRisk = 'MediumRisk',
    Thriving = 'Thriving'
}

export type RiskCohortStats = {
    __typename?: 'RiskCohortStats'
    absoluteSize: Scalars['Int']['output']
    changeSinceLastPeriod: Scalars['Float']['output']
    relativeSizePercentage: Scalars['Float']['output']
    riskCohort: RiskCohort
    totalEmployees: Scalars['Int']['output']
}

export enum RiskProfile {
    HighRisk = 'HIGH_RISK',
    ModerateRisk = 'MODERATE_RISK',
    Thriving = 'THRIVING'
}

export type SaveFeedbackError = {
    __typename?: 'SaveFeedbackError'
    error: SaveFeedbackResponseError
}

export type SaveFeedbackResponse = SaveFeedbackError | SaveFeedbackResult

export enum SaveFeedbackResponseError {
    ErrorSavingAnswer = 'ERROR_SAVING_ANSWER',
    NonExistentUserPlan = 'NON_EXISTENT_USER_PLAN'
}

export type SaveFeedbackResult = {
    __typename?: 'SaveFeedbackResult'
    newFeedbackScore: Scalars['Int']['output']
}

export type SaveSurveyAnswerResponse = {
    __typename?: 'SaveSurveyAnswerResponse'
    currentStreak: Scalars['Int']['output']
    isResponseSaved: Scalars['Boolean']['output']
    maxStreak: Scalars['Int']['output']
    recommendedContent?: Maybe<SimpleRecommendedContent>
}

export type SavedCheckInDto = {
    __typename?: 'SavedCheckInDTO'
    recommendedContent: RecommendedContentDto
    /** @deprecated Use savedCheckIn.response.recommendedContentDimension */
    recommendedContentDimension: Surveys
    savedCheckIn: DailyCheckInDto
    streak: PulseStreakDto
}

export type ScheduleOtm = {
    __typename?: 'ScheduleOtm'
    codaId?: Maybe<Scalars['Int']['output']>
    companyName?: Maybe<Scalars['String']['output']>
    createdAt: Scalars['Instant']['output']
    csvBlobDownloadUrl?: Maybe<Scalars['String']['output']>
    csvBlobPath: Scalars['String']['output']
    csvBlobUploadUrl: Scalars['String']['output']
    failReason?: Maybe<Scalars['String']['output']>
    id: Scalars['UUID']['output']
    messageParameters: MessageParameters
    messageTime: Scalars['Instant']['output']
    schedulerAdminId: Scalars['UUID']['output']
    status: ScheduleOtmStatus
    templateName: OtmTemplateName
    thriveCompanyId?: Maybe<Scalars['UUID']['output']>
    updatedAt: Scalars['Instant']['output']
}

export type ScheduleOtmInput = {
    codaId?: InputMaybe<Scalars['Int']['input']>
    messageParameters: MessageParametersInput
    messageTime: Scalars['Instant']['input']
    thriveCompanyId: Scalars['UUID']['input']
}

export type ScheduleOtmPage = {
    __typename?: 'ScheduleOtmPage'
    items: Array<ScheduleOtm>
    itemsPerPage: Scalars['Int']['output']
    page: Scalars['Int']['output']
    total: Scalars['Int']['output']
}

export enum ScheduleOtmStatus {
    CsvPending = 'CSV_PENDING',
    Scheduled = 'SCHEDULED',
    SchedulingFailed = 'SCHEDULING_FAILED'
}

export type Scope = {
    __typename?: 'Scope'
    accessType: Scalars['String']['output']
    entitlement?: Maybe<Scalars['String']['output']>
    id: Scalars['UUID']['output']
    resourceType: Scalars['String']['output']
    subscriptionId: Scalars['UUID']['output']
}

export type ScopeInputGraphQlInput = {
    scope: Scalars['String']['input']
    subscriptionId: Scalars['UUID']['input']
}

export type ScopePage = {
    __typename?: 'ScopePage'
    items: Array<Scope>
    itemsPerPage: Scalars['Int']['output']
    page: Scalars['Int']['output']
    total: Scalars['Int']['output']
}

export type ScoreRanked = {
    __typename?: 'ScoreRanked'
    /** The entity id */
    entityId?: Maybe<Scalars['UUID']['output']>
    /** The rank position on the leaderboard */
    rank: Scalars['Int']['output']
    /** The requester entity display name */
    requesterDisplayName: Scalars['String']['output']
    /** Total steps number */
    totalSteps: Scalars['Int']['output']
}

export type SearchMutation = {
    __typename?: 'SearchMutation'
    /** Update the Algolia Search Index */
    populateAlgolia: Scalars['Int']['output']
}

export type SearchMutationPopulateAlgoliaArgs = {
    contentType?: InputMaybe<CmsContentType>
}

export type SearchQuery = {
    __typename?: 'SearchQuery'
    /** Get a Read-Only key for accessing Algolia which enforces filter requirements */
    getAlgoliaKey: Scalars['String']['output']
    /** Search for given Type using the input search test */
    search: Array<GraphQlSearchResult>
    /** Search for all types of content */
    searchAll: Array<GraphQlSearchResult>
}

export type SearchQuerySearchArgs = {
    searchText: Scalars['String']['input']
    types: Array<Type>
}

export type SearchQuerySearchAllArgs = {
    searchText: Scalars['String']['input']
}

export enum SeatType {
    Executive = 'EXECUTIVE',
    Group = 'GROUP',
    Individual = 'INDIVIDUAL'
}

export enum SessionStatus {
    Cancelled = 'CANCELLED',
    CancelledLate = 'CANCELLED_LATE',
    CoacheeNoShow = 'COACHEE_NO_SHOW',
    Completed = 'COMPLETED',
    Invalid = 'INVALID',
    Pending = 'PENDING',
    Rejected = 'REJECTED',
    Scheduled = 'SCHEDULED'
}

export type SetCoacheePreferencesFailure = {
    __typename?: 'SetCoacheePreferencesFailure'
    errorCode: CoachingErrorCode
}

export type SetCoacheePreferencesGqlResponse =
    | SetCoacheePreferencesFailure
    | SetCoacheePreferencesSuccess

export type SetCoacheePreferencesSuccess = {
    __typename?: 'SetCoacheePreferencesSuccess'
    result: Array<Scalars['UUID']['output']>
}

export type SetGroupChallengeTypeResult = SetTypeErrorMessage | SetTypeSuccess

export type SetIntentionError = {
    __typename?: 'SetIntentionError'
    inappropriateContent?: Maybe<IntentionValidation>
    type: SetIntentionResponseErrorType
}

export type SetIntentionResponse = SetIntentionError | SetIntentionResult

export enum SetIntentionResponseErrorType {
    EmptyJourneysError = 'EMPTY_JOURNEYS_ERROR',
    InappropriateContentError = 'INAPPROPRIATE_CONTENT_ERROR',
    IntentionLengthError = 'INTENTION_LENGTH_ERROR'
}

export type SetIntentionResult = {
    __typename?: 'SetIntentionResult'
    intention: Intention
}

export type SetTypeErrorMessage = {
    __typename?: 'SetTypeErrorMessage'
    message: Scalars['String']['output']
}

export type SetTypeSuccess = {
    __typename?: 'SetTypeSuccess'
    message: Scalars['String']['output']
}

export type SharedPersonalizedReset = {
    __typename?: 'SharedPersonalizedReset'
    id: Scalars['UUID']['output']
    personalizedResetId: Scalars['UUID']['output']
}

export type SignupCode = {
    __typename?: 'SignupCode'
    code: Scalars['String']['output']
    subscriptionId: Scalars['UUID']['output']
    validFrom: Scalars['Instant']['output']
    validUntil: Scalars['Instant']['output']
}

export type SignupCodeFiltersInput = {
    subscriptionId?: InputMaybe<Scalars['UUID']['input']>
}

export type SignupCodeInput = {
    code: Scalars['String']['input']
    subscriptionId: Scalars['UUID']['input']
    validFrom: Scalars['Instant']['input']
    validUntil: Scalars['Instant']['input']
}

export type SignupCodePage = {
    __typename?: 'SignupCodePage'
    items: Array<SignupCode>
    itemsPerPage: Scalars['Int']['output']
    page: Scalars['Int']['output']
    total: Scalars['Int']['output']
}

export type SimpleRecommendedContent = {
    __typename?: 'SimpleRecommendedContent'
    contentType: SupportedRecommendedContentType
    domainId: Scalars['String']['output']
    gqlQueryString: Scalars['String']['output']
    title: Scalars['String']['output']
}

export type SingleMetricResult = {
    __typename?: 'SingleMetricResult'
    count?: Maybe<Scalars['Int']['output']>
    countDescription?: Maybe<Scalars['String']['output']>
    percentChange?: Maybe<Scalars['Float']['output']>
    result: Scalars['Float']['output']
}

export type SkipAssessmentInput = {
    assessmentAttemptId: Scalars['UUID']['input']
    userTime?: InputMaybe<Scalars['Instant']['input']>
}

export type SlackIntegrationMutation = {
    __typename?: 'SlackIntegrationMutation'
    /** Disables Slack integration for given company. If company doesn't exist it is a NOOP. Returns true if operation actually changed anything */
    disable: Scalars['Boolean']['output']
    /** Add a new Slack integration to given company. If company doesn't exist, will return an error. If config already exists, it will be enabled without changing anything else. Returns true if operation actually changed anything */
    enable: Scalars['Boolean']['output']
}

export type SlackIntegrationMutationDisableArgs = {
    companyId: Scalars['UUID']['input']
}

export type SlackIntegrationMutationEnableArgs = {
    companyId: Scalars['UUID']['input']
    workspaceId: Scalars['String']['input']
}

export type SlackMutation = {
    __typename?: 'SlackMutation'
    notify: NotifyMutation
    slackUser: TryDeleteSlackUserMutation
}

export type SlackQuery = {
    __typename?: 'SlackQuery'
    firstQuery: Scalars['String']['output']
    team: SlackTeamQuery
}

export type SlackQueryTeamArgs = {
    teamId: Scalars['String']['input']
}

export type SlackTeamBotInfo = {
    __typename?: 'SlackTeamBotInfo'
    appId?: Maybe<Scalars['String']['output']>
    botId?: Maybe<Scalars['String']['output']>
    botUserId?: Maybe<BotUserId>
    companyId: Scalars['UUID']['output']
    enterpriseId?: Maybe<Scalars['String']['output']>
    enterpriseName?: Maybe<Scalars['String']['output']>
    enterpriseUrl?: Maybe<Scalars['String']['output']>
    installedAt?: Maybe<Scalars['Instant']['output']>
    isEnterpriseInstall?: Maybe<Scalars['Boolean']['output']>
    teamId?: Maybe<Scalars['String']['output']>
    teamName?: Maybe<Scalars['String']['output']>
}

export type SlackTeamBotTokens = {
    __typename?: 'SlackTeamBotTokens'
    botAccessToken?: Maybe<Scalars['String']['output']>
    botRefreshToken?: Maybe<Scalars['String']['output']>
    botScope?: Maybe<Scalars['String']['output']>
    botTokenExpiresAt?: Maybe<Scalars['Instant']['output']>
    companyId?: Maybe<Scalars['UUID']['output']>
    scope?: Maybe<Scalars['String']['output']>
    teamId?: Maybe<Scalars['String']['output']>
    tokenType?: Maybe<Scalars['String']['output']>
}

export type SlackTeamProfileField = {
    __typename?: 'SlackTeamProfileField'
    fieldName?: Maybe<Scalars['String']['output']>
    id?: Maybe<Scalars['String']['output']>
    isHidden?: Maybe<Scalars['Boolean']['output']>
    label?: Maybe<Scalars['String']['output']>
    ordering?: Maybe<Scalars['Int']['output']>
    possibleValues?: Maybe<Array<Scalars['String']['output']>>
    type?: Maybe<Scalars['String']['output']>
}

export type SlackTeamProfileFields = {
    __typename?: 'SlackTeamProfileFields'
    fieldsBySection: Array<SlackTeamProfileSection>
}

export type SlackTeamProfileSection = {
    __typename?: 'SlackTeamProfileSection'
    fields: Array<SlackTeamProfileField>
    id?: Maybe<Scalars['String']['output']>
    isHidden?: Maybe<Scalars['Boolean']['output']>
    label?: Maybe<Scalars['String']['output']>
    order?: Maybe<Scalars['Int']['output']>
}

export type SlackTeamQuery = {
    __typename?: 'SlackTeamQuery'
    botInfo?: Maybe<SlackTeamBotInfo>
    botTokens?: Maybe<SlackTeamBotTokens>
    profileFields?: Maybe<SlackTeamProfileFields>
    teamId: Scalars['String']['output']
}

export type SleepHabits = {
    __typename?: 'SleepHabits'
    /** Challenge id */
    challengeId: Scalars['UUID']['output']
    /** Habits at challenge end */
    endAnswer?: Maybe<Scalars['Int']['output']>
    /** Habits at challenge start */
    startAnswer?: Maybe<Scalars['Int']['output']>
}

export type SleepHabitsOperationResult =
    | ErrorMessageSleepHabits
    | SleepHabitsResult

export type SleepHabitsResult = {
    __typename?: 'SleepHabitsResult'
    sleepHabits: SleepHabits
}

export type SleepMutation = {
    __typename?: 'SleepMutation'
    /** Save an updated Sleep Count from Apple Health */
    saveAppleHealthSleepBlocks: Scalars['Boolean']['output']
}

export type SleepMutationSaveAppleHealthSleepBlocksArgs = {
    sleepRecords: Array<AppleHealthSleepBlocksInput>
}

export type SleepSummaryStats = {
    /** Average time to bed since midnight(UTC) in seconds */
    averageBedTimeStart?: Maybe<Scalars['Long']['output']>
    /** Average minutes asleep */
    averageMinutesAsleep: Scalars['Float']['output']
}

export type SleepSummaryStatsResponse = SleepSummaryStats & {
    __typename?: 'SleepSummaryStatsResponse'
    averageBedTimeStart?: Maybe<Scalars['Long']['output']>
    averageMinutesAsleep: Scalars['Float']['output']
}

export type Slot = {
    __typename?: 'Slot'
    time: Scalars['Instant']['output']
}

export type SlotGroup = {
    __typename?: 'SlotGroup'
    localDate: Scalars['ISODate']['output']
    slots: Array<Slot>
}

export type SmartNudgeReset = {
    __typename?: 'SmartNudgeReset'
    intentionId?: Maybe<Scalars['UUID']['output']>
    personalResetId?: Maybe<Scalars['UUID']['output']>
    resetId?: Maybe<Scalars['UUID']['output']>
    timeOfDay?: Maybe<SmartNudgeTimeOfDay>
}

export enum SmartNudgeTimeOfDay {
    Afternoon = 'Afternoon',
    Evening = 'Evening',
    Morning = 'Morning'
}

export type SmartNudgesResetInput = {
    intentionId?: InputMaybe<Scalars['UUID']['input']>
    personalResetId?: InputMaybe<Scalars['UUID']['input']>
    resetId: Scalars['UUID']['input']
    thriveUserId: Scalars['UUID']['input']
    timeOfDay?: InputMaybe<TeamsSmartNudgeResetTimeOfDay>
}

export type SmartNudgesResetMutation = {
    __typename?: 'SmartNudgesResetMutation'
    /** Send a Smart Nudges message to users */
    sendSmartNudgesResetMessage: SmartNudgesResetResult
}

export type SmartNudgesResetMutationSendSmartNudgesResetMessageArgs = {
    input: SmartNudgesResetInput
}

export type SmartNudgesResetResult = {
    __typename?: 'SmartNudgesResetResult'
    error?: Maybe<Scalars['String']['output']>
    messageSent: Scalars['Boolean']['output']
}

export type SocialGroup = {
    __typename?: 'SocialGroup'
    /** the challengeId of the group */
    challengeId?: Maybe<Scalars['UUID']['output']>
    /** When this social group was created */
    createdAt: Scalars['Instant']['output']
    /** User id of who created this social group */
    createdBy: Scalars['String']['output']
    /** The id of this social group */
    id: Scalars['UUID']['output']
    /** if the group is the main community challenge group */
    isMainCommunitySocialGroup?: Maybe<Scalars['Boolean']['output']>
    /** Indicates if the social group is public or private */
    isPublic: Scalars['Boolean']['output']
    /** if the group is a community challenge solo group */
    isSoloChallenge?: Maybe<Scalars['Boolean']['output']>
    /** the expiration date for the social group */
    isSubscriptionGroup: Scalars['Boolean']['output']
    /** the join date of the user */
    joinDate?: Maybe<Scalars['Instant']['output']>
    /** User id of who last updated this social group */
    lastUpdatedBy?: Maybe<Scalars['String']['output']>
    /** Max members allowed in the group (null is unlimited) */
    maxSize?: Maybe<Scalars['Int']['output']>
    /** the total member count for the group */
    memberCount?: Maybe<Scalars['Int']['output']>
    /**
     * Current members of this social group
     * @deprecated this dataloader is deprecated, use `members` with pagination, replace with paginatedMembers
     */
    members: Array<SocialGroupMember>
    /** The name of this social group */
    name: Scalars['String']['output']
    /** Current members of this social group, paginated */
    paginatedMembers: Array<SocialGroupMember>
    /** the stats for the social group */
    socialGroupStats?: Maybe<SocialGroupStats>
    /** The subscription id */
    subscriptionId?: Maybe<Scalars['UUID']['output']>
    /** When this social group was last updated */
    updatedAt?: Maybe<Scalars['Instant']['output']>
    /** the expiration date for the social group */
    validTo?: Maybe<Scalars['Instant']['output']>
}

export type SocialGroupPaginatedMembersArgs = {
    limit: Scalars['Int']['input']
    offset: Scalars['Int']['input']
}

export type SocialGroupCreateInput = {
    /** The challenge id */
    challengeId?: InputMaybe<Scalars['UUID']['input']>
    /** Indicates if the social group is public or private */
    isPublic?: InputMaybe<Scalars['Boolean']['input']>
    /** Indicates if members are unlimited */
    isUnlimited?: InputMaybe<Scalars['Boolean']['input']>
    /** Indicates the maximum number of members allowed in the social group */
    maxSize?: InputMaybe<Scalars['Int']['input']>
    /** The name for the new social group */
    name: Scalars['String']['input']
    /** The expiration date for the social group */
    validTo?: InputMaybe<Scalars['String']['input']>
}

export type SocialGroupEditInput = {
    /** Indicates if the social group is public or private */
    isPublic?: InputMaybe<Scalars['Boolean']['input']>
    /** The updated name for this social group */
    name: Scalars['String']['input']
    /** The ID of the social group to edit */
    socialGroupId: Scalars['UUID']['input']
}

export type SocialGroupMember = {
    __typename?: 'SocialGroupMember'
    createdAt: Scalars['Instant']['output']
    /** The user's display name */
    displayName: Scalars['String']['output']
    updatedAt: Scalars['Instant']['output']
    /** The user object for this member */
    user: User
}

export type SocialGroupMutation = {
    __typename?: 'SocialGroupMutation'
    createSocialGroup?: Maybe<SocialGroupsResult>
    deleteSocialGroup?: Maybe<SocialGroupsResult>
    editDisplayName: SocialGroupsResult
    editIsPublic: SocialGroupsResult
    editSocialGroup?: Maybe<SocialGroupsResult>
    joinSocialGroup: SocialGroupsResult
    joinSocialGroupAdmin: SocialGroupsResult
    joinSocialGroups: Array<SocialGroupsResult>
    joinSoloSocialGroup?: Maybe<SocialGroupsResult>
    joinSoloSocialGroupAdmin?: Maybe<SocialGroupsResult>
    leaveSocialGroup: SocialGroupsResult
    leaveSocialGroupAdmin: SocialGroupsResult
    leaveSoloSocialGroupAdmin?: Maybe<SocialGroupsResult>
    reactToPost: SocialGroupsResult
    undoSocialGroupPostReaction: SocialGroupsResult
    updateDisplayName: SocialGroupsResult
    validateDisplayName: SocialGroupsResult
}

export type SocialGroupMutationCreateSocialGroupArgs = {
    newSocialGroup: SocialGroupCreateInput
}

export type SocialGroupMutationDeleteSocialGroupArgs = {
    socialGroupID: Scalars['UUID']['input']
}

export type SocialGroupMutationEditDisplayNameArgs = {
    displayName: Scalars['String']['input']
}

export type SocialGroupMutationEditIsPublicArgs = {
    isPublic: Scalars['Boolean']['input']
}

export type SocialGroupMutationEditSocialGroupArgs = {
    updatedSocialGroup: SocialGroupEditInput
}

export type SocialGroupMutationJoinSocialGroupArgs = {
    publishPost?: InputMaybe<Scalars['Boolean']['input']>
    socialGroupID: Scalars['UUID']['input']
}

export type SocialGroupMutationJoinSocialGroupAdminArgs = {
    socialGroupID: Scalars['UUID']['input']
    subscriptionId: Scalars['UUID']['input']
    userId: Scalars['UUID']['input']
}

export type SocialGroupMutationJoinSocialGroupsArgs = {
    socialGroupIDs: Array<Scalars['UUID']['input']>
}

export type SocialGroupMutationJoinSoloSocialGroupArgs = {
    challengeId: Scalars['UUID']['input']
    validTo?: InputMaybe<Scalars['String']['input']>
}

export type SocialGroupMutationJoinSoloSocialGroupAdminArgs = {
    challengeId: Scalars['UUID']['input']
    companyId: Scalars['UUID']['input']
    subscriptionId: Scalars['UUID']['input']
    userId: Scalars['UUID']['input']
    validTo?: InputMaybe<Scalars['String']['input']>
}

export type SocialGroupMutationLeaveSocialGroupArgs = {
    socialGroupID: Scalars['UUID']['input']
}

export type SocialGroupMutationLeaveSocialGroupAdminArgs = {
    socialGroupID: Scalars['UUID']['input']
    userId: Scalars['UUID']['input']
}

export type SocialGroupMutationLeaveSoloSocialGroupAdminArgs = {
    challengeId: Scalars['UUID']['input']
    userId: Scalars['UUID']['input']
}

export type SocialGroupMutationReactToPostArgs = {
    postReactionInput: PostReactionInput
}

export type SocialGroupMutationUndoSocialGroupPostReactionArgs = {
    reactionId: Scalars['UUID']['input']
}

export type SocialGroupMutationUpdateDisplayNameArgs = {
    displayName: Scalars['String']['input']
}

export type SocialGroupMutationValidateDisplayNameArgs = {
    displayName: Scalars['String']['input']
}

export type SocialGroupOperationSucceeded = {
    __typename?: 'SocialGroupOperationSucceeded'
    /** The ID of the social group for which the operation succeeded */
    socialGroupId: Scalars['UUID']['output']
}

export type SocialGroupQuery = {
    __typename?: 'SocialGroupQuery'
    /** Get the posts of a given challengeId */
    communitySocialGroupActivityFeed: Array<Post>
    /** Get all company challenge social groups */
    companyChallengeSocialGroups: Array<SocialGroup>
    /** Get the display name of the user */
    displayName: DisplayName
    /** Get all display names for the given user ids */
    getDisplayNames: Array<DisplayName>
    /** Get social group by ID */
    socialGroup?: Maybe<SocialGroupsResult>
    /** Get the posts of a given group id and optionally for a given challenge id */
    socialGroupActivityFeed: Array<Post>
    /** Get all social groups for subscription except challenge groups */
    socialGroupsForCompany: Array<SocialGroup>
    /** Get all social groups for user */
    socialGroupsForUser: Array<SocialGroup>
}

export type SocialGroupQueryCommunitySocialGroupActivityFeedArgs = {
    challengeId: Scalars['UUID']['input']
    limit: Scalars['Int']['input']
    offset: Scalars['Int']['input']
}

export type SocialGroupQueryCompanyChallengeSocialGroupsArgs = {
    challengeId: Scalars['UUID']['input']
    excludeFullGroups?: InputMaybe<Scalars['Boolean']['input']>
}

export type SocialGroupQueryGetDisplayNamesArgs = {
    userIds: Array<Scalars['UUID']['input']>
}

export type SocialGroupQuerySocialGroupArgs = {
    id: Scalars['UUID']['input']
}

export type SocialGroupQuerySocialGroupActivityFeedArgs = {
    challengeId?: InputMaybe<Scalars['UUID']['input']>
    limit: Scalars['Int']['input']
    offset: Scalars['Int']['input']
    socialGroupId: Scalars['UUID']['input']
}

export type SocialGroupQuerySocialGroupsForUserArgs = {
    challengeId?: InputMaybe<Scalars['UUID']['input']>
}

export type SocialGroupStats = {
    __typename?: 'SocialGroupStats'
    /** total number of posts in the social group */
    totalPostCount: Scalars['Int']['output']
    /** total number celebrations given in the social group */
    totalReactionCount: Scalars['Int']['output']
}

export type SocialGroupUndoPostReactionSucceed = {
    __typename?: 'SocialGroupUndoPostReactionSucceed'
    /** The ID of the reaction for which the operation succeeded */
    reactionId: Scalars['UUID']['output']
}

export type SocialGroupsResult =
    | InvalidAction
    | InvalidInput
    | PostOperationSucceeded
    | PostReactionCreationSucceeded
    | SocialGroup
    | SocialGroupOperationSucceeded
    | SocialGroupUndoPostReactionSucceed
    | UpdateDisplayNameOperationSucceeded
    | UpdateIsPublicOperationSucceeded
    | ValidateDisplayNameOperationSucceeded

export enum SortOrder {
    CheckedDateAsc = 'CHECKED_DATE_ASC',
    CheckedDateDesc = 'CHECKED_DATE_DESC',
    CheckedNumberAsc = 'CHECKED_NUMBER_ASC',
    CheckedNumberDesc = 'CHECKED_NUMBER_DESC',
    CommittedAsc = 'COMMITTED_ASC',
    CommittedDesc = 'COMMITTED_DESC',
    PopularityAsc = 'POPULARITY_ASC',
    PopularityDesc = 'POPULARITY_DESC'
}

export type SpecialtyGqlModel = {
    __typename?: 'SpecialtyGqlModel'
    category: CoachCategory
    id: Scalars['UUID']['output']
    name: Scalars['String']['output']
}

export type Step = {
    __typename?: 'Step'
    checked?: Maybe<Scalars['Boolean']['output']>
    createdAt: Scalars['Instant']['output']
    dataType: StepType
    date?: Maybe<Scalars['ISODate']['output']>
    frequency?: Maybe<StepFrequency>
    id: Scalars['UUID']['output']
    order?: Maybe<Scalars['Int']['output']>
    position?: Maybe<Scalars['Int']['output']>
    stepContent: StepContent
    updatedAt: Scalars['Instant']['output']
}

export type StepContent = GraphQlMicrostep

export enum StepFrequency {
    Daily = 'DAILY',
    Once = 'ONCE',
    Situational = 'SITUATIONAL',
    Weekly = 'WEEKLY'
}

export enum StepType {
    Microstep = 'MICROSTEP'
}

export type StepsGoalDetail = {
    __typename?: 'StepsGoalDetail'
    steps: Scalars['Int']['output']
}

export type StepsInfo = {
    __typename?: 'StepsInfo'
    /** User's today steps */
    todaySteps: Scalars['Int']['output']
    /** User's total steps */
    totalSteps: Scalars['Int']['output']
}

export type Story = {
    __typename?: 'Story'
    createdAt?: Maybe<Scalars['Instant']['output']>
    /** The id of this story */
    id: Scalars['UUID']['output']
    /** The story */
    story?: Maybe<Scalars['String']['output']>
    /** The id of story type */
    storyTypeId: Scalars['UUID']['output']
    updatedAt?: Maybe<Scalars['Instant']['output']>
    /** The id of the user challenge activity */
    userChallengeActivityId: Scalars['UUID']['output']
    /** The visiblity of the story */
    visibility?: Maybe<Visibility>
}

export type StoryCreateInput = {
    /** The story to create */
    message: Scalars['String']['input']
    /** The story type ID of the story to create */
    storyTypeId: Scalars['UUID']['input']
    /** The user-challenge ID of the participation */
    userChallengeActivityId: Scalars['UUID']['input']
    /** The visibility of the story */
    visibility: Visibility
}

export type StoryQuestionCreateInput = {
    id?: InputMaybe<Scalars['UUID']['input']>
    kind?: InputMaybe<Scalars['String']['input']>
    language: Scalars['String']['input']
    questions: Scalars['String']['input']
    region: Scalars['String']['input']
}

export type StoryType = {
    __typename?: 'StoryType'
    createdAt?: Maybe<Scalars['Instant']['output']>
    /** The id of this story type */
    id: Scalars['UUID']['output']
    kind?: Maybe<Scalars['String']['output']>
    language: Scalars['String']['output']
    questions?: Maybe<Scalars['String']['output']>
    region: Scalars['String']['output']
    subTitle?: Maybe<Scalars['String']['output']>
    termsAndConditionsUrl?: Maybe<Scalars['String']['output']>
    title?: Maybe<Scalars['String']['output']>
    updatedAt?: Maybe<Scalars['Instant']['output']>
}

export type StoryTypeAdmin = {
    __typename?: 'StoryTypeAdmin'
    createdAt?: Maybe<Scalars['Instant']['output']>
    /** The id of this story type */
    id: Scalars['UUID']['output']
    /** The kind of this story type */
    kind?: Maybe<Scalars['String']['output']>
    /** The name of this story type */
    name?: Maybe<Scalars['String']['output']>
    updatedAt?: Maybe<Scalars['Instant']['output']>
}

export type SubmitResponseInput = {
    assessmentAttemptId: Scalars['UUID']['input']
    assessmentItemId: Scalars['UUID']['input']
    questionText: Scalars['String']['input']
    response?: InputMaybe<ResponseInput>
    userTime?: InputMaybe<UserTimezoneInput>
}

export type SubscriptionCompanyInput = {
    /** The company id */
    companyId: Scalars['UUID']['input']
    /** The subscription id */
    subscriptionId: Scalars['UUID']['input']
}

export type SubscriptionFiltersInput = {
    companyId?: InputMaybe<Scalars['UUID']['input']>
}

export type SubscriptionGroupCodes = {
    __typename?: 'SubscriptionGroupCodes'
    groupCodes: Array<Scalars['String']['output']>
    subscription: UserSubscription
}

export type SubscriptionGroupCodesResponse = {
    __typename?: 'SubscriptionGroupCodesResponse'
    items: Array<SubscriptionGroupCodes>
}

export type SubscriptionId = {
    __typename?: 'SubscriptionId'
    id: Scalars['UUID']['output']
}

export type SubscriptionInputGraphQlInput = {
    companyId: Scalars['UUID']['input']
    enabled?: InputMaybe<Scalars['Boolean']['input']>
    expiryDate?: InputMaybe<Scalars['Instant']['input']>
    internalDescription?: InputMaybe<Scalars['String']['input']>
    isDefault: Scalars['Boolean']['input']
    license?: InputMaybe<LicenseType>
    seatsAllowed?: InputMaybe<Scalars['Int']['input']>
    startDate?: InputMaybe<Scalars['Instant']['input']>
    subscriptionType?: InputMaybe<SubscriptionType>
}

export type SubscriptionPage = {
    __typename?: 'SubscriptionPage'
    items: Array<UserSubscription>
    itemsPerPage: Scalars['Int']['output']
    page: Scalars['Int']['output']
    total: Scalars['Int']['output']
}

export enum SubscriptionType {
    Employee = 'employee',
    FriendsAndFamily = 'friendsAndFamily',
    Other = 'other'
}

export type SuccessStoryFeedback = {
    __typename?: 'SuccessStoryFeedback'
    featuredTextFull: Scalars['String']['output']
    featuredTextShort: Scalars['String']['output']
    featuredTitle: Scalars['String']['output']
    hint: Scalars['String']['output']
    id: Scalars['UUID']['output']
    photoUploadText: Scalars['String']['output']
    savedFooter: Scalars['String']['output']
    savedText: Scalars['String']['output']
    savedTitle: Scalars['String']['output']
    submittedFooter: Scalars['String']['output']
    submittedText: Scalars['String']['output']
    submittedTitle: Scalars['String']['output']
    subtitle: Scalars['String']['output']
    suggestions: Array<Scalars['String']['output']>
    suggestionsTitle: Scalars['String']['output']
    title: Scalars['String']['output']
    type: SuccessStoryFeedbackType
}

export enum SuccessStoryFeedbackType {
    CourseLesson = 'CourseLesson',
    JourneyLevel = 'JourneyLevel',
    RoleModel = 'RoleModel'
}

export type SuccessStoryMutation = {
    __typename?: 'SuccessStoryMutation'
    saveMySuccessStory?: Maybe<MySuccessStory>
}

export type SuccessStoryMutationSaveMySuccessStoryArgs = {
    input: MySuccessStoryInput
}

export type SuccessStoryQuery = {
    __typename?: 'SuccessStoryQuery'
    /** Get My Success Stories, based on userId from context */
    getMySuccessStories: MySuccessStoryPage
    /** Get My Success Story, based on userId from context */
    getMySuccessStory?: Maybe<MySuccessStory>
    /** Get Success Story Feedback by type */
    getSuccessStoryFeedback?: Maybe<SuccessStoryFeedback>
}

export type SuccessStoryQueryGetMySuccessStoriesArgs = {
    page?: InputMaybe<Scalars['Int']['input']>
    pageSize?: InputMaybe<Scalars['Int']['input']>
}

export type SuccessStoryQueryGetMySuccessStoryArgs = {
    id: Scalars['UUID']['input']
}

export type SuccessStoryQueryGetSuccessStoryFeedbackArgs = {
    type: SuccessStoryFeedbackType
}

export type SuperlativeWithScore = {
    __typename?: 'SuperlativeWithScore'
    description: Scalars['String']['output']
    imageUrl: Scalars['String']['output']
    journey?: Maybe<AssessmentJourney>
    locale: Scalars['String']['output']
    lowScoreDescription: Scalars['String']['output']
    lowScoreTitle: Scalars['String']['output']
    score: Scalars['Float']['output']
    title: Scalars['String']['output']
    uuid: Scalars['UUID']['output']
}

export enum SupportedRecommendedContentType {
    Article = 'ARTICLE',
    Course = 'COURSE',
    None = 'NONE',
    Qotd = 'QOTD',
    Reset = 'RESET'
}

export enum SurveyEligibility {
    AlreadyResponded = 'AlreadyResponded',
    AlreadySent = 'AlreadySent',
    Eligible = 'Eligible',
    NotSubscribed = 'NotSubscribed'
}

export type SurveyResponse = {
    __typename?: 'SurveyResponse'
    selectedResponseOption: Scalars['Int']['output']
    surveyQuestionDimension: Scalars['String']['output']
    surveyQuestionJourneyUUID?: Maybe<Scalars['String']['output']>
    surveyQuestionUUID: Scalars['String']['output']
}

export type SurveyResponseInput = {
    selectedResponseOption: Scalars['Int']['input']
    surveyQuestionDimension: Scalars['String']['input']
    surveyQuestionJourneyUUID?: InputMaybe<Scalars['String']['input']>
    surveyQuestionUUID: Scalars['String']['input']
}

export enum Surveys {
    Allyship = 'ALLYSHIP',
    Efficacy = 'EFFICACY',
    EnergyLevels = 'ENERGY_LEVELS',
    Enthusiasm = 'ENTHUSIASM',
    Productivity = 'PRODUCTIVITY',
    Retention = 'RETENTION'
}

export type SurveysMutation = {
    __typename?: 'SurveysMutation'
    /** Create any possible make-up Daily Check-Ins for a user for the past week */
    createMakeUpCheckIns?: Maybe<Array<DailyCheckInDto>>
    /** Get a user's Daily Check-In question */
    requestCheckIn?: Maybe<DailyCheckInDto>
    /** Bulk request Daily Check-Ins for users */
    requestCheckIns?: Maybe<Array<DailyCheckInDto>>
    /** Save a Daily Check-In response */
    saveCheckInResponse?: Maybe<SavedCheckInDto>
}

export type SurveysMutationCreateMakeUpCheckInsArgs = {
    channel: Channel
}

export type SurveysMutationRequestCheckInArgs = {
    channel: Channel
    requestDate: Scalars['ISODate']['input']
}

export type SurveysMutationRequestCheckInsArgs = {
    request: BulkDailyCheckInRequestInput
}

export type SurveysMutationSaveCheckInResponseArgs = {
    responseInputData: DailyCheckInResponseInput
}

export type SurveysQuery = {
    __typename?: 'SurveysQuery'
    /**
     * Retrieve the response of a user
     * @deprecated Use dailyCheckInResponse2 or dailyCheckInResponse2Admin instead, replace with dailyCheckInResponse2
     */
    dailyCheckInResponse: CheckInResponseDetailsPage
    /** Retrieve your survey responses */
    dailyCheckInResponse2: CheckInResponseDetailsPage
    /** Retrieve the survey responses of a user */
    dailyCheckInResponse2Admin: CheckInResponseDetailsPage
    /** Get all survey questions */
    getAll: Array<PulseSurveyQuestionDto>
    /** Get survey questions by ID */
    getById?: Maybe<PulseSurveyQuestionDto>
    /** Get a paginated list of Daily Check-In responses */
    responses?: Maybe<CheckInResponseDetailsPage>
}

export type SurveysQueryDailyCheckInResponseArgs = {
    companyId: Scalars['UUID']['input']
    fromDate: Scalars['ISODate']['input']
    locale: Scalars['Locale']['input']
    page: Scalars['Long']['input']
    pageSize: Scalars['Int']['input']
    thriveToken: Scalars['String']['input']
    thriveUserId: Scalars['UUID']['input']
    toDate: Scalars['ISODate']['input']
}

export type SurveysQueryDailyCheckInResponse2Args = {
    fromDate: Scalars['ISODate']['input']
    locale: Scalars['Locale']['input']
    page: Scalars['Long']['input']
    pageSize: Scalars['Int']['input']
    toDate: Scalars['ISODate']['input']
}

export type SurveysQueryDailyCheckInResponse2AdminArgs = {
    companyId: Scalars['UUID']['input']
    fromDate: Scalars['ISODate']['input']
    locale: Scalars['Locale']['input']
    page: Scalars['Long']['input']
    pageSize: Scalars['Int']['input']
    toDate: Scalars['ISODate']['input']
    userId: Scalars['UUID']['input']
}

export type SurveysQueryGetAllArgs = {
    activeOnly?: InputMaybe<Scalars['Boolean']['input']>
}

export type SurveysQueryGetByIdArgs = {
    activeOnly?: InputMaybe<Scalars['Boolean']['input']>
    surveyId: Scalars['UUID']['input']
}

export type SurveysQueryResponsesArgs = {
    from?: InputMaybe<Scalars['ISODate']['input']>
    pagination?: InputMaybe<PaginationInput>
    surveyDimension?: InputMaybe<Surveys>
    to?: InputMaybe<Scalars['ISODate']['input']>
}

export type Tag = {
    __typename?: 'Tag'
    id: Scalars['ID']['output']
    name: Scalars['String']['output']
    uuid?: Maybe<Scalars['UUID']['output']>
}

export type TeamsMutation = {
    __typename?: 'TeamsMutation'
    notify: TeamsNotifyMutation
    otm: TeamsOtmMutation
    resetTokenForUser: TeamsResetTokenForUserMutation
    savePulseSettings: PulseSettingsMutation
    sendIntentionSelectedConfirmationMessage: IntentionSettingMutation
    sendSmartNudgesReset: SmartNudgesResetMutation
    subscribeUser: MsTeamsSubscribeUserMutation
    tryDeleteUser: TryDeleteUserMutation
}

export type TeamsNotifyChallengeUserResult = {
    __typename?: 'TeamsNotifyChallengeUserResult'
    error?: Maybe<Scalars['String']['output']>
    numberOfUsersNotified: Scalars['Int']['output']
}

export type TeamsNotifyMutation = {
    __typename?: 'TeamsNotifyMutation'
    /** Enqueue baseline assessment nudge to a user. We will send a nudge at 10 am the day after their intention set time. Best effort is made to not send two of these messages to the user but the caller should make sure not to call the endpoint more than once per user. */
    enqueueBaselineAssessmentNudge: TeamsNudgeBaselineAssessmentResult
    /** Enqueue daily challenge message to user */
    enqueueDailyChallengeMessage: TeamsSendDailyChallengeMessageResult
    /** Send a reminder to complete the daily goals for a challenge */
    notifyDailyGoalsChallengeUsers: TeamsNotifyChallengeUserResult
}

export type TeamsNotifyMutationEnqueueBaselineAssessmentNudgeArgs = {
    intentionSetTime: Scalars['Instant']['input']
    thriveUserId: Scalars['UUID']['input']
}

export type TeamsNotifyMutationEnqueueDailyChallengeMessageArgs = {
    input: TeamsThriveChallengeMessageInput
}

export type TeamsNotifyMutationNotifyDailyGoalsChallengeUsersArgs = {
    input: TeamsThriveChallengeDailyGoalNotificationInput
}

export type TeamsNudgeBaselineAssessmentResult = {
    __typename?: 'TeamsNudgeBaselineAssessmentResult'
    error?: Maybe<Scalars['String']['output']>
    notified: Scalars['Boolean']['output']
}

export type TeamsOtmMutation = {
    __typename?: 'TeamsOtmMutation'
    /** Schedule OTM */
    scheduleOtm: TeamsScheduleOtmResult
}

export type TeamsOtmMutationScheduleOtmArgs = {
    input: ScheduleOtmInput
}

export type TeamsOtmQuery = {
    __typename?: 'TeamsOtmQuery'
    /** Get individual scheduled one time message */
    getScheduledOneTimeMessage?: Maybe<ScheduleOtm>
    /** Get scheduled one time messages */
    getScheduledOneTimeMessages: ScheduleOtmPage
}

export type TeamsOtmQueryGetScheduledOneTimeMessageArgs = {
    id: Scalars['UUID']['input']
}

export type TeamsOtmQueryGetScheduledOneTimeMessagesArgs = {
    limit: Scalars['Int']['input']
    page: Scalars['Int']['input']
    thriveCompanyId?: InputMaybe<Scalars['UUID']['input']>
}

export type TeamsQuery = {
    __typename?: 'TeamsQuery'
    getNotificationSettings: GetNotificationSettings
    getTimezoneForUsers: GetTimezoneForUsersQuery
    otm: TeamsOtmQuery
}

export type TeamsResetTokenForUserInput = {
    userId: Scalars['UUID']['input']
}

export type TeamsResetTokenForUserMutation = {
    __typename?: 'TeamsResetTokenForUserMutation'
    /** Force refresh the thrive token for a user */
    resetTokenForUser: TeamsResetTokenForUserResult
}

export type TeamsResetTokenForUserMutationResetTokenForUserArgs = {
    input: TeamsResetTokenForUserInput
}

export type TeamsResetTokenForUserResult = {
    __typename?: 'TeamsResetTokenForUserResult'
    error?: Maybe<Scalars['String']['output']>
    updated: Scalars['Boolean']['output']
}

export type TeamsScheduleOtmResult = {
    __typename?: 'TeamsScheduleOtmResult'
    error?: Maybe<Scalars['String']['output']>
    scheduled: Scalars['Boolean']['output']
    uploadUrl?: Maybe<Scalars['String']['output']>
}

export type TeamsSendDailyChallengeMessageResult = {
    __typename?: 'TeamsSendDailyChallengeMessageResult'
    error?: Maybe<Scalars['String']['output']>
    notificationSent: Scalars['Boolean']['output']
}

export type TeamsSendIntentionSelectedConfirmationResult = {
    __typename?: 'TeamsSendIntentionSelectedConfirmationResult'
    error?: Maybe<Scalars['String']['output']>
    notificationSent: Scalars['Boolean']['output']
}

export enum TeamsSmartNudgeResetTimeOfDay {
    Afternoon = 'Afternoon',
    Evening = 'Evening',
    Morning = 'Morning'
}

export type TeamsSubscribeUserResult = {
    __typename?: 'TeamsSubscribeUserResult'
    error?: Maybe<Scalars['String']['output']>
    subscribed: Scalars['Boolean']['output']
}

export type TeamsThriveChallengeDailyGoalNotificationInput = {
    challengeId: Scalars['UUID']['input']
    companyId: Scalars['UUID']['input']
    users: Array<Scalars['UUID']['input']>
}

export type TeamsThriveChallengeMessageInput = {
    challengeIds: Array<Scalars['UUID']['input']>
    thriveUserId: Scalars['UUID']['input']
}

export type TemplateBiotype = {
    __typename?: 'TemplateBiotype'
    name?: Maybe<Scalars['String']['output']>
}

export type TemplateJourney = {
    __typename?: 'TemplateJourney'
    id: Scalars['UUID']['output']
    name: Scalars['String']['output']
    shortName: Scalars['String']['output']
}

export type TemplateOperationResult =
    | ChallengeTemplateInstance
    | ErrorMessageTemplate
    | UpdateResult

export type TemplateQuote = {
    __typename?: 'TemplateQuote'
    author: Scalars['String']['output']
    backgroundColor?: Maybe<Scalars['String']['output']>
    backgroundImageUrl?: Maybe<Scalars['String']['output']>
    body: Scalars['String']['output']
    day: Scalars['Int']['output']
    id: Scalars['UUID']['output']
    imageWithTextUrl?: Maybe<Scalars['String']['output']>
}

export type TestNudge = {
    __typename?: 'TestNudge'
    testCtaUrl?: Maybe<Scalars['String']['output']>
    testValue?: Maybe<Scalars['String']['output']>
}

export type ThriveAudioConnection = {
    __typename?: 'ThriveAudioConnection'
    edges: Array<ThriveAudioEdge>
    /** @deprecated this field is deprecated, replace with nodes */
    items: Array<Audio>
    /** @deprecated this field is deprecated, replace with pageInfo */
    itemsPerPage: Scalars['Int']['output']
    nodes: Array<Audio>
    /** @deprecated this field is deprecated, replace with pageInfo */
    page: Scalars['Int']['output']
    pageInfo: PageInfo
    /** @deprecated this field is deprecated, replace with pageInfo */
    total: Scalars['Int']['output']
}

export type ThriveAudioEdge = {
    __typename?: 'ThriveAudioEdge'
    cursor: Scalars['String']['output']
    node: Audio
}

export type ThriveAudioQuery = {
    __typename?: 'ThriveAudioQuery'
    get: ThriveAudioConnection
    getByGenres: ThriveAudioConnection
    getByIds: Array<Audio>
}

export type ThriveAudioQueryGetArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    locale?: InputMaybe<Scalars['Locale']['input']>
    page?: InputMaybe<Scalars['Int']['input']>
    provider?: InputMaybe<Scalars['String']['input']>
}

export type ThriveAudioQueryGetByGenresArgs = {
    genres: Array<Scalars['String']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    locale?: InputMaybe<Scalars['Locale']['input']>
    page?: InputMaybe<Scalars['Int']['input']>
    provider?: InputMaybe<Scalars['String']['input']>
}

export type ThriveAudioQueryGetByIdsArgs = {
    ids: Array<Scalars['String']['input']>
    locale?: InputMaybe<Scalars['Locale']['input']>
}

export type ThriveBanner = {
    __typename?: 'ThriveBanner'
    callToAction?: Maybe<CallToAction>
    description: Scalars['String']['output']
    durationInSeconds: Scalars['Int']['output']
    eyebrow: Scalars['String']['output']
    imageDescription: Scalars['String']['output']
    imageUrl: Scalars['Url']['output']
    landscape: ThriveResetUrls
    portrait: ThriveResetUrls
    themes: Array<ThriveResetTheme>
    title: Scalars['String']['output']
}

export type ThriveBannerConnection = {
    __typename?: 'ThriveBannerConnection'
    edges: Array<ThriveBannerEdge>
    /** @deprecated this field is deprecated, replace with nodes */
    items: Array<ThriveBanner>
    /** @deprecated this field is deprecated, replace with pageInfo */
    itemsPerPage: Scalars['Int']['output']
    nodes: Array<ThriveBanner>
    /** @deprecated this field is deprecated, replace with pageInfo */
    page: Scalars['Int']['output']
    pageInfo: PageInfo
    /** @deprecated this field is deprecated, replace with pageInfo */
    total: Scalars['Int']['output']
}

export type ThriveBannerEdge = {
    __typename?: 'ThriveBannerEdge'
    cursor: Scalars['String']['output']
    node: ThriveBanner
}

export type ThriveBannerQuery = {
    __typename?: 'ThriveBannerQuery'
    get: ThriveBannerConnection
}

export type ThriveBannerQueryGetArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    locale?: InputMaybe<Scalars['Locale']['input']>
    page?: InputMaybe<Scalars['Int']['input']>
}

export type ThriveChallengeDailyGoalNotificationInput = {
    challengeDay: Scalars['Int']['input']
    challengeId: Scalars['UUID']['input']
    companyId: Scalars['UUID']['input']
    users: Array<Scalars['UUID']['input']>
}

export type ThriveContentQuery = {
    __typename?: 'ThriveContentQuery'
    book: BookQuery
    /** Get bookmarked content for a user */
    getBookmarkedContent: LearnContentItemPage
    /** Get content by Topic. A topic can have Journey UUID or a Pulse Dimension Type. */
    getContentByTopic: LearnContentByTopicOutput
    /** Get content in progress for a user, sorted by latest updatedAt descending. */
    getContentInProgress: LearnContentItemPage
    /** Get finished content for a user, sorted by latest updatedAt descending. */
    getFinishedContent: LearnContentItemPage
    /** Get content by Topic. A topic can have Journey UUID or a Pulse Dimension Type. */
    getMostViewedContent: Array<LearnContentItem>
    reset: ResetQueryV2
}

export type ThriveContentQueryGetBookmarkedContentArgs = {
    page?: InputMaybe<Scalars['Int']['input']>
    pageSize?: InputMaybe<Scalars['Int']['input']>
}

export type ThriveContentQueryGetContentByTopicArgs = {
    page?: InputMaybe<Scalars['Int']['input']>
    pageSize?: InputMaybe<Scalars['Int']['input']>
    topic: TopicInput
}

export type ThriveContentQueryGetContentInProgressArgs = {
    page?: InputMaybe<Scalars['Int']['input']>
    pageSize?: InputMaybe<Scalars['Int']['input']>
}

export type ThriveContentQueryGetFinishedContentArgs = {
    page?: InputMaybe<Scalars['Int']['input']>
    pageSize?: InputMaybe<Scalars['Int']['input']>
}

export type ThriveContentQueryGetMostViewedContentArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
}

export type ThriveHapiResponse =
    | HapiAccessToken
    | HapiIdToken
    | HapiSessionToken

export type ThriveImagePage = {
    __typename?: 'ThriveImagePage'
    items: Array<Image>
    itemsPerPage: Scalars['Int']['output']
    page: Scalars['Int']['output']
    total: Scalars['Int']['output']
}

export type ThriveImageQuery = {
    __typename?: 'ThriveImageQuery'
    get: ThriveImagePage
}

export type ThriveImageQueryGetArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    locale?: InputMaybe<Scalars['Locale']['input']>
    page?: InputMaybe<Scalars['Int']['input']>
}

export type ThrivePulseMutation = {
    __typename?: 'ThrivePulseMutation'
    /** Admin Controls */
    admin: AdminMutation
    /** Modify Insights settings in Pulse */
    insights: InsightsMutation
    /** Modify survey data in Pulse */
    surveys: SurveysMutation
}

export type ThrivePulseQuery = {
    __typename?: 'ThrivePulseQuery'
    /** Get company details from Pulse */
    companies: CompaniesQuery
    /** Get insights/reporting data from Pulse */
    insights: InsightsQuery
    /** Get recommendations from Pulse */
    recommendations: RecommendationsQuery
    /** Get surveys from Pulse */
    surveys: SurveysQuery
    /**
     * Get user data from Pulse
     * @deprecated Don't use Pulse user information. Go to Identity
     */
    users: UsersQuery
}

export type ThrivePulseQueryInsightsArgs = {
    from: Scalars['String']['input']
    to: Scalars['String']['input']
}

export type ThriveQuote = Frame & {
    __typename?: 'ThriveQuote'
    _: Scalars['Boolean']['output']
    author: Scalars['String']['output']
    backgroundColor?: Maybe<Scalars['Color']['output']>
    createdAt: Scalars['Instant']['output']
    id: Scalars['UUID']['output']
    order?: Maybe<Scalars['Int']['output']>
    text: Scalars['String']['output']
    textColor?: Maybe<Scalars['Color']['output']>
    updatedAt: Scalars['Instant']['output']
    /** @deprecated ThriveQuote will never be assigned to a user */
    user?: Maybe<ResetApiUser>
}

export type ThriveQuoteConnection = {
    __typename?: 'ThriveQuoteConnection'
    edges: Array<ThriveQuoteEdge>
    /** @deprecated this field is deprecated, replace with nodes */
    items: Array<ThriveQuote>
    /** @deprecated this field is deprecated, replace with pageInfo */
    itemsPerPage: Scalars['Int']['output']
    nodes: Array<ThriveQuote>
    /** @deprecated this field is deprecated, replace with pageInfo */
    page: Scalars['Int']['output']
    pageInfo: PageInfo
    /** @deprecated this field is deprecated, replace with pageInfo */
    total: Scalars['Int']['output']
}

export type ThriveQuoteEdge = {
    __typename?: 'ThriveQuoteEdge'
    cursor: Scalars['String']['output']
    node: ThriveQuote
}

export type ThriveQuoteQuery = {
    __typename?: 'ThriveQuoteQuery'
    get: ThriveQuoteConnection
}

export type ThriveQuoteQueryGetArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    page?: InputMaybe<Scalars['Int']['input']>
}

export type ThriveReset = Reset & {
    __typename?: 'ThriveReset'
    _: Scalars['Boolean']['output']
    appUrl: Scalars['Url']['output']
    bookmarked: Scalars['Boolean']['output']
    cmsTags: Array<Tag>
    createdAt: Scalars['Instant']['output']
    description?: Maybe<Scalars['String']['output']>
    durationInSeconds: Scalars['Int']['output']
    id: Scalars['UUID']['output']
    iframeUrls: AspectRatioUrls
    keywords: Array<ThriveResetKeyword>
    landscape: ThriveResetUrls
    latestFeedback?: Maybe<Feedback>
    likes: Likes
    locale: Scalars['Locale']['output']
    /** @deprecated this field is deprecated, replace with themes.localized */
    localizedTags: Array<LocalizedThriveResetTag>
    name?: Maybe<Scalars['String']['output']>
    partner?: Maybe<Partner>
    portrait: ThriveResetUrls
    resetType: ThriveResetType
    /** @deprecated this field is deprecated, replace with themes */
    tags: Array<ThriveResetTag>
    themes: Array<ThriveResetTheme>
    /** @deprecated this field is deprecated, replace with portrait.thumbnail OR landscape.thumbnail */
    thumbnail?: Maybe<Scalars['Url']['output']>
    updatedAt: Scalars['Instant']['output']
    /** @deprecated this field is deprecated, replace with portrait.url OR landscape.url */
    url?: Maybe<Scalars['Url']['output']>
    watched: Scalars['Boolean']['output']
}

export type ThriveResetAppUrlArgs = {
    utmSource: Scalars['String']['input']
}

export type ThriveResetIframeUrlsArgs = {
    utmSource: Scalars['String']['input']
}

export type ThriveResetLocalizedTagsArgs = {
    locale: Scalars['Locale']['input']
}

export type ThriveResetActionsMutation = {
    __typename?: 'ThriveResetActionsMutation'
    watched: Scalars['Boolean']['output']
}

export type ThriveResetActionsMutationWatchedArgs = {
    resetId: Scalars['UUID']['input']
}

export type ThriveResetAdminQuery = {
    __typename?: 'ThriveResetAdminQuery'
    getByIds: Array<ThriveReset>
}

export type ThriveResetAdminQueryGetByIdsArgs = {
    input: AdminThriveResetGetByIdsInput
}

export type ThriveResetAudio = Reset & {
    __typename?: 'ThriveResetAudio'
    _: Scalars['Boolean']['output']
    bookmarked: Scalars['Boolean']['output']
    createdAt: Scalars['Instant']['output']
    description: Scalars['String']['output']
    durationInSeconds: Scalars['Int']['output']
    id: Scalars['UUID']['output']
    images: ImageUrls
    latestFeedback?: Maybe<Feedback>
    likes: Likes
    mp3Url: Scalars['Url']['output']
    name: Scalars['String']['output']
    provider?: Maybe<AudioProvider>
    themes: Array<ThriveResetAudioTheme>
    updatedAt: Scalars['Instant']['output']
    watched: Scalars['Boolean']['output']
}

export type ThriveResetAudioEventMutation = {
    __typename?: 'ThriveResetAudioEventMutation'
    watched: Scalars['Boolean']['output']
}

export type ThriveResetAudioEventMutationWatchedArgs = {
    thriveResetAudioId: Scalars['UUID']['input']
}

export type ThriveResetAudioFeedbackMutation = {
    __typename?: 'ThriveResetAudioFeedbackMutation'
    clear: Scalars['Boolean']['output']
    create: Scalars['Boolean']['output']
}

export type ThriveResetAudioFeedbackMutationClearArgs = {
    id: Scalars['UUID']['input']
}

export type ThriveResetAudioFeedbackMutationCreateArgs = {
    feedback: Feedback
    id: Scalars['UUID']['input']
}

export type ThriveResetAudioFilterInput = {
    theme?: InputMaybe<ThriveResetAudioFilterThemeInput>
}

export type ThriveResetAudioFilterThemeInput = {
    in?: InputMaybe<Array<Scalars['String']['input']>>
}

export type ThriveResetAudioMutation = {
    __typename?: 'ThriveResetAudioMutation'
    event: ThriveResetAudioEventMutation
    feedback: ThriveResetAudioFeedbackMutation
}

export type ThriveResetAudioPage = {
    __typename?: 'ThriveResetAudioPage'
    items: Array<ThriveResetAudio>
    itemsPerPage: Scalars['Int']['output']
    page: Scalars['Int']['output']
    total: Scalars['Int']['output']
}

export type ThriveResetAudioPageV2 = {
    __typename?: 'ThriveResetAudioPageV2'
    hasMore?: Maybe<Scalars['Boolean']['output']>
    items: Array<ThriveResetAudioV2>
    page: Scalars['Int']['output']
    pageCount?: Maybe<Scalars['Int']['output']>
    pageSize: Scalars['Int']['output']
}

export type ThriveResetAudioQuery = {
    __typename?: 'ThriveResetAudioQuery'
    feedback: ThriveResetFeedbackQuery
    get: ThriveResetAudioPage
    getByIds: Array<ThriveResetAudio>
    getRandomBasedOnUserHistory: ThriveResetAudio
    themes: Array<ThriveResetAudioTheme>
}

export type ThriveResetAudioQueryGetArgs = {
    filter?: InputMaybe<ThriveResetAudioFilterInput>
    limit?: InputMaybe<Scalars['Int']['input']>
    page?: InputMaybe<Scalars['Int']['input']>
    random?: InputMaybe<Scalars['Boolean']['input']>
}

export type ThriveResetAudioQueryGetByIdsArgs = {
    ids: Array<Scalars['UUID']['input']>
}

export type ThriveResetAudioTheme = {
    __typename?: 'ThriveResetAudioTheme'
    localized: Scalars['String']['output']
    theme: Scalars['String']['output']
}

export type ThriveResetAudioV2 = {
    __typename?: 'ThriveResetAudioV2'
    durationInSeconds: Scalars['Int']['output']
    images?: Maybe<ImageUrls>
    isArchived: Scalars['Boolean']['output']
    name: Scalars['String']['output']
    uuid: Scalars['UUID']['output']
}

export type ThriveResetFeedbackMutation = {
    __typename?: 'ThriveResetFeedbackMutation'
    clear: Scalars['Boolean']['output']
    create: Scalars['Boolean']['output']
}

export type ThriveResetFeedbackMutationClearArgs = {
    id: Scalars['UUID']['input']
}

export type ThriveResetFeedbackMutationCreateArgs = {
    feedback: Feedback
    id: Scalars['UUID']['input']
}

export type ThriveResetFeedbackQuery = {
    __typename?: 'ThriveResetFeedbackQuery'
    getLatest?: Maybe<Feedback>
}

export type ThriveResetFeedbackQueryGetLatestArgs = {
    id: Scalars['UUID']['input']
}

export type ThriveResetFilterInput = {
    closedCaption?: InputMaybe<ThriveResetFilterStringInput>
    description?: InputMaybe<ThriveResetFilterStringInput>
    keyword?: InputMaybe<ThriveResetFilterKeywordInput>
    name?: InputMaybe<ThriveResetFilterStringInput>
    platform?: InputMaybe<ThriveResetFilterPlatformInput>
    theme?: InputMaybe<ThriveResetFilterThemeInput>
}

export type ThriveResetFilterKeywordInput = {
    in?: InputMaybe<Array<Scalars['String']['input']>>
    notIn?: InputMaybe<Array<Scalars['String']['input']>>
}

export type ThriveResetFilterPlatformInput = {
    in?: InputMaybe<Array<ThriveResetPlatform>>
}

export type ThriveResetFilterStringInput = {
    contains?: InputMaybe<Scalars['String']['input']>
}

export type ThriveResetFilterThemeInput = {
    in?: InputMaybe<Array<Scalars['String']['input']>>
}

export type ThriveResetKeyword = {
    __typename?: 'ThriveResetKeyword'
    isAvailableInHelpMeChoose: Scalars['Boolean']['output']
    keyword: Scalars['String']['output']
    localized: Scalars['String']['output']
}

export type ThriveResetKeywordFilterInput = {
    isAvailableInHelpMeChoose?: InputMaybe<Scalars['Boolean']['input']>
    platform?: InputMaybe<ThriveResetKeywordFilterPlatformInput>
}

export type ThriveResetKeywordFilterPlatformInput = {
    in?: InputMaybe<Array<ThriveResetPlatform>>
}

export type ThriveResetPage = {
    __typename?: 'ThriveResetPage'
    items: Array<ThriveReset>
    itemsPerPage: Scalars['Int']['output']
    page: Scalars['Int']['output']
    total: Scalars['Int']['output']
}

export type ThriveResetPageV2 = {
    __typename?: 'ThriveResetPageV2'
    hasMore?: Maybe<Scalars['Boolean']['output']>
    items: Array<ThriveResetV2>
    page: Scalars['Int']['output']
    pageCount?: Maybe<Scalars['Int']['output']>
    pageSize: Scalars['Int']['output']
}

export enum ThriveResetPlatform {
    App = 'App',
    Calls = 'Calls'
}

export type ThriveResetQuery = {
    __typename?: 'ThriveResetQuery'
    /** @deprecated Use featured query */
    daily?: Maybe<ThriveReset>
    featured?: Maybe<ThriveReset>
    feedback: ThriveResetFeedbackQuery
    get: ThriveResetPage
    getByIds: Array<ThriveReset>
    getMostRecentResetUserHistory: Array<ThriveResetUserHistory>
    getRandomResetBasedOnUserFeedback: ThriveReset
    getRandomResetBasedOnUserHistory: ThriveReset
    keywords: Array<ThriveResetKeyword>
    random?: Maybe<ThriveReset>
    recommended: Array<ThriveReset>
    /** @deprecated this field is deprecated, replace with themes */
    tags: Array<LocalizedThriveResetTag>
    themes: Array<ThriveResetTheme>
    watched: ThriveResetWatchQuery
}

export type ThriveResetQueryGetArgs = {
    filter?: InputMaybe<ThriveResetFilterInput>
    limit?: InputMaybe<Scalars['Int']['input']>
    locale?: InputMaybe<Scalars['Locale']['input']>
    page?: InputMaybe<Scalars['Int']['input']>
    random?: InputMaybe<Scalars['Boolean']['input']>
    resetType?: InputMaybe<ThriveResetType>
    thriveResetTag?: InputMaybe<ThriveResetTag>
}

export type ThriveResetQueryGetByIdsArgs = {
    ids: Array<Scalars['UUID']['input']>
    locale?: InputMaybe<Scalars['Locale']['input']>
}

export type ThriveResetQueryGetMostRecentResetUserHistoryArgs = {
    userId: Scalars['UUID']['input']
}

export type ThriveResetQueryGetRandomResetBasedOnUserFeedbackArgs = {
    feedbackWeights?: InputMaybe<FeedbackWeightsInput>
    filter?: InputMaybe<ThriveResetFilterInput>
}

export type ThriveResetQueryGetRandomResetBasedOnUserHistoryArgs = {
    filter?: InputMaybe<ThriveResetFilterInput>
}

export type ThriveResetQueryKeywordsArgs = {
    filter?: InputMaybe<ThriveResetKeywordFilterInput>
}

export type ThriveResetQueryRecommendedArgs = {
    input: RecommendedResetsGraphQlInput
}

export type ThriveResetQueryTagsArgs = {
    locale?: InputMaybe<Scalars['Locale']['input']>
}

export type ThriveResetQueryThemesArgs = {
    filter?: InputMaybe<ThriveResetThemeFilterInput>
}

export enum ThriveResetTag {
    Animals = 'Animals',
    Breathing = 'Breathing',
    EscapeAndExplore = 'EscapeAndExplore',
    Gratitude = 'Gratitude',
    Meditation = 'Meditation',
    Miir = 'Miir',
    Purpose = 'Purpose',
    RestAndReflect = 'RestAndReflect',
    Seasons = 'Seasons',
    Sollos = 'Sollos',
    Sports = 'Sports',
    StressRelief = 'StressRelief',
    Stretching = 'Stretching',
    Thrive = 'Thrive',
    Wonder = 'Wonder'
}

export type ThriveResetTheme = {
    __typename?: 'ThriveResetTheme'
    localized: Scalars['String']['output']
    theme: Scalars['String']['output']
    toLocalizedThriveResetTag?: Maybe<LocalizedThriveResetTag>
    toThriveResetTag?: Maybe<ThriveResetTag>
}

export type ThriveResetThemeFilterInput = {
    platform?: InputMaybe<ThriveResetThemeFilterPlatformInput>
}

export type ThriveResetThemeFilterPlatformInput = {
    in?: InputMaybe<Array<ThriveResetPlatform>>
}

export enum ThriveResetType {
    PepTalk = 'PEP_TALK',
    Standard = 'STANDARD'
}

export type ThriveResetUrls = {
    __typename?: 'ThriveResetUrls'
    iframe?: Maybe<Scalars['Url']['output']>
    thumbnail?: Maybe<Scalars['Url']['output']>
    thumbnails?: Maybe<ImageUrls>
}

export type ThriveResetUrlsV2 = {
    __typename?: 'ThriveResetUrlsV2'
    iframe?: Maybe<Scalars['Url']['output']>
    thumbnails?: Maybe<ImageUrls>
}

export type ThriveResetUserHistory = {
    __typename?: 'ThriveResetUserHistory'
    country?: Maybe<Scalars['String']['output']>
    language?: Maybe<Scalars['String']['output']>
    resetId: Scalars['UUID']['output']
    userId: Scalars['UUID']['output']
    watchedAt: Scalars['Instant']['output']
}

export type ThriveResetV2 = {
    __typename?: 'ThriveResetV2'
    description: Scalars['String']['output']
    durationInSeconds: Scalars['Int']['output']
    excludedSubscriptionIds: Array<Scalars['UUID']['output']>
    includedSubscriptionIds: Array<Scalars['UUID']['output']>
    isUnrestricted: Scalars['Boolean']['output']
    landscape: ThriveResetUrlsV2
    name: Scalars['String']['output']
    portrait: ThriveResetUrlsV2
    uuid: Scalars['UUID']['output']
}

export type ThriveResetWatchQuery = {
    __typename?: 'ThriveResetWatchQuery'
    company: Scalars['Int']['output']
    historyByDay: Array<ResetDailyWatched>
    user: Scalars['Int']['output']
}

export type ThriveResetWatchQueryCompanyArgs = {
    end: Scalars['Instant']['input']
    id: Scalars['UUID']['input']
    start: Scalars['Instant']['input']
}

export type ThriveResetWatchQueryHistoryByDayArgs = {
    from: Scalars['ISODate']['input']
    to: Scalars['ISODate']['input']
}

export type ThriveResetWatchQueryUserArgs = {
    end: Scalars['Instant']['input']
    id: Scalars['UUID']['input']
    start: Scalars['Instant']['input']
}

export type ThriveResetsMutation = {
    __typename?: 'ThriveResetsMutation'
    event: ThriveResetActionsMutation
    feedback: ThriveResetFeedbackMutation
}

export type ThriveScore = {
    __typename?: 'ThriveScore'
    endDate: Scalars['ISODate']['output']
    score: Scalars['Int']['output']
    startDate: Scalars['ISODate']['output']
    surveysAnsweredDayOf: Scalars['Int']['output']
    surveysAnsweredRetroactive: Scalars['Int']['output']
}

export type ThriveScoreQuery = {
    __typename?: 'ThriveScoreQuery'
    /** Get thrive score */
    thriveScore: Array<ThriveScore>
}

export type ThriveScoreQueryThriveScoreArgs = {
    endDate: Scalars['ISODate']['input']
}

export type TimedRecommendedResetContext = {
    __typename?: 'TimedRecommendedResetContext'
    intentionId?: Maybe<Scalars['UUID']['output']>
    timeOfDay: ResetRecommendationTimeOfDay
}

export type TodayMutation = {
    __typename?: 'TodayMutation'
    /** Adds check-ins for the given date and microstep ids. Returns a list of affected results, or an empty list if the checkins already exist */
    checkinToMicrostepsV2: Array<MicrostepCheckin>
    checkinToMicrostepsV2Admin: Array<MicrostepCheckin>
    commitToMicrosteps: Array<MicrostepSubscription>
    /** Remove the like of a microstep */
    removeLikedMicrostep: Scalars['Int']['output']
    /** Like a microstep */
    setLikedMicrostep?: Maybe<Scalars['UUID']['output']>
    /** Removes check-ins for the given date and microstep ids. Returns a list of the removed microstep ids */
    unCheckinToMicrostepsV2: Array<Scalars['ID']['output']>
    unCommitToMicrostep: Array<MicrostepSubscription>
}

export type TodayMutationCheckinToMicrostepsV2Args = {
    date?: InputMaybe<Scalars['ISODate']['input']>
    microstepIds: Array<Scalars['ID']['input']>
}

export type TodayMutationCheckinToMicrostepsV2AdminArgs = {
    checkinDate: Scalars['ISODate']['input']
    companyId: Scalars['UUID']['input']
    microstepIds: Array<Scalars['ID']['input']>
    userId: Scalars['UUID']['input']
}

export type TodayMutationCommitToMicrostepsArgs = {
    microstepIds: Array<Scalars['ID']['input']>
}

export type TodayMutationRemoveLikedMicrostepArgs = {
    microstepId: Scalars['UUID']['input']
}

export type TodayMutationSetLikedMicrostepArgs = {
    microstepId: Scalars['UUID']['input']
}

export type TodayMutationUnCheckinToMicrostepsV2Args = {
    date?: InputMaybe<Scalars['ISODate']['input']>
    microstepIds: Array<Scalars['ID']['input']>
}

export type TodayMutationUnCommitToMicrostepArgs = {
    microstepAndRemovalReason: Array<MicrostepAndRemovalReasonInput>
}

export type TodayQuery = {
    __typename?: 'TodayQuery'
    /** Returns all microsteps for the user's locale (no pagination) */
    allMicrosteps: Array<GraphQlMicrostep>
    /** Returns committed microsteps for the user */
    getActiveMicrostepsV2: Array<MicrostepUserStatus>
    /** Returns checked-in and committed microsteps for the user, daily, between two dates */
    getAllMicrostepCheckinProgressV2: Array<MicrostepCheckinProgressDate>
    /** For each microstep passed, returns the dates the user checked in */
    getMicrostepCheckinDates: Array<MicrostepCheckinDateList>
    getMicrostepCheckinDatesAdmin: Array<MicrostepCheckinDateList>
    /**
     * Returns number of check-ins the user did for a given microstep between two dates
     * @deprecated Only used in Today web
     */
    getMicrostepCheckinProgressV2: MicrostepUserProgress
    getMicrostepUserCheckinTotalsAdmin: Array<MicrostepUserTotal>
    /**
     * Returns a list of microsteps with their commit & checkin status
     * @deprecated Only used in Today web
     */
    getMicrostepsUserStatusForJourneys: Array<MicrostepUserStatus>
    /** Returns a list of microsteps for the given uuids */
    getMicrostepsV2: Array<GraphQlMicrostep>
    /** Returns a list of microsteps with pagination */
    getPaginatedMicrosteps: MicrostepPage
    /** Returns a list of `MicrostepCheckinsFromDateOutput`, this include information about the number of checkins per microstep since the date passed in  */
    getUserMicrostepCheckinsFromDate: Array<MicrostepCheckinsFromDateOutput>
    /** Returns a list of microsteps user status for the given uuids */
    getUserMicrostepStatus: Array<MicrostepUserStatus>
    /**
     * Returns an array of date and microstep check-in count pairings, with a cumulative total. if `timeDimension` parameter is not passed: If the date range us up to 3 months, return each day in the response
     *
     * If the date range is between 3 months and 2 years, bundle the check-ins by week
     *
     * If the date range is longer than 2 years, bundle the check-ins by month.
     * @deprecated Only used in Today web
     */
    microstepMomentum: MicrostepMomentumResult
    /** Returns random microsteps from a curated list for onboarding */
    onboardingMicrosteps: Array<GraphQlMicrostep>
    /** Returns random microsteps for current time of day */
    timeOfDayMicrosteps: Array<GraphQlMicrostep>
}

export type TodayQueryAllMicrostepsArgs = {
    removeDeprecated?: InputMaybe<Scalars['Boolean']['input']>
}

export type TodayQueryGetActiveMicrostepsV2Args = {
    activeDate?: InputMaybe<Scalars['ISODate']['input']>
}

export type TodayQueryGetAllMicrostepCheckinProgressV2Args = {
    from: Scalars['ISODate']['input']
    fullMicrosteps?: InputMaybe<Scalars['Boolean']['input']>
    to: Scalars['ISODate']['input']
}

export type TodayQueryGetMicrostepCheckinDatesArgs = {
    microstepIds: Array<Scalars['UUID']['input']>
}

export type TodayQueryGetMicrostepCheckinDatesAdminArgs = {
    microstepIds: Array<Scalars['UUID']['input']>
    userId: Scalars['UUID']['input']
}

export type TodayQueryGetMicrostepCheckinProgressV2Args = {
    from: Scalars['ISODate']['input']
    microstepId: Scalars['ID']['input']
    to: Scalars['ISODate']['input']
}

export type TodayQueryGetMicrostepUserCheckinTotalsAdminArgs = {
    microstepIds: Array<Scalars['UUID']['input']>
    userIds: Array<Scalars['UUID']['input']>
}

export type TodayQueryGetMicrostepsUserStatusForJourneysArgs = {
    checkinDate?: InputMaybe<Scalars['ISODate']['input']>
    journeyIds: Array<Scalars['UUID']['input']>
}

export type TodayQueryGetMicrostepsV2Args = {
    ids: Array<Scalars['ID']['input']>
}

export type TodayQueryGetPaginatedMicrostepsArgs = {
    frequency?: InputMaybe<Scalars['String']['input']>
    journeyIds?: InputMaybe<Array<Scalars['UUID']['input']>>
    onlyCheckedIn?: InputMaybe<Scalars['Boolean']['input']>
    onlySubscribed?: InputMaybe<Scalars['Boolean']['input']>
    page: Scalars['Int']['input']
    pageSize: Scalars['Int']['input']
    removeDeprecated?: InputMaybe<Scalars['Boolean']['input']>
    searchText?: InputMaybe<Scalars['String']['input']>
    sortOrder?: InputMaybe<SortOrder>
}

export type TodayQueryGetUserMicrostepCheckinsFromDateArgs = {
    input: Array<MicrostepCheckinDateInput>
    userId: Scalars['UUID']['input']
}

export type TodayQueryGetUserMicrostepStatusArgs = {
    microstepIds: Array<Scalars['UUID']['input']>
}

export type TodayQueryMicrostepMomentumArgs = {
    from?: InputMaybe<Scalars['ISODate']['input']>
    timeDimension?: InputMaybe<Scalars['String']['input']>
    to?: InputMaybe<Scalars['ISODate']['input']>
}

export type TodayQueryOnboardingMicrostepsArgs = {
    excludedIds?: InputMaybe<Array<Scalars['UUID']['input']>>
    limit?: InputMaybe<Scalars['Int']['input']>
}

export type TodayQueryTimeOfDayMicrostepsArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    locale?: InputMaybe<Scalars['Locale']['input']>
    zoneId?: InputMaybe<Scalars['String']['input']>
}

export type TokenResponse = {
    __typename?: 'TokenResponse'
    token: Scalars['String']['output']
}

export type Topic = {
    __typename?: 'Topic'
    journey?: Maybe<Journey>
    journeyUUID?: Maybe<Scalars['UUID']['output']>
    pulseDimension?: Maybe<PulseDimension>
    pulseDimensionType?: Maybe<Scalars['String']['output']>
}

export type TopicInput = {
    journeyUUID?: InputMaybe<Scalars['UUID']['input']>
    pulseDimensionType?: InputMaybe<Scalars['String']['input']>
}

export type TransactionHistoryInfo = {
    __typename?: 'TransactionHistoryInfo'
    /** The transaction's amount */
    amount: Scalars['Int']['output']
    createdAt: Scalars['Instant']['output']
    /** The currency code */
    currencyCode: Scalars['String']['output']
    /** In case of DEBIT, the product upc associated to it */
    productUpc?: Maybe<Scalars['String']['output']>
    /** The transaction type. Can be CREDIT or DEBIT */
    transactionType: Scalars['String']['output']
    updatedAt: Scalars['Instant']['output']
    /** The user id */
    userId: Scalars['UUID']['output']
}

export type TrendHighlights = {
    __typename?: 'TrendHighlights'
    greatestOpportunity?: Maybe<DimensionTrendsDto>
    greatestStrength?: Maybe<DimensionTrendsDto>
    mostConsistent?: Maybe<DimensionTrendsDto>
    mostImproved?: Maybe<DimensionTrendsDto>
}

export type TriggerConfiguration = {
    __typename?: 'TriggerConfiguration'
    agentGroupId: Scalars['String']['output']
    callCountLimit?: Maybe<Scalars['Int']['output']>
    callCountTriggerEnabled: Scalars['Boolean']['output']
    callDurationLimit?: Maybe<Scalars['Int']['output']>
    callDurationTriggerEnabled: Scalars['Boolean']['output']
    createdAt: Scalars['Instant']['output']
    digitalOnly?: Maybe<Scalars['Boolean']['output']>
    direction: Array<Direction>
    isTest: Scalars['Boolean']['output']
    locale?: Maybe<Scalars['String']['output']>
    mediaTypes: Array<MediaType>
    updatedAt: Scalars['Instant']['output']
}

export type TriggerInChallengeGoalRemindersInput = {
    /** If providing more than five challenges in this metadata, it is strongly recommended to lower the user batch size to prevent issues. */
    challenges: Array<InChallengeDataInput>
    sendDate: Scalars['ISODate']['input']
    /** ISO-8601 time string.  Should be the time the nudge should send, in the users' timezone. */
    sendTime: Scalars['String']['input']
    /** Cannot exceed 300 IDs in a batch.  NOTE: if providing more than five challenges in the metadata, it is strongly recommended to use a smaller batch size. */
    thriveUserIds: Array<Scalars['UUID']['input']>
    /** The users' timezone.  A valid IANA timezone that parses as a ZoneId */
    timezone: Scalars['String']['input']
}

export type TriggerMutation = {
    __typename?: 'TriggerMutation'
    /** Inserts or updates a trigger configuration for a company */
    delete?: Maybe<CompanyConfiguration>
    /** Inserts or updates a trigger configuration for a company */
    upsert: CompanyConfiguration
}

export type TriggerMutationDeleteArgs = {
    agentGroupId: Scalars['String']['input']
    companyId: Scalars['UUID']['input']
    platform: PlatformType
}

export type TriggerMutationUpsertArgs = {
    agentGroupId: Scalars['String']['input']
    callCountLimit?: InputMaybe<Scalars['Int']['input']>
    callCountTriggerEnabled?: InputMaybe<Scalars['Boolean']['input']>
    callDurationLimit?: InputMaybe<Scalars['Int']['input']>
    callDurationTriggerEnabled?: InputMaybe<Scalars['Boolean']['input']>
    companyId: Scalars['UUID']['input']
    digitalOnly?: InputMaybe<Scalars['Boolean']['input']>
    direction?: InputMaybe<Array<Direction>>
    locale?: InputMaybe<Scalars['String']['input']>
    mediaTypes?: InputMaybe<Array<MediaType>>
    platform: PlatformType
}

export type TriggerQuery = {
    __typename?: 'TriggerQuery'
    /** Returns the trigger configuration for the given group id */
    get?: Maybe<TriggerConfiguration>
    /** Returns all trigger configuration for the given company */
    getAll: Array<Maybe<TriggerConfiguration>>
}

export type TriggerQueryGetArgs = {
    agentGroupId: Scalars['String']['input']
    companyId: Scalars['UUID']['input']
    platform: PlatformType
}

export type TriggerQueryGetAllArgs = {
    companyId: Scalars['UUID']['input']
    platform: PlatformType
}

export enum TriggerReason {
    ConsecutiveCalls = 'CONSECUTIVE_CALLS',
    Duration = 'DURATION',
    Manual = 'MANUAL'
}

export type TriggerReset = CallsCommand & {
    __typename?: 'TriggerReset'
    companyId: Scalars['UUID']['output']
    date: Scalars['Instant']['output']
    platformType: PlatformType
    type: CallsCommandType
    userId: Scalars['String']['output']
}

export type TriggerSelfTestEventInput = {
    testCtaUrl?: InputMaybe<Scalars['String']['input']>
    testValue?: InputMaybe<Scalars['String']['input']>
}

export type TriggerTestEventInput = {
    testCtaUrl?: InputMaybe<Scalars['String']['input']>
    testValue?: InputMaybe<Scalars['String']['input']>
    thriveUserId: Scalars['UUID']['input']
}

export type TriggerTestEventsInput = {
    testCtaUrl?: InputMaybe<Scalars['String']['input']>
    testValue?: InputMaybe<Scalars['String']['input']>
    /** Cannot exceed 300 IDs in a batch. */
    thriveUserIds: Array<Scalars['UUID']['input']>
}

export type TriggerWebNudgeAnnouncementsForCompanyInput = {
    companyId: Scalars['UUID']['input']
}

export type TryDeleteSlackUserInput = {
    slackUserId: Scalars['UUID']['input']
}

export type TryDeleteSlackUserMutation = {
    __typename?: 'TryDeleteSlackUserMutation'
    /** Try to delete a slack user */
    tryDeleteBySlackId: TryDeleteSlackUserResult
}

export type TryDeleteSlackUserMutationTryDeleteBySlackIdArgs = {
    tryDeleteSlackUserBySlackIdInput: TryDeleteSlackUserInput
}

export type TryDeleteSlackUserResult = {
    __typename?: 'TryDeleteSlackUserResult'
    deleted: Scalars['Boolean']['output']
    error?: Maybe<Scalars['String']['output']>
}

export type TryDeleteUserInput = {
    teamsUserId: Scalars['UUID']['input']
}

export type TryDeleteUserMutation = {
    __typename?: 'TryDeleteUserMutation'
    /** Try to delete a teams user */
    tryDelete: TryDeleteUserResult
}

export type TryDeleteUserMutationTryDeleteArgs = {
    tryDeleteUserInput: TryDeleteUserInput
}

export type TryDeleteUserResult = {
    __typename?: 'TryDeleteUserResult'
    deleted: Scalars['Boolean']['output']
    error?: Maybe<Scalars['String']['output']>
}

export type TutorialConfig = {
    __typename?: 'TutorialConfig'
    hasPlayedTutorial: Scalars['Boolean']['output']
    lastPlayedAt?: Maybe<Scalars['Instant']['output']>
    pulseUserId: Scalars['UUID']['output']
}

export enum Type {
    Article = 'ARTICLE',
    Book = 'BOOK',
    Challenge = 'CHALLENGE',
    Course = 'COURSE',
    CourseLesson = 'COURSE_LESSON',
    CourseModule = 'COURSE_MODULE',
    Journey = 'JOURNEY',
    Microstep = 'MICROSTEP',
    Podcast = 'PODCAST',
    PodcastEpisode = 'PODCAST_EPISODE',
    PodcastSeason = 'PODCAST_SEASON',
    Recipe = 'RECIPE',
    Reset = 'RESET',
    ResetStockAudio = 'RESET_STOCK_AUDIO',
    RoleModel = 'ROLE_MODEL',
    WatchMeThrive = 'WATCH_ME_THRIVE'
}

export type UncompletedJourneyProgress = {
    __typename?: 'UncompletedJourneyProgress'
    completedProgress: Array<UserJourneyProgress>
    currentLevel?: Maybe<JourneyLevelV2>
    currentStep?: Maybe<JourneyDailyStepV2>
    dailySteps?: Maybe<Array<JourneyDailyStepV2>>
    isCompleted: Scalars['Boolean']['output']
    journey?: Maybe<Journey>
    stepCompletedToday?: Maybe<UserJourneyProgress>
}

export type UngroupedAssessmentStatsResponse = AssessmentStats & {
    __typename?: 'UngroupedAssessmentStatsResponse'
    average: Scalars['Float']['output']
    survey?: Maybe<Surveys>
    totalNumberOfResponses: Scalars['Int']['output']
    valuePercentage: Scalars['Int']['output']
}

export type UnifiedBiotype = {
    __typename?: 'UnifiedBiotype'
    id?: Maybe<Scalars['UUID']['output']>
    name?: Maybe<Scalars['String']['output']>
}

export type UnifiedChallenge = {
    __typename?: 'UnifiedChallenge'
    /** Indicates if this template allows customers to override step goals */
    allowCustomSteps: Scalars['Boolean']['output']
    /** The background image */
    backgroundImage?: Maybe<Scalars['String']['output']>
    /** List of better choices of the challenge */
    betterChoices: Array<Scalars['UUID']['output']>
    /** Biotype */
    biotype?: Maybe<UnifiedBiotype>
    /**
     * Deprecated - use journeys list field
     * @deprecated Deprecated - use journeys list field
     */
    category?: Maybe<UnifiedJourney>
    /** The template id in case this challenge was created from a template */
    challengeTemplateId: Scalars['UUID']['output']
    /** Type of challenge (JOURNEY, BIOTYPE, PRIZE, COMPANY) */
    challenge_type: Scalars['String']['output']
    /** The signup day (with no time) if the challenge is a company challenge */
    companyChallengeSignupDay?: Maybe<Scalars['ISODate']['output']>
    /** The start date if the challenge is a company challenge */
    companyChallengeStartDate?: Maybe<Scalars['Instant']['output']>
    /** The start day (with no time) if the challenge is a company challenge */
    companyChallengeStartDay?: Maybe<Scalars['ISODate']['output']>
    /** The instance creator's userId in case this challenges was created from a template */
    createdBy?: Maybe<Scalars['UUID']['output']>
    /** The day of company challenge it's negative if the has not started yet */
    dayOfChallenge?: Maybe<Scalars['Int']['output']>
    /** Description of the challenge */
    description?: Maybe<Scalars['String']['output']>
    /** Identifies if challenge supports wearables functionality  */
    device_enabled: Scalars['Boolean']['output']
    /** Duration of the challenge */
    duration: Scalars['Int']['output']
    /** If the challenge is visible to all users */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** Goal of the challenge */
    goal?: Maybe<Scalars['String']['output']>
    /** Group challenge type */
    groupChallengeType?: Maybe<GroupChallengeType>
    /** Header image */
    header?: Maybe<Scalars['String']['output']>
    /** The id of this challenge */
    id: Scalars['UUID']['output']
    /** Determines if the challenge is featured (Appears at the top) */
    isFeatured?: Maybe<Scalars['Boolean']['output']>
    /** List of Journeys */
    journeys?: Maybe<Array<UnifiedJourney>>
    /** Indicates the max team size for the challenge */
    maxTeamSize?: Maybe<Scalars['Int']['output']>
    /** Deprecated since moving away from CMS Challenges */
    microsteps: Array<UnifiedMicrostep>
    /** Name of the challenge */
    name: Scalars['String']['output']
    /** Custom  order position set for the challenge */
    position: Scalars['Int']['output']
    /** The description for promo 1 field */
    promoDescription1?: Maybe<Scalars['String']['output']>
    /** The description for promo 2 field */
    promoDescription2?: Maybe<Scalars['String']['output']>
    /** The description for promo 3 field */
    promoDescription3?: Maybe<Scalars['String']['output']>
    /** The header for promo 1 field */
    promoHeader1?: Maybe<Scalars['String']['output']>
    /** The header for promo 2 field */
    promoHeader2?: Maybe<Scalars['String']['output']>
    /** The header for promo 3 field */
    promoHeader3?: Maybe<Scalars['String']['output']>
    /** The image for promo 1 field */
    promoImage1?: Maybe<Scalars['String']['output']>
    /** The image for promo 2 field */
    promoImage2?: Maybe<Scalars['String']['output']>
    /** The image for promo 3 field */
    promoImage3?: Maybe<Scalars['String']['output']>
    /** List of Quotes */
    quotes?: Maybe<Array<TemplateQuote>>
    /** Indicates if the challenge is read only */
    readOnly: Scalars['Boolean']['output']
    /** List of resets ids of the challenge */
    resetIds: Array<Scalars['UUID']['output']>
    /** The company challenge theme */
    theme?: Maybe<Scalars['String']['output']>
    /** Thumbnail */
    thumbnail?: Maybe<Scalars['String']['output']>
    /** Total number of participants in this challenge for the same company */
    totalParticipants: Scalars['Int']['output']
    /** The image for the community challenge trophy plant */
    trophyPlantImage?: Maybe<Scalars['String']['output']>
    /**
     * Deprecated - use challenge_type instead
     * @deprecated Deprecated - use challenge_type instead, replace with challenge_type
     */
    type?: Maybe<Scalars['String']['output']>
}

export type UnifiedChallengeActivity = {
    __typename?: 'UnifiedChallengeActivity'
    completedOn?: Maybe<Scalars['Instant']['output']>
    expiredOn?: Maybe<Scalars['Instant']['output']>
    id: Scalars['UUID']['output']
    join: Scalars['Instant']['output']
    leave?: Maybe<Scalars['Instant']['output']>
    microstepActivities?: Maybe<Array<UnifiedMicrostepActivities>>
    socialGroup?: Maybe<Scalars['UUID']['output']>
    streak?: Maybe<UnifiedStreak>
}

export type UnifiedChallengeAdmin = {
    __typename?: 'UnifiedChallengeAdmin'
    /** Type of challenge (JOURNEY, BIOTYPE, PRIZE, COMPANY) */
    challengeType: Scalars['String']['output']
    createdAt?: Maybe<Scalars['Instant']['output']>
    /** Description of the challenge */
    description?: Maybe<Scalars['String']['output']>
    /** Is enabled */
    enabled: Scalars['Boolean']['output']
    /** The id of this challenge */
    id: Scalars['UUID']['output']
    /** Is default challenge */
    isDefault: Scalars['Boolean']['output']
    /** Name of the challenge */
    name: Scalars['String']['output']
    updatedAt?: Maybe<Scalars['Instant']['output']>
}

export type UnifiedChallengeCompany = {
    __typename?: 'UnifiedChallengeCompany'
    /** The id of the challenge */
    challenge_id: Scalars['UUID']['output']
    /** The id of the company */
    company_id: Scalars['String']['output']
    /** enabled flag */
    enabled: Scalars['Boolean']['output']
    /** The id of this relation */
    id: Scalars['UUID']['output']
    /** The id of the subscription */
    subscription_id?: Maybe<Scalars['UUID']['output']>
}

export type UnifiedChallengeCompanyStoryType = {
    __typename?: 'UnifiedChallengeCompanyStoryType'
    /** The id of the challenge company */
    challengeCompanyId: Scalars['UUID']['output']
    /** The id of this relation */
    id: Scalars['UUID']['output']
    /** The id of the story type */
    storyTypeId: Scalars['UUID']['output']
}

export type UnifiedChallengeParticipation = {
    __typename?: 'UnifiedChallengeParticipation'
    challenge: UnifiedChallenge
    participation: Array<UnifiedChallengeActivity>
}

export type UnifiedChallengesMutation = {
    __typename?: 'UnifiedChallengesMutation'
    /** Admin endpoint to add new challenge goals */
    addChallengeGoals: Array<ChallengeGoal>
    /** Admin endpoint to add challenges to a company subscription */
    addChallengesToSubscription: UnifiedResult
    /** Admin endpoint to add challenges to multiple company subscriptions */
    addChallengesToSubscriptions: UnifiedResult
    /** Add water intake for selected user's challenge */
    addWaterIntake: WaterOperationResult
    /** Stores the answer for a user's feeling-question */
    answerFeelingQuestion: FeelingQuestionOperationResult
    /** Changes a user participating in a community challenge to another socialGroup (or null for solo) */
    changeCommunityChallengeTeam: UnifiedResult
    /** Complete a challenge for the user */
    completeChallenge?: Maybe<UnifiedUserChallengeActivity>
    /** Complete a user's community challenge daily goal */
    completeCommunityChallengeDailyGoal?: Maybe<ChallengeGoal>
    /** @deprecated Deprecated - use createChallengeFromTemplate instead */
    createChallenge?: Maybe<Scalars['UUID']['output']>
    /** Creates a new challenge from a template */
    createChallengeFromTemplate: TemplateOperationResult
    /** Creates a new group challenge from a template */
    createGroupChallengeFromTemplate: TemplateOperationResult
    /** Add the user to a challenge */
    joinChallenge: UnifiedResult
    /** Add the user to a community challenge */
    joinCommunityChallenge: UnifiedResult
    /** Remove the user from a challenge using a userChallengeActivityId */
    leaveChallenge?: Maybe<UnifiedUserChallengeActivity>
    /** Remove user's group challenge */
    removeGroupChallenge: RemoveChallengeResult
    /** Remove the user from a challenge using a challengeId */
    removeUserFromChallenge: UnifiedResult
    /** Set the customization options for the selected user's challenge */
    setChallengeCustomization: ChallengeCustomizationOperationResult
    /** @deprecated Default status no longer used */
    setChallengeDefaultStatus: Scalars['Boolean']['output']
    /** Admin endpoint to set the status for challenges */
    setChallengesStatusForSubscription: UnifiedResult
    /** Sets the company challenge notification status for a user */
    setCompanyNotificationStatus?: Maybe<Scalars['Boolean']['output']>
    /** For group challenges, updates the type */
    setGroupChallengeType: SetGroupChallengeTypeResult
    /** Sets the company challenge notification status for a user */
    setPrivateNotificationStatus?: Maybe<Scalars['Boolean']['output']>
    /** Stores the answer for a user's sleep habits */
    setSleepHabits: SleepHabitsOperationResult
    /** Marks if a user has watched the tutorial */
    setTutorialWatchedStatus: Scalars['Boolean']['output']
    /** Sets a user flag */
    setUserFlag?: Maybe<Scalars['String']['output']>
    /** Submit a new story to be created */
    submitStory?: Maybe<Story>
    /** Unified Challenges util functions for adhoc mutations */
    unifiedChallengesUtil: UnifiedChallengesMutationUtil
    /** Admin endpoint to update challenge goals */
    updateChallengeGoal: ChallengeGoal
    /** Updates an instance of a challenge */
    updateChallengeInstance: TemplateOperationResult
    /** Update the measure unit settings for the selected user's challenge */
    updateMeasureUnitSettings?: Maybe<UserInfo>
    /** Sets the weekend notification status for a user */
    updateWeekendNotificationSettings?: Maybe<UserInfo>
}

export type UnifiedChallengesMutationAddChallengeGoalsArgs = {
    newChallengeGoalsInput: Array<ChallengeGoalCreateInput>
}

export type UnifiedChallengesMutationAddChallengesToSubscriptionArgs = {
    challengesToAdd?: InputMaybe<Array<Scalars['UUID']['input']>>
    companyId: Scalars['UUID']['input']
    storyTypeId?: InputMaybe<Scalars['UUID']['input']>
    subscriptionId: Scalars['UUID']['input']
}

export type UnifiedChallengesMutationAddChallengesToSubscriptionsArgs = {
    challengesToAdd: Array<Scalars['UUID']['input']>
    companiesSubscriptionsToAdd?: InputMaybe<Array<SubscriptionCompanyInput>>
    companiesSubscriptionsToExclude?: InputMaybe<
        Array<SubscriptionCompanyInput>
    >
    storyTypeId?: InputMaybe<Scalars['UUID']['input']>
}

export type UnifiedChallengesMutationAddWaterIntakeArgs = {
    amount: Scalars['Int']['input']
    challengeId: Scalars['UUID']['input']
    date?: InputMaybe<Scalars['ISODate']['input']>
}

export type UnifiedChallengesMutationAnswerFeelingQuestionArgs = {
    answer: Scalars['Int']['input']
    challengeId: Scalars['UUID']['input']
    date?: InputMaybe<Scalars['ISODate']['input']>
}

export type UnifiedChallengesMutationChangeCommunityChallengeTeamArgs = {
    challengeId: Scalars['UUID']['input']
    socialGroupId?: InputMaybe<Scalars['UUID']['input']>
}

export type UnifiedChallengesMutationCompleteChallengeArgs = {
    completedOn?: InputMaybe<Scalars['Instant']['input']>
    userChallengeActivityId: Scalars['UUID']['input']
}

export type UnifiedChallengesMutationCompleteCommunityChallengeDailyGoalArgs = {
    challengeGoalId: Scalars['UUID']['input']
    challengeId: Scalars['UUID']['input']
}

export type UnifiedChallengesMutationCreateChallengeArgs = {
    newChallengeId?: InputMaybe<Scalars['UUID']['input']>
}

export type UnifiedChallengesMutationCreateChallengeFromTemplateArgs = {
    challengeTemplateCreateInput: ChallengeTemplateCreateInput
}

export type UnifiedChallengesMutationCreateGroupChallengeFromTemplateArgs = {
    input: GroupChallengeTemplateCreateInput
}

export type UnifiedChallengesMutationJoinChallengeArgs = {
    challengeId: Scalars['UUID']['input']
    joinDate?: InputMaybe<Scalars['ISODate']['input']>
    joinedOn?: InputMaybe<Scalars['Instant']['input']>
    socialGroupId?: InputMaybe<Scalars['UUID']['input']>
}

export type UnifiedChallengesMutationJoinCommunityChallengeArgs = {
    challengeId: Scalars['UUID']['input']
    joinDate?: InputMaybe<Scalars['ISODate']['input']>
    joinedOn?: InputMaybe<Scalars['Instant']['input']>
    socialGroupId?: InputMaybe<Scalars['UUID']['input']>
    socialGroupName?: InputMaybe<Scalars['String']['input']>
    socialGroupPublic?: InputMaybe<Scalars['Boolean']['input']>
}

export type UnifiedChallengesMutationLeaveChallengeArgs = {
    leaveOn?: InputMaybe<Scalars['Instant']['input']>
    userChallengeActivityId: Scalars['UUID']['input']
}

export type UnifiedChallengesMutationRemoveGroupChallengeArgs = {
    challengeId: Scalars['UUID']['input']
}

export type UnifiedChallengesMutationRemoveUserFromChallengeArgs = {
    challengeId: Scalars['UUID']['input']
    userIdToRemove: Scalars['UUID']['input']
}

export type UnifiedChallengesMutationSetChallengeCustomizationArgs = {
    challengeId: Scalars['UUID']['input']
    stepsAmount?: InputMaybe<Scalars['Int']['input']>
    waterAmount?: InputMaybe<Scalars['Int']['input']>
}

export type UnifiedChallengesMutationSetChallengeDefaultStatusArgs = {
    challengeId: Scalars['UUID']['input']
    isDefault: Scalars['Boolean']['input']
}

export type UnifiedChallengesMutationSetChallengesStatusForSubscriptionArgs = {
    challenges: Array<Scalars['UUID']['input']>
    status: Scalars['Boolean']['input']
    subscriptionId: Scalars['UUID']['input']
}

export type UnifiedChallengesMutationSetCompanyNotificationStatusArgs = {
    status: Scalars['Boolean']['input']
}

export type UnifiedChallengesMutationSetGroupChallengeTypeArgs = {
    challengeId: Scalars['UUID']['input']
    groupChallengeType: GroupChallengeType
}

export type UnifiedChallengesMutationSetPrivateNotificationStatusArgs = {
    status: Scalars['Boolean']['input']
}

export type UnifiedChallengesMutationSetSleepHabitsArgs = {
    answer: Scalars['Int']['input']
    challengeId: Scalars['UUID']['input']
    challengeTimePoint: ChallengeTimePoint
}

export type UnifiedChallengesMutationSetTutorialWatchedStatusArgs = {
    status: Scalars['Boolean']['input']
}

export type UnifiedChallengesMutationSetUserFlagArgs = {
    key: Scalars['String']['input']
    value?: InputMaybe<Scalars['String']['input']>
}

export type UnifiedChallengesMutationSubmitStoryArgs = {
    newStory: StoryCreateInput
}

export type UnifiedChallengesMutationUpdateChallengeGoalArgs = {
    challengeGoalId: Scalars['UUID']['input']
    challengeGoalInput: ChallengeGoalCreateInput
}

export type UnifiedChallengesMutationUpdateChallengeInstanceArgs = {
    challengeId: Scalars['UUID']['input']
    challengeTemplateCreateInput: ChallengeTemplateCreateInput
}

export type UnifiedChallengesMutationUpdateMeasureUnitSettingsArgs = {
    measureUnit: MeasureUnit
}

export type UnifiedChallengesMutationUpdateWeekendNotificationSettingsArgs = {
    weekendNotificationsActivated: Scalars['Boolean']['input']
}

/** These are utility Admin mutation endpoints, designed to only be used for adhoc data fixes */
export type UnifiedChallengesMutationUtil = {
    __typename?: 'UnifiedChallengesMutationUtil'
    /** Admin endpoint to add story type to company ids */
    addStorySubmissionToCompany: Array<UnifiedChallengeCompanyStoryType>
    /** Admin endpoint to complete a community challenge day */
    batchCompleteCommunityChallengeDay: Array<ChallengeUserDailyGoal>
    /** Changes a user participating in a community challenge to another socialGroup (or null for solo) */
    changeCommunityChallengeTeamAdmin: UnifiedResult
    /** Admin endpoint to complete a challenge for the user */
    completeChallengeAdmin?: Maybe<UnifiedUserChallengeActivity>
    /** Admin endpoint to complete a community challenge day */
    completeCommunityChallengeDay: Array<ChallengeUserDailyGoal>
    /** Admin endpoint to create new story questions */
    createStoryQuestions?: Maybe<Scalars['String']['output']>
    /** Admin endpoint to create new story questions for i18n */
    createStoryQuestionsI18N?: Maybe<Scalars['String']['output']>
    /** Admin endpoint to add the user to a challenge */
    joinChallengeAdmin: UnifiedResult
    /** Admin endpoint to remove the user from a challenge using a userChallengeActivityId */
    leaveChallengeAdmin?: Maybe<UnifiedUserChallengeActivity>
    /** Admin endpoint to remove challenge */
    removeChallenge: Scalars['String']['output']
    /** Admin endpoint to remove challenge goals */
    removeChallengeGoals: Scalars['String']['output']
    /** Admin endpoint to remove challenges from a company */
    removeChallengesFromCompany: Scalars['String']['output']
    /** Admin endpoint to update challenge daily goal content */
    updateChallengesDailyGoalContent: Array<ChallengeGoal>
    /** Admin endpoint to modify the join date for a user */
    updateJoinDate: UnifiedResult
    /** Admin endpoint to update company ids to add a story type */
    updateStorySubmissionToCompany: Array<UnifiedChallengeCompanyStoryType>
}

/** These are utility Admin mutation endpoints, designed to only be used for adhoc data fixes */
export type UnifiedChallengesMutationUtilAddStorySubmissionToCompanyArgs = {
    challengeCompanyIds: Array<Scalars['UUID']['input']>
    storyTypeId: Scalars['UUID']['input']
}

/** These are utility Admin mutation endpoints, designed to only be used for adhoc data fixes */
export type UnifiedChallengesMutationUtilBatchCompleteCommunityChallengeDayArgs =
    {
        challengeId: Scalars['UUID']['input']
        day: Scalars['Int']['input']
    }

/** These are utility Admin mutation endpoints, designed to only be used for adhoc data fixes */
export type UnifiedChallengesMutationUtilChangeCommunityChallengeTeamAdminArgs =
    {
        challengeId: Scalars['UUID']['input']
        socialGroupId?: InputMaybe<Scalars['UUID']['input']>
        userId: Scalars['UUID']['input']
    }

/** These are utility Admin mutation endpoints, designed to only be used for adhoc data fixes */
export type UnifiedChallengesMutationUtilCompleteChallengeAdminArgs = {
    companyId: Scalars['UUID']['input']
    completedOn?: InputMaybe<Scalars['Instant']['input']>
    subscriptionId: Scalars['UUID']['input']
    userChallengeActivityId: Scalars['UUID']['input']
    userId: Scalars['UUID']['input']
}

/** These are utility Admin mutation endpoints, designed to only be used for adhoc data fixes */
export type UnifiedChallengesMutationUtilCompleteCommunityChallengeDayArgs = {
    challengeId: Scalars['UUID']['input']
    day: Scalars['Int']['input']
    userId: Scalars['UUID']['input']
}

/** These are utility Admin mutation endpoints, designed to only be used for adhoc data fixes */
export type UnifiedChallengesMutationUtilCreateStoryQuestionsArgs = {
    id?: InputMaybe<Scalars['UUID']['input']>
    storyCreateInput: StoryQuestionCreateInput
}

/** These are utility Admin mutation endpoints, designed to only be used for adhoc data fixes */
export type UnifiedChallengesMutationUtilCreateStoryQuestionsI18NArgs = {
    storyCreateInput: StoryQuestionCreateInput
}

/** These are utility Admin mutation endpoints, designed to only be used for adhoc data fixes */
export type UnifiedChallengesMutationUtilJoinChallengeAdminArgs = {
    challengeId: Scalars['UUID']['input']
    companyId: Scalars['UUID']['input']
    joinedOn?: InputMaybe<Scalars['Instant']['input']>
    locale?: InputMaybe<Scalars['Locale']['input']>
    socialGroupId?: InputMaybe<Scalars['UUID']['input']>
    subscriptionId: Scalars['UUID']['input']
    thriveTimeZone?: InputMaybe<Scalars['String']['input']>
    userId: Scalars['UUID']['input']
}

/** These are utility Admin mutation endpoints, designed to only be used for adhoc data fixes */
export type UnifiedChallengesMutationUtilLeaveChallengeAdminArgs = {
    leaveOn?: InputMaybe<Scalars['Instant']['input']>
    userChallengeActivityId: Scalars['UUID']['input']
    userId: Scalars['UUID']['input']
}

/** These are utility Admin mutation endpoints, designed to only be used for adhoc data fixes */
export type UnifiedChallengesMutationUtilRemoveChallengeArgs = {
    challengeId: Scalars['UUID']['input']
}

/** These are utility Admin mutation endpoints, designed to only be used for adhoc data fixes */
export type UnifiedChallengesMutationUtilRemoveChallengeGoalsArgs = {
    challengeGoalIds: Array<Scalars['UUID']['input']>
}

/** These are utility Admin mutation endpoints, designed to only be used for adhoc data fixes */
export type UnifiedChallengesMutationUtilRemoveChallengesFromCompanyArgs = {
    challengeCompanyIds: Array<Scalars['UUID']['input']>
}

/** These are utility Admin mutation endpoints, designed to only be used for adhoc data fixes */
export type UnifiedChallengesMutationUtilUpdateChallengesDailyGoalContentArgs =
    {
        updateChallengesDailyGoalContentInput: UpdateChallengesDailyGoalContentInput
    }

/** These are utility Admin mutation endpoints, designed to only be used for adhoc data fixes */
export type UnifiedChallengesMutationUtilUpdateJoinDateArgs = {
    joinDate: Scalars['Instant']['input']
    modifyExpirationDate: Scalars['Boolean']['input']
    userId: Scalars['UUID']['input']
}

/** These are utility Admin mutation endpoints, designed to only be used for adhoc data fixes */
export type UnifiedChallengesMutationUtilUpdateStorySubmissionToCompanyArgs = {
    challengeCompanyIds: Array<Scalars['UUID']['input']>
    storyTypeId: Scalars['UUID']['input']
}

export type UnifiedChallengesQuery = {
    __typename?: 'UnifiedChallengesQuery'
    /** Get all challenges provisioned */
    allChallenges: Array<UnifiedChallengeAdmin>
    /** Get available interactions for a challenge */
    availableInteractions: Array<StoryType>
    /** Get available interactions for a challenge template */
    availableTemplateInteractions: Array<StoryType>
    /** Get a list of subscriptions information for a given challenge */
    challengeSubscriptionsInfo: Array<ChallengeSubscriptionsInfo>
    /** Get challenge template goals */
    challengeTemplateGoals: Array<ChallengeTemplateGoal>
    /** Admin endpoint for getting company challenge templates */
    challengeTemplatesAdmin: Array<ChallengeTemplate>
    /** Get community challenge goals */
    communityChallengeGoals: Array<ChallengeGoal>
    /** Get community challenge goals */
    communityChallengeGoalsAdmin: Array<ChallengeGoal>
    /** Get team members daily goals and progress for a challenge */
    communityChallengeTeamDailyGoals: Array<ChallengeTeamDailyGoal>
    /** Get community challenge template goals */
    communityChallengeTemplateGoals: Array<ChallengeTemplateGoal>
    /** Get total number of completed daily goals for a user */
    communityChallengeTotalDailyGoalsCompleted: Scalars['Int']['output']
    /** Get user daily goals and progress for a challenge. If not challengeDay is passed it will return today's goals by default */
    communityChallengeUserDailyGoals: Array<ChallengeUserDailyGoal>
    /** Returns the user daily and total steps for a community challenge */
    communityChallengeUserSteps: StepsInfo
    /** Get information for a user for community challenges they're in */
    communityUserChallenges: Array<UnifiedChallengeParticipation>
    /** Returns challenge stats for a user */
    getChallengeStats: ChallengeStats
    /** Get community challenge total steps */
    getChallengeTotalSteps: Scalars['Int']['output']
    /** Get community challenge total water */
    getChallengeTotalWater: Scalars['Int']['output']
    /** Get community challenge threshold */
    getCommunityChallengeThreshold?: Maybe<CommunityChallengeThreshold>
    /** Gets the company challenge notification status for a user */
    getCompanyNotificationStatus: Scalars['Boolean']['output']
    /** Returns the answer for the feeling-question */
    getFeelingAnswer: FeelingQuestionOperationResult
    /** Get the water measure units defined for this user */
    getMeasureUnitSettings?: Maybe<MeasureUnit>
    /** Gets the private challenge notification status for a user */
    getPrivateNotificationStatus: Scalars['Boolean']['output']
    /** Returns recommended challenges based on the user's intention */
    getRecommendedChallenges: Array<ChallengeTemplate>
    /** Returns the answer for the sleep habits question */
    getSleepHabits: SleepHabitsOperationResult
    /** Returns the user's rank if participating solo on a given challenge */
    getSoloPlayerRank: ScoreRanked
    /** Get stories related to a challenge submitted by a user */
    getStories: Array<Story>
    /** Returns the user's team rank on a given challenge using totals */
    getTeamRank: ScoreRanked
    /** Returns the user's team rank on a given challenge using averages */
    getTeamRankByAverage: ScoreRanked
    /** Get team's total water for a challenge */
    getTeamTotalWater: Scalars['Int']['output']
    /** Returns the team players leaderboard for a challenge using totals */
    getTeamsLeaderboard: Leaderboard
    /** Returns the team players leaderboard for a challenge using averages */
    getTeamsLeaderboardByAverage: Leaderboard
    /** Returns a boolean indicating if a user has watched the tutorial */
    getTutorialWatchedStatus: Scalars['Boolean']['output']
    /** Returns the value for a user flag */
    getUserFlag?: Maybe<Scalars['String']['output']>
    /** Returns all flags stored for a user */
    getUserFlags: Array<UserFlag>
    /** Get user's total water for a challenge */
    getUserTotalWater: Scalars['Int']['output']
    /** Returns the solo players leaderboard for a challenge */
    getUsersLeaderboard: Leaderboard
    /** Get user's water intake for date (or today by default) */
    getWaterIntake: WaterOperationResult
    /** Gets the weekend notification status for a user */
    getWeekendNotificationStatus?: Maybe<Scalars['Boolean']['output']>
    /** Get the requested group challenge template */
    groupChallengeTemplate?: Maybe<ChallengeTemplate>
    /** Get Group challenge templates for the current user subscription */
    groupChallengeTemplates: Array<ChallengeTemplate>
    /** Get story types based on enabled status */
    storyTypes: Array<StoryTypeAdmin>
    /** Get challenge */
    unifiedChallenge?: Maybe<UnifiedChallenge>
    /** Retrieves a Company or Group challenge by id */
    unifiedChallengeAdmin?: Maybe<UnifiedChallengeAdmin>
    /** Get challenges */
    unifiedChallenges: Array<UnifiedChallenge>
    unifiedChallengesAdmin: Array<UnifiedChallenge>
    /** Retrieves a list of Company or Group challenges by id */
    unifiedChallengesByIdAdmin: Array<UnifiedChallenge>
    /** Get challenges by subscriptionId */
    unifiedChallengesBySubscriptionId: Array<UnifiedChallenge>
    /** Unified Challenges util functions for adhoc mutations */
    unifiedChallengesUtil: UnifiedChallengesQueryUtil
    /** Get a user's participation information for a given challenge */
    unifiedUserChallenge?: Maybe<UnifiedChallengeParticipation>
    /** Returns user challenge participation. If inProgress=true (default), excludes completed/expired beyond a 10-day grace period; if false, includes all records. */
    unifiedUserChallenges: Array<UnifiedChallengeParticipation>
    /** Admin endpoint for getting participation information for a user for challenges they're in */
    unifiedUserChallengesAdmin: Array<UnifiedChallengeParticipation>
    /** Get user uuids participating in a given challenge */
    usersParticipatingInChallenge: Array<Scalars['UUID']['output']>
    /** Get user checkins for a given challenge */
    usersTotalCheckins: Array<UserTotalCheckins>
}

export type UnifiedChallengesQueryAllChallengesArgs = {
    subscriptionIds?: InputMaybe<Array<Scalars['UUID']['input']>>
}

export type UnifiedChallengesQueryAvailableInteractionsArgs = {
    challengeId: Scalars['UUID']['input']
    locale?: InputMaybe<Scalars['Locale']['input']>
}

export type UnifiedChallengesQueryAvailableTemplateInteractionsArgs = {
    locale?: InputMaybe<Scalars['Locale']['input']>
    templateId: Scalars['UUID']['input']
}

export type UnifiedChallengesQueryChallengeSubscriptionsInfoArgs = {
    challengeId: Scalars['UUID']['input']
}

export type UnifiedChallengesQueryChallengeTemplateGoalsArgs = {
    challengeTemplateId: Scalars['UUID']['input']
}

export type UnifiedChallengesQueryChallengeTemplatesAdminArgs = {
    excludeReadOnly?: InputMaybe<Scalars['Boolean']['input']>
    locale: Scalars['Locale']['input']
}

export type UnifiedChallengesQueryCommunityChallengeGoalsArgs = {
    challengeId: Scalars['UUID']['input']
}

export type UnifiedChallengesQueryCommunityChallengeGoalsAdminArgs = {
    challengeId: Scalars['UUID']['input']
}

export type UnifiedChallengesQueryCommunityChallengeTeamDailyGoalsArgs = {
    challengeId: Scalars['UUID']['input']
}

export type UnifiedChallengesQueryCommunityChallengeTemplateGoalsArgs = {
    challengeTemplateId: Scalars['UUID']['input']
}

export type UnifiedChallengesQueryCommunityChallengeTotalDailyGoalsCompletedArgs =
    {
        challengeId: Scalars['UUID']['input']
    }

export type UnifiedChallengesQueryCommunityChallengeUserDailyGoalsArgs = {
    challengeDay?: InputMaybe<Scalars['Int']['input']>
    challengeId: Scalars['UUID']['input']
}

export type UnifiedChallengesQueryCommunityChallengeUserStepsArgs = {
    challengeId: Scalars['UUID']['input']
}

export type UnifiedChallengesQueryGetChallengeStatsArgs = {
    challengeId: Scalars['UUID']['input']
}

export type UnifiedChallengesQueryGetChallengeTotalStepsArgs = {
    challengeId: Scalars['UUID']['input']
}

export type UnifiedChallengesQueryGetChallengeTotalWaterArgs = {
    challengeId: Scalars['UUID']['input']
}

export type UnifiedChallengesQueryGetCommunityChallengeThresholdArgs = {
    challengeId: Scalars['UUID']['input']
}

export type UnifiedChallengesQueryGetFeelingAnswerArgs = {
    challengeId: Scalars['UUID']['input']
    date?: InputMaybe<Scalars['ISODate']['input']>
}

export type UnifiedChallengesQueryGetRecommendedChallengesArgs = {
    numberOfRecommendations: Scalars['Int']['input']
}

export type UnifiedChallengesQueryGetSleepHabitsArgs = {
    challengeId: Scalars['UUID']['input']
}

export type UnifiedChallengesQueryGetSoloPlayerRankArgs = {
    challengeId: Scalars['UUID']['input']
}

export type UnifiedChallengesQueryGetStoriesArgs = {
    challengeId: Scalars['UUID']['input']
}

export type UnifiedChallengesQueryGetTeamRankArgs = {
    challengeId: Scalars['UUID']['input']
    socialGroupId?: InputMaybe<Scalars['UUID']['input']>
}

export type UnifiedChallengesQueryGetTeamRankByAverageArgs = {
    challengeId: Scalars['UUID']['input']
    socialGroupId?: InputMaybe<Scalars['UUID']['input']>
}

export type UnifiedChallengesQueryGetTeamTotalWaterArgs = {
    challengeId: Scalars['UUID']['input']
    socialGroupId: Scalars['UUID']['input']
}

export type UnifiedChallengesQueryGetTeamsLeaderboardArgs = {
    challengeId: Scalars['UUID']['input']
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    socialGroupId?: InputMaybe<Scalars['UUID']['input']>
}

export type UnifiedChallengesQueryGetTeamsLeaderboardByAverageArgs = {
    challengeId: Scalars['UUID']['input']
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    socialGroupId?: InputMaybe<Scalars['UUID']['input']>
}

export type UnifiedChallengesQueryGetUserFlagArgs = {
    key: Scalars['String']['input']
}

export type UnifiedChallengesQueryGetUserTotalWaterArgs = {
    challengeId: Scalars['UUID']['input']
}

export type UnifiedChallengesQueryGetUsersLeaderboardArgs = {
    challengeId: Scalars['UUID']['input']
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
}

export type UnifiedChallengesQueryGetWaterIntakeArgs = {
    challengeId: Scalars['UUID']['input']
    date?: InputMaybe<Scalars['ISODate']['input']>
}

export type UnifiedChallengesQueryGroupChallengeTemplateArgs = {
    templateId: Scalars['UUID']['input']
}

export type UnifiedChallengesQueryGroupChallengeTemplatesArgs = {
    excludeReadOnly?: InputMaybe<Scalars['Boolean']['input']>
}

export type UnifiedChallengesQueryStoryTypesArgs = {
    status: Scalars['Boolean']['input']
}

export type UnifiedChallengesQueryUnifiedChallengeArgs = {
    challengeId: Scalars['UUID']['input']
    locale?: InputMaybe<Scalars['Locale']['input']>
}

export type UnifiedChallengesQueryUnifiedChallengeAdminArgs = {
    challengeId: Scalars['UUID']['input']
}

export type UnifiedChallengesQueryUnifiedChallengesArgs = {
    locale?: InputMaybe<Scalars['Locale']['input']>
}

export type UnifiedChallengesQueryUnifiedChallengesAdminArgs = {
    locale: Scalars['Locale']['input']
    subscriptionId: Scalars['UUID']['input']
    zoneId?: InputMaybe<Scalars['String']['input']>
}

export type UnifiedChallengesQueryUnifiedChallengesByIdAdminArgs = {
    challengeIds: Array<Scalars['UUID']['input']>
    locale?: InputMaybe<Scalars['Locale']['input']>
    zoneId?: InputMaybe<Scalars['String']['input']>
}

export type UnifiedChallengesQueryUnifiedChallengesBySubscriptionIdArgs = {
    locale?: InputMaybe<Scalars['Locale']['input']>
    subscriptionId: Scalars['UUID']['input']
}

export type UnifiedChallengesQueryUnifiedUserChallengeArgs = {
    locale?: InputMaybe<Scalars['Locale']['input']>
    userChallengeActivityId: Scalars['UUID']['input']
}

export type UnifiedChallengesQueryUnifiedUserChallengesArgs = {
    challengeIds?: InputMaybe<Array<Scalars['UUID']['input']>>
    inProgress?: InputMaybe<Scalars['Boolean']['input']>
    locale?: InputMaybe<Scalars['Locale']['input']>
    userChallengeActivityId?: InputMaybe<Scalars['UUID']['input']>
}

export type UnifiedChallengesQueryUnifiedUserChallengesAdminArgs = {
    challengeIds?: InputMaybe<Array<Scalars['UUID']['input']>>
    companyId?: InputMaybe<Scalars['UUID']['input']>
    inProgress?: InputMaybe<Scalars['Boolean']['input']>
    locale?: InputMaybe<Scalars['Locale']['input']>
    subscriptionId?: InputMaybe<Scalars['UUID']['input']>
    userChallengeActivityId?: InputMaybe<Scalars['UUID']['input']>
    userId: Scalars['UUID']['input']
}

export type UnifiedChallengesQueryUsersParticipatingInChallengeArgs = {
    challengeId: Scalars['UUID']['input']
    companyId?: InputMaybe<Scalars['UUID']['input']>
    subscriptionId?: InputMaybe<Scalars['UUID']['input']>
    withCheckins: Scalars['Boolean']['input']
}

export type UnifiedChallengesQueryUsersTotalCheckinsArgs = {
    challengeId: Scalars['UUID']['input']
    companyId?: InputMaybe<Scalars['UUID']['input']>
    subscriptionId?: InputMaybe<Scalars['UUID']['input']>
}

/** These are utility Admin query endpoints, designed to only be used for adhoc data queries */
export type UnifiedChallengesQueryUtil = {
    __typename?: 'UnifiedChallengesQueryUtil'
    /** Get a list of completed days of a community challenge by the user */
    getCommunityChallengeCompletedDays: Array<CommunityChallengeCompletedDay>
}

/** These are utility Admin query endpoints, designed to only be used for adhoc data queries */
export type UnifiedChallengesQueryUtilGetCommunityChallengeCompletedDaysArgs = {
    challengeId: Scalars['UUID']['input']
    userId: Scalars['UUID']['input']
}

export type UnifiedJourney = {
    __typename?: 'UnifiedJourney'
    id: Scalars['UUID']['output']
    name?: Maybe<Scalars['String']['output']>
    shortName?: Maybe<Scalars['String']['output']>
}

export type UnifiedMicrostep = {
    __typename?: 'UnifiedMicrostep'
    action?: Maybe<Scalars['String']['output']>
    body?: Maybe<Scalars['String']['output']>
    createdAt?: Maybe<Scalars['Instant']['output']>
    deprecatedAt?: Maybe<Scalars['Instant']['output']>
    duration?: Maybe<Scalars['Int']['output']>
    id: Scalars['UUID']['output']
    journeys?: Maybe<Array<UnifiedJourney>>
    reminderEnabled?: Maybe<Scalars['Boolean']['output']>
    timeUnit?: Maybe<Scalars['String']['output']>
    title?: Maybe<Scalars['String']['output']>
    updatedAt?: Maybe<Scalars['Instant']['output']>
}

export type UnifiedMicrostepActivities = {
    __typename?: 'UnifiedMicrostepActivities'
    checkIns: Array<Scalars['Instant']['output']>
    microstep: UnifiedMicrostep
}

export type UnifiedResult =
    | EnablingChallengeStatus
    | ErrorMessage
    | JoinChallengeSucceeded
    | UpdateUserChallengeSucceeded

export type UnifiedStreak = {
    __typename?: 'UnifiedStreak'
    currentStreak: Scalars['Int']['output']
    id: Scalars['UUID']['output']
    maxStreak: Scalars['Int']['output']
    updatedAt: Scalars['Instant']['output']
    userChallengeActivityId: Scalars['UUID']['output']
}

export type UnifiedUserChallengeActivity = {
    __typename?: 'UnifiedUserChallengeActivity'
    /** The id of this user Challenge Activity */
    challengeActivityId: Scalars['UUID']['output']
    /** The id of the challenge  */
    challengeId: Scalars['UUID']['output']
    /** The completion date for the challenge */
    completedOn?: Maybe<Scalars['Instant']['output']>
    createdAt: Scalars['Instant']['output']
    /** The expiration date for the challenge */
    expiredOn?: Maybe<Scalars['Instant']['output']>
    /** The creation date for the relation */
    joinDate?: Maybe<Scalars['Instant']['output']>
    /** The date when the user left a challenge */
    leaveDate?: Maybe<Scalars['Instant']['output']>
    /** The social group id of the challenge  */
    socialGroupId?: Maybe<Scalars['UUID']['output']>
    updatedAt?: Maybe<Scalars['Instant']['output']>
    /** The id of the user  */
    userId: Scalars['String']['output']
}

export type UpdateChallengesDailyGoalContentInput = {
    /** The id of the entity related with the alternative goal */
    altGoalEntityId?: InputMaybe<Scalars['UUID']['input']>
    /** Alternative goal type */
    altGoalType?: InputMaybe<GoalType>
    /** Day this goal belongs during the challenge */
    challengeDay: Scalars['Int']['input']
    /** List of challengeIds to update. If empty, all challenges will be updated */
    challengeIds: Array<Scalars['UUID']['input']>
    /** Ordering during the day */
    challengePosition: Scalars['Int']['input']
    /** The id of the entity related with the goal */
    goalEntityId?: InputMaybe<Scalars['UUID']['input']>
    /** Goal type */
    goalType?: InputMaybe<GoalType>
    /** The id of the challenge template */
    templateId: Scalars['UUID']['input']
}

export type UpdateDisplayNameOperationSucceeded = {
    __typename?: 'UpdateDisplayNameOperationSucceeded'
    /** The display name of the user */
    displayName: Scalars['String']['output']
    /** The ID of the post for which the operation succeeded */
    userId: Scalars['String']['output']
}

export type UpdateIsPublicOperationSucceeded = {
    __typename?: 'UpdateIsPublicOperationSucceeded'
    /** The isPublic status of the user */
    isPublic: Scalars['Boolean']['output']
    /** The ID of the user for which the operation succeeded */
    userId: Scalars['String']['output']
}

export type UpdateNudgeSentAtFailure = {
    __typename?: 'UpdateNudgeSentAtFailure'
    error: Scalars['String']['output']
}

export type UpdateNudgeSentAtResponse =
    | UpdateNudgeSentAtFailure
    | UpdateNudgeSentAtSuccess

export type UpdateNudgeSentAtSuccess = {
    __typename?: 'UpdateNudgeSentAtSuccess'
    result: Array<UserNudgesSentResult>
}

export type UpdateResult = {
    __typename?: 'UpdateResult'
    updatedChallenge: UnifiedChallenge
}

export type UpdateUserChallengeSucceeded = {
    __typename?: 'UpdateUserChallengeSucceeded'
    challengeActivity: UnifiedUserChallengeActivity
}

export type UploadFileDto = {
    __typename?: 'UploadFileDTO'
    alternativeText?: Maybe<Scalars['String']['output']>
    caption?: Maybe<Scalars['String']['output']>
    previewUrl?: Maybe<Scalars['String']['output']>
    url: Scalars['String']['output']
}

export type UpsertCoachCapacityFailure = {
    __typename?: 'UpsertCoachCapacityFailure'
    errorCode: CoachingErrorCode
}

export type UpsertCoachCapacityGqlResponse =
    | UpsertCoachCapacityFailure
    | UpsertCoachCapacitySuccess

export type UpsertCoachCapacitySuccess = {
    __typename?: 'UpsertCoachCapacitySuccess'
    result: CoachCapacityGqlModel
}

export type UpsertUserInput = {
    email: Scalars['String']['input']
    realm?: InputMaybe<Realm>
    subscriptionId: Scalars['UUID']['input']
}

export type UsageQuery = {
    __typename?: 'UsageQuery'
    /** Historical App Usage for a company */
    historicAppUsage: HistoricAppUsageResponse
}

export type UsageQueryHistoricAppUsageArgs = {
    companyId: Scalars['UUID']['input']
    end: MonthYearInput
    start: MonthYearInput
}

export type User = {
    __typename?: 'User'
    attributes: Array<UserAttribute>
    company?: Maybe<Company>
    /** @deprecated Country code has been deprecated in favour of either HR-based or IP-based country code. Teams should make an explicit decision between the two, replace with user.hrBasedCountryCode */
    countryCode?: Maybe<Scalars['String']['output']>
    email?: Maybe<Scalars['String']['output']>
    firstName?: Maybe<Scalars['String']['output']>
    groups: Array<Scalars['String']['output']>
    hrBasedCountryCode?: Maybe<Scalars['String']['output']>
    /** The ID of the user */
    id: Scalars['String']['output']
    idpIds: Array<IdpIdEntry>
    ipBasedCountryCode?: Maybe<Scalars['String']['output']>
    lastName?: Maybe<Scalars['String']['output']>
    magicLink?: Maybe<Scalars['String']['output']>
    realm?: Maybe<Realm>
    roles: Array<Scalars['String']['output']>
    /** Social Groups for this user */
    socialGroups?: Maybe<Array<SocialGroup>>
    subscription?: Maybe<UserSubscription>
    verified?: Maybe<Scalars['Boolean']['output']>
}

export type UserAttribute = {
    __typename?: 'UserAttribute'
    key: Scalars['String']['output']
    value?: Maybe<Scalars['String']['output']>
}

export type UserAttributeInput = {
    key: Scalars['String']['input']
    value?: InputMaybe<Scalars['String']['input']>
}

export type UserAttributeMutation = {
    __typename?: 'UserAttributeMutation'
    /** Update attributes for authenticated user */
    save: Array<IdentityUserAttribute>
    /**
     * Update locale and timezone for authenticated user
     * @deprecated Use more generic save instead
     */
    update: Array<IdentityUserAttribute>
}

export type UserAttributeMutationSaveArgs = {
    attributes: Array<UserAttributeInput>
}

export type UserAttributeMutationUpdateArgs = {
    locale: Scalars['AllowedLocale']['input']
    timeZone: Scalars['TimeZone']['input']
}

export type UserAttributeQuery = {
    __typename?: 'UserAttributeQuery'
    /** Get user attributes for the authenticated user (does not include attributes from the IDP) */
    get: Array<IdentityUserAttribute>
    /** Get user attributes for the given user (does not include attributes from the IDP) */
    getForUserId: Array<IdentityUserAttribute>
}

export type UserAttributeQueryGetForUserIdArgs = {
    userId: Scalars['UUID']['input']
}

export type UserByCompany = {
    __typename?: 'UserByCompany'
    companyId: Scalars['UUID']['output']
    id: Scalars['UUID']['output']
    subscriptionId: Scalars['UUID']['output']
}

export type UserByCompanyPage = {
    __typename?: 'UserByCompanyPage'
    items: Array<UserByCompany>
    itemsPerPage: Scalars['Int']['output']
    page: Scalars['Int']['output']
    total: Scalars['Int']['output']
}

export type UserCheckinMaturity = {
    __typename?: 'UserCheckinMaturity'
    checkInsUntilMature: Scalars['Int']['output']
    isAccountMature: Scalars['Boolean']['output']
}

export type UserConfigInput = {
    /** The user's company id */
    companyId: Scalars['UUID']['input']
    /** The locale in which the Daily Check-In should be translated. Defaults to en-US */
    locale?: InputMaybe<Scalars['Locale']['input']>
    /** The user's thrive id */
    thriveId: Scalars['UUID']['input']
}

export type UserDto = {
    __typename?: 'UserDTO'
    /** Any linked accounts the user has connected with Pulse (i.e. Slack/Teams) */
    accounts: Array<LinkedAccountDto>
    /** The company this user is assigned to */
    companyId: Scalars['UUID']['output']
    /** The company name, as per the user's Thrive profile */
    companyName?: Maybe<Scalars['String']['output']>
    /** When the user was created in Pulse */
    createdAt: Scalars['Instant']['output']
    /** The user's first name, as per their Thrive profile */
    firstName?: Maybe<Scalars['String']['output']>
    /** The internal pulse id for this user */
    id: Scalars['UUID']['output']
    /** The user's last name, as per their Thrive profile */
    lastName?: Maybe<Scalars['String']['output']>
    /** The user's locale, as per their Thrive profile */
    locale?: Maybe<Scalars['String']['output']>
    /** The global thrive id for this user, if known */
    thriveId?: Maybe<Scalars['UUID']['output']>
    /** The user's timezone, as per their Thrive profile */
    timeZone?: Maybe<Scalars['String']['output']>
    /** When the user was last update in Pulse */
    updatedAt: Scalars['Instant']['output']
}

export type UserFlag = {
    __typename?: 'UserFlag'
    createdAt?: Maybe<Scalars['Instant']['output']>
    /** The flag's key */
    key: Scalars['String']['output']
    updatedAt?: Maybe<Scalars['Instant']['output']>
    /** The flag's value */
    value?: Maybe<Scalars['String']['output']>
}

export type UserGroup = {
    __typename?: 'UserGroup'
    attributes: Array<UserGroupAttribute>
    id: Scalars['String']['output']
    name: Scalars['String']['output']
    path: Scalars['String']['output']
    roles: Array<Scalars['String']['output']>
    subGroups: Array<UserGroup>
}

export type UserGroupAttribute = {
    __typename?: 'UserGroupAttribute'
    key: Scalars['String']['output']
    value?: Maybe<Array<Scalars['String']['output']>>
}

export type UserHabitHistory = {
    __typename?: 'UserHabitHistory'
    completedDate: Scalars['ISODate']['output']
    id: Scalars['UUID']['output']
    planId: Scalars['UUID']['output']
}

export type UserHistoryMutation = {
    __typename?: 'UserHistoryMutation'
    /** @deprecated Just placeholder for testing, replace with pulse */
    hello: Scalars['String']['output']
}

export type UserHistoryQuery = {
    __typename?: 'UserHistoryQuery'
    myHistory: Array<Event>
}

export type UserHistoryQueryMyHistoryArgs = {
    from: Scalars['Instant']['input']
    to?: InputMaybe<Scalars['Instant']['input']>
}

export type UserIdLocale = {
    __typename?: 'UserIdLocale'
    id: Scalars['UUID']['output']
    locale: Scalars['Locale']['output']
}

export type UserInfo = {
    __typename?: 'UserInfo'
    companyId?: Maybe<Scalars['UUID']['output']>
    id: Scalars['UUID']['output']
    locale?: Maybe<Scalars['Locale']['output']>
    measureUnit?: Maybe<MeasureUnit>
    notificationsActivated?: Maybe<Scalars['Boolean']['output']>
    subscriptionId?: Maybe<Scalars['UUID']['output']>
    timeZone?: Maybe<Scalars['String']['output']>
    weekendNotificationsActivated?: Maybe<Scalars['Boolean']['output']>
}

export type UserInfoInput = {
    companyId?: InputMaybe<Scalars['UUID']['input']>
    userId: Scalars['UUID']['input']
}

export type UserInventoryInfo = {
    __typename?: 'UserInventoryInfo'
    createdAt?: Maybe<Scalars['Instant']['output']>
    /** the product upc */
    productUpc?: Maybe<Scalars['String']['output']>
    /** the transaction id */
    transactionId?: Maybe<Scalars['UUID']['output']>
    updatedAt?: Maybe<Scalars['Instant']['output']>
    /** The user id */
    userId: Scalars['UUID']['output']
    /** the user plant Id */
    userPlantId?: Maybe<Scalars['UUID']['output']>
}

export type UserJourneyProgress = {
    __typename?: 'UserJourneyProgress'
    contentId: Scalars['UUID']['output']
    contentInfo?: Maybe<JourneyDailyStepV2>
    createdAt: Scalars['Instant']['output']
    id: Scalars['UUID']['output']
    journeyDay: Scalars['Int']['output']
    journeyId: Scalars['UUID']['output']
    journeyLevel: Scalars['Int']['output']
    journeyRepetition: Scalars['Int']['output']
    updatedAt: Scalars['Instant']['output']
    userId: Scalars['UUID']['output']
}

export type UserJourneyProgressV2 = {
    __typename?: 'UserJourneyProgressV2'
    currentJourney: JourneyProgressV2
    previousJourney?: Maybe<JourneyProgressV2>
}

export type UserJourneys = {
    __typename?: 'UserJourneys'
    /** @deprecated No longer supported */
    preferredJourneys: Array<Journey>
    /** Journey selected for Journey progress */
    selectedJourney?: Maybe<Journey>
    /** @deprecated No longer supported */
    subscriptionJourneys: Array<Journey>
}

/** Contains information related to a user's level reward */
export type UserLevelReward = {
    __typename?: 'UserLevelReward'
    /** When the reward was claimed. Null if unclaimed */
    claimedAt?: Maybe<Scalars['Instant']['output']>
    /** The uuid of the reward */
    id: Scalars['UUID']['output']
    /** The reward content. Will be different based on type */
    rewardContent: UserLevelRewardContent
    /** The reward type */
    rewardType: LevelRewardType
}

export type UserLevelRewardContent = GardenItemContent

export type UserMutation = {
    __typename?: 'UserMutation'
    /** Create a new user */
    createUser?: Maybe<WearablesUserDto>
    /** Create a new well-being source */
    createWellBeingSource?: Maybe<UserSourceDto>
    /** Update the connection status of a well-being source */
    updateWellBeingConnectionStatus: Scalars['Boolean']['output']
}

export type UserMutationCreateWellBeingSourceArgs = {
    source: WellBeingSourceInput
}

export type UserMutationUpdateWellBeingConnectionStatusArgs = {
    connected: Scalars['Boolean']['input']
    sourceId: Scalars['UUID']['input']
}

export type UserNpsResult = {
    __typename?: 'UserNPSResult'
    comment?: Maybe<Scalars['String']['output']>
    completionDate: Scalars['Instant']['output']
    locationPath: Scalars['String']['output']
    npsScore?: Maybe<Scalars['Float']['output']>
    platform: Scalars['String']['output']
    sessionId?: Maybe<Scalars['UUID']['output']>
    userId: Scalars['UUID']['output']
    userLocale: Scalars['String']['output']
}

export type UserNudgeStatusFetchFailure = {
    __typename?: 'UserNudgeStatusFetchFailure'
    error: Scalars['String']['output']
}

export type UserNudgeStatusFetchResponse =
    | UserNudgeStatusFetchFailure
    | UserNudgeStatusFetchSuccess

export type UserNudgeStatusFetchSuccess = {
    __typename?: 'UserNudgeStatusFetchSuccess'
    result: Array<UserNudgeStatusResult>
}

export type UserNudgeStatusResult = {
    __typename?: 'UserNudgeStatusResult'
    enabled: Scalars['Boolean']['output']
    nudgeType: NudgeType
    thriveUserId: Scalars['UUID']['output']
    updatedAt: Scalars['Instant']['output']
}

export type UserNudgeStatusUpsertFailure = {
    __typename?: 'UserNudgeStatusUpsertFailure'
    error: Scalars['String']['output']
}

export type UserNudgeStatusUpsertResponse =
    | UserNudgeStatusUpsertFailure
    | UserNudgeStatusUpsertSuccess

export type UserNudgeStatusUpsertSuccess = {
    __typename?: 'UserNudgeStatusUpsertSuccess'
    result: UserNudgeStatusResult
}

export type UserNudgesSentResult = {
    __typename?: 'UserNudgesSentResult'
    expiresAt: Scalars['Instant']['output']
    nudgeMetadata: NudgeMetadata
    nudgeType: NudgeType
    producedAt: Scalars['Instant']['output']
    sendDate: Scalars['ISODate']['output']
    sendTime: Scalars['String']['output']
    sentAt?: Maybe<Scalars['Instant']['output']>
    targetTimestamp: Scalars['Instant']['output']
    thriveUserId: Scalars['UUID']['output']
    whereToShow: Array<DisplayTarget>
}

export type UserObjectInfo = {
    __typename?: 'UserObjectInfo'
    createdAt: Scalars['Instant']['output']
    /** The garden id the object belongs to */
    gardenId?: Maybe<Scalars['UUID']['output']>
    /** The object id */
    id: Scalars['UUID']['output']
    /** The product upc associated to the object */
    productUpc: Scalars['String']['output']
    updatedAt: Scalars['Instant']['output']
    /** The user id the object belongs to */
    userId: Scalars['UUID']['output']
}

export type UserOnboarding = {
    __typename?: 'UserOnboarding'
    createdAt: Scalars['Instant']['output']
    id: Scalars['UUID']['output']
    status: OnboardingAssessmentStatus
    updatedAt: Scalars['Instant']['output']
    userId: Scalars['UUID']['output']
    version: Scalars['Float']['output']
}

export type UserOnboardingAssessment = {
    __typename?: 'UserOnboardingAssessment'
    assessmentChoices: Scalars['String']['output']
    createdAt: Scalars['Instant']['output']
    onBoardingId: Scalars['UUID']['output']
    updatedAt: Scalars['Instant']['output']
    userId: Scalars['UUID']['output']
}

export enum UserOnboardingStatus {
    Completed = 'COMPLETED',
    NotStarted = 'NOT_STARTED',
    Skipped = 'SKIPPED'
}

export type UserPendingNudgesFetchFailure = {
    __typename?: 'UserPendingNudgesFetchFailure'
    error: Scalars['String']['output']
}

export type UserPendingNudgesFetchResponse =
    | UserPendingNudgesFetchFailure
    | UserPendingNudgesFetchSuccess

export type UserPendingNudgesFetchSuccess = {
    __typename?: 'UserPendingNudgesFetchSuccess'
    result: Array<UserNudgesSentResult>
}

export type UserPlanResponse =
    | UserPlanResponseErrorResult
    | UserPlanResponseResult

export enum UserPlanResponseError {
    ErrorCreatingHabit = 'ERROR_CREATING_HABIT',
    ErrorCreatingPlan = 'ERROR_CREATING_PLAN',
    NonExistentGoal = 'NON_EXISTENT_GOAL',
    NonExistentIntention = 'NON_EXISTENT_INTENTION',
    NonExistentPlan = 'NON_EXISTENT_PLAN',
    NonExistentToken = 'NON_EXISTENT_TOKEN'
}

export type UserPlanResponseErrorResult = {
    __typename?: 'UserPlanResponseErrorResult'
    error: UserPlanResponseError
}

export type UserPlanResponseResult = {
    __typename?: 'UserPlanResponseResult'
    planResponseType: PlanResponseType
    userPlan: PlanEntity
}

export type UserPlant = {
    __typename?: 'UserPlant'
    colorLayer1?: Maybe<Scalars['String']['output']>
    colorLayer2?: Maybe<Scalars['String']['output']>
    colorLayer3?: Maybe<Scalars['String']['output']>
    colorLayer4?: Maybe<Scalars['String']['output']>
    createdAt: Scalars['Instant']['output']
    gardenChallengeId?: Maybe<Scalars['UUID']['output']>
    gardenSocialGroupId?: Maybe<Scalars['UUID']['output']>
    id: Scalars['UUID']['output']
    plantedGardenId?: Maybe<Scalars['UUID']['output']>
    productUpc: Scalars['String']['output']
    progressSteps: Scalars['Int']['output']
    trophyChallengeId?: Maybe<Scalars['UUID']['output']>
    updatedAt: Scalars['Instant']['output']
    userId: Scalars['UUID']['output']
    wateredAt?: Maybe<Scalars['Instant']['output']>
}

export type UserPlantInfo = {
    __typename?: 'UserPlantInfo'
    /** Indicates if the plant can be watered */
    canBeWatered: Scalars['Boolean']['output']
    /** Challenge id the plant belongs to */
    challengeId?: Maybe<Scalars['UUID']['output']>
    /** Challenge name the plant belongs to */
    challengeName?: Maybe<Scalars['String']['output']>
    /** Plant color for layer 1 */
    colorLayer1?: Maybe<Scalars['String']['output']>
    /** Plant color for layer 2 */
    colorLayer2?: Maybe<Scalars['String']['output']>
    /** Plant color for layer 3 */
    colorLayer3?: Maybe<Scalars['String']['output']>
    /** Plant color for layer 4 */
    colorLayer4?: Maybe<Scalars['String']['output']>
    createdAt: Scalars['Instant']['output']
    /** The plant id */
    id: Scalars['UUID']['output']
    /** Number of microsteps used to grow this plant */
    microstepsNumber: Scalars['Int']['output']
    /** The plant's owner display name */
    ownerDisplayName?: Maybe<Scalars['String']['output']>
    /** Plant image for TROPHY_PLANT type */
    plantImage?: Maybe<Scalars['String']['output']>
    /** The garden id where the plant is planted */
    plantedGardenId?: Maybe<Scalars['UUID']['output']>
    /** The product upc associated to the plant */
    productUpc: Scalars['String']['output']
    /** The number of times a plant has been watered */
    progressSteps: Scalars['Int']['output']
    /** Number of resets used to grow this plant */
    resetsNumber: Scalars['Int']['output']
    updatedAt: Scalars['Instant']['output']
    /** The user id the plant belongs to */
    userId: Scalars['UUID']['output']
    /** Last time this plant was watered */
    wateredAt?: Maybe<Scalars['Instant']['output']>
}

export type UserQuery = {
    __typename?: 'UserQuery'
    /** Get a user */
    getUser?: Maybe<WearablesUserDto>
    /** Get a user's well-being sources */
    sources: UserSourcesResponse
}

export type UserRecommendationInput = {
    /** The most recent survey response for the user. */
    mostRecentSurveyResponse?: InputMaybe<SurveyResponseInput>
    /** The user's journey UUID. */
    userJourneyUUID?: InputMaybe<Scalars['String']['input']>
}

export enum UserRecommendationsContentType {
    CompanyResource = 'COMPANY_RESOURCE',
    Microstep = 'MICROSTEP'
}

export enum UserRecommendationsInteractionType {
    CheckIn = 'CHECK_IN',
    Seen = 'SEEN',
    Skip = 'SKIP'
}

export type UserSourceDto = {
    __typename?: 'UserSourceDTO'
    connected: Scalars['Boolean']['output']
    created: Scalars['Instant']['output']
    externalSourceId?: Maybe<Scalars['String']['output']>
    lastSynced?: Maybe<Scalars['Instant']['output']>
    sourceId: Scalars['UUID']['output']
    sourceName: Scalars['String']['output']
}

export type UserSourcesResponse = {
    __typename?: 'UserSourcesResponse'
    directSources: Array<UserSourceDto>
    humanApiSources: Array<UserSourceDto>
}

/** User's subscription associated with Company. Type renamed as UserSubscription to avoid clash with GraphQL Subscription */
export type UserSubscription = {
    __typename?: 'UserSubscription'
    companyId: Scalars['UUID']['output']
    enabled: Scalars['Boolean']['output']
    expiryDate?: Maybe<Scalars['Instant']['output']>
    id: Scalars['UUID']['output']
    internalDescription?: Maybe<Scalars['String']['output']>
    isDefault: Scalars['Boolean']['output']
    license: LicenseType
    scopes: Array<Scalars['String']['output']>
    /** @deprecated Subscription level seat count has been deprecated in favour of company level seat count, replace with company.seatsAllowed */
    seatsAllowed: Scalars['Int']['output']
    startDate?: Maybe<Scalars['Instant']['output']>
    subscriptionType: SubscriptionType
}

export type UserTimezoneInput = {
    time: Scalars['Instant']['input']
    timezone: Scalars['String']['input']
}

export type UserTotalCheckins = {
    __typename?: 'UserTotalCheckins'
    checkedInCount: Scalars['Int']['output']
    userId: Scalars['UUID']['output']
}

export type UsersByTimezone = {
    __typename?: 'UsersByTimezone'
    timezone: Scalars['String']['output']
    users: Array<UserIdLocale>
}

export type UsersQuery = {
    __typename?: 'UsersQuery'
    /**
     * Returns the calling user's pulse profile, if one exists
     * @deprecated Don't use Pulse user information. Go to Identity
     */
    me?: Maybe<UserDto>
}

export type ValidateDisplayNameOperationSucceeded = {
    __typename?: 'ValidateDisplayNameOperationSucceeded'
    /** The validity of the display name */
    valid: Scalars['Boolean']['output']
}

export enum VerificationStatus {
    Unverified = 'unverified',
    Verifiedviacompanyclaimeddomain = 'verifiedviacompanyclaimeddomain',
    Verifiedviaconfirmationemail = 'verifiedviaconfirmationemail',
    Verifiedviasociallogin = 'verifiedviasociallogin',
    Verifiedviasso = 'verifiedviasso'
}

export type VideoMutation = {
    __typename?: 'VideoMutation'
    personalized: PersonalizedVideoMutation
}

export type VideoQuery = {
    __typename?: 'VideoQuery'
    personalized: PersonalizedVideoQuery
}

export type VideoUrls = {
    __typename?: 'VideoUrls'
    playback: Scalars['Url']['output']
    thumbnail: Scalars['Url']['output']
}

export enum Visibility {
    Private = 'PRIVATE',
    Public = 'PUBLIC'
}

export enum VisibleProfileAttribute {
    EmployeeId = 'employeeId',
    FacilityNumber = 'facilityNumber',
    FirstName = 'firstName',
    GroupCode = 'groupCode',
    LastName = 'lastName',
    PhoneNumber = 'phoneNumber',
    ProfileAvatar = 'profileAvatar',
    ZipCode = 'zipCode'
}

export type WaterDailyStats = {
    __typename?: 'WaterDailyStats'
    /** Calendar day */
    day: Scalars['Int']['output']
    /** Calendar month */
    month: Scalars['Int']['output']
    /** User water intake */
    water: Scalars['Int']['output']
    /** Calendar year */
    year: Scalars['Int']['output']
}

export type WaterGoalDetail = {
    __typename?: 'WaterGoalDetail'
    water: Scalars['Int']['output']
}

export type WaterIntake = {
    __typename?: 'WaterIntake'
    /** Amount of water for the day */
    amount: Scalars['Int']['output']
    /** Challenge id */
    challengeId: Scalars['UUID']['output']
    /** Intake water day */
    intakeDate: Scalars['ISODate']['output']
    /** Social group the user belongs to */
    socialGroupId?: Maybe<Scalars['UUID']['output']>
}

export type WaterOperationResult = ErrorMessageWater | IntakeResult

export enum WaterPlantError {
    DuplicatedEvent = 'DUPLICATED_EVENT',
    ErrorAutomaticPlant = 'ERROR_AUTOMATIC_PLANT',
    ErrorWateringPlant = 'ERROR_WATERING_PLANT',
    NoPlantGrowing = 'NO_PLANT_GROWING',
    PlantAlreadyFullyGrown = 'PLANT_ALREADY_FULLY_GROWN',
    PlantAlreadyWatered = 'PLANT_ALREADY_WATERED',
    PlantNotFoundForUser = 'PLANT_NOT_FOUND_FOR_USER'
}

export type WaterPlantErrorResult = {
    __typename?: 'WaterPlantErrorResult'
    error: WaterPlantError
    plantError?: Maybe<PlantActionError>
}

export type WaterPlantResponse = WaterPlantErrorResult | WaterPlantResult

export type WaterPlantResult = {
    __typename?: 'WaterPlantResult'
    plantActionResult?: Maybe<PlantActionResult>
    userPlant: UserPlantInfo
}

export type WaterStats = {
    __typename?: 'WaterStats'
    /** Average individual water intake through the whole challenge */
    averageIndividualWater: Scalars['Int']['output']
    /** Average team water intake through the whole challenge */
    averageTeamWater?: Maybe<Scalars['Int']['output']>
    dailyIndividualStats: Array<WaterDailyStats>
    dailyTeamStats: Array<WaterDailyStats>
}

export type WearablesAccess = {
    __typename?: 'WearablesAccess'
    isActivityDataEnabled: Scalars['Boolean']['output']
    isSleepDataEnabled: Scalars['Boolean']['output']
    isSleepRecordsEnabled: Scalars['Boolean']['output']
}

export type WearablesInsightsQuery = {
    __typename?: 'WearablesInsightsQuery'
    /** Get daily activity summaries for a user grouped by day, week or month over a time period */
    activitySummaryStats?: Maybe<Array<ActivitySummaryStats>>
    /** Get daily sleep summaries for a user grouped by day, week or month over a time period */
    sleepSummaryStats?: Maybe<Array<SleepSummaryStats>>
}

export type WearablesInsightsQueryActivitySummaryStatsArgs = {
    intervalType: WearablesReportInterval
}

export type WearablesInsightsQuerySleepSummaryStatsArgs = {
    intervalType: WearablesReportInterval
}

export type WearablesPlatformMutation = {
    __typename?: 'WearablesPlatformMutation'
    /** Modify activity data for a user */
    activity: ActivityMutation
    /** Modify Human API user data */
    humanApi: HumanApiMutation
    /** Modify oura user data */
    oura: OuraMutation
    /** Modify sleep data for a user */
    sleep: SleepMutation
    /** Update step count and run auto check-in for a user */
    updateActivitySummary?: Maybe<HapiActivitySummaryModel>
    /** Modify user data */
    users: UserMutation
}

export type WearablesPlatformMutationUpdateActivitySummaryArgs = {
    localTimestamp?: InputMaybe<Scalars['String']['input']>
    localUTCTimezoneOffsetInMinutes?: InputMaybe<Scalars['Int']['input']>
}

export type WearablesPlatformQuery = {
    __typename?: 'WearablesPlatformQuery'
    /** Get manual activity data for a user */
    activity: ActivityQuery
    /** Get HumanAPI session or id token required to open the HumanAPI connect dialog */
    getHapiToken: ThriveHapiResponse
    /** Get last minutes asleep for a user */
    getLastSleep?: Maybe<Scalars['Int']['output']>
    /** Get step count for a user */
    getStepCount?: Maybe<Scalars['Int']['output']>
    /** Get human api specific data */
    humanApi: HumanApiQuery
    /** Get insights/reporting data from Wearables */
    insights: WearablesInsightsQuery
    /** Get Oura specific data */
    oura: OuraQuery
    /** Get user data */
    users: UserQuery
    /** Get user's permissions to access/store steps and sleep via wearables */
    wearablesAccess: WearablesAccess
}

export type WearablesPlatformQueryGetHapiTokenArgs = {
    email: Scalars['String']['input']
    thriveUserId: Scalars['String']['input']
}

export type WearablesPlatformQueryInsightsArgs = {
    from: Scalars['String']['input']
    to: Scalars['String']['input']
}

export enum WearablesReportInterval {
    Daily = 'DAILY',
    Monthly = 'MONTHLY',
    Ungrouped = 'UNGROUPED',
    Weekly = 'WEEKLY'
}

export type WearablesUserDto = {
    __typename?: 'WearablesUserDTO'
    companyId: Scalars['UUID']['output']
    created: Scalars['Instant']['output']
    hasActiveAppleHealthDirectConnection: Scalars['Boolean']['output']
    hasActiveHumanApiConnection: Scalars['Boolean']['output']
    hasActiveOuraDirectConnection: Scalars['Boolean']['output']
    hasAppleHealthDirectConnection: Scalars['Boolean']['output']
    hasHumanApiConnection: Scalars['Boolean']['output']
    hasOuraDirectConnection: Scalars['Boolean']['output']
    isHumanApiUser: Scalars['Boolean']['output']
    userId: Scalars['UUID']['output']
}

export type WebexIntegrationMutation = {
    __typename?: 'WebexIntegrationMutation'
    /** Disables Webex integration for given company. If company doesn't exist it is a NOOP. Returns true if operation actually changed anything */
    disable: Scalars['Boolean']['output']
    /** Add a new Webex integration to given company. If company doesn't exist, will return an error. If config already exists, it will be enabled without changing anything else. Returns true if operation actually changed anything */
    enable: Scalars['Boolean']['output']
}

export type WebexIntegrationMutationDisableArgs = {
    companyId: Scalars['UUID']['input']
}

export type WebexIntegrationMutationEnableArgs = {
    companyId: Scalars['UUID']['input']
    orgId: Scalars['String']['input']
}

export type WebexTstIntegrationMutation = {
    __typename?: 'WebexTstIntegrationMutation'
    /** Disables Webex TST integration for given company. If company doesn't exist it is a NOOP. Returns true if operation actually changed anything */
    disable: Scalars['Boolean']['output']
    /** Add a new Webex TST integration to given company. If company doesn't exist, will return an error. If config already exists, it will be enabled without changing anything else. Returns true if operation actually changed anything */
    enable: Scalars['Boolean']['output']
}

export type WebexTstIntegrationMutationDisableArgs = {
    companyId: Scalars['UUID']['input']
}

export type WebexTstIntegrationMutationEnableArgs = {
    companyId: Scalars['UUID']['input']
    orgId: Scalars['String']['input']
}

export type Webinar = {
    __typename?: 'Webinar'
    description?: Maybe<Scalars['String']['output']>
    events: Array<WebinarEvent>
    excludedSubscriptions: Array<Scalars['UUID']['output']>
    id: Scalars['ID']['output']
    imageUrl?: Maybe<Scalars['String']['output']>
    includedSubscriptions: Array<Scalars['UUID']['output']>
    isUnrestricted: Scalars['Boolean']['output']
    title: Scalars['String']['output']
    webinarProgress: WebinarProgress
}

export type WebinarEvent = {
    __typename?: 'WebinarEvent'
    id: Scalars['ID']['output']
    imageUrl: Scalars['String']['output']
    sessions: Array<WebinarSession>
    subtitle?: Maybe<Scalars['String']['output']>
    tasks: Array<WebinarResource>
    title: Scalars['String']['output']
    webinarEventProgress?: Maybe<WebinarEventProgress>
}

export type WebinarEventProgress = {
    __typename?: 'WebinarEventProgress'
    durationInSeconds: Scalars['Int']['output']
    hasAttended: Scalars['Boolean']['output']
    hasCompleted: Scalars['Boolean']['output']
    inProgress: Scalars['Boolean']['output']
    isPristine: Scalars['Boolean']['output']
    numberOfPristineSessions: Scalars['Int']['output']
    numberOfSessionsInProgress: Scalars['Int']['output']
    progressInPercent: Scalars['Int']['output']
    progressInSeconds: Scalars['Int']['output']
    updatedAt: Scalars['Instant']['output']
}

export type WebinarPage = {
    __typename?: 'WebinarPage'
    hasMore?: Maybe<Scalars['Boolean']['output']>
    items: Array<Webinar>
    page: Scalars['Int']['output']
    pageCount?: Maybe<Scalars['Int']['output']>
    pageSize: Scalars['Int']['output']
}

export type WebinarProgress = {
    __typename?: 'WebinarProgress'
    attendedEvents: Scalars['Int']['output']
    completedEvents: Scalars['Int']['output']
    hasAttended: Scalars['Boolean']['output']
    hasCompleted: Scalars['Boolean']['output']
    percentageProgress: Scalars['Float']['output']
}

export type WebinarRegistrationResponse = {
    __typename?: 'WebinarRegistrationResponse'
    isForbidden: Scalars['Boolean']['output']
    isNewRegistration: Scalars['Boolean']['output']
    isNotFound: Scalars['Boolean']['output']
    webinar?: Maybe<Webinar>
}

/** Webinar Resource to contain PDF or Survey */
export type WebinarResource = {
    __typename?: 'WebinarResource'
    createdAt: Scalars['Instant']['output']
    id: Scalars['ID']['output']
    /** Course resource type */
    resourceType: CourseResourceType
    /** link to the resource */
    source: Scalars['String']['output']
    summary?: Maybe<Scalars['String']['output']>
    title: Scalars['String']['output']
    updatedAt: Scalars['Instant']['output']
}

export type WebinarSession = {
    __typename?: 'WebinarSession'
    endTime?: Maybe<Scalars['Instant']['output']>
    id: Scalars['ID']['output']
    liveUrl: Scalars['String']['output']
    startTime: Scalars['Instant']['output']
    videoUrl?: Maybe<Scalars['String']['output']>
    webinarSessionProgress?: Maybe<WebinarSessionProgress>
}

export type WebinarSessionProgress = {
    __typename?: 'WebinarSessionProgress'
    durationInSeconds: Scalars['Int']['output']
    hasAttended: Scalars['Boolean']['output']
    hasCompleted: Scalars['Boolean']['output']
    inProgress: Scalars['Boolean']['output']
    progressInPercent: Scalars['Int']['output']
    progressInSeconds: Scalars['Int']['output']
    updatedAt: Scalars['Instant']['output']
}

export type WebinarVideoContentStatusInput = {
    /** Webinar Video id */
    contentId: Scalars['String']['input']
    /** Webinar Video progress in seconds */
    progressInSeconds?: InputMaybe<Scalars['Int']['input']>
    progressType: LearnContentStatusProgressType
    totalInSeconds?: InputMaybe<Scalars['Int']['input']>
}

export type WeeklyActivitySummaryStatsResponse = ActivitySummaryStats & {
    __typename?: 'WeeklyActivitySummaryStatsResponse'
    averageSteps: Scalars['Float']['output']
    weekOfYear: Scalars['Int']['output']
    year: Scalars['Int']['output']
}

export type WeeklyAssessmentStatsResponse = AssessmentStats & {
    __typename?: 'WeeklyAssessmentStatsResponse'
    average: Scalars['Float']['output']
    month: Scalars['Int']['output']
    survey?: Maybe<Surveys>
    totalNumberOfResponses: Scalars['Int']['output']
    valuePercentage: Scalars['Int']['output']
    weekOfYear: Scalars['Int']['output']
    year: Scalars['Int']['output']
}

export type WeeklySleepSummaryStatsResponse = SleepSummaryStats & {
    __typename?: 'WeeklySleepSummaryStatsResponse'
    averageBedTimeStart?: Maybe<Scalars['Long']['output']>
    averageMinutesAsleep: Scalars['Float']['output']
    weekOfYear: Scalars['Int']['output']
    year: Scalars['Int']['output']
}

export type WellBeingSourceInput = {
    connected: Scalars['Boolean']['input']
    sourceName: Scalars['String']['input']
}

export type WhenToSAccepted = {
    __typename?: 'WhenToSAccepted'
    serverTime: Scalars['Instant']['output']
    userId: Scalars['UUID']['output']
    userTime?: Maybe<Scalars['Instant']['output']>
    userZoneId?: Maybe<Scalars['TimeZone']['output']>
}

export type WithBookmarkMutation = {
    bookmark: BookmarkMutation
}

export type WithBookmarkQuery = {
    bookmark: BookmarkQuery
}

export type WithLikeMutation = {
    like: LikeMutation
}

export type WithLikeQuery = {
    like: LikeQuery
}

export type SetUserFlagMutationVariables = Exact<{
    key: Scalars['String']['input']
    value?: InputMaybe<Scalars['String']['input']>
}>

export type SetUserFlagMutation = {
    __typename?: 'Mutation'
    achievements: {
        __typename?: 'AchievementsMutation'
        setUserFlag?: string | null
    }
}

export type PurchaseProductMutationVariables = Exact<{
    upc: Scalars['String']['input']
}>

export type PurchaseProductMutation = {
    __typename?: 'Mutation'
    retail: {
        __typename?: 'RetailMutation'
        purchaseProduct:
            | { __typename?: 'PurchaseErrorResult'; error: PurchaseError }
            | {
                  __typename?: 'PurchaseResult'
                  userBalance?: Array<{
                      __typename?: 'BalanceInfo'
                      amount: number
                      currencyCode: string
                  }> | null
                  userInventory: Array<{
                      __typename?: 'UserInventoryInfo'
                      createdAt?: any | null
                      productUpc?: string | null
                      transactionId?: any | null
                      updatedAt?: any | null
                      userId: any
                      userPlantId?: any | null
                  }>
              }
    }
}

export type GetUserFlagQueryVariables = Exact<{
    key: Scalars['String']['input']
}>

export type GetUserFlagQuery = {
    __typename?: 'Query'
    achievements: {
        __typename?: 'AchievementsQuery'
        getUserFlag?: string | null
    }
}

export type GetUserFlagsQueryVariables = Exact<{ [key: string]: never }>

export type GetUserFlagsQuery = {
    __typename?: 'Query'
    achievements: {
        __typename?: 'AchievementsQuery'
        getUserFlags: Array<{
            __typename?: 'UserFlag'
            createdAt?: any | null
            key: string
            updatedAt?: any | null
            value?: string | null
        }>
    }
}

export type GetPlantsQueryVariables = Exact<{ [key: string]: never }>

export type GetPlantsQuery = {
    __typename?: 'Query'
    retail: {
        __typename?: 'RetailQuery'
        getPlants: Array<{
            __typename?: 'UserPlantInfo'
            createdAt: any
            id: any
            plantedGardenId?: any | null
            productUpc: string
            updatedAt: any
            userId: any
            progressSteps: number
            wateredAt?: any | null
        }>
        getProducts: Array<{
            __typename?: 'ProductInfo'
            updatedAt?: any | null
            upc: string
            title?: string | null
            productType?: string | null
            plantWateringSteps?: number | null
            description?: string | null
            currencyCode?: string | null
            createdAt?: any | null
            cost?: number | null
        }>
    }
}

export type GetRecommendedPlantsQueryVariables = Exact<{ [key: string]: never }>

export type GetRecommendedPlantsQuery = {
    __typename?: 'Query'
    retail: {
        __typename?: 'RetailQuery'
        getRecommendedPlants:
            | {
                  __typename?: 'RecommendedPlantsErrorResult'
                  error: RecommendedPlantsError
              }
            | {
                  __typename?: 'RecommendedPlantsResult'
                  recommendedPlants: Array<{
                      __typename?: 'ProductInfo'
                      cost?: number | null
                      createdAt?: any | null
                      currencyCode?: string | null
                      description?: string | null
                      plantWateringSteps?: number | null
                      productType?: string | null
                      title?: string | null
                      upc: string
                      updatedAt?: any | null
                  }>
              }
    }
}

export const SetUserFlagDocument = gql`
    mutation SetUserFlag($key: String!, $value: String) {
        achievements {
            setUserFlag(key: $key, value: $value)
        }
    }
`
export type SetUserFlagMutationFn = Apollo.MutationFunction<
    SetUserFlagMutation,
    SetUserFlagMutationVariables
>

/**
 * __useSetUserFlagMutation__
 *
 * To run a mutation, you first call `useSetUserFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserFlagMutation, { data, loading, error }] = useSetUserFlagMutation({
 *   variables: {
 *      key: // value for 'key'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useSetUserFlagMutation(
    baseOptions?: Apollo.MutationHookOptions<
        SetUserFlagMutation,
        SetUserFlagMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        SetUserFlagMutation,
        SetUserFlagMutationVariables
    >(SetUserFlagDocument, options)
}
export type SetUserFlagMutationHookResult = ReturnType<
    typeof useSetUserFlagMutation
>
export type SetUserFlagMutationResult =
    Apollo.MutationResult<SetUserFlagMutation>
export type SetUserFlagMutationOptions = Apollo.BaseMutationOptions<
    SetUserFlagMutation,
    SetUserFlagMutationVariables
>
export const PurchaseProductDocument = gql`
    mutation PurchaseProduct($upc: String!) {
        retail {
            purchaseProduct(upc: $upc) {
                ... on PurchaseResult {
                    userBalance {
                        amount
                        currencyCode
                    }
                    userInventory {
                        createdAt
                        productUpc
                        transactionId
                        updatedAt
                        userId
                        userPlantId
                    }
                }
                ... on PurchaseErrorResult {
                    error
                }
            }
        }
    }
`
export type PurchaseProductMutationFn = Apollo.MutationFunction<
    PurchaseProductMutation,
    PurchaseProductMutationVariables
>

/**
 * __usePurchaseProductMutation__
 *
 * To run a mutation, you first call `usePurchaseProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseProductMutation, { data, loading, error }] = usePurchaseProductMutation({
 *   variables: {
 *      upc: // value for 'upc'
 *   },
 * });
 */
export function usePurchaseProductMutation(
    baseOptions?: Apollo.MutationHookOptions<
        PurchaseProductMutation,
        PurchaseProductMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        PurchaseProductMutation,
        PurchaseProductMutationVariables
    >(PurchaseProductDocument, options)
}
export type PurchaseProductMutationHookResult = ReturnType<
    typeof usePurchaseProductMutation
>
export type PurchaseProductMutationResult =
    Apollo.MutationResult<PurchaseProductMutation>
export type PurchaseProductMutationOptions = Apollo.BaseMutationOptions<
    PurchaseProductMutation,
    PurchaseProductMutationVariables
>
export const GetUserFlagDocument = gql`
    query GetUserFlag($key: String!) {
        achievements {
            getUserFlag(key: $key)
        }
    }
`

/**
 * __useGetUserFlagQuery__
 *
 * To run a query within a React component, call `useGetUserFlagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserFlagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserFlagQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useGetUserFlagQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetUserFlagQuery,
        GetUserFlagQueryVariables
    > &
        (
            | { variables: GetUserFlagQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetUserFlagQuery, GetUserFlagQueryVariables>(
        GetUserFlagDocument,
        options
    )
}
export function useGetUserFlagLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetUserFlagQuery,
        GetUserFlagQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetUserFlagQuery, GetUserFlagQueryVariables>(
        GetUserFlagDocument,
        options
    )
}
export function useGetUserFlagSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetUserFlagQuery,
              GetUserFlagQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions }
    return Apollo.useSuspenseQuery<GetUserFlagQuery, GetUserFlagQueryVariables>(
        GetUserFlagDocument,
        options
    )
}
export type GetUserFlagQueryHookResult = ReturnType<typeof useGetUserFlagQuery>
export type GetUserFlagLazyQueryHookResult = ReturnType<
    typeof useGetUserFlagLazyQuery
>
export type GetUserFlagSuspenseQueryHookResult = ReturnType<
    typeof useGetUserFlagSuspenseQuery
>
export type GetUserFlagQueryResult = Apollo.QueryResult<
    GetUserFlagQuery,
    GetUserFlagQueryVariables
>
export const GetUserFlagsDocument = gql`
    query GetUserFlags {
        achievements {
            getUserFlags {
                createdAt
                key
                updatedAt
                value
            }
        }
    }
`

/**
 * __useGetUserFlagsQuery__
 *
 * To run a query within a React component, call `useGetUserFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserFlagsQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetUserFlagsQuery,
        GetUserFlagsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetUserFlagsQuery, GetUserFlagsQueryVariables>(
        GetUserFlagsDocument,
        options
    )
}
export function useGetUserFlagsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetUserFlagsQuery,
        GetUserFlagsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetUserFlagsQuery, GetUserFlagsQueryVariables>(
        GetUserFlagsDocument,
        options
    )
}
export function useGetUserFlagsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetUserFlagsQuery,
              GetUserFlagsQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions }
    return Apollo.useSuspenseQuery<
        GetUserFlagsQuery,
        GetUserFlagsQueryVariables
    >(GetUserFlagsDocument, options)
}
export type GetUserFlagsQueryHookResult = ReturnType<
    typeof useGetUserFlagsQuery
>
export type GetUserFlagsLazyQueryHookResult = ReturnType<
    typeof useGetUserFlagsLazyQuery
>
export type GetUserFlagsSuspenseQueryHookResult = ReturnType<
    typeof useGetUserFlagsSuspenseQuery
>
export type GetUserFlagsQueryResult = Apollo.QueryResult<
    GetUserFlagsQuery,
    GetUserFlagsQueryVariables
>
export const GetPlantsDocument = gql`
    query GetPlants {
        retail {
            getPlants {
                createdAt
                id
                plantedGardenId
                productUpc
                updatedAt
                userId
                progressSteps
                wateredAt
            }
            getProducts {
                updatedAt
                upc
                title
                productType
                plantWateringSteps
                description
                currencyCode
                createdAt
                cost
            }
        }
    }
`

/**
 * __useGetPlantsQuery__
 *
 * To run a query within a React component, call `useGetPlantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlantsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPlantsQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetPlantsQuery,
        GetPlantsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetPlantsQuery, GetPlantsQueryVariables>(
        GetPlantsDocument,
        options
    )
}
export function useGetPlantsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetPlantsQuery,
        GetPlantsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetPlantsQuery, GetPlantsQueryVariables>(
        GetPlantsDocument,
        options
    )
}
export function useGetPlantsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetPlantsQuery,
              GetPlantsQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions }
    return Apollo.useSuspenseQuery<GetPlantsQuery, GetPlantsQueryVariables>(
        GetPlantsDocument,
        options
    )
}
export type GetPlantsQueryHookResult = ReturnType<typeof useGetPlantsQuery>
export type GetPlantsLazyQueryHookResult = ReturnType<
    typeof useGetPlantsLazyQuery
>
export type GetPlantsSuspenseQueryHookResult = ReturnType<
    typeof useGetPlantsSuspenseQuery
>
export type GetPlantsQueryResult = Apollo.QueryResult<
    GetPlantsQuery,
    GetPlantsQueryVariables
>
export const GetRecommendedPlantsDocument = gql`
    query GetRecommendedPlants {
        retail {
            getRecommendedPlants {
                ... on RecommendedPlantsErrorResult {
                    error
                }
                ... on RecommendedPlantsResult {
                    recommendedPlants {
                        cost
                        createdAt
                        currencyCode
                        description
                        plantWateringSteps
                        productType
                        title
                        upc
                        updatedAt
                    }
                }
            }
        }
    }
`

/**
 * __useGetRecommendedPlantsQuery__
 *
 * To run a query within a React component, call `useGetRecommendedPlantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecommendedPlantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecommendedPlantsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRecommendedPlantsQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetRecommendedPlantsQuery,
        GetRecommendedPlantsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<
        GetRecommendedPlantsQuery,
        GetRecommendedPlantsQueryVariables
    >(GetRecommendedPlantsDocument, options)
}
export function useGetRecommendedPlantsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetRecommendedPlantsQuery,
        GetRecommendedPlantsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<
        GetRecommendedPlantsQuery,
        GetRecommendedPlantsQueryVariables
    >(GetRecommendedPlantsDocument, options)
}
export function useGetRecommendedPlantsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetRecommendedPlantsQuery,
              GetRecommendedPlantsQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions }
    return Apollo.useSuspenseQuery<
        GetRecommendedPlantsQuery,
        GetRecommendedPlantsQueryVariables
    >(GetRecommendedPlantsDocument, options)
}
export type GetRecommendedPlantsQueryHookResult = ReturnType<
    typeof useGetRecommendedPlantsQuery
>
export type GetRecommendedPlantsLazyQueryHookResult = ReturnType<
    typeof useGetRecommendedPlantsLazyQuery
>
export type GetRecommendedPlantsSuspenseQueryHookResult = ReturnType<
    typeof useGetRecommendedPlantsSuspenseQuery
>
export type GetRecommendedPlantsQueryResult = Apollo.QueryResult<
    GetRecommendedPlantsQuery,
    GetRecommendedPlantsQueryVariables
>

export interface PossibleTypesResultData {
    possibleTypes: {
        [key: string]: string[]
    }
}
const result: PossibleTypesResultData = {
    possibleTypes: {
        ActivitySummaryStats: [
            'ActivitySummaryStatsResponse',
            'DailyActivitySummaryStatsResponse',
            'MonthlyActivitySummaryStatsResponse',
            'WeeklyActivitySummaryStatsResponse'
        ],
        AddAdoptedMicrostepResponse: [
            'AddAdoptedMicrostepError',
            'AddAdoptedMicrostepResult'
        ],
        AllAssessmentAttemptsResult: [
            'AllAssessmentAttemptsError',
            'AllAssessmentAttemptsSuccess'
        ],
        AssessmentAttemptResult: [
            'AssessmentAttemptError',
            'AssessmentAttemptSuccess'
        ],
        AssessmentResult: ['AssessmentError', 'AssessmentSuccess'],
        AssessmentStats: [
            'DailyAssessmentStatsResponse',
            'MonthlyAssessmentStatsResponse',
            'UngroupedAssessmentStatsResponse',
            'WeeklyAssessmentStatsResponse'
        ],
        BehavioralProfileResult: [
            'BehavioralProfileError',
            'BehavioralProfileSuccess'
        ],
        BookmarkedContent: ['ThriveReset', 'ThriveResetAudio'],
        CallsCommand: ['TriggerReset'],
        ChallengeCustomizationOperationResult: [
            'ChallengeCustomizationResult',
            'ErrorMessageCustomization'
        ],
        ClaimGardenItemRewardResponse: [
            'ClaimGardenItemError',
            'ClaimGardenItemResult'
        ],
        CnsAsyncTriggerEventLaunchedResponse: [
            'CnsAsyncTriggerEventLaunchFailed',
            'CnsAsyncTriggerEventLaunched'
        ],
        CnsBatchTriggerEventResponse: [
            'CnsBatchTriggerEventFailure',
            'CnsBatchTriggerEventSuccess'
        ],
        CnsLargeBatchTriggerEventResponse: [
            'CnsLargeBatchTriggerEventAttempted',
            'CnsLargeBatchTriggerEventTotalFailure'
        ],
        CnsTriggerEventResponse: [
            'CnsTriggerEventFailure',
            'CnsTriggerEventSuccess'
        ],
        CoacheeAvailabilityIntervalsGqlResponse: [
            'CoacheeAvailabilityIntervalsFailure',
            'CoacheeAvailabilityIntervalsSuccess'
        ],
        CoacheeBookSessionGqlResponse: [
            'CoacheeBookSessionFailure',
            'CoacheeBookSessionSuccess'
        ],
        CoacheeCancelSessionGqlResponse: [
            'CoacheeCancelSessionFailure',
            'CoacheeCancelSessionSuccess'
        ],
        CoacheePreferredLocalesGqlResponse: [
            'CoacheePreferredLocalesFailure',
            'CoacheePreferredLocalesSuccess'
        ],
        CourseMutation: ['LearnMutationV2'],
        CourseQuery: ['LearnQueryV2'],
        DeleteGameAchievementConditionResponse: [
            'DeleteGameAchievementConditionResponseError',
            'DeleteGameAchievementConditionResponseResult'
        ],
        DeleteGameAchievementResponse: [
            'DeleteGameAchievementResponseError',
            'DeleteGameAchievementResponseResult'
        ],
        DeleteGameAchievementRewardResponse: [
            'DeleteGameAchievementRewardResponseError',
            'DeleteGameAchievementRewardResponseResult'
        ],
        DeleteGameResponse: [
            'DeleteGameResponseError',
            'DeleteGameResponseResult'
        ],
        DeleteLevelResponse: [
            'DeleteLevelResponseError',
            'DeleteLevelResponseResult'
        ],
        DeleteLevelRewardFilterResponse: [
            'DeleteLevelRewardFilterResponseError',
            'DeleteLevelRewardFilterResponseResult'
        ],
        DeleteLevelRewardResponse: [
            'DeleteLevelRewardResponseError',
            'DeleteLevelRewardResponseResult'
        ],
        DislikeStepResponse: ['DislikeStepError', 'DislikeStepResult'],
        FeedbackQuestionResponse: ['FeedbackQuestionYesNoResponse'],
        FeelingQuestionOperationResult: [
            'ErrorMessageFeelingQuestion',
            'FeelingQuestionResult'
        ],
        Frame: [
            'Image',
            'PersonalizedQuote',
            'PersonalizedVideoFrame',
            'ThriveQuote'
        ],
        GameAchievementConditionResponse: [
            'GameAchievementConditionError',
            'GameAchievementConditionResult'
        ],
        GameAchievementResponse: [
            'GameAchievementError',
            'GameAchievementResult'
        ],
        GameAchievementRewardResponse: [
            'GameAchievementRewardError',
            'GameAchievementRewardResult'
        ],
        GameResponse: ['GameResponseError', 'GameResponseResult'],
        GetActiveCoachesForCoacheeGqlResponse: [
            'GetActiveCoachesForCoacheeFailure',
            'GetActiveCoachesForCoacheeSuccess'
        ],
        GetCoachAvailableTimeSlotsGqlResponse: [
            'GetCoachAvailableTimeSlotsFailure',
            'GetCoachAvailableTimeSlotsSuccess'
        ],
        GetCoachGqlResponse: ['GetCoachFailure', 'GetCoachSuccess'],
        GetCoacheeOnboardingStateResponse: [
            'GetCoacheeOnboardingStateFailure',
            'GetCoacheeOnboardingStateSuccess'
        ],
        GetCoacheeSessionStartTimesGqlResponse: [
            'GetCoacheeSessionStartTimesFailure',
            'GetCoacheeSessionStartTimesSuccess'
        ],
        GetCoacheeSessionStatsAndCohortStatusGqlResponse: [
            'GetCoacheeSessionStatsAndCohortStatusFailure',
            'GetCoacheeSessionStatsAndCohortStatusSuccess'
        ],
        GetCoacheeSessionsGqlResponse: [
            'GetCoacheeSessionsFailure',
            'GetCoacheeSessionsSuccess'
        ],
        GetCoacheeSpecialtiesResponse: [
            'GetCoacheeSpecialtiesFailure',
            'GetCoacheeSpecialtiesSuccess'
        ],
        GetCoachesGqlResponse: ['GetCoachesFailure', 'GetCoachesSuccess'],
        GetCoachingSpecialtiesResponse: [
            'GetCoachingSpecialtyFailure',
            'GetCoachingSpecialtySuccess'
        ],
        GetRecommendedCoachesGqlResponse: [
            'GetRecommendedCoachesFailure',
            'GetRecommendedCoachesSuccess'
        ],
        GoalEntityDetail: [
            'ArticleDetail',
            'AudioResetGoalDetail',
            'DailyCheckinDetail',
            'ExternalLinkDetail',
            'FeelingQuestionDetail',
            'MicrostepGoalDetail',
            'ResetGoalDetail',
            'StepsGoalDetail',
            'WaterGoalDetail'
        ],
        IntentionToJourneysResponseV2: [
            'IntentionToJourneysV2Error',
            'IntentionToJourneysV2Result'
        ],
        IsCoacheeOnboardingCompleteResponse: [
            'IsOnboardingCompleteFailure',
            'IsOnboardingCompleteSuccess'
        ],
        JourneyRestartResponse: ['JourneyRestartError', 'JourneyRestartResult'],
        LearnContentParent: [
            'AudioChapterPartParent',
            'CourseModuleParent',
            'PodcastEpisodeParent'
        ],
        LevelResponse: ['LevelResponseError', 'LevelResponseResult'],
        LevelRewardFilterResponse: [
            'LevelRewardFilterResponseError',
            'LevelRewardFilterResponseResult'
        ],
        LevelRewardResponse: [
            'LevelRewardResponseError',
            'LevelRewardResponseResult'
        ],
        MicrostepMomentumResult: [
            'GraphQlMicrostepMomentum',
            'MicrostepMomentumErrorResponse'
        ],
        ModuleMutation: ['LearnMutationV2'],
        NotificationSettingsOperationResult: ['NotificationSettingsResult'],
        NudgeMetadata: [
            'InChallengeGoalReminder',
            'NoMetadata',
            'SmartNudgeReset',
            'TestNudge'
        ],
        PlantActionResponse: ['PlantActionErrorResult', 'PlantActionResult'],
        PulseOnDemand: [
            'PulseDispatchEventResponse',
            'PulseOnDemandErrorResponse'
        ],
        PurchaseResponse: ['PurchaseErrorResult', 'PurchaseResult'],
        RecommendedEntities: [
            'ArticleV2',
            'GraphQlMicrostep',
            'JourneyDailyStep'
        ],
        RecommendedJourneysResult: [
            'RecommendedJourneysError',
            'RecommendedJourneysInconclusive',
            'RecommendedJourneysSuccess'
        ],
        RecommendedMicrostep: ['GraphQlMicrostep'],
        RecommendedPlantsResponse: [
            'RecommendedPlantsErrorResult',
            'RecommendedPlantsResult'
        ],
        RecommendedResourceV3: [
            'ArticleV2',
            'CompanyResourceGroup',
            'GraphQlMicrostep',
            'JourneyDailyStep',
            'ModuleV2',
            'PodcastEpisode',
            'ThriveReset'
        ],
        RemoveAdoptedMicrostepResponse: [
            'RemoveAdoptedMicrostepError',
            'RemoveAdoptedMicrostepResult'
        ],
        RemoveChallengeResult: ['RemoveErrorMessage', 'RemoveSuccess'],
        RemoveCoacheePreferencesGqlResponse: [
            'RemoveCoacheePreferencesFailure',
            'RemoveCoacheePreferencesSuccess'
        ],
        Reset: ['PersonalizedReset', 'ThriveReset', 'ThriveResetAudio'],
        SaveFeedbackResponse: ['SaveFeedbackError', 'SaveFeedbackResult'],
        SetCoacheePreferencesGqlResponse: [
            'SetCoacheePreferencesFailure',
            'SetCoacheePreferencesSuccess'
        ],
        SetGroupChallengeTypeResult: ['SetTypeErrorMessage', 'SetTypeSuccess'],
        SetIntentionResponse: ['SetIntentionError', 'SetIntentionResult'],
        SleepHabitsOperationResult: [
            'ErrorMessageSleepHabits',
            'SleepHabitsResult'
        ],
        SleepSummaryStats: [
            'DailySleepSummaryStatsResponse',
            'MonthlySleepSummaryStatsResponse',
            'SleepSummaryStatsResponse',
            'WeeklySleepSummaryStatsResponse'
        ],
        SocialGroupsResult: [
            'InvalidAction',
            'InvalidInput',
            'PostOperationSucceeded',
            'PostReactionCreationSucceeded',
            'SocialGroup',
            'SocialGroupOperationSucceeded',
            'SocialGroupUndoPostReactionSucceed',
            'UpdateDisplayNameOperationSucceeded',
            'UpdateIsPublicOperationSucceeded',
            'ValidateDisplayNameOperationSucceeded'
        ],
        StepContent: ['GraphQlMicrostep'],
        TemplateOperationResult: [
            'ChallengeTemplateInstance',
            'ErrorMessageTemplate',
            'UpdateResult'
        ],
        ThriveHapiResponse: [
            'HapiAccessToken',
            'HapiIdToken',
            'HapiSessionToken'
        ],
        UnifiedResult: [
            'EnablingChallengeStatus',
            'ErrorMessage',
            'JoinChallengeSucceeded',
            'UpdateUserChallengeSucceeded'
        ],
        UpdateNudgeSentAtResponse: [
            'UpdateNudgeSentAtFailure',
            'UpdateNudgeSentAtSuccess'
        ],
        UpsertCoachCapacityGqlResponse: [
            'UpsertCoachCapacityFailure',
            'UpsertCoachCapacitySuccess'
        ],
        UserLevelRewardContent: ['GardenItemContent'],
        UserNudgeStatusFetchResponse: [
            'UserNudgeStatusFetchFailure',
            'UserNudgeStatusFetchSuccess'
        ],
        UserNudgeStatusUpsertResponse: [
            'UserNudgeStatusUpsertFailure',
            'UserNudgeStatusUpsertSuccess'
        ],
        UserPendingNudgesFetchResponse: [
            'UserPendingNudgesFetchFailure',
            'UserPendingNudgesFetchSuccess'
        ],
        UserPlanResponse: [
            'UserPlanResponseErrorResult',
            'UserPlanResponseResult'
        ],
        WaterOperationResult: ['ErrorMessageWater', 'IntakeResult'],
        WaterPlantResponse: ['WaterPlantErrorResult', 'WaterPlantResult'],
        WithBookmarkMutation: ['ResetAudioMutationV2', 'ResetVideoMutationV2'],
        WithBookmarkQuery: ['ResetAudioQueryV2', 'ResetVideoQueryV2'],
        WithLikeMutation: ['ResetAudioMutationV2', 'ResetVideoMutationV2'],
        WithLikeQuery: ['ResetAudioQueryV2', 'ResetVideoQueryV2']
    }
}
export default result
